/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum Currency {
  AUD = "AUD",
  GBP = "GBP",
  NZD = "NZD",
}

export enum DataImportDetailType {
  Error = "Error",
  Information = "Information",
}

export enum DiscountType {
  Amount = "Amount",
  Percent = "Percent",
}

export enum ExternalMatterStatus {
  Assigned = "Assigned",
  Unassigned = "Unassigned",
}

export enum ExternalMatterTaxStatus {
  Exempt = "Exempt",
  NoData = "NoData",
  NotExempt = "NotExempt",
}

export enum MatterStatus {
  ClientReview = "ClientReview",
  Closed = "Closed",
  Draft = "Draft",
  Live = "Live",
  Lost = "Lost",
}

export enum MatterStatusEnum {
  ClientReview = "ClientReview",
  Closed = "Closed",
  Draft = "Draft",
  Live = "Live",
  Lost = "Lost",
}

export enum MatterType {
  MultiDisciplinary = "MultiDisciplinary",
  Standard = "Standard",
}

export enum NotificationType {
  Alert = "Alert",
  Standard = "Standard",
}

export enum PricingLevel {
  FeeEarner = "FeeEarner",
  Matter = "Matter",
  None = "None",
  Phase = "Phase",
}

export enum PricingLevelEnum {
  FeeEarner = "FeeEarner",
  Matter = "Matter",
  None = "None",
  Phase = "Phase",
}

export enum PricingType {
  Capped = "Capped",
  Estimated = "Estimated",
  EstimatedRange = "EstimatedRange",
  Fixed = "Fixed",
  TopDown = "TopDown",
  None = "None",
}

export enum PricingTypeEnum {
  Capped = "Capped",
  Estimated = "Estimated",
  EstimatedRange = "EstimatedRange",
  Fixed = "Fixed",
  None = "None",
}

export enum QueryMode {
  default = "default",
  insensitive = "insensitive",
}

export enum RiskLevel {
  HighRisk = "HighRisk",
  Issue = "Issue",
  LowRisk = "LowRisk",
  MediumRisk = "MediumRisk",
  None = "None",
}

export enum TaxLabel {
  GST = "GST",
  VAT = "VAT",
}

export enum TaxLabelStatus {
  Exclusive = "Exclusive",
  Exempt = "Exempt",
  Inclusive = "Inclusive",
}

export enum TaxStatus {
  ClientExempt = "ClientExempt",
  ExternalMatterExempt = "ExternalMatterExempt",
  MatterExempt = "MatterExempt",
  None = "None",
}

export enum TemplateType {
  Firm = "Firm",
  VPD = "VPD",
}

export enum UpliftType {
  Amount = "Amount",
  Percent = "Percent",
}

export enum VpdDataImportType {
  Client = "Client",
  ExternalMatter = "ExternalMatter",
  FeeEarner = "FeeEarner",
  FeeEarnerLevel = "FeeEarnerLevel",
  LibraryAssumption = "LibraryAssumption",
  LibraryDisbursement = "LibraryDisbursement",
  LibraryExclusion = "LibraryExclusion",
  LibraryUplift = "LibraryUplift",
  OfficeLocation = "OfficeLocation",
  OrganisationalUnit = "OrganisationalUnit",
  Rate = "Rate",
  TimeEntry = "TimeEntry",
  User = "User",
}

export interface AccruedFeeForUserPagination {
  skip?: number | null;
  take?: number | null;
  matterStatus?: MatterStatus | null;
}

export interface AssumptionCreateInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  text: string;
  order: number;
  mandatory?: boolean | null;
  default?: boolean | null;
  matter: MatterCreateNestedOneWithoutAssumptionsInput;
}

export interface AssumptionCreateManyMatterInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  text: string;
  order: number;
  mandatory?: boolean | null;
  default?: boolean | null;
}

export interface AssumptionCreateManyMatterInputEnvelope {
  data: AssumptionCreateManyMatterInput[];
  skipDuplicates?: boolean | null;
}

export interface AssumptionCreateNestedManyWithoutMatterInput {
  create?: AssumptionCreateWithoutMatterInput[] | null;
  connectOrCreate?: AssumptionCreateOrConnectWithoutMatterInput[] | null;
  createMany?: AssumptionCreateManyMatterInputEnvelope | null;
  connect?: AssumptionWhereUniqueInput[] | null;
}

export interface AssumptionCreateOrConnectWithoutMatterInput {
  where: AssumptionWhereUniqueInput;
  create: AssumptionCreateWithoutMatterInput;
}

export interface AssumptionCreateWithoutMatterInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  text: string;
  order: number;
  mandatory?: boolean | null;
  default?: boolean | null;
}

export interface AssumptionListRelationFilter {
  every?: AssumptionWhereInput | null;
  some?: AssumptionWhereInput | null;
  none?: AssumptionWhereInput | null;
}

export interface AssumptionScalarWhereInput {
  AND?: AssumptionScalarWhereInput[] | null;
  OR?: AssumptionScalarWhereInput[] | null;
  NOT?: AssumptionScalarWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  text?: StringFilter | null;
  matterId?: IntFilter | null;
  order?: IntFilter | null;
  mandatory?: BoolNullableFilter | null;
  default?: BoolNullableFilter | null;
}

export interface AssumptionUpdateInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  text?: StringFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  mandatory?: NullableBoolFieldUpdateOperationsInput | null;
  default?: NullableBoolFieldUpdateOperationsInput | null;
  matter?: MatterUpdateOneRequiredWithoutAssumptionsNestedInput | null;
}

export interface AssumptionUpdateManyMutationInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  text?: StringFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  mandatory?: NullableBoolFieldUpdateOperationsInput | null;
  default?: NullableBoolFieldUpdateOperationsInput | null;
}

export interface AssumptionUpdateManyWithWhereWithoutMatterInput {
  where: AssumptionScalarWhereInput;
  data: AssumptionUpdateManyMutationInput;
}

export interface AssumptionUpdateManyWithoutMatterNestedInput {
  create?: AssumptionCreateWithoutMatterInput[] | null;
  connectOrCreate?: AssumptionCreateOrConnectWithoutMatterInput[] | null;
  upsert?: AssumptionUpsertWithWhereUniqueWithoutMatterInput[] | null;
  createMany?: AssumptionCreateManyMatterInputEnvelope | null;
  set?: AssumptionWhereUniqueInput[] | null;
  disconnect?: AssumptionWhereUniqueInput[] | null;
  delete?: AssumptionWhereUniqueInput[] | null;
  connect?: AssumptionWhereUniqueInput[] | null;
  update?: AssumptionUpdateWithWhereUniqueWithoutMatterInput[] | null;
  updateMany?: AssumptionUpdateManyWithWhereWithoutMatterInput[] | null;
  deleteMany?: AssumptionScalarWhereInput[] | null;
}

export interface AssumptionUpdateWithWhereUniqueWithoutMatterInput {
  where: AssumptionWhereUniqueInput;
  data: AssumptionUpdateWithoutMatterInput;
}

export interface AssumptionUpdateWithoutMatterInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  text?: StringFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  mandatory?: NullableBoolFieldUpdateOperationsInput | null;
  default?: NullableBoolFieldUpdateOperationsInput | null;
}

export interface AssumptionUpsertWithWhereUniqueWithoutMatterInput {
  where: AssumptionWhereUniqueInput;
  update: AssumptionUpdateWithoutMatterInput;
  create: AssumptionCreateWithoutMatterInput;
}

export interface AssumptionWhereInput {
  AND?: AssumptionWhereInput[] | null;
  OR?: AssumptionWhereInput[] | null;
  NOT?: AssumptionWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  text?: StringFilter | null;
  matterId?: IntFilter | null;
  order?: IntFilter | null;
  mandatory?: BoolNullableFilter | null;
  default?: BoolNullableFilter | null;
  matter?: MatterRelationFilter | null;
}

export interface AssumptionWhereUniqueInput {
  id?: number | null;
}

export interface BoolFieldUpdateOperationsInput {
  set?: boolean | null;
}

export interface BoolFilter {
  equals?: boolean | null;
  not?: NestedBoolFilter | null;
}

export interface BoolNullableFilter {
  equals?: boolean | null;
  not?: NestedBoolNullableFilter | null;
}

export interface BrandCreateNestedOneWithoutMattersInput {
  create?: BrandCreateWithoutMattersInput | null;
  connectOrCreate?: BrandCreateOrConnectWithoutMattersInput | null;
  connect?: BrandWhereUniqueInput | null;
}

export interface BrandCreateNestedOneWithoutParentMattersInput {
  create?: BrandCreateWithoutParentMattersInput | null;
  connectOrCreate?: BrandCreateOrConnectWithoutParentMattersInput | null;
  connect?: BrandWhereUniqueInput | null;
}

export interface BrandCreateOrConnectWithoutMattersInput {
  where: BrandWhereUniqueInput;
  create: BrandCreateWithoutMattersInput;
}

export interface BrandCreateOrConnectWithoutParentMattersInput {
  where: BrandWhereUniqueInput;
  create: BrandCreateWithoutParentMattersInput;
}

export interface BrandCreateWithoutMattersInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  organisationName?: string | null;
  organisationLogo?: string | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  proposalFont?: string | null;
  isDefault?: boolean | null;
  parentMatters?: ParentMatterCreateNestedManyWithoutBrandInput | null;
}

export interface BrandCreateWithoutParentMattersInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  organisationName?: string | null;
  organisationLogo?: string | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  proposalFont?: string | null;
  isDefault?: boolean | null;
  matters?: MatterCreateNestedManyWithoutBrandInput | null;
}

export interface BrandInput {
  organisationName?: string | null;
  organisationLogo?: any | null;
  includeTasksInProposalOutput?: boolean | null;
  proposalFont?: string | null;
  isDefault?: boolean | null;
}

export interface BrandRelationFilter {
  is?: BrandWhereInput | null;
  isNot?: BrandWhereInput | null;
}

export interface BrandUpdateOneWithoutMattersNestedInput {
  create?: BrandCreateWithoutMattersInput | null;
  connectOrCreate?: BrandCreateOrConnectWithoutMattersInput | null;
  upsert?: BrandUpsertWithoutMattersInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: BrandWhereUniqueInput | null;
  update?: BrandUpdateWithoutMattersInput | null;
}

export interface BrandUpdateOneWithoutParentMattersNestedInput {
  create?: BrandCreateWithoutParentMattersInput | null;
  connectOrCreate?: BrandCreateOrConnectWithoutParentMattersInput | null;
  upsert?: BrandUpsertWithoutParentMattersInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: BrandWhereUniqueInput | null;
  update?: BrandUpdateWithoutParentMattersInput | null;
}

export interface BrandUpdateWithoutMattersInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  organisationName?: NullableStringFieldUpdateOperationsInput | null;
  organisationLogo?: NullableStringFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: BoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: BoolFieldUpdateOperationsInput | null;
  proposalFont?: StringFieldUpdateOperationsInput | null;
  isDefault?: BoolFieldUpdateOperationsInput | null;
  parentMatters?: ParentMatterUpdateManyWithoutBrandNestedInput | null;
}

export interface BrandUpdateWithoutParentMattersInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  organisationName?: NullableStringFieldUpdateOperationsInput | null;
  organisationLogo?: NullableStringFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: BoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: BoolFieldUpdateOperationsInput | null;
  proposalFont?: StringFieldUpdateOperationsInput | null;
  isDefault?: BoolFieldUpdateOperationsInput | null;
  matters?: MatterUpdateManyWithoutBrandNestedInput | null;
}

export interface BrandUpsertWithoutMattersInput {
  update: BrandUpdateWithoutMattersInput;
  create: BrandCreateWithoutMattersInput;
}

export interface BrandUpsertWithoutParentMattersInput {
  update: BrandUpdateWithoutParentMattersInput;
  create: BrandCreateWithoutParentMattersInput;
}

export interface BrandWhereInput {
  AND?: BrandWhereInput[] | null;
  OR?: BrandWhereInput[] | null;
  NOT?: BrandWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  organisationName?: StringNullableFilter | null;
  organisationLogo?: StringNullableFilter | null;
  includeTasksInProposalOutput?: BoolFilter | null;
  includeRatesInProposalOutput?: BoolFilter | null;
  proposalFont?: StringFilter | null;
  isDefault?: BoolFilter | null;
  matters?: MatterListRelationFilter | null;
  parentMatters?: ParentMatterListRelationFilter | null;
}

export interface BrandWhereUniqueInput {
  id?: number | null;
  organisationName?: string | null;
}

export interface ClientCreateInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  type?: number | null;
  name: string;
  gpmDangerThreshold?: number | null;
  excludeTax?: boolean | null;
  externalMatters?: ExternalMatterCreateNestedManyWithoutClientInput | null;
  matters?: MatterCreateNestedManyWithoutClientInput | null;
  rates?: RateCreateNestedManyWithoutClientInput | null;
  notificationRule?: NotificationRuleClientsCreateNestedManyWithoutClientInput | null;
  parentMatter?: ParentMatterCreateNestedManyWithoutClientInput | null;
}

export interface ClientCreateNestedOneWithoutExternalMattersInput {
  create?: ClientCreateWithoutExternalMattersInput | null;
  connectOrCreate?: ClientCreateOrConnectWithoutExternalMattersInput | null;
  connect?: ClientWhereUniqueInput | null;
}

export interface ClientCreateNestedOneWithoutMattersInput {
  create?: ClientCreateWithoutMattersInput | null;
  connectOrCreate?: ClientCreateOrConnectWithoutMattersInput | null;
  connect?: ClientWhereUniqueInput | null;
}

export interface ClientCreateNestedOneWithoutNotificationRuleInput {
  create?: ClientCreateWithoutNotificationRuleInput | null;
  connectOrCreate?: ClientCreateOrConnectWithoutNotificationRuleInput | null;
  connect?: ClientWhereUniqueInput | null;
}

export interface ClientCreateNestedOneWithoutParentMatterInput {
  create?: ClientCreateWithoutParentMatterInput | null;
  connectOrCreate?: ClientCreateOrConnectWithoutParentMatterInput | null;
  connect?: ClientWhereUniqueInput | null;
}

export interface ClientCreateNestedOneWithoutRatesInput {
  create?: ClientCreateWithoutRatesInput | null;
  connectOrCreate?: ClientCreateOrConnectWithoutRatesInput | null;
  connect?: ClientWhereUniqueInput | null;
}

export interface ClientCreateOrConnectWithoutExternalMattersInput {
  where: ClientWhereUniqueInput;
  create: ClientCreateWithoutExternalMattersInput;
}

export interface ClientCreateOrConnectWithoutMattersInput {
  where: ClientWhereUniqueInput;
  create: ClientCreateWithoutMattersInput;
}

export interface ClientCreateOrConnectWithoutNotificationRuleInput {
  where: ClientWhereUniqueInput;
  create: ClientCreateWithoutNotificationRuleInput;
}

export interface ClientCreateOrConnectWithoutParentMatterInput {
  where: ClientWhereUniqueInput;
  create: ClientCreateWithoutParentMatterInput;
}

export interface ClientCreateOrConnectWithoutRatesInput {
  where: ClientWhereUniqueInput;
  create: ClientCreateWithoutRatesInput;
}

export interface ClientCreateWithoutExternalMattersInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  type?: number | null;
  name: string;
  gpmDangerThreshold?: number | null;
  excludeTax?: boolean | null;
  matters?: MatterCreateNestedManyWithoutClientInput | null;
  rates?: RateCreateNestedManyWithoutClientInput | null;
  notificationRule?: NotificationRuleClientsCreateNestedManyWithoutClientInput | null;
  parentMatter?: ParentMatterCreateNestedManyWithoutClientInput | null;
}

export interface ClientCreateWithoutMattersInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  type?: number | null;
  name: string;
  gpmDangerThreshold?: number | null;
  excludeTax?: boolean | null;
  externalMatters?: ExternalMatterCreateNestedManyWithoutClientInput | null;
  rates?: RateCreateNestedManyWithoutClientInput | null;
  notificationRule?: NotificationRuleClientsCreateNestedManyWithoutClientInput | null;
  parentMatter?: ParentMatterCreateNestedManyWithoutClientInput | null;
}

export interface ClientCreateWithoutNotificationRuleInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  type?: number | null;
  name: string;
  gpmDangerThreshold?: number | null;
  excludeTax?: boolean | null;
  externalMatters?: ExternalMatterCreateNestedManyWithoutClientInput | null;
  matters?: MatterCreateNestedManyWithoutClientInput | null;
  rates?: RateCreateNestedManyWithoutClientInput | null;
  parentMatter?: ParentMatterCreateNestedManyWithoutClientInput | null;
}

export interface ClientCreateWithoutParentMatterInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  type?: number | null;
  name: string;
  gpmDangerThreshold?: number | null;
  excludeTax?: boolean | null;
  externalMatters?: ExternalMatterCreateNestedManyWithoutClientInput | null;
  matters?: MatterCreateNestedManyWithoutClientInput | null;
  rates?: RateCreateNestedManyWithoutClientInput | null;
  notificationRule?: NotificationRuleClientsCreateNestedManyWithoutClientInput | null;
}

export interface ClientCreateWithoutRatesInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  type?: number | null;
  name: string;
  gpmDangerThreshold?: number | null;
  excludeTax?: boolean | null;
  externalMatters?: ExternalMatterCreateNestedManyWithoutClientInput | null;
  matters?: MatterCreateNestedManyWithoutClientInput | null;
  notificationRule?: NotificationRuleClientsCreateNestedManyWithoutClientInput | null;
  parentMatter?: ParentMatterCreateNestedManyWithoutClientInput | null;
}

export interface ClientRelationFilter {
  is?: ClientWhereInput | null;
  isNot?: ClientWhereInput | null;
}

export interface ClientUpdateInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  type?: IntFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  gpmDangerThreshold?: NullableIntFieldUpdateOperationsInput | null;
  excludeTax?: BoolFieldUpdateOperationsInput | null;
  externalMatters?: ExternalMatterUpdateManyWithoutClientNestedInput | null;
  matters?: MatterUpdateManyWithoutClientNestedInput | null;
  rates?: RateUpdateManyWithoutClientNestedInput | null;
  notificationRule?: NotificationRuleClientsUpdateManyWithoutClientNestedInput | null;
  parentMatter?: ParentMatterUpdateManyWithoutClientNestedInput | null;
}

export interface ClientUpdateOneRequiredWithoutNotificationRuleNestedInput {
  create?: ClientCreateWithoutNotificationRuleInput | null;
  connectOrCreate?: ClientCreateOrConnectWithoutNotificationRuleInput | null;
  upsert?: ClientUpsertWithoutNotificationRuleInput | null;
  connect?: ClientWhereUniqueInput | null;
  update?: ClientUpdateWithoutNotificationRuleInput | null;
}

export interface ClientUpdateOneWithoutExternalMattersNestedInput {
  create?: ClientCreateWithoutExternalMattersInput | null;
  connectOrCreate?: ClientCreateOrConnectWithoutExternalMattersInput | null;
  upsert?: ClientUpsertWithoutExternalMattersInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: ClientWhereUniqueInput | null;
  update?: ClientUpdateWithoutExternalMattersInput | null;
}

export interface ClientUpdateOneWithoutMattersNestedInput {
  create?: ClientCreateWithoutMattersInput | null;
  connectOrCreate?: ClientCreateOrConnectWithoutMattersInput | null;
  upsert?: ClientUpsertWithoutMattersInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: ClientWhereUniqueInput | null;
  update?: ClientUpdateWithoutMattersInput | null;
}

export interface ClientUpdateOneWithoutParentMatterNestedInput {
  create?: ClientCreateWithoutParentMatterInput | null;
  connectOrCreate?: ClientCreateOrConnectWithoutParentMatterInput | null;
  upsert?: ClientUpsertWithoutParentMatterInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: ClientWhereUniqueInput | null;
  update?: ClientUpdateWithoutParentMatterInput | null;
}

export interface ClientUpdateOneWithoutRatesNestedInput {
  create?: ClientCreateWithoutRatesInput | null;
  connectOrCreate?: ClientCreateOrConnectWithoutRatesInput | null;
  upsert?: ClientUpsertWithoutRatesInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: ClientWhereUniqueInput | null;
  update?: ClientUpdateWithoutRatesInput | null;
}

export interface ClientUpdateWithoutExternalMattersInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  type?: IntFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  gpmDangerThreshold?: NullableIntFieldUpdateOperationsInput | null;
  excludeTax?: BoolFieldUpdateOperationsInput | null;
  matters?: MatterUpdateManyWithoutClientNestedInput | null;
  rates?: RateUpdateManyWithoutClientNestedInput | null;
  notificationRule?: NotificationRuleClientsUpdateManyWithoutClientNestedInput | null;
  parentMatter?: ParentMatterUpdateManyWithoutClientNestedInput | null;
}

export interface ClientUpdateWithoutMattersInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  type?: IntFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  gpmDangerThreshold?: NullableIntFieldUpdateOperationsInput | null;
  excludeTax?: BoolFieldUpdateOperationsInput | null;
  externalMatters?: ExternalMatterUpdateManyWithoutClientNestedInput | null;
  rates?: RateUpdateManyWithoutClientNestedInput | null;
  notificationRule?: NotificationRuleClientsUpdateManyWithoutClientNestedInput | null;
  parentMatter?: ParentMatterUpdateManyWithoutClientNestedInput | null;
}

export interface ClientUpdateWithoutNotificationRuleInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  type?: IntFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  gpmDangerThreshold?: NullableIntFieldUpdateOperationsInput | null;
  excludeTax?: BoolFieldUpdateOperationsInput | null;
  externalMatters?: ExternalMatterUpdateManyWithoutClientNestedInput | null;
  matters?: MatterUpdateManyWithoutClientNestedInput | null;
  rates?: RateUpdateManyWithoutClientNestedInput | null;
  parentMatter?: ParentMatterUpdateManyWithoutClientNestedInput | null;
}

export interface ClientUpdateWithoutParentMatterInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  type?: IntFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  gpmDangerThreshold?: NullableIntFieldUpdateOperationsInput | null;
  excludeTax?: BoolFieldUpdateOperationsInput | null;
  externalMatters?: ExternalMatterUpdateManyWithoutClientNestedInput | null;
  matters?: MatterUpdateManyWithoutClientNestedInput | null;
  rates?: RateUpdateManyWithoutClientNestedInput | null;
  notificationRule?: NotificationRuleClientsUpdateManyWithoutClientNestedInput | null;
}

export interface ClientUpdateWithoutRatesInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  type?: IntFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  gpmDangerThreshold?: NullableIntFieldUpdateOperationsInput | null;
  excludeTax?: BoolFieldUpdateOperationsInput | null;
  externalMatters?: ExternalMatterUpdateManyWithoutClientNestedInput | null;
  matters?: MatterUpdateManyWithoutClientNestedInput | null;
  notificationRule?: NotificationRuleClientsUpdateManyWithoutClientNestedInput | null;
  parentMatter?: ParentMatterUpdateManyWithoutClientNestedInput | null;
}

export interface ClientUpsertWithoutExternalMattersInput {
  update: ClientUpdateWithoutExternalMattersInput;
  create: ClientCreateWithoutExternalMattersInput;
}

export interface ClientUpsertWithoutMattersInput {
  update: ClientUpdateWithoutMattersInput;
  create: ClientCreateWithoutMattersInput;
}

export interface ClientUpsertWithoutNotificationRuleInput {
  update: ClientUpdateWithoutNotificationRuleInput;
  create: ClientCreateWithoutNotificationRuleInput;
}

export interface ClientUpsertWithoutParentMatterInput {
  update: ClientUpdateWithoutParentMatterInput;
  create: ClientCreateWithoutParentMatterInput;
}

export interface ClientUpsertWithoutRatesInput {
  update: ClientUpdateWithoutRatesInput;
  create: ClientCreateWithoutRatesInput;
}

export interface ClientWhereInput {
  AND?: ClientWhereInput[] | null;
  OR?: ClientWhereInput[] | null;
  NOT?: ClientWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  externalId?: StringNullableFilter | null;
  externalReference?: StringNullableFilter | null;
  externalCreatedAt?: DateTimeNullableFilter | null;
  externalUpdatedAt?: DateTimeNullableFilter | null;
  externalDeletedAt?: DateTimeNullableFilter | null;
  type?: IntFilter | null;
  name?: StringFilter | null;
  gpmDangerThreshold?: IntNullableFilter | null;
  excludeTax?: BoolFilter | null;
  externalMatters?: ExternalMatterListRelationFilter | null;
  matters?: MatterListRelationFilter | null;
  rates?: RateListRelationFilter | null;
  notificationRule?: NotificationRuleClientsListRelationFilter | null;
  parentMatter?: ParentMatterListRelationFilter | null;
}

export interface ClientWhereUniqueInput {
  id?: number | null;
  externalId?: string | null;
}

export interface CollaboratorCreateManyCreatedByUserInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  matterId?: number | null;
  userId: number;
  parentMatterId?: number | null;
}

export interface CollaboratorCreateManyCreatedByUserInputEnvelope {
  data: CollaboratorCreateManyCreatedByUserInput[];
  skipDuplicates?: boolean | null;
}

export interface CollaboratorCreateManyMatterInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  userId: number;
  createdByUserId: number;
  parentMatterId?: number | null;
}

export interface CollaboratorCreateManyMatterInputEnvelope {
  data: CollaboratorCreateManyMatterInput[];
  skipDuplicates?: boolean | null;
}

export interface CollaboratorCreateManyParentMatterInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  matterId?: number | null;
  userId: number;
  createdByUserId: number;
}

export interface CollaboratorCreateManyParentMatterInputEnvelope {
  data: CollaboratorCreateManyParentMatterInput[];
  skipDuplicates?: boolean | null;
}

export interface CollaboratorCreateManyUserInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  matterId?: number | null;
  createdByUserId: number;
  parentMatterId?: number | null;
}

export interface CollaboratorCreateManyUserInputEnvelope {
  data: CollaboratorCreateManyUserInput[];
  skipDuplicates?: boolean | null;
}

export interface CollaboratorCreateNestedManyWithoutCreatedByUserInput {
  create?: CollaboratorCreateWithoutCreatedByUserInput[] | null;
  connectOrCreate?: CollaboratorCreateOrConnectWithoutCreatedByUserInput[] | null;
  createMany?: CollaboratorCreateManyCreatedByUserInputEnvelope | null;
  connect?: CollaboratorWhereUniqueInput[] | null;
}

export interface CollaboratorCreateNestedManyWithoutMatterInput {
  create?: CollaboratorCreateWithoutMatterInput[] | null;
  connectOrCreate?: CollaboratorCreateOrConnectWithoutMatterInput[] | null;
  createMany?: CollaboratorCreateManyMatterInputEnvelope | null;
  connect?: CollaboratorWhereUniqueInput[] | null;
}

export interface CollaboratorCreateNestedManyWithoutParentMatterInput {
  create?: CollaboratorCreateWithoutParentMatterInput[] | null;
  connectOrCreate?: CollaboratorCreateOrConnectWithoutParentMatterInput[] | null;
  createMany?: CollaboratorCreateManyParentMatterInputEnvelope | null;
  connect?: CollaboratorWhereUniqueInput[] | null;
}

export interface CollaboratorCreateNestedManyWithoutUserInput {
  create?: CollaboratorCreateWithoutUserInput[] | null;
  connectOrCreate?: CollaboratorCreateOrConnectWithoutUserInput[] | null;
  createMany?: CollaboratorCreateManyUserInputEnvelope | null;
  connect?: CollaboratorWhereUniqueInput[] | null;
}

export interface CollaboratorCreateOrConnectWithoutCreatedByUserInput {
  where: CollaboratorWhereUniqueInput;
  create: CollaboratorCreateWithoutCreatedByUserInput;
}

export interface CollaboratorCreateOrConnectWithoutMatterInput {
  where: CollaboratorWhereUniqueInput;
  create: CollaboratorCreateWithoutMatterInput;
}

export interface CollaboratorCreateOrConnectWithoutParentMatterInput {
  where: CollaboratorWhereUniqueInput;
  create: CollaboratorCreateWithoutParentMatterInput;
}

export interface CollaboratorCreateOrConnectWithoutUserInput {
  where: CollaboratorWhereUniqueInput;
  create: CollaboratorCreateWithoutUserInput;
}

export interface CollaboratorCreateWithoutCreatedByUserInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  matter?: MatterCreateNestedOneWithoutCollaboratorsInput | null;
  user: UserCreateNestedOneWithoutCollaboratorUserInput;
  parentMatter?: ParentMatterCreateNestedOneWithoutCollaboratorsInput | null;
}

export interface CollaboratorCreateWithoutMatterInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  user: UserCreateNestedOneWithoutCollaboratorUserInput;
  createdByUser: UserCreateNestedOneWithoutCollaboratorCreatedByUserInput;
  parentMatter?: ParentMatterCreateNestedOneWithoutCollaboratorsInput | null;
}

export interface CollaboratorCreateWithoutParentMatterInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  matter?: MatterCreateNestedOneWithoutCollaboratorsInput | null;
  user: UserCreateNestedOneWithoutCollaboratorUserInput;
  createdByUser: UserCreateNestedOneWithoutCollaboratorCreatedByUserInput;
}

export interface CollaboratorCreateWithoutUserInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  matter?: MatterCreateNestedOneWithoutCollaboratorsInput | null;
  createdByUser: UserCreateNestedOneWithoutCollaboratorCreatedByUserInput;
  parentMatter?: ParentMatterCreateNestedOneWithoutCollaboratorsInput | null;
}

export interface CollaboratorListRelationFilter {
  every?: CollaboratorWhereInput | null;
  some?: CollaboratorWhereInput | null;
  none?: CollaboratorWhereInput | null;
}

export interface CollaboratorScalarWhereInput {
  AND?: CollaboratorScalarWhereInput[] | null;
  OR?: CollaboratorScalarWhereInput[] | null;
  NOT?: CollaboratorScalarWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  matterId?: IntNullableFilter | null;
  userId?: IntFilter | null;
  createdByUserId?: IntFilter | null;
  parentMatterId?: IntNullableFilter | null;
}

export interface CollaboratorUpdateManyMutationInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
}

export interface CollaboratorUpdateManyWithWhereWithoutCreatedByUserInput {
  where: CollaboratorScalarWhereInput;
  data: CollaboratorUpdateManyMutationInput;
}

export interface CollaboratorUpdateManyWithWhereWithoutMatterInput {
  where: CollaboratorScalarWhereInput;
  data: CollaboratorUpdateManyMutationInput;
}

export interface CollaboratorUpdateManyWithWhereWithoutParentMatterInput {
  where: CollaboratorScalarWhereInput;
  data: CollaboratorUpdateManyMutationInput;
}

export interface CollaboratorUpdateManyWithWhereWithoutUserInput {
  where: CollaboratorScalarWhereInput;
  data: CollaboratorUpdateManyMutationInput;
}

export interface CollaboratorUpdateManyWithoutCreatedByUserNestedInput {
  create?: CollaboratorCreateWithoutCreatedByUserInput[] | null;
  connectOrCreate?: CollaboratorCreateOrConnectWithoutCreatedByUserInput[] | null;
  upsert?: CollaboratorUpsertWithWhereUniqueWithoutCreatedByUserInput[] | null;
  createMany?: CollaboratorCreateManyCreatedByUserInputEnvelope | null;
  set?: CollaboratorWhereUniqueInput[] | null;
  disconnect?: CollaboratorWhereUniqueInput[] | null;
  delete?: CollaboratorWhereUniqueInput[] | null;
  connect?: CollaboratorWhereUniqueInput[] | null;
  update?: CollaboratorUpdateWithWhereUniqueWithoutCreatedByUserInput[] | null;
  updateMany?: CollaboratorUpdateManyWithWhereWithoutCreatedByUserInput[] | null;
  deleteMany?: CollaboratorScalarWhereInput[] | null;
}

export interface CollaboratorUpdateManyWithoutMatterNestedInput {
  create?: CollaboratorCreateWithoutMatterInput[] | null;
  connectOrCreate?: CollaboratorCreateOrConnectWithoutMatterInput[] | null;
  upsert?: CollaboratorUpsertWithWhereUniqueWithoutMatterInput[] | null;
  createMany?: CollaboratorCreateManyMatterInputEnvelope | null;
  set?: CollaboratorWhereUniqueInput[] | null;
  disconnect?: CollaboratorWhereUniqueInput[] | null;
  delete?: CollaboratorWhereUniqueInput[] | null;
  connect?: CollaboratorWhereUniqueInput[] | null;
  update?: CollaboratorUpdateWithWhereUniqueWithoutMatterInput[] | null;
  updateMany?: CollaboratorUpdateManyWithWhereWithoutMatterInput[] | null;
  deleteMany?: CollaboratorScalarWhereInput[] | null;
}

export interface CollaboratorUpdateManyWithoutParentMatterNestedInput {
  create?: CollaboratorCreateWithoutParentMatterInput[] | null;
  connectOrCreate?: CollaboratorCreateOrConnectWithoutParentMatterInput[] | null;
  upsert?: CollaboratorUpsertWithWhereUniqueWithoutParentMatterInput[] | null;
  createMany?: CollaboratorCreateManyParentMatterInputEnvelope | null;
  set?: CollaboratorWhereUniqueInput[] | null;
  disconnect?: CollaboratorWhereUniqueInput[] | null;
  delete?: CollaboratorWhereUniqueInput[] | null;
  connect?: CollaboratorWhereUniqueInput[] | null;
  update?: CollaboratorUpdateWithWhereUniqueWithoutParentMatterInput[] | null;
  updateMany?: CollaboratorUpdateManyWithWhereWithoutParentMatterInput[] | null;
  deleteMany?: CollaboratorScalarWhereInput[] | null;
}

export interface CollaboratorUpdateManyWithoutUserNestedInput {
  create?: CollaboratorCreateWithoutUserInput[] | null;
  connectOrCreate?: CollaboratorCreateOrConnectWithoutUserInput[] | null;
  upsert?: CollaboratorUpsertWithWhereUniqueWithoutUserInput[] | null;
  createMany?: CollaboratorCreateManyUserInputEnvelope | null;
  set?: CollaboratorWhereUniqueInput[] | null;
  disconnect?: CollaboratorWhereUniqueInput[] | null;
  delete?: CollaboratorWhereUniqueInput[] | null;
  connect?: CollaboratorWhereUniqueInput[] | null;
  update?: CollaboratorUpdateWithWhereUniqueWithoutUserInput[] | null;
  updateMany?: CollaboratorUpdateManyWithWhereWithoutUserInput[] | null;
  deleteMany?: CollaboratorScalarWhereInput[] | null;
}

export interface CollaboratorUpdateWithWhereUniqueWithoutCreatedByUserInput {
  where: CollaboratorWhereUniqueInput;
  data: CollaboratorUpdateWithoutCreatedByUserInput;
}

export interface CollaboratorUpdateWithWhereUniqueWithoutMatterInput {
  where: CollaboratorWhereUniqueInput;
  data: CollaboratorUpdateWithoutMatterInput;
}

export interface CollaboratorUpdateWithWhereUniqueWithoutParentMatterInput {
  where: CollaboratorWhereUniqueInput;
  data: CollaboratorUpdateWithoutParentMatterInput;
}

export interface CollaboratorUpdateWithWhereUniqueWithoutUserInput {
  where: CollaboratorWhereUniqueInput;
  data: CollaboratorUpdateWithoutUserInput;
}

export interface CollaboratorUpdateWithoutCreatedByUserInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  matter?: MatterUpdateOneWithoutCollaboratorsNestedInput | null;
  user?: UserUpdateOneRequiredWithoutCollaboratorUserNestedInput | null;
  parentMatter?: ParentMatterUpdateOneWithoutCollaboratorsNestedInput | null;
}

export interface CollaboratorUpdateWithoutMatterInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  user?: UserUpdateOneRequiredWithoutCollaboratorUserNestedInput | null;
  createdByUser?: UserUpdateOneRequiredWithoutCollaboratorCreatedByUserNestedInput | null;
  parentMatter?: ParentMatterUpdateOneWithoutCollaboratorsNestedInput | null;
}

export interface CollaboratorUpdateWithoutParentMatterInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  matter?: MatterUpdateOneWithoutCollaboratorsNestedInput | null;
  user?: UserUpdateOneRequiredWithoutCollaboratorUserNestedInput | null;
  createdByUser?: UserUpdateOneRequiredWithoutCollaboratorCreatedByUserNestedInput | null;
}

export interface CollaboratorUpdateWithoutUserInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  matter?: MatterUpdateOneWithoutCollaboratorsNestedInput | null;
  createdByUser?: UserUpdateOneRequiredWithoutCollaboratorCreatedByUserNestedInput | null;
  parentMatter?: ParentMatterUpdateOneWithoutCollaboratorsNestedInput | null;
}

export interface CollaboratorUpsertWithWhereUniqueWithoutCreatedByUserInput {
  where: CollaboratorWhereUniqueInput;
  update: CollaboratorUpdateWithoutCreatedByUserInput;
  create: CollaboratorCreateWithoutCreatedByUserInput;
}

export interface CollaboratorUpsertWithWhereUniqueWithoutMatterInput {
  where: CollaboratorWhereUniqueInput;
  update: CollaboratorUpdateWithoutMatterInput;
  create: CollaboratorCreateWithoutMatterInput;
}

export interface CollaboratorUpsertWithWhereUniqueWithoutParentMatterInput {
  where: CollaboratorWhereUniqueInput;
  update: CollaboratorUpdateWithoutParentMatterInput;
  create: CollaboratorCreateWithoutParentMatterInput;
}

export interface CollaboratorUpsertWithWhereUniqueWithoutUserInput {
  where: CollaboratorWhereUniqueInput;
  update: CollaboratorUpdateWithoutUserInput;
  create: CollaboratorCreateWithoutUserInput;
}

export interface CollaboratorWhereInput {
  AND?: CollaboratorWhereInput[] | null;
  OR?: CollaboratorWhereInput[] | null;
  NOT?: CollaboratorWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  matterId?: IntNullableFilter | null;
  userId?: IntFilter | null;
  createdByUserId?: IntFilter | null;
  parentMatterId?: IntNullableFilter | null;
  matter?: MatterRelationFilter | null;
  user?: UserRelationFilter | null;
  createdByUser?: UserRelationFilter | null;
  parentMatter?: ParentMatterRelationFilter | null;
}

export interface CollaboratorWhereUniqueInput {
  id?: number | null;
}

export interface DateTimeFieldUpdateOperationsInput {
  set?: any | null;
}

export interface DateTimeFilter {
  equals?: any | null;
  in?: any[] | null;
  notIn?: any[] | null;
  lt?: any | null;
  lte?: any | null;
  gt?: any | null;
  gte?: any | null;
  not?: NestedDateTimeFilter | null;
}

export interface DateTimeNullableFilter {
  equals?: any | null;
  in?: any[] | null;
  notIn?: any[] | null;
  lt?: any | null;
  lte?: any | null;
  gt?: any | null;
  gte?: any | null;
  not?: NestedDateTimeNullableFilter | null;
}

export interface DisburmentUpdate {
  id: number;
  data: DisbursementUpdateInput;
}

export interface DisbursementCreateInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  name: string;
  amount?: number | null;
  vatStatus: TaxLabelStatus;
  order: number;
  matter: MatterCreateNestedOneWithoutDisbursementsInput;
}

export interface DisbursementCreateManyMatterInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  name: string;
  amount?: number | null;
  vatStatus: TaxLabelStatus;
  order: number;
}

export interface DisbursementCreateManyMatterInputEnvelope {
  data: DisbursementCreateManyMatterInput[];
  skipDuplicates?: boolean | null;
}

export interface DisbursementCreateNestedManyWithoutMatterInput {
  create?: DisbursementCreateWithoutMatterInput[] | null;
  connectOrCreate?: DisbursementCreateOrConnectWithoutMatterInput[] | null;
  createMany?: DisbursementCreateManyMatterInputEnvelope | null;
  connect?: DisbursementWhereUniqueInput[] | null;
}

export interface DisbursementCreateOrConnectWithoutMatterInput {
  where: DisbursementWhereUniqueInput;
  create: DisbursementCreateWithoutMatterInput;
}

export interface DisbursementCreateWithoutMatterInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  name: string;
  amount?: number | null;
  vatStatus: TaxLabelStatus;
  order: number;
}

export interface DisbursementListRelationFilter {
  every?: DisbursementWhereInput | null;
  some?: DisbursementWhereInput | null;
  none?: DisbursementWhereInput | null;
}

export interface DisbursementScalarWhereInput {
  AND?: DisbursementScalarWhereInput[] | null;
  OR?: DisbursementScalarWhereInput[] | null;
  NOT?: DisbursementScalarWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  name?: StringFilter | null;
  amount?: FloatFilter | null;
  vatStatus?: EnumTaxLabelStatusFilter | null;
  matterId?: IntFilter | null;
  order?: IntFilter | null;
}

export interface DisbursementUpdateInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  amount?: FloatFieldUpdateOperationsInput | null;
  vatStatus?: EnumTaxLabelStatusFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  matter?: MatterUpdateOneRequiredWithoutDisbursementsNestedInput | null;
}

export interface DisbursementUpdateManyMutationInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  amount?: FloatFieldUpdateOperationsInput | null;
  vatStatus?: EnumTaxLabelStatusFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
}

export interface DisbursementUpdateManyWithWhereWithoutMatterInput {
  where: DisbursementScalarWhereInput;
  data: DisbursementUpdateManyMutationInput;
}

export interface DisbursementUpdateManyWithoutMatterNestedInput {
  create?: DisbursementCreateWithoutMatterInput[] | null;
  connectOrCreate?: DisbursementCreateOrConnectWithoutMatterInput[] | null;
  upsert?: DisbursementUpsertWithWhereUniqueWithoutMatterInput[] | null;
  createMany?: DisbursementCreateManyMatterInputEnvelope | null;
  set?: DisbursementWhereUniqueInput[] | null;
  disconnect?: DisbursementWhereUniqueInput[] | null;
  delete?: DisbursementWhereUniqueInput[] | null;
  connect?: DisbursementWhereUniqueInput[] | null;
  update?: DisbursementUpdateWithWhereUniqueWithoutMatterInput[] | null;
  updateMany?: DisbursementUpdateManyWithWhereWithoutMatterInput[] | null;
  deleteMany?: DisbursementScalarWhereInput[] | null;
}

export interface DisbursementUpdateWithWhereUniqueWithoutMatterInput {
  where: DisbursementWhereUniqueInput;
  data: DisbursementUpdateWithoutMatterInput;
}

export interface DisbursementUpdateWithoutMatterInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  amount?: FloatFieldUpdateOperationsInput | null;
  vatStatus?: EnumTaxLabelStatusFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
}

export interface DisbursementUpsertWithWhereUniqueWithoutMatterInput {
  where: DisbursementWhereUniqueInput;
  update: DisbursementUpdateWithoutMatterInput;
  create: DisbursementCreateWithoutMatterInput;
}

export interface DisbursementWhereInput {
  AND?: DisbursementWhereInput[] | null;
  OR?: DisbursementWhereInput[] | null;
  NOT?: DisbursementWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  name?: StringFilter | null;
  amount?: FloatFilter | null;
  vatStatus?: EnumTaxLabelStatusFilter | null;
  matterId?: IntFilter | null;
  order?: IntFilter | null;
  matter?: MatterRelationFilter | null;
}

export interface DisbursementWhereUniqueInput {
  id?: number | null;
}

export interface DiscountCreateInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  reason: string;
  amount: number;
  type: DiscountType;
  order: number;
  matter: MatterCreateNestedOneWithoutDiscountsInput;
}

export interface DiscountCreateManyMatterInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  reason: string;
  amount: number;
  type: DiscountType;
  order: number;
}

export interface DiscountCreateManyMatterInputEnvelope {
  data: DiscountCreateManyMatterInput[];
  skipDuplicates?: boolean | null;
}

export interface DiscountCreateNestedManyWithoutMatterInput {
  create?: DiscountCreateWithoutMatterInput[] | null;
  connectOrCreate?: DiscountCreateOrConnectWithoutMatterInput[] | null;
  createMany?: DiscountCreateManyMatterInputEnvelope | null;
  connect?: DiscountWhereUniqueInput[] | null;
}

export interface DiscountCreateOrConnectWithoutMatterInput {
  where: DiscountWhereUniqueInput;
  create: DiscountCreateWithoutMatterInput;
}

export interface DiscountCreateWithoutMatterInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  reason: string;
  amount: number;
  type: DiscountType;
  order: number;
}

export interface DiscountListRelationFilter {
  every?: DiscountWhereInput | null;
  some?: DiscountWhereInput | null;
  none?: DiscountWhereInput | null;
}

export interface DiscountScalarWhereInput {
  AND?: DiscountScalarWhereInput[] | null;
  OR?: DiscountScalarWhereInput[] | null;
  NOT?: DiscountScalarWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  reason?: StringFilter | null;
  amount?: FloatFilter | null;
  type?: EnumDiscountTypeFilter | null;
  matterId?: IntFilter | null;
  order?: IntFilter | null;
}

export interface DiscountUpdateInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  reason?: StringFieldUpdateOperationsInput | null;
  amount?: FloatFieldUpdateOperationsInput | null;
  type?: EnumDiscountTypeFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  matter?: MatterUpdateOneRequiredWithoutDiscountsNestedInput | null;
}

export interface DiscountUpdateManyMutationInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  reason?: StringFieldUpdateOperationsInput | null;
  amount?: FloatFieldUpdateOperationsInput | null;
  type?: EnumDiscountTypeFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
}

export interface DiscountUpdateManyWithWhereWithoutMatterInput {
  where: DiscountScalarWhereInput;
  data: DiscountUpdateManyMutationInput;
}

export interface DiscountUpdateManyWithoutMatterNestedInput {
  create?: DiscountCreateWithoutMatterInput[] | null;
  connectOrCreate?: DiscountCreateOrConnectWithoutMatterInput[] | null;
  upsert?: DiscountUpsertWithWhereUniqueWithoutMatterInput[] | null;
  createMany?: DiscountCreateManyMatterInputEnvelope | null;
  set?: DiscountWhereUniqueInput[] | null;
  disconnect?: DiscountWhereUniqueInput[] | null;
  delete?: DiscountWhereUniqueInput[] | null;
  connect?: DiscountWhereUniqueInput[] | null;
  update?: DiscountUpdateWithWhereUniqueWithoutMatterInput[] | null;
  updateMany?: DiscountUpdateManyWithWhereWithoutMatterInput[] | null;
  deleteMany?: DiscountScalarWhereInput[] | null;
}

export interface DiscountUpdateWithWhereUniqueWithoutMatterInput {
  where: DiscountWhereUniqueInput;
  data: DiscountUpdateWithoutMatterInput;
}

export interface DiscountUpdateWithoutMatterInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  reason?: StringFieldUpdateOperationsInput | null;
  amount?: FloatFieldUpdateOperationsInput | null;
  type?: EnumDiscountTypeFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
}

export interface DiscountUpsertWithWhereUniqueWithoutMatterInput {
  where: DiscountWhereUniqueInput;
  update: DiscountUpdateWithoutMatterInput;
  create: DiscountCreateWithoutMatterInput;
}

export interface DiscountWhereInput {
  AND?: DiscountWhereInput[] | null;
  OR?: DiscountWhereInput[] | null;
  NOT?: DiscountWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  reason?: StringFilter | null;
  amount?: FloatFilter | null;
  type?: EnumDiscountTypeFilter | null;
  matterId?: IntFilter | null;
  order?: IntFilter | null;
  matter?: MatterRelationFilter | null;
}

export interface DiscountWhereUniqueInput {
  id?: number | null;
}

export interface EnumCurrencyFieldUpdateOperationsInput {
  set?: Currency | null;
}

export interface EnumDiscountTypeFieldUpdateOperationsInput {
  set?: DiscountType | null;
}

export interface EnumDiscountTypeFilter {
  equals?: DiscountType | null;
  in?: DiscountType[] | null;
  notIn?: DiscountType[] | null;
  not?: NestedEnumDiscountTypeFilter | null;
}

export interface EnumExternalMatterStatusFieldUpdateOperationsInput {
  set?: ExternalMatterStatus | null;
}

export interface EnumExternalMatterStatusFilter {
  equals?: ExternalMatterStatus | null;
  in?: ExternalMatterStatus[] | null;
  notIn?: ExternalMatterStatus[] | null;
  not?: NestedEnumExternalMatterStatusFilter | null;
}

export interface EnumExternalMatterTaxStatusFieldUpdateOperationsInput {
  set?: ExternalMatterTaxStatus | null;
}

export interface EnumExternalMatterTaxStatusFilter {
  equals?: ExternalMatterTaxStatus | null;
  in?: ExternalMatterTaxStatus[] | null;
  notIn?: ExternalMatterTaxStatus[] | null;
  not?: NestedEnumExternalMatterTaxStatusFilter | null;
}

export interface EnumMatterStatusFieldUpdateOperationsInput {
  set?: MatterStatus | null;
}

export interface EnumMatterStatusFilter {
  equals?: MatterStatus | null;
  in?: MatterStatus[] | null;
  notIn?: MatterStatus[] | null;
  not?: NestedEnumMatterStatusFilter | null;
}

export interface EnumMatterTypeFieldUpdateOperationsInput {
  set?: MatterType | null;
}

export interface EnumMatterTypeFilter {
  equals?: MatterType | null;
  in?: MatterType[] | null;
  notIn?: MatterType[] | null;
  not?: NestedEnumMatterTypeFilter | null;
}

export interface EnumNotificationTypeFieldUpdateOperationsInput {
  set?: NotificationType | null;
}

export interface EnumNotificationTypeFilter {
  equals?: NotificationType | null;
  in?: NotificationType[] | null;
  notIn?: NotificationType[] | null;
  not?: NestedEnumNotificationTypeFilter | null;
}

export interface EnumPricingLevelFieldUpdateOperationsInput {
  set?: PricingLevel | null;
}

export interface EnumPricingLevelFilter {
  equals?: PricingLevel | null;
  in?: PricingLevel[] | null;
  notIn?: PricingLevel[] | null;
  not?: NestedEnumPricingLevelFilter | null;
}

export interface EnumPricingTypeFieldUpdateOperationsInput {
  set?: PricingType | null;
}

export interface EnumPricingTypeFilter {
  equals?: PricingType | null;
  in?: PricingType[] | null;
  notIn?: PricingType[] | null;
  not?: NestedEnumPricingTypeFilter | null;
}

export interface EnumTaxLabelFieldUpdateOperationsInput {
  set?: TaxLabel | null;
}

export interface EnumTaxLabelStatusFieldUpdateOperationsInput {
  set?: TaxLabelStatus | null;
}

export interface EnumTaxLabelStatusFilter {
  equals?: TaxLabelStatus | null;
  in?: TaxLabelStatus[] | null;
  notIn?: TaxLabelStatus[] | null;
  not?: NestedEnumTaxLabelStatusFilter | null;
}

export interface EnumTaxStatusFieldUpdateOperationsInput {
  set?: TaxStatus | null;
}

export interface EnumTaxStatusFilter {
  equals?: TaxStatus | null;
  in?: TaxStatus[] | null;
  notIn?: TaxStatus[] | null;
  not?: NestedEnumTaxStatusFilter | null;
}

export interface EnumTemplateTypeNullableFilter {
  equals?: TemplateType | null;
  in?: TemplateType[] | null;
  notIn?: TemplateType[] | null;
  not?: NestedEnumTemplateTypeNullableFilter | null;
}

export interface EnumUpliftTypeFieldUpdateOperationsInput {
  set?: UpliftType | null;
}

export interface EnumUpliftTypeFilter {
  equals?: UpliftType | null;
  in?: UpliftType[] | null;
  notIn?: UpliftType[] | null;
  not?: NestedEnumUpliftTypeFilter | null;
}

export interface ExclusionCreateInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  text: string;
  order: number;
  mandatory?: boolean | null;
  default?: boolean | null;
  matter: MatterCreateNestedOneWithoutExclusionsInput;
}

export interface ExclusionCreateManyMatterInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  text: string;
  order: number;
  mandatory?: boolean | null;
  default?: boolean | null;
}

export interface ExclusionCreateManyMatterInputEnvelope {
  data: ExclusionCreateManyMatterInput[];
  skipDuplicates?: boolean | null;
}

export interface ExclusionCreateNestedManyWithoutMatterInput {
  create?: ExclusionCreateWithoutMatterInput[] | null;
  connectOrCreate?: ExclusionCreateOrConnectWithoutMatterInput[] | null;
  createMany?: ExclusionCreateManyMatterInputEnvelope | null;
  connect?: ExclusionWhereUniqueInput[] | null;
}

export interface ExclusionCreateOrConnectWithoutMatterInput {
  where: ExclusionWhereUniqueInput;
  create: ExclusionCreateWithoutMatterInput;
}

export interface ExclusionCreateWithoutMatterInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  text: string;
  order: number;
  mandatory?: boolean | null;
  default?: boolean | null;
}

export interface ExclusionListRelationFilter {
  every?: ExclusionWhereInput | null;
  some?: ExclusionWhereInput | null;
  none?: ExclusionWhereInput | null;
}

export interface ExclusionScalarWhereInput {
  AND?: ExclusionScalarWhereInput[] | null;
  OR?: ExclusionScalarWhereInput[] | null;
  NOT?: ExclusionScalarWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  text?: StringFilter | null;
  matterId?: IntFilter | null;
  order?: IntFilter | null;
  mandatory?: BoolNullableFilter | null;
  default?: BoolNullableFilter | null;
}

export interface ExclusionUpdateInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  text?: StringFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  mandatory?: NullableBoolFieldUpdateOperationsInput | null;
  default?: NullableBoolFieldUpdateOperationsInput | null;
  matter?: MatterUpdateOneRequiredWithoutExclusionsNestedInput | null;
}

export interface ExclusionUpdateManyMutationInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  text?: StringFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  mandatory?: NullableBoolFieldUpdateOperationsInput | null;
  default?: NullableBoolFieldUpdateOperationsInput | null;
}

export interface ExclusionUpdateManyWithWhereWithoutMatterInput {
  where: ExclusionScalarWhereInput;
  data: ExclusionUpdateManyMutationInput;
}

export interface ExclusionUpdateManyWithoutMatterNestedInput {
  create?: ExclusionCreateWithoutMatterInput[] | null;
  connectOrCreate?: ExclusionCreateOrConnectWithoutMatterInput[] | null;
  upsert?: ExclusionUpsertWithWhereUniqueWithoutMatterInput[] | null;
  createMany?: ExclusionCreateManyMatterInputEnvelope | null;
  set?: ExclusionWhereUniqueInput[] | null;
  disconnect?: ExclusionWhereUniqueInput[] | null;
  delete?: ExclusionWhereUniqueInput[] | null;
  connect?: ExclusionWhereUniqueInput[] | null;
  update?: ExclusionUpdateWithWhereUniqueWithoutMatterInput[] | null;
  updateMany?: ExclusionUpdateManyWithWhereWithoutMatterInput[] | null;
  deleteMany?: ExclusionScalarWhereInput[] | null;
}

export interface ExclusionUpdateWithWhereUniqueWithoutMatterInput {
  where: ExclusionWhereUniqueInput;
  data: ExclusionUpdateWithoutMatterInput;
}

export interface ExclusionUpdateWithoutMatterInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  text?: StringFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  mandatory?: NullableBoolFieldUpdateOperationsInput | null;
  default?: NullableBoolFieldUpdateOperationsInput | null;
}

export interface ExclusionUpsertWithWhereUniqueWithoutMatterInput {
  where: ExclusionWhereUniqueInput;
  update: ExclusionUpdateWithoutMatterInput;
  create: ExclusionCreateWithoutMatterInput;
}

export interface ExclusionWhereInput {
  AND?: ExclusionWhereInput[] | null;
  OR?: ExclusionWhereInput[] | null;
  NOT?: ExclusionWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  text?: StringFilter | null;
  matterId?: IntFilter | null;
  order?: IntFilter | null;
  mandatory?: BoolNullableFilter | null;
  default?: BoolNullableFilter | null;
  matter?: MatterRelationFilter | null;
}

export interface ExclusionWhereUniqueInput {
  id?: number | null;
}

export interface ExternalMatterCreateManyClientInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  title: string;
  status: ExternalMatterStatus;
  organisationalUnitId?: number | null;
  leadFeeEarnerId?: number | null;
  taxStatus?: ExternalMatterTaxStatus | null;
}

export interface ExternalMatterCreateManyClientInputEnvelope {
  data: ExternalMatterCreateManyClientInput[];
  skipDuplicates?: boolean | null;
}

export interface ExternalMatterCreateManyFeeEarnerInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  title: string;
  status: ExternalMatterStatus;
  clientId?: number | null;
  organisationalUnitId?: number | null;
  taxStatus?: ExternalMatterTaxStatus | null;
}

export interface ExternalMatterCreateManyFeeEarnerInputEnvelope {
  data: ExternalMatterCreateManyFeeEarnerInput[];
  skipDuplicates?: boolean | null;
}

export interface ExternalMatterCreateManyOrganisationalUnitInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  title: string;
  status: ExternalMatterStatus;
  clientId?: number | null;
  leadFeeEarnerId?: number | null;
  taxStatus?: ExternalMatterTaxStatus | null;
}

export interface ExternalMatterCreateManyOrganisationalUnitInputEnvelope {
  data: ExternalMatterCreateManyOrganisationalUnitInput[];
  skipDuplicates?: boolean | null;
}

export interface ExternalMatterCreateNestedManyWithoutClientInput {
  create?: ExternalMatterCreateWithoutClientInput[] | null;
  connectOrCreate?: ExternalMatterCreateOrConnectWithoutClientInput[] | null;
  createMany?: ExternalMatterCreateManyClientInputEnvelope | null;
  connect?: ExternalMatterWhereUniqueInput[] | null;
}

export interface ExternalMatterCreateNestedManyWithoutFeeEarnerInput {
  create?: ExternalMatterCreateWithoutFeeEarnerInput[] | null;
  connectOrCreate?: ExternalMatterCreateOrConnectWithoutFeeEarnerInput[] | null;
  createMany?: ExternalMatterCreateManyFeeEarnerInputEnvelope | null;
  connect?: ExternalMatterWhereUniqueInput[] | null;
}

export interface ExternalMatterCreateNestedManyWithoutOrganisationalUnitInput {
  create?: ExternalMatterCreateWithoutOrganisationalUnitInput[] | null;
  connectOrCreate?: ExternalMatterCreateOrConnectWithoutOrganisationalUnitInput[] | null;
  createMany?: ExternalMatterCreateManyOrganisationalUnitInputEnvelope | null;
  connect?: ExternalMatterWhereUniqueInput[] | null;
}

export interface ExternalMatterCreateNestedOneWithoutMatterInput {
  create?: ExternalMatterCreateWithoutMatterInput | null;
  connectOrCreate?: ExternalMatterCreateOrConnectWithoutMatterInput | null;
  connect?: ExternalMatterWhereUniqueInput | null;
}

export interface ExternalMatterCreateNestedOneWithoutRatesInput {
  create?: ExternalMatterCreateWithoutRatesInput | null;
  connectOrCreate?: ExternalMatterCreateOrConnectWithoutRatesInput | null;
  connect?: ExternalMatterWhereUniqueInput | null;
}

export interface ExternalMatterCreateNestedOneWithoutTimeEntriesInput {
  create?: ExternalMatterCreateWithoutTimeEntriesInput | null;
  connectOrCreate?: ExternalMatterCreateOrConnectWithoutTimeEntriesInput | null;
  connect?: ExternalMatterWhereUniqueInput | null;
}

export interface ExternalMatterCreateOrConnectWithoutClientInput {
  where: ExternalMatterWhereUniqueInput;
  create: ExternalMatterCreateWithoutClientInput;
}

export interface ExternalMatterCreateOrConnectWithoutFeeEarnerInput {
  where: ExternalMatterWhereUniqueInput;
  create: ExternalMatterCreateWithoutFeeEarnerInput;
}

export interface ExternalMatterCreateOrConnectWithoutMatterInput {
  where: ExternalMatterWhereUniqueInput;
  create: ExternalMatterCreateWithoutMatterInput;
}

export interface ExternalMatterCreateOrConnectWithoutOrganisationalUnitInput {
  where: ExternalMatterWhereUniqueInput;
  create: ExternalMatterCreateWithoutOrganisationalUnitInput;
}

export interface ExternalMatterCreateOrConnectWithoutRatesInput {
  where: ExternalMatterWhereUniqueInput;
  create: ExternalMatterCreateWithoutRatesInput;
}

export interface ExternalMatterCreateOrConnectWithoutTimeEntriesInput {
  where: ExternalMatterWhereUniqueInput;
  create: ExternalMatterCreateWithoutTimeEntriesInput;
}

export interface ExternalMatterCreateWithoutClientInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  title: string;
  status: ExternalMatterStatus;
  taxStatus?: ExternalMatterTaxStatus | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutExternalMattersInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutExternalMattersInput | null;
  matter?: MatterCreateNestedOneWithoutExternalMatterInput | null;
  rates?: RateCreateNestedManyWithoutExternalMatterInput | null;
  timeEntries?: TimeEntryCreateNestedManyWithoutExternalMatterInput | null;
}

export interface ExternalMatterCreateWithoutFeeEarnerInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  title: string;
  status: ExternalMatterStatus;
  taxStatus?: ExternalMatterTaxStatus | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutExternalMattersInput | null;
  client?: ClientCreateNestedOneWithoutExternalMattersInput | null;
  matter?: MatterCreateNestedOneWithoutExternalMatterInput | null;
  rates?: RateCreateNestedManyWithoutExternalMatterInput | null;
  timeEntries?: TimeEntryCreateNestedManyWithoutExternalMatterInput | null;
}

export interface ExternalMatterCreateWithoutMatterInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  title: string;
  status: ExternalMatterStatus;
  taxStatus?: ExternalMatterTaxStatus | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutExternalMattersInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutExternalMattersInput | null;
  client?: ClientCreateNestedOneWithoutExternalMattersInput | null;
  rates?: RateCreateNestedManyWithoutExternalMatterInput | null;
  timeEntries?: TimeEntryCreateNestedManyWithoutExternalMatterInput | null;
}

export interface ExternalMatterCreateWithoutOrganisationalUnitInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  title: string;
  status: ExternalMatterStatus;
  taxStatus?: ExternalMatterTaxStatus | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutExternalMattersInput | null;
  client?: ClientCreateNestedOneWithoutExternalMattersInput | null;
  matter?: MatterCreateNestedOneWithoutExternalMatterInput | null;
  rates?: RateCreateNestedManyWithoutExternalMatterInput | null;
  timeEntries?: TimeEntryCreateNestedManyWithoutExternalMatterInput | null;
}

export interface ExternalMatterCreateWithoutRatesInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  title: string;
  status: ExternalMatterStatus;
  taxStatus?: ExternalMatterTaxStatus | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutExternalMattersInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutExternalMattersInput | null;
  client?: ClientCreateNestedOneWithoutExternalMattersInput | null;
  matter?: MatterCreateNestedOneWithoutExternalMatterInput | null;
  timeEntries?: TimeEntryCreateNestedManyWithoutExternalMatterInput | null;
}

export interface ExternalMatterCreateWithoutTimeEntriesInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  title: string;
  status: ExternalMatterStatus;
  taxStatus?: ExternalMatterTaxStatus | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutExternalMattersInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutExternalMattersInput | null;
  client?: ClientCreateNestedOneWithoutExternalMattersInput | null;
  matter?: MatterCreateNestedOneWithoutExternalMatterInput | null;
  rates?: RateCreateNestedManyWithoutExternalMatterInput | null;
}

export interface ExternalMatterListRelationFilter {
  every?: ExternalMatterWhereInput | null;
  some?: ExternalMatterWhereInput | null;
  none?: ExternalMatterWhereInput | null;
}

export interface ExternalMatterRelationFilter {
  is?: ExternalMatterWhereInput | null;
  isNot?: ExternalMatterWhereInput | null;
}

export interface ExternalMatterScalarWhereInput {
  AND?: ExternalMatterScalarWhereInput[] | null;
  OR?: ExternalMatterScalarWhereInput[] | null;
  NOT?: ExternalMatterScalarWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  externalId?: StringNullableFilter | null;
  externalReference?: StringNullableFilter | null;
  externalCreatedAt?: DateTimeNullableFilter | null;
  externalUpdatedAt?: DateTimeNullableFilter | null;
  externalDeletedAt?: DateTimeNullableFilter | null;
  title?: StringFilter | null;
  status?: EnumExternalMatterStatusFilter | null;
  clientId?: IntNullableFilter | null;
  organisationalUnitId?: IntNullableFilter | null;
  leadFeeEarnerId?: IntNullableFilter | null;
  taxStatus?: EnumExternalMatterTaxStatusFilter | null;
}

export interface ExternalMatterUpdateManyMutationInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  status?: EnumExternalMatterStatusFieldUpdateOperationsInput | null;
  taxStatus?: EnumExternalMatterTaxStatusFieldUpdateOperationsInput | null;
}

export interface ExternalMatterUpdateManyWithWhereWithoutClientInput {
  where: ExternalMatterScalarWhereInput;
  data: ExternalMatterUpdateManyMutationInput;
}

export interface ExternalMatterUpdateManyWithWhereWithoutFeeEarnerInput {
  where: ExternalMatterScalarWhereInput;
  data: ExternalMatterUpdateManyMutationInput;
}

export interface ExternalMatterUpdateManyWithWhereWithoutOrganisationalUnitInput {
  where: ExternalMatterScalarWhereInput;
  data: ExternalMatterUpdateManyMutationInput;
}

export interface ExternalMatterUpdateManyWithoutClientNestedInput {
  create?: ExternalMatterCreateWithoutClientInput[] | null;
  connectOrCreate?: ExternalMatterCreateOrConnectWithoutClientInput[] | null;
  upsert?: ExternalMatterUpsertWithWhereUniqueWithoutClientInput[] | null;
  createMany?: ExternalMatterCreateManyClientInputEnvelope | null;
  set?: ExternalMatterWhereUniqueInput[] | null;
  disconnect?: ExternalMatterWhereUniqueInput[] | null;
  delete?: ExternalMatterWhereUniqueInput[] | null;
  connect?: ExternalMatterWhereUniqueInput[] | null;
  update?: ExternalMatterUpdateWithWhereUniqueWithoutClientInput[] | null;
  updateMany?: ExternalMatterUpdateManyWithWhereWithoutClientInput[] | null;
  deleteMany?: ExternalMatterScalarWhereInput[] | null;
}

export interface ExternalMatterUpdateManyWithoutFeeEarnerNestedInput {
  create?: ExternalMatterCreateWithoutFeeEarnerInput[] | null;
  connectOrCreate?: ExternalMatterCreateOrConnectWithoutFeeEarnerInput[] | null;
  upsert?: ExternalMatterUpsertWithWhereUniqueWithoutFeeEarnerInput[] | null;
  createMany?: ExternalMatterCreateManyFeeEarnerInputEnvelope | null;
  set?: ExternalMatterWhereUniqueInput[] | null;
  disconnect?: ExternalMatterWhereUniqueInput[] | null;
  delete?: ExternalMatterWhereUniqueInput[] | null;
  connect?: ExternalMatterWhereUniqueInput[] | null;
  update?: ExternalMatterUpdateWithWhereUniqueWithoutFeeEarnerInput[] | null;
  updateMany?: ExternalMatterUpdateManyWithWhereWithoutFeeEarnerInput[] | null;
  deleteMany?: ExternalMatterScalarWhereInput[] | null;
}

export interface ExternalMatterUpdateManyWithoutOrganisationalUnitNestedInput {
  create?: ExternalMatterCreateWithoutOrganisationalUnitInput[] | null;
  connectOrCreate?: ExternalMatterCreateOrConnectWithoutOrganisationalUnitInput[] | null;
  upsert?: ExternalMatterUpsertWithWhereUniqueWithoutOrganisationalUnitInput[] | null;
  createMany?: ExternalMatterCreateManyOrganisationalUnitInputEnvelope | null;
  set?: ExternalMatterWhereUniqueInput[] | null;
  disconnect?: ExternalMatterWhereUniqueInput[] | null;
  delete?: ExternalMatterWhereUniqueInput[] | null;
  connect?: ExternalMatterWhereUniqueInput[] | null;
  update?: ExternalMatterUpdateWithWhereUniqueWithoutOrganisationalUnitInput[] | null;
  updateMany?: ExternalMatterUpdateManyWithWhereWithoutOrganisationalUnitInput[] | null;
  deleteMany?: ExternalMatterScalarWhereInput[] | null;
}

export interface ExternalMatterUpdateOneRequiredWithoutTimeEntriesNestedInput {
  create?: ExternalMatterCreateWithoutTimeEntriesInput | null;
  connectOrCreate?: ExternalMatterCreateOrConnectWithoutTimeEntriesInput | null;
  upsert?: ExternalMatterUpsertWithoutTimeEntriesInput | null;
  connect?: ExternalMatterWhereUniqueInput | null;
  update?: ExternalMatterUpdateWithoutTimeEntriesInput | null;
}

export interface ExternalMatterUpdateOneWithoutMatterNestedInput {
  create?: ExternalMatterCreateWithoutMatterInput | null;
  connectOrCreate?: ExternalMatterCreateOrConnectWithoutMatterInput | null;
  upsert?: ExternalMatterUpsertWithoutMatterInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: ExternalMatterWhereUniqueInput | null;
  update?: ExternalMatterUpdateWithoutMatterInput | null;
}

export interface ExternalMatterUpdateOneWithoutRatesNestedInput {
  create?: ExternalMatterCreateWithoutRatesInput | null;
  connectOrCreate?: ExternalMatterCreateOrConnectWithoutRatesInput | null;
  upsert?: ExternalMatterUpsertWithoutRatesInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: ExternalMatterWhereUniqueInput | null;
  update?: ExternalMatterUpdateWithoutRatesInput | null;
}

export interface ExternalMatterUpdateWithWhereUniqueWithoutClientInput {
  where: ExternalMatterWhereUniqueInput;
  data: ExternalMatterUpdateWithoutClientInput;
}

export interface ExternalMatterUpdateWithWhereUniqueWithoutFeeEarnerInput {
  where: ExternalMatterWhereUniqueInput;
  data: ExternalMatterUpdateWithoutFeeEarnerInput;
}

export interface ExternalMatterUpdateWithWhereUniqueWithoutOrganisationalUnitInput {
  where: ExternalMatterWhereUniqueInput;
  data: ExternalMatterUpdateWithoutOrganisationalUnitInput;
}

export interface ExternalMatterUpdateWithoutClientInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  status?: EnumExternalMatterStatusFieldUpdateOperationsInput | null;
  taxStatus?: EnumExternalMatterTaxStatusFieldUpdateOperationsInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutExternalMattersNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutExternalMattersNestedInput | null;
  matter?: MatterUpdateOneWithoutExternalMatterNestedInput | null;
  rates?: RateUpdateManyWithoutExternalMatterNestedInput | null;
  timeEntries?: TimeEntryUpdateManyWithoutExternalMatterNestedInput | null;
}

export interface ExternalMatterUpdateWithoutFeeEarnerInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  status?: EnumExternalMatterStatusFieldUpdateOperationsInput | null;
  taxStatus?: EnumExternalMatterTaxStatusFieldUpdateOperationsInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutExternalMattersNestedInput | null;
  client?: ClientUpdateOneWithoutExternalMattersNestedInput | null;
  matter?: MatterUpdateOneWithoutExternalMatterNestedInput | null;
  rates?: RateUpdateManyWithoutExternalMatterNestedInput | null;
  timeEntries?: TimeEntryUpdateManyWithoutExternalMatterNestedInput | null;
}

export interface ExternalMatterUpdateWithoutMatterInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  status?: EnumExternalMatterStatusFieldUpdateOperationsInput | null;
  taxStatus?: EnumExternalMatterTaxStatusFieldUpdateOperationsInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutExternalMattersNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutExternalMattersNestedInput | null;
  client?: ClientUpdateOneWithoutExternalMattersNestedInput | null;
  rates?: RateUpdateManyWithoutExternalMatterNestedInput | null;
  timeEntries?: TimeEntryUpdateManyWithoutExternalMatterNestedInput | null;
}

export interface ExternalMatterUpdateWithoutOrganisationalUnitInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  status?: EnumExternalMatterStatusFieldUpdateOperationsInput | null;
  taxStatus?: EnumExternalMatterTaxStatusFieldUpdateOperationsInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutExternalMattersNestedInput | null;
  client?: ClientUpdateOneWithoutExternalMattersNestedInput | null;
  matter?: MatterUpdateOneWithoutExternalMatterNestedInput | null;
  rates?: RateUpdateManyWithoutExternalMatterNestedInput | null;
  timeEntries?: TimeEntryUpdateManyWithoutExternalMatterNestedInput | null;
}

export interface ExternalMatterUpdateWithoutRatesInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  status?: EnumExternalMatterStatusFieldUpdateOperationsInput | null;
  taxStatus?: EnumExternalMatterTaxStatusFieldUpdateOperationsInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutExternalMattersNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutExternalMattersNestedInput | null;
  client?: ClientUpdateOneWithoutExternalMattersNestedInput | null;
  matter?: MatterUpdateOneWithoutExternalMatterNestedInput | null;
  timeEntries?: TimeEntryUpdateManyWithoutExternalMatterNestedInput | null;
}

export interface ExternalMatterUpdateWithoutTimeEntriesInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  status?: EnumExternalMatterStatusFieldUpdateOperationsInput | null;
  taxStatus?: EnumExternalMatterTaxStatusFieldUpdateOperationsInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutExternalMattersNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutExternalMattersNestedInput | null;
  client?: ClientUpdateOneWithoutExternalMattersNestedInput | null;
  matter?: MatterUpdateOneWithoutExternalMatterNestedInput | null;
  rates?: RateUpdateManyWithoutExternalMatterNestedInput | null;
}

export interface ExternalMatterUpsertWithWhereUniqueWithoutClientInput {
  where: ExternalMatterWhereUniqueInput;
  update: ExternalMatterUpdateWithoutClientInput;
  create: ExternalMatterCreateWithoutClientInput;
}

export interface ExternalMatterUpsertWithWhereUniqueWithoutFeeEarnerInput {
  where: ExternalMatterWhereUniqueInput;
  update: ExternalMatterUpdateWithoutFeeEarnerInput;
  create: ExternalMatterCreateWithoutFeeEarnerInput;
}

export interface ExternalMatterUpsertWithWhereUniqueWithoutOrganisationalUnitInput {
  where: ExternalMatterWhereUniqueInput;
  update: ExternalMatterUpdateWithoutOrganisationalUnitInput;
  create: ExternalMatterCreateWithoutOrganisationalUnitInput;
}

export interface ExternalMatterUpsertWithoutMatterInput {
  update: ExternalMatterUpdateWithoutMatterInput;
  create: ExternalMatterCreateWithoutMatterInput;
}

export interface ExternalMatterUpsertWithoutRatesInput {
  update: ExternalMatterUpdateWithoutRatesInput;
  create: ExternalMatterCreateWithoutRatesInput;
}

export interface ExternalMatterUpsertWithoutTimeEntriesInput {
  update: ExternalMatterUpdateWithoutTimeEntriesInput;
  create: ExternalMatterCreateWithoutTimeEntriesInput;
}

export interface ExternalMatterWhereInput {
  AND?: ExternalMatterWhereInput[] | null;
  OR?: ExternalMatterWhereInput[] | null;
  NOT?: ExternalMatterWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  externalId?: StringNullableFilter | null;
  externalReference?: StringNullableFilter | null;
  externalCreatedAt?: DateTimeNullableFilter | null;
  externalUpdatedAt?: DateTimeNullableFilter | null;
  externalDeletedAt?: DateTimeNullableFilter | null;
  title?: StringFilter | null;
  status?: EnumExternalMatterStatusFilter | null;
  clientId?: IntNullableFilter | null;
  organisationalUnitId?: IntNullableFilter | null;
  leadFeeEarnerId?: IntNullableFilter | null;
  taxStatus?: EnumExternalMatterTaxStatusFilter | null;
  organisationalUnit?: OrganisationalUnitRelationFilter | null;
  feeEarner?: FeeEarnerRelationFilter | null;
  client?: ClientRelationFilter | null;
  matter?: MatterRelationFilter | null;
  rates?: RateListRelationFilter | null;
  timeEntries?: TimeEntryListRelationFilter | null;
}

export interface ExternalMatterWhereUniqueInput {
  id?: number | null;
  externalId?: string | null;
}

export interface FeeEarnerCreateManyFeeEarnerLevelInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  name: string;
  organisationalUnitId?: number | null;
  officeLocationId?: number | null;
  costRate?: number | null;
}

export interface FeeEarnerCreateManyFeeEarnerLevelInputEnvelope {
  data: FeeEarnerCreateManyFeeEarnerLevelInput[];
  skipDuplicates?: boolean | null;
}

export interface FeeEarnerCreateManyOfficeLocationInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  name: string;
  organisationalUnitId?: number | null;
  feeEarnerLevelId?: number | null;
  costRate?: number | null;
}

export interface FeeEarnerCreateManyOfficeLocationInputEnvelope {
  data: FeeEarnerCreateManyOfficeLocationInput[];
  skipDuplicates?: boolean | null;
}

export interface FeeEarnerCreateManyOrganisationalUnitInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  name: string;
  officeLocationId?: number | null;
  feeEarnerLevelId?: number | null;
  costRate?: number | null;
}

export interface FeeEarnerCreateManyOrganisationalUnitInputEnvelope {
  data: FeeEarnerCreateManyOrganisationalUnitInput[];
  skipDuplicates?: boolean | null;
}

export interface FeeEarnerCreateNestedManyWithoutFeeEarnerLevelInput {
  create?: FeeEarnerCreateWithoutFeeEarnerLevelInput[] | null;
  connectOrCreate?: FeeEarnerCreateOrConnectWithoutFeeEarnerLevelInput[] | null;
  createMany?: FeeEarnerCreateManyFeeEarnerLevelInputEnvelope | null;
  connect?: FeeEarnerWhereUniqueInput[] | null;
}

export interface FeeEarnerCreateNestedManyWithoutOfficeLocationInput {
  create?: FeeEarnerCreateWithoutOfficeLocationInput[] | null;
  connectOrCreate?: FeeEarnerCreateOrConnectWithoutOfficeLocationInput[] | null;
  createMany?: FeeEarnerCreateManyOfficeLocationInputEnvelope | null;
  connect?: FeeEarnerWhereUniqueInput[] | null;
}

export interface FeeEarnerCreateNestedManyWithoutOrganisationalUnitInput {
  create?: FeeEarnerCreateWithoutOrganisationalUnitInput[] | null;
  connectOrCreate?: FeeEarnerCreateOrConnectWithoutOrganisationalUnitInput[] | null;
  createMany?: FeeEarnerCreateManyOrganisationalUnitInputEnvelope | null;
  connect?: FeeEarnerWhereUniqueInput[] | null;
}

export interface FeeEarnerCreateNestedOneWithoutExternalMattersInput {
  create?: FeeEarnerCreateWithoutExternalMattersInput | null;
  connectOrCreate?: FeeEarnerCreateOrConnectWithoutExternalMattersInput | null;
  connect?: FeeEarnerWhereUniqueInput | null;
}

export interface FeeEarnerCreateNestedOneWithoutMattersInput {
  create?: FeeEarnerCreateWithoutMattersInput | null;
  connectOrCreate?: FeeEarnerCreateOrConnectWithoutMattersInput | null;
  connect?: FeeEarnerWhereUniqueInput | null;
}

export interface FeeEarnerCreateNestedOneWithoutRatesInput {
  create?: FeeEarnerCreateWithoutRatesInput | null;
  connectOrCreate?: FeeEarnerCreateOrConnectWithoutRatesInput | null;
  connect?: FeeEarnerWhereUniqueInput | null;
}

export interface FeeEarnerCreateNestedOneWithoutTimeEntriesInput {
  create?: FeeEarnerCreateWithoutTimeEntriesInput | null;
  connectOrCreate?: FeeEarnerCreateOrConnectWithoutTimeEntriesInput | null;
  connect?: FeeEarnerWhereUniqueInput | null;
}

export interface FeeEarnerCreateNestedOneWithoutUsersInput {
  create?: FeeEarnerCreateWithoutUsersInput | null;
  connectOrCreate?: FeeEarnerCreateOrConnectWithoutUsersInput | null;
  connect?: FeeEarnerWhereUniqueInput | null;
}

export interface FeeEarnerCreateNestedOneWithoutWorkInput {
  create?: FeeEarnerCreateWithoutWorkInput | null;
  connectOrCreate?: FeeEarnerCreateOrConnectWithoutWorkInput | null;
  connect?: FeeEarnerWhereUniqueInput | null;
}

export interface FeeEarnerCreateOrConnectWithoutExternalMattersInput {
  where: FeeEarnerWhereUniqueInput;
  create: FeeEarnerCreateWithoutExternalMattersInput;
}

export interface FeeEarnerCreateOrConnectWithoutFeeEarnerLevelInput {
  where: FeeEarnerWhereUniqueInput;
  create: FeeEarnerCreateWithoutFeeEarnerLevelInput;
}

export interface FeeEarnerCreateOrConnectWithoutMattersInput {
  where: FeeEarnerWhereUniqueInput;
  create: FeeEarnerCreateWithoutMattersInput;
}

export interface FeeEarnerCreateOrConnectWithoutOfficeLocationInput {
  where: FeeEarnerWhereUniqueInput;
  create: FeeEarnerCreateWithoutOfficeLocationInput;
}

export interface FeeEarnerCreateOrConnectWithoutOrganisationalUnitInput {
  where: FeeEarnerWhereUniqueInput;
  create: FeeEarnerCreateWithoutOrganisationalUnitInput;
}

export interface FeeEarnerCreateOrConnectWithoutRatesInput {
  where: FeeEarnerWhereUniqueInput;
  create: FeeEarnerCreateWithoutRatesInput;
}

export interface FeeEarnerCreateOrConnectWithoutTimeEntriesInput {
  where: FeeEarnerWhereUniqueInput;
  create: FeeEarnerCreateWithoutTimeEntriesInput;
}

export interface FeeEarnerCreateOrConnectWithoutUsersInput {
  where: FeeEarnerWhereUniqueInput;
  create: FeeEarnerCreateWithoutUsersInput;
}

export interface FeeEarnerCreateOrConnectWithoutWorkInput {
  where: FeeEarnerWhereUniqueInput;
  create: FeeEarnerCreateWithoutWorkInput;
}

export interface FeeEarnerCreateWithoutExternalMattersInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  name: string;
  costRate?: number | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutFeeEarnersInput | null;
  officeLocation?: OfficeLocationCreateNestedOneWithoutFeeEarnersInput | null;
  feeEarnerLevel?: FeeEarnerLevelCreateNestedOneWithoutFeeEarnersInput | null;
  matters?: MatterCreateNestedManyWithoutFeeEarnerInput | null;
  rates?: RateCreateNestedManyWithoutFeeEarnerInput | null;
  timeEntries?: TimeEntryCreateNestedManyWithoutFeeEarnerInput | null;
  users?: UserCreateNestedOneWithoutFeeEarnerInput | null;
  work?: WorkCreateNestedManyWithoutFeeEarnerInput | null;
}

export interface FeeEarnerCreateWithoutFeeEarnerLevelInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  name: string;
  costRate?: number | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutFeeEarnersInput | null;
  officeLocation?: OfficeLocationCreateNestedOneWithoutFeeEarnersInput | null;
  externalMatters?: ExternalMatterCreateNestedManyWithoutFeeEarnerInput | null;
  matters?: MatterCreateNestedManyWithoutFeeEarnerInput | null;
  rates?: RateCreateNestedManyWithoutFeeEarnerInput | null;
  timeEntries?: TimeEntryCreateNestedManyWithoutFeeEarnerInput | null;
  users?: UserCreateNestedOneWithoutFeeEarnerInput | null;
  work?: WorkCreateNestedManyWithoutFeeEarnerInput | null;
}

export interface FeeEarnerCreateWithoutMattersInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  name: string;
  costRate?: number | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutFeeEarnersInput | null;
  officeLocation?: OfficeLocationCreateNestedOneWithoutFeeEarnersInput | null;
  feeEarnerLevel?: FeeEarnerLevelCreateNestedOneWithoutFeeEarnersInput | null;
  externalMatters?: ExternalMatterCreateNestedManyWithoutFeeEarnerInput | null;
  rates?: RateCreateNestedManyWithoutFeeEarnerInput | null;
  timeEntries?: TimeEntryCreateNestedManyWithoutFeeEarnerInput | null;
  users?: UserCreateNestedOneWithoutFeeEarnerInput | null;
  work?: WorkCreateNestedManyWithoutFeeEarnerInput | null;
}

export interface FeeEarnerCreateWithoutOfficeLocationInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  name: string;
  costRate?: number | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutFeeEarnersInput | null;
  feeEarnerLevel?: FeeEarnerLevelCreateNestedOneWithoutFeeEarnersInput | null;
  externalMatters?: ExternalMatterCreateNestedManyWithoutFeeEarnerInput | null;
  matters?: MatterCreateNestedManyWithoutFeeEarnerInput | null;
  rates?: RateCreateNestedManyWithoutFeeEarnerInput | null;
  timeEntries?: TimeEntryCreateNestedManyWithoutFeeEarnerInput | null;
  users?: UserCreateNestedOneWithoutFeeEarnerInput | null;
  work?: WorkCreateNestedManyWithoutFeeEarnerInput | null;
}

export interface FeeEarnerCreateWithoutOrganisationalUnitInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  name: string;
  costRate?: number | null;
  officeLocation?: OfficeLocationCreateNestedOneWithoutFeeEarnersInput | null;
  feeEarnerLevel?: FeeEarnerLevelCreateNestedOneWithoutFeeEarnersInput | null;
  externalMatters?: ExternalMatterCreateNestedManyWithoutFeeEarnerInput | null;
  matters?: MatterCreateNestedManyWithoutFeeEarnerInput | null;
  rates?: RateCreateNestedManyWithoutFeeEarnerInput | null;
  timeEntries?: TimeEntryCreateNestedManyWithoutFeeEarnerInput | null;
  users?: UserCreateNestedOneWithoutFeeEarnerInput | null;
  work?: WorkCreateNestedManyWithoutFeeEarnerInput | null;
}

export interface FeeEarnerCreateWithoutRatesInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  name: string;
  costRate?: number | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutFeeEarnersInput | null;
  officeLocation?: OfficeLocationCreateNestedOneWithoutFeeEarnersInput | null;
  feeEarnerLevel?: FeeEarnerLevelCreateNestedOneWithoutFeeEarnersInput | null;
  externalMatters?: ExternalMatterCreateNestedManyWithoutFeeEarnerInput | null;
  matters?: MatterCreateNestedManyWithoutFeeEarnerInput | null;
  timeEntries?: TimeEntryCreateNestedManyWithoutFeeEarnerInput | null;
  users?: UserCreateNestedOneWithoutFeeEarnerInput | null;
  work?: WorkCreateNestedManyWithoutFeeEarnerInput | null;
}

export interface FeeEarnerCreateWithoutTimeEntriesInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  name: string;
  costRate?: number | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutFeeEarnersInput | null;
  officeLocation?: OfficeLocationCreateNestedOneWithoutFeeEarnersInput | null;
  feeEarnerLevel?: FeeEarnerLevelCreateNestedOneWithoutFeeEarnersInput | null;
  externalMatters?: ExternalMatterCreateNestedManyWithoutFeeEarnerInput | null;
  matters?: MatterCreateNestedManyWithoutFeeEarnerInput | null;
  rates?: RateCreateNestedManyWithoutFeeEarnerInput | null;
  users?: UserCreateNestedOneWithoutFeeEarnerInput | null;
  work?: WorkCreateNestedManyWithoutFeeEarnerInput | null;
}

export interface FeeEarnerCreateWithoutUsersInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  name: string;
  costRate?: number | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutFeeEarnersInput | null;
  officeLocation?: OfficeLocationCreateNestedOneWithoutFeeEarnersInput | null;
  feeEarnerLevel?: FeeEarnerLevelCreateNestedOneWithoutFeeEarnersInput | null;
  externalMatters?: ExternalMatterCreateNestedManyWithoutFeeEarnerInput | null;
  matters?: MatterCreateNestedManyWithoutFeeEarnerInput | null;
  rates?: RateCreateNestedManyWithoutFeeEarnerInput | null;
  timeEntries?: TimeEntryCreateNestedManyWithoutFeeEarnerInput | null;
  work?: WorkCreateNestedManyWithoutFeeEarnerInput | null;
}

export interface FeeEarnerCreateWithoutWorkInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  name: string;
  costRate?: number | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutFeeEarnersInput | null;
  officeLocation?: OfficeLocationCreateNestedOneWithoutFeeEarnersInput | null;
  feeEarnerLevel?: FeeEarnerLevelCreateNestedOneWithoutFeeEarnersInput | null;
  externalMatters?: ExternalMatterCreateNestedManyWithoutFeeEarnerInput | null;
  matters?: MatterCreateNestedManyWithoutFeeEarnerInput | null;
  rates?: RateCreateNestedManyWithoutFeeEarnerInput | null;
  timeEntries?: TimeEntryCreateNestedManyWithoutFeeEarnerInput | null;
  users?: UserCreateNestedOneWithoutFeeEarnerInput | null;
}

export interface FeeEarnerLevelCreateNestedOneWithoutFeeEarnersInput {
  create?: FeeEarnerLevelCreateWithoutFeeEarnersInput | null;
  connectOrCreate?: FeeEarnerLevelCreateOrConnectWithoutFeeEarnersInput | null;
  connect?: FeeEarnerLevelWhereUniqueInput | null;
}

export interface FeeEarnerLevelCreateNestedOneWithoutNotifyNotificationRulesInput {
  create?: FeeEarnerLevelCreateWithoutNotifyNotificationRulesInput | null;
  connectOrCreate?: FeeEarnerLevelCreateOrConnectWithoutNotifyNotificationRulesInput | null;
  connect?: FeeEarnerLevelWhereUniqueInput | null;
}

export interface FeeEarnerLevelCreateNestedOneWithoutRatesInput {
  create?: FeeEarnerLevelCreateWithoutRatesInput | null;
  connectOrCreate?: FeeEarnerLevelCreateOrConnectWithoutRatesInput | null;
  connect?: FeeEarnerLevelWhereUniqueInput | null;
}

export interface FeeEarnerLevelCreateNestedOneWithoutTriggeredNotificationRulesInput {
  create?: FeeEarnerLevelCreateWithoutTriggeredNotificationRulesInput | null;
  connectOrCreate?: FeeEarnerLevelCreateOrConnectWithoutTriggeredNotificationRulesInput | null;
  connect?: FeeEarnerLevelWhereUniqueInput | null;
}

export interface FeeEarnerLevelCreateNestedOneWithoutWorkInput {
  create?: FeeEarnerLevelCreateWithoutWorkInput | null;
  connectOrCreate?: FeeEarnerLevelCreateOrConnectWithoutWorkInput | null;
  connect?: FeeEarnerLevelWhereUniqueInput | null;
}

export interface FeeEarnerLevelCreateOrConnectWithoutFeeEarnersInput {
  where: FeeEarnerLevelWhereUniqueInput;
  create: FeeEarnerLevelCreateWithoutFeeEarnersInput;
}

export interface FeeEarnerLevelCreateOrConnectWithoutNotifyNotificationRulesInput {
  where: FeeEarnerLevelWhereUniqueInput;
  create: FeeEarnerLevelCreateWithoutNotifyNotificationRulesInput;
}

export interface FeeEarnerLevelCreateOrConnectWithoutRatesInput {
  where: FeeEarnerLevelWhereUniqueInput;
  create: FeeEarnerLevelCreateWithoutRatesInput;
}

export interface FeeEarnerLevelCreateOrConnectWithoutTriggeredNotificationRulesInput {
  where: FeeEarnerLevelWhereUniqueInput;
  create: FeeEarnerLevelCreateWithoutTriggeredNotificationRulesInput;
}

export interface FeeEarnerLevelCreateOrConnectWithoutWorkInput {
  where: FeeEarnerLevelWhereUniqueInput;
  create: FeeEarnerLevelCreateWithoutWorkInput;
}

export interface FeeEarnerLevelCreateWithoutFeeEarnersInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  description: string;
  order: number;
  rates?: RateCreateNestedManyWithoutFeeEarnerLevelInput | null;
  work?: WorkCreateNestedManyWithoutFeeEarnerLevelInput | null;
  triggeredNotificationRules?: NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutFeeEarnerLevelInput | null;
  notifyNotificationRules?: NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutFeeEarnerLevelInput | null;
}

export interface FeeEarnerLevelCreateWithoutNotifyNotificationRulesInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  description: string;
  order: number;
  feeEarners?: FeeEarnerCreateNestedManyWithoutFeeEarnerLevelInput | null;
  rates?: RateCreateNestedManyWithoutFeeEarnerLevelInput | null;
  work?: WorkCreateNestedManyWithoutFeeEarnerLevelInput | null;
  triggeredNotificationRules?: NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutFeeEarnerLevelInput | null;
}

export interface FeeEarnerLevelCreateWithoutRatesInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  description: string;
  order: number;
  feeEarners?: FeeEarnerCreateNestedManyWithoutFeeEarnerLevelInput | null;
  work?: WorkCreateNestedManyWithoutFeeEarnerLevelInput | null;
  triggeredNotificationRules?: NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutFeeEarnerLevelInput | null;
  notifyNotificationRules?: NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutFeeEarnerLevelInput | null;
}

export interface FeeEarnerLevelCreateWithoutTriggeredNotificationRulesInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  description: string;
  order: number;
  feeEarners?: FeeEarnerCreateNestedManyWithoutFeeEarnerLevelInput | null;
  rates?: RateCreateNestedManyWithoutFeeEarnerLevelInput | null;
  work?: WorkCreateNestedManyWithoutFeeEarnerLevelInput | null;
  notifyNotificationRules?: NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutFeeEarnerLevelInput | null;
}

export interface FeeEarnerLevelCreateWithoutWorkInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  description: string;
  order: number;
  feeEarners?: FeeEarnerCreateNestedManyWithoutFeeEarnerLevelInput | null;
  rates?: RateCreateNestedManyWithoutFeeEarnerLevelInput | null;
  triggeredNotificationRules?: NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutFeeEarnerLevelInput | null;
  notifyNotificationRules?: NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutFeeEarnerLevelInput | null;
}

export interface FeeEarnerLevelRelationFilter {
  is?: FeeEarnerLevelWhereInput | null;
  isNot?: FeeEarnerLevelWhereInput | null;
}

export interface FeeEarnerLevelUpdateInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  feeEarners?: FeeEarnerUpdateManyWithoutFeeEarnerLevelNestedInput | null;
  rates?: RateUpdateManyWithoutFeeEarnerLevelNestedInput | null;
  work?: WorkUpdateManyWithoutFeeEarnerLevelNestedInput | null;
  triggeredNotificationRules?: NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutFeeEarnerLevelNestedInput | null;
  notifyNotificationRules?: NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutFeeEarnerLevelNestedInput | null;
}

export interface FeeEarnerLevelUpdateOneRequiredWithoutNotifyNotificationRulesNestedInput {
  create?: FeeEarnerLevelCreateWithoutNotifyNotificationRulesInput | null;
  connectOrCreate?: FeeEarnerLevelCreateOrConnectWithoutNotifyNotificationRulesInput | null;
  upsert?: FeeEarnerLevelUpsertWithoutNotifyNotificationRulesInput | null;
  connect?: FeeEarnerLevelWhereUniqueInput | null;
  update?: FeeEarnerLevelUpdateWithoutNotifyNotificationRulesInput | null;
}

export interface FeeEarnerLevelUpdateOneRequiredWithoutTriggeredNotificationRulesNestedInput {
  create?: FeeEarnerLevelCreateWithoutTriggeredNotificationRulesInput | null;
  connectOrCreate?: FeeEarnerLevelCreateOrConnectWithoutTriggeredNotificationRulesInput | null;
  upsert?: FeeEarnerLevelUpsertWithoutTriggeredNotificationRulesInput | null;
  connect?: FeeEarnerLevelWhereUniqueInput | null;
  update?: FeeEarnerLevelUpdateWithoutTriggeredNotificationRulesInput | null;
}

export interface FeeEarnerLevelUpdateOneWithoutFeeEarnersNestedInput {
  create?: FeeEarnerLevelCreateWithoutFeeEarnersInput | null;
  connectOrCreate?: FeeEarnerLevelCreateOrConnectWithoutFeeEarnersInput | null;
  upsert?: FeeEarnerLevelUpsertWithoutFeeEarnersInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: FeeEarnerLevelWhereUniqueInput | null;
  update?: FeeEarnerLevelUpdateWithoutFeeEarnersInput | null;
}

export interface FeeEarnerLevelUpdateOneWithoutRatesNestedInput {
  create?: FeeEarnerLevelCreateWithoutRatesInput | null;
  connectOrCreate?: FeeEarnerLevelCreateOrConnectWithoutRatesInput | null;
  upsert?: FeeEarnerLevelUpsertWithoutRatesInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: FeeEarnerLevelWhereUniqueInput | null;
  update?: FeeEarnerLevelUpdateWithoutRatesInput | null;
}

export interface FeeEarnerLevelUpdateOneWithoutWorkNestedInput {
  create?: FeeEarnerLevelCreateWithoutWorkInput | null;
  connectOrCreate?: FeeEarnerLevelCreateOrConnectWithoutWorkInput | null;
  upsert?: FeeEarnerLevelUpsertWithoutWorkInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: FeeEarnerLevelWhereUniqueInput | null;
  update?: FeeEarnerLevelUpdateWithoutWorkInput | null;
}

export interface FeeEarnerLevelUpdateWithoutFeeEarnersInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  rates?: RateUpdateManyWithoutFeeEarnerLevelNestedInput | null;
  work?: WorkUpdateManyWithoutFeeEarnerLevelNestedInput | null;
  triggeredNotificationRules?: NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutFeeEarnerLevelNestedInput | null;
  notifyNotificationRules?: NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutFeeEarnerLevelNestedInput | null;
}

export interface FeeEarnerLevelUpdateWithoutNotifyNotificationRulesInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  feeEarners?: FeeEarnerUpdateManyWithoutFeeEarnerLevelNestedInput | null;
  rates?: RateUpdateManyWithoutFeeEarnerLevelNestedInput | null;
  work?: WorkUpdateManyWithoutFeeEarnerLevelNestedInput | null;
  triggeredNotificationRules?: NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutFeeEarnerLevelNestedInput | null;
}

export interface FeeEarnerLevelUpdateWithoutRatesInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  feeEarners?: FeeEarnerUpdateManyWithoutFeeEarnerLevelNestedInput | null;
  work?: WorkUpdateManyWithoutFeeEarnerLevelNestedInput | null;
  triggeredNotificationRules?: NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutFeeEarnerLevelNestedInput | null;
  notifyNotificationRules?: NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutFeeEarnerLevelNestedInput | null;
}

export interface FeeEarnerLevelUpdateWithoutTriggeredNotificationRulesInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  feeEarners?: FeeEarnerUpdateManyWithoutFeeEarnerLevelNestedInput | null;
  rates?: RateUpdateManyWithoutFeeEarnerLevelNestedInput | null;
  work?: WorkUpdateManyWithoutFeeEarnerLevelNestedInput | null;
  notifyNotificationRules?: NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutFeeEarnerLevelNestedInput | null;
}

export interface FeeEarnerLevelUpdateWithoutWorkInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  feeEarners?: FeeEarnerUpdateManyWithoutFeeEarnerLevelNestedInput | null;
  rates?: RateUpdateManyWithoutFeeEarnerLevelNestedInput | null;
  triggeredNotificationRules?: NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutFeeEarnerLevelNestedInput | null;
  notifyNotificationRules?: NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutFeeEarnerLevelNestedInput | null;
}

export interface FeeEarnerLevelUpsertWithoutFeeEarnersInput {
  update: FeeEarnerLevelUpdateWithoutFeeEarnersInput;
  create: FeeEarnerLevelCreateWithoutFeeEarnersInput;
}

export interface FeeEarnerLevelUpsertWithoutNotifyNotificationRulesInput {
  update: FeeEarnerLevelUpdateWithoutNotifyNotificationRulesInput;
  create: FeeEarnerLevelCreateWithoutNotifyNotificationRulesInput;
}

export interface FeeEarnerLevelUpsertWithoutRatesInput {
  update: FeeEarnerLevelUpdateWithoutRatesInput;
  create: FeeEarnerLevelCreateWithoutRatesInput;
}

export interface FeeEarnerLevelUpsertWithoutTriggeredNotificationRulesInput {
  update: FeeEarnerLevelUpdateWithoutTriggeredNotificationRulesInput;
  create: FeeEarnerLevelCreateWithoutTriggeredNotificationRulesInput;
}

export interface FeeEarnerLevelUpsertWithoutWorkInput {
  update: FeeEarnerLevelUpdateWithoutWorkInput;
  create: FeeEarnerLevelCreateWithoutWorkInput;
}

export interface FeeEarnerLevelWhereInput {
  AND?: FeeEarnerLevelWhereInput[] | null;
  OR?: FeeEarnerLevelWhereInput[] | null;
  NOT?: FeeEarnerLevelWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  externalId?: StringNullableFilter | null;
  externalReference?: StringNullableFilter | null;
  externalCreatedAt?: DateTimeNullableFilter | null;
  externalUpdatedAt?: DateTimeNullableFilter | null;
  externalDeletedAt?: DateTimeNullableFilter | null;
  description?: StringFilter | null;
  order?: IntFilter | null;
  feeEarners?: FeeEarnerListRelationFilter | null;
  rates?: RateListRelationFilter | null;
  work?: WorkListRelationFilter | null;
  triggeredNotificationRules?: NotificationRuleFeeEarnerLevelTriggerListRelationFilter | null;
  notifyNotificationRules?: NotificationRuleFeeEarnerLevelNotifyListRelationFilter | null;
}

export interface FeeEarnerLevelWhereUniqueInput {
  id?: number | null;
  externalId?: string | null;
  description?: string | null;
}

export interface FeeEarnerListRelationFilter {
  every?: FeeEarnerWhereInput | null;
  some?: FeeEarnerWhereInput | null;
  none?: FeeEarnerWhereInput | null;
}

export interface FeeEarnerRelationFilter {
  is?: FeeEarnerWhereInput | null;
  isNot?: FeeEarnerWhereInput | null;
}

export interface FeeEarnerScalarWhereInput {
  AND?: FeeEarnerScalarWhereInput[] | null;
  OR?: FeeEarnerScalarWhereInput[] | null;
  NOT?: FeeEarnerScalarWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  externalId?: StringNullableFilter | null;
  externalReference?: StringNullableFilter | null;
  externalCreatedAt?: DateTimeNullableFilter | null;
  externalUpdatedAt?: DateTimeNullableFilter | null;
  externalDeletedAt?: DateTimeNullableFilter | null;
  name?: StringFilter | null;
  organisationalUnitId?: IntNullableFilter | null;
  officeLocationId?: IntNullableFilter | null;
  feeEarnerLevelId?: IntNullableFilter | null;
  costRate?: FloatNullableFilter | null;
}

export interface FeeEarnerUpdateManyMutationInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  costRate?: NullableFloatFieldUpdateOperationsInput | null;
}

export interface FeeEarnerUpdateManyWithWhereWithoutFeeEarnerLevelInput {
  where: FeeEarnerScalarWhereInput;
  data: FeeEarnerUpdateManyMutationInput;
}

export interface FeeEarnerUpdateManyWithWhereWithoutOfficeLocationInput {
  where: FeeEarnerScalarWhereInput;
  data: FeeEarnerUpdateManyMutationInput;
}

export interface FeeEarnerUpdateManyWithWhereWithoutOrganisationalUnitInput {
  where: FeeEarnerScalarWhereInput;
  data: FeeEarnerUpdateManyMutationInput;
}

export interface FeeEarnerUpdateManyWithoutFeeEarnerLevelNestedInput {
  create?: FeeEarnerCreateWithoutFeeEarnerLevelInput[] | null;
  connectOrCreate?: FeeEarnerCreateOrConnectWithoutFeeEarnerLevelInput[] | null;
  upsert?: FeeEarnerUpsertWithWhereUniqueWithoutFeeEarnerLevelInput[] | null;
  createMany?: FeeEarnerCreateManyFeeEarnerLevelInputEnvelope | null;
  set?: FeeEarnerWhereUniqueInput[] | null;
  disconnect?: FeeEarnerWhereUniqueInput[] | null;
  delete?: FeeEarnerWhereUniqueInput[] | null;
  connect?: FeeEarnerWhereUniqueInput[] | null;
  update?: FeeEarnerUpdateWithWhereUniqueWithoutFeeEarnerLevelInput[] | null;
  updateMany?: FeeEarnerUpdateManyWithWhereWithoutFeeEarnerLevelInput[] | null;
  deleteMany?: FeeEarnerScalarWhereInput[] | null;
}

export interface FeeEarnerUpdateManyWithoutOfficeLocationNestedInput {
  create?: FeeEarnerCreateWithoutOfficeLocationInput[] | null;
  connectOrCreate?: FeeEarnerCreateOrConnectWithoutOfficeLocationInput[] | null;
  upsert?: FeeEarnerUpsertWithWhereUniqueWithoutOfficeLocationInput[] | null;
  createMany?: FeeEarnerCreateManyOfficeLocationInputEnvelope | null;
  set?: FeeEarnerWhereUniqueInput[] | null;
  disconnect?: FeeEarnerWhereUniqueInput[] | null;
  delete?: FeeEarnerWhereUniqueInput[] | null;
  connect?: FeeEarnerWhereUniqueInput[] | null;
  update?: FeeEarnerUpdateWithWhereUniqueWithoutOfficeLocationInput[] | null;
  updateMany?: FeeEarnerUpdateManyWithWhereWithoutOfficeLocationInput[] | null;
  deleteMany?: FeeEarnerScalarWhereInput[] | null;
}

export interface FeeEarnerUpdateManyWithoutOrganisationalUnitNestedInput {
  create?: FeeEarnerCreateWithoutOrganisationalUnitInput[] | null;
  connectOrCreate?: FeeEarnerCreateOrConnectWithoutOrganisationalUnitInput[] | null;
  upsert?: FeeEarnerUpsertWithWhereUniqueWithoutOrganisationalUnitInput[] | null;
  createMany?: FeeEarnerCreateManyOrganisationalUnitInputEnvelope | null;
  set?: FeeEarnerWhereUniqueInput[] | null;
  disconnect?: FeeEarnerWhereUniqueInput[] | null;
  delete?: FeeEarnerWhereUniqueInput[] | null;
  connect?: FeeEarnerWhereUniqueInput[] | null;
  update?: FeeEarnerUpdateWithWhereUniqueWithoutOrganisationalUnitInput[] | null;
  updateMany?: FeeEarnerUpdateManyWithWhereWithoutOrganisationalUnitInput[] | null;
  deleteMany?: FeeEarnerScalarWhereInput[] | null;
}

export interface FeeEarnerUpdateOneRequiredWithoutTimeEntriesNestedInput {
  create?: FeeEarnerCreateWithoutTimeEntriesInput | null;
  connectOrCreate?: FeeEarnerCreateOrConnectWithoutTimeEntriesInput | null;
  upsert?: FeeEarnerUpsertWithoutTimeEntriesInput | null;
  connect?: FeeEarnerWhereUniqueInput | null;
  update?: FeeEarnerUpdateWithoutTimeEntriesInput | null;
}

export interface FeeEarnerUpdateOneWithoutExternalMattersNestedInput {
  create?: FeeEarnerCreateWithoutExternalMattersInput | null;
  connectOrCreate?: FeeEarnerCreateOrConnectWithoutExternalMattersInput | null;
  upsert?: FeeEarnerUpsertWithoutExternalMattersInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: FeeEarnerWhereUniqueInput | null;
  update?: FeeEarnerUpdateWithoutExternalMattersInput | null;
}

export interface FeeEarnerUpdateOneWithoutMattersNestedInput {
  create?: FeeEarnerCreateWithoutMattersInput | null;
  connectOrCreate?: FeeEarnerCreateOrConnectWithoutMattersInput | null;
  upsert?: FeeEarnerUpsertWithoutMattersInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: FeeEarnerWhereUniqueInput | null;
  update?: FeeEarnerUpdateWithoutMattersInput | null;
}

export interface FeeEarnerUpdateOneWithoutRatesNestedInput {
  create?: FeeEarnerCreateWithoutRatesInput | null;
  connectOrCreate?: FeeEarnerCreateOrConnectWithoutRatesInput | null;
  upsert?: FeeEarnerUpsertWithoutRatesInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: FeeEarnerWhereUniqueInput | null;
  update?: FeeEarnerUpdateWithoutRatesInput | null;
}

export interface FeeEarnerUpdateOneWithoutUsersNestedInput {
  create?: FeeEarnerCreateWithoutUsersInput | null;
  connectOrCreate?: FeeEarnerCreateOrConnectWithoutUsersInput | null;
  upsert?: FeeEarnerUpsertWithoutUsersInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: FeeEarnerWhereUniqueInput | null;
  update?: FeeEarnerUpdateWithoutUsersInput | null;
}

export interface FeeEarnerUpdateOneWithoutWorkNestedInput {
  create?: FeeEarnerCreateWithoutWorkInput | null;
  connectOrCreate?: FeeEarnerCreateOrConnectWithoutWorkInput | null;
  upsert?: FeeEarnerUpsertWithoutWorkInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: FeeEarnerWhereUniqueInput | null;
  update?: FeeEarnerUpdateWithoutWorkInput | null;
}

export interface FeeEarnerUpdateWithWhereUniqueWithoutFeeEarnerLevelInput {
  where: FeeEarnerWhereUniqueInput;
  data: FeeEarnerUpdateWithoutFeeEarnerLevelInput;
}

export interface FeeEarnerUpdateWithWhereUniqueWithoutOfficeLocationInput {
  where: FeeEarnerWhereUniqueInput;
  data: FeeEarnerUpdateWithoutOfficeLocationInput;
}

export interface FeeEarnerUpdateWithWhereUniqueWithoutOrganisationalUnitInput {
  where: FeeEarnerWhereUniqueInput;
  data: FeeEarnerUpdateWithoutOrganisationalUnitInput;
}

export interface FeeEarnerUpdateWithoutExternalMattersInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  costRate?: NullableFloatFieldUpdateOperationsInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutFeeEarnersNestedInput | null;
  officeLocation?: OfficeLocationUpdateOneWithoutFeeEarnersNestedInput | null;
  feeEarnerLevel?: FeeEarnerLevelUpdateOneWithoutFeeEarnersNestedInput | null;
  matters?: MatterUpdateManyWithoutFeeEarnerNestedInput | null;
  rates?: RateUpdateManyWithoutFeeEarnerNestedInput | null;
  timeEntries?: TimeEntryUpdateManyWithoutFeeEarnerNestedInput | null;
  users?: UserUpdateOneWithoutFeeEarnerNestedInput | null;
  work?: WorkUpdateManyWithoutFeeEarnerNestedInput | null;
}

export interface FeeEarnerUpdateWithoutFeeEarnerLevelInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  costRate?: NullableFloatFieldUpdateOperationsInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutFeeEarnersNestedInput | null;
  officeLocation?: OfficeLocationUpdateOneWithoutFeeEarnersNestedInput | null;
  externalMatters?: ExternalMatterUpdateManyWithoutFeeEarnerNestedInput | null;
  matters?: MatterUpdateManyWithoutFeeEarnerNestedInput | null;
  rates?: RateUpdateManyWithoutFeeEarnerNestedInput | null;
  timeEntries?: TimeEntryUpdateManyWithoutFeeEarnerNestedInput | null;
  users?: UserUpdateOneWithoutFeeEarnerNestedInput | null;
  work?: WorkUpdateManyWithoutFeeEarnerNestedInput | null;
}

export interface FeeEarnerUpdateWithoutMattersInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  costRate?: NullableFloatFieldUpdateOperationsInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutFeeEarnersNestedInput | null;
  officeLocation?: OfficeLocationUpdateOneWithoutFeeEarnersNestedInput | null;
  feeEarnerLevel?: FeeEarnerLevelUpdateOneWithoutFeeEarnersNestedInput | null;
  externalMatters?: ExternalMatterUpdateManyWithoutFeeEarnerNestedInput | null;
  rates?: RateUpdateManyWithoutFeeEarnerNestedInput | null;
  timeEntries?: TimeEntryUpdateManyWithoutFeeEarnerNestedInput | null;
  users?: UserUpdateOneWithoutFeeEarnerNestedInput | null;
  work?: WorkUpdateManyWithoutFeeEarnerNestedInput | null;
}

export interface FeeEarnerUpdateWithoutOfficeLocationInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  costRate?: NullableFloatFieldUpdateOperationsInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutFeeEarnersNestedInput | null;
  feeEarnerLevel?: FeeEarnerLevelUpdateOneWithoutFeeEarnersNestedInput | null;
  externalMatters?: ExternalMatterUpdateManyWithoutFeeEarnerNestedInput | null;
  matters?: MatterUpdateManyWithoutFeeEarnerNestedInput | null;
  rates?: RateUpdateManyWithoutFeeEarnerNestedInput | null;
  timeEntries?: TimeEntryUpdateManyWithoutFeeEarnerNestedInput | null;
  users?: UserUpdateOneWithoutFeeEarnerNestedInput | null;
  work?: WorkUpdateManyWithoutFeeEarnerNestedInput | null;
}

export interface FeeEarnerUpdateWithoutOrganisationalUnitInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  costRate?: NullableFloatFieldUpdateOperationsInput | null;
  officeLocation?: OfficeLocationUpdateOneWithoutFeeEarnersNestedInput | null;
  feeEarnerLevel?: FeeEarnerLevelUpdateOneWithoutFeeEarnersNestedInput | null;
  externalMatters?: ExternalMatterUpdateManyWithoutFeeEarnerNestedInput | null;
  matters?: MatterUpdateManyWithoutFeeEarnerNestedInput | null;
  rates?: RateUpdateManyWithoutFeeEarnerNestedInput | null;
  timeEntries?: TimeEntryUpdateManyWithoutFeeEarnerNestedInput | null;
  users?: UserUpdateOneWithoutFeeEarnerNestedInput | null;
  work?: WorkUpdateManyWithoutFeeEarnerNestedInput | null;
}

export interface FeeEarnerUpdateWithoutRatesInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  costRate?: NullableFloatFieldUpdateOperationsInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutFeeEarnersNestedInput | null;
  officeLocation?: OfficeLocationUpdateOneWithoutFeeEarnersNestedInput | null;
  feeEarnerLevel?: FeeEarnerLevelUpdateOneWithoutFeeEarnersNestedInput | null;
  externalMatters?: ExternalMatterUpdateManyWithoutFeeEarnerNestedInput | null;
  matters?: MatterUpdateManyWithoutFeeEarnerNestedInput | null;
  timeEntries?: TimeEntryUpdateManyWithoutFeeEarnerNestedInput | null;
  users?: UserUpdateOneWithoutFeeEarnerNestedInput | null;
  work?: WorkUpdateManyWithoutFeeEarnerNestedInput | null;
}

export interface FeeEarnerUpdateWithoutTimeEntriesInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  costRate?: NullableFloatFieldUpdateOperationsInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutFeeEarnersNestedInput | null;
  officeLocation?: OfficeLocationUpdateOneWithoutFeeEarnersNestedInput | null;
  feeEarnerLevel?: FeeEarnerLevelUpdateOneWithoutFeeEarnersNestedInput | null;
  externalMatters?: ExternalMatterUpdateManyWithoutFeeEarnerNestedInput | null;
  matters?: MatterUpdateManyWithoutFeeEarnerNestedInput | null;
  rates?: RateUpdateManyWithoutFeeEarnerNestedInput | null;
  users?: UserUpdateOneWithoutFeeEarnerNestedInput | null;
  work?: WorkUpdateManyWithoutFeeEarnerNestedInput | null;
}

export interface FeeEarnerUpdateWithoutUsersInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  costRate?: NullableFloatFieldUpdateOperationsInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutFeeEarnersNestedInput | null;
  officeLocation?: OfficeLocationUpdateOneWithoutFeeEarnersNestedInput | null;
  feeEarnerLevel?: FeeEarnerLevelUpdateOneWithoutFeeEarnersNestedInput | null;
  externalMatters?: ExternalMatterUpdateManyWithoutFeeEarnerNestedInput | null;
  matters?: MatterUpdateManyWithoutFeeEarnerNestedInput | null;
  rates?: RateUpdateManyWithoutFeeEarnerNestedInput | null;
  timeEntries?: TimeEntryUpdateManyWithoutFeeEarnerNestedInput | null;
  work?: WorkUpdateManyWithoutFeeEarnerNestedInput | null;
}

export interface FeeEarnerUpdateWithoutWorkInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  costRate?: NullableFloatFieldUpdateOperationsInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutFeeEarnersNestedInput | null;
  officeLocation?: OfficeLocationUpdateOneWithoutFeeEarnersNestedInput | null;
  feeEarnerLevel?: FeeEarnerLevelUpdateOneWithoutFeeEarnersNestedInput | null;
  externalMatters?: ExternalMatterUpdateManyWithoutFeeEarnerNestedInput | null;
  matters?: MatterUpdateManyWithoutFeeEarnerNestedInput | null;
  rates?: RateUpdateManyWithoutFeeEarnerNestedInput | null;
  timeEntries?: TimeEntryUpdateManyWithoutFeeEarnerNestedInput | null;
  users?: UserUpdateOneWithoutFeeEarnerNestedInput | null;
}

export interface FeeEarnerUpsertWithWhereUniqueWithoutFeeEarnerLevelInput {
  where: FeeEarnerWhereUniqueInput;
  update: FeeEarnerUpdateWithoutFeeEarnerLevelInput;
  create: FeeEarnerCreateWithoutFeeEarnerLevelInput;
}

export interface FeeEarnerUpsertWithWhereUniqueWithoutOfficeLocationInput {
  where: FeeEarnerWhereUniqueInput;
  update: FeeEarnerUpdateWithoutOfficeLocationInput;
  create: FeeEarnerCreateWithoutOfficeLocationInput;
}

export interface FeeEarnerUpsertWithWhereUniqueWithoutOrganisationalUnitInput {
  where: FeeEarnerWhereUniqueInput;
  update: FeeEarnerUpdateWithoutOrganisationalUnitInput;
  create: FeeEarnerCreateWithoutOrganisationalUnitInput;
}

export interface FeeEarnerUpsertWithoutExternalMattersInput {
  update: FeeEarnerUpdateWithoutExternalMattersInput;
  create: FeeEarnerCreateWithoutExternalMattersInput;
}

export interface FeeEarnerUpsertWithoutMattersInput {
  update: FeeEarnerUpdateWithoutMattersInput;
  create: FeeEarnerCreateWithoutMattersInput;
}

export interface FeeEarnerUpsertWithoutRatesInput {
  update: FeeEarnerUpdateWithoutRatesInput;
  create: FeeEarnerCreateWithoutRatesInput;
}

export interface FeeEarnerUpsertWithoutTimeEntriesInput {
  update: FeeEarnerUpdateWithoutTimeEntriesInput;
  create: FeeEarnerCreateWithoutTimeEntriesInput;
}

export interface FeeEarnerUpsertWithoutUsersInput {
  update: FeeEarnerUpdateWithoutUsersInput;
  create: FeeEarnerCreateWithoutUsersInput;
}

export interface FeeEarnerUpsertWithoutWorkInput {
  update: FeeEarnerUpdateWithoutWorkInput;
  create: FeeEarnerCreateWithoutWorkInput;
}

export interface FeeEarnerWhereInput {
  AND?: FeeEarnerWhereInput[] | null;
  OR?: FeeEarnerWhereInput[] | null;
  NOT?: FeeEarnerWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  externalId?: StringNullableFilter | null;
  externalReference?: StringNullableFilter | null;
  externalCreatedAt?: DateTimeNullableFilter | null;
  externalUpdatedAt?: DateTimeNullableFilter | null;
  externalDeletedAt?: DateTimeNullableFilter | null;
  name?: StringFilter | null;
  organisationalUnitId?: IntNullableFilter | null;
  officeLocationId?: IntNullableFilter | null;
  feeEarnerLevelId?: IntNullableFilter | null;
  costRate?: FloatNullableFilter | null;
  organisationalUnit?: OrganisationalUnitRelationFilter | null;
  officeLocation?: OfficeLocationRelationFilter | null;
  feeEarnerLevel?: FeeEarnerLevelRelationFilter | null;
  externalMatters?: ExternalMatterListRelationFilter | null;
  matters?: MatterListRelationFilter | null;
  rates?: RateListRelationFilter | null;
  timeEntries?: TimeEntryListRelationFilter | null;
  users?: UserRelationFilter | null;
  work?: WorkListRelationFilter | null;
}

export interface FeeEarnerWhereUniqueInput {
  id?: number | null;
  externalId?: string | null;
}

export interface FilterArg {
  search?: string | null;
}

export interface FilteredExternalMattersInput {
  filter: ExternalMatterWhereInput;
  offset?: number | null;
  limit?: number | null;
}

export interface FilteredMattersInput {
  filter: MatterWhereInput;
  offset?: number | null;
  limit?: number | null;
  orderBy?: FilteredMattersInputOrderBy[] | null;
}

export interface FilteredMattersInputOrderBy {
  updatedAt?: any | null;
  client?: FilteredMattersInputOrderByClient | null;
  createdBy?: FilteredMattersInputOrderByCreatedBy | null;
}

export interface FilteredMattersInputOrderByClient {
  name?: any | null;
}

export interface FilteredMattersInputOrderByCreatedBy {
  displayName?: any | null;
}

export interface FloatFieldUpdateOperationsInput {
  set?: number | null;
  increment?: number | null;
  decrement?: number | null;
  multiply?: number | null;
  divide?: number | null;
}

export interface FloatFilter {
  equals?: number | null;
  in?: number[] | null;
  notIn?: number[] | null;
  lt?: number | null;
  lte?: number | null;
  gt?: number | null;
  gte?: number | null;
  not?: NestedFloatFilter | null;
}

export interface FloatNullableFilter {
  equals?: number | null;
  in?: number[] | null;
  notIn?: number[] | null;
  lt?: number | null;
  lte?: number | null;
  gt?: number | null;
  gte?: number | null;
  not?: NestedFloatNullableFilter | null;
}

export interface IntFieldUpdateOperationsInput {
  set?: number | null;
  increment?: number | null;
  decrement?: number | null;
  multiply?: number | null;
  divide?: number | null;
}

export interface IntFilter {
  equals?: number | null;
  in?: number[] | null;
  notIn?: number[] | null;
  lt?: number | null;
  lte?: number | null;
  gt?: number | null;
  gte?: number | null;
  not?: NestedIntFilter | null;
}

export interface IntNullableFilter {
  equals?: number | null;
  in?: number[] | null;
  notIn?: number[] | null;
  lt?: number | null;
  lte?: number | null;
  gt?: number | null;
  gte?: number | null;
  not?: NestedIntNullableFilter | null;
}

export interface LibraryAssumptionCreateInput {
  text: string;
  mandatory?: boolean | null;
  default?: boolean | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  organisationalUnits?: OrganisationalUnitCreateNestedManyWithoutLibraryAssumptionsInput | null;
}

export interface LibraryAssumptionCreateNestedManyWithoutOrganisationalUnitsInput {
  create?: LibraryAssumptionCreateWithoutOrganisationalUnitsInput[] | null;
  connectOrCreate?: LibraryAssumptionCreateOrConnectWithoutOrganisationalUnitsInput[] | null;
  connect?: LibraryAssumptionWhereUniqueInput[] | null;
}

export interface LibraryAssumptionCreateOrConnectWithoutOrganisationalUnitsInput {
  where: LibraryAssumptionWhereUniqueInput;
  create: LibraryAssumptionCreateWithoutOrganisationalUnitsInput;
}

export interface LibraryAssumptionCreateWithoutOrganisationalUnitsInput {
  text: string;
  mandatory?: boolean | null;
  default?: boolean | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
}

export interface LibraryAssumptionListRelationFilter {
  every?: LibraryAssumptionWhereInput | null;
  some?: LibraryAssumptionWhereInput | null;
  none?: LibraryAssumptionWhereInput | null;
}

export interface LibraryAssumptionScalarWhereInput {
  AND?: LibraryAssumptionScalarWhereInput[] | null;
  OR?: LibraryAssumptionScalarWhereInput[] | null;
  NOT?: LibraryAssumptionScalarWhereInput[] | null;
  id?: IntFilter | null;
  text?: StringFilter | null;
  mandatory?: BoolNullableFilter | null;
  default?: BoolNullableFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
}

export interface LibraryAssumptionUpdate {
  id: number;
  default?: boolean | null;
  mandatory?: boolean | null;
  delete?: boolean | null;
  organisationalUnitIds?: number[] | null;
  firmWide?: boolean | null;
  text: string;
}

export interface LibraryAssumptionUpdateManyMutationInput {
  text?: StringFieldUpdateOperationsInput | null;
  mandatory?: NullableBoolFieldUpdateOperationsInput | null;
  default?: NullableBoolFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
}

export interface LibraryAssumptionUpdateManyWithWhereWithoutOrganisationalUnitsInput {
  where: LibraryAssumptionScalarWhereInput;
  data: LibraryAssumptionUpdateManyMutationInput;
}

export interface LibraryAssumptionUpdateManyWithoutOrganisationalUnitsNestedInput {
  create?: LibraryAssumptionCreateWithoutOrganisationalUnitsInput[] | null;
  connectOrCreate?: LibraryAssumptionCreateOrConnectWithoutOrganisationalUnitsInput[] | null;
  upsert?: LibraryAssumptionUpsertWithWhereUniqueWithoutOrganisationalUnitsInput[] | null;
  set?: LibraryAssumptionWhereUniqueInput[] | null;
  disconnect?: LibraryAssumptionWhereUniqueInput[] | null;
  delete?: LibraryAssumptionWhereUniqueInput[] | null;
  connect?: LibraryAssumptionWhereUniqueInput[] | null;
  update?: LibraryAssumptionUpdateWithWhereUniqueWithoutOrganisationalUnitsInput[] | null;
  updateMany?: LibraryAssumptionUpdateManyWithWhereWithoutOrganisationalUnitsInput[] | null;
  deleteMany?: LibraryAssumptionScalarWhereInput[] | null;
}

export interface LibraryAssumptionUpdateWithWhereUniqueWithoutOrganisationalUnitsInput {
  where: LibraryAssumptionWhereUniqueInput;
  data: LibraryAssumptionUpdateWithoutOrganisationalUnitsInput;
}

export interface LibraryAssumptionUpdateWithoutOrganisationalUnitsInput {
  text?: StringFieldUpdateOperationsInput | null;
  mandatory?: NullableBoolFieldUpdateOperationsInput | null;
  default?: NullableBoolFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
}

export interface LibraryAssumptionUpsertWithWhereUniqueWithoutOrganisationalUnitsInput {
  where: LibraryAssumptionWhereUniqueInput;
  update: LibraryAssumptionUpdateWithoutOrganisationalUnitsInput;
  create: LibraryAssumptionCreateWithoutOrganisationalUnitsInput;
}

export interface LibraryAssumptionWhereInput {
  AND?: LibraryAssumptionWhereInput[] | null;
  OR?: LibraryAssumptionWhereInput[] | null;
  NOT?: LibraryAssumptionWhereInput[] | null;
  id?: IntFilter | null;
  text?: StringFilter | null;
  mandatory?: BoolNullableFilter | null;
  default?: BoolNullableFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  organisationalUnits?: OrganisationalUnitListRelationFilter | null;
}

export interface LibraryAssumptionWhereUniqueInput {
  id?: number | null;
}

export interface LibraryDisbursementCreate {
  name: string;
  amount: number;
  vatStatus: string;
}

export interface LibraryDisbursementUpdate {
  id: number;
  name?: string | null;
  amount?: number | null;
  vatStatus?: string | null;
}

export interface LibraryDisbursementWhereInput {
  AND?: LibraryDisbursementWhereInput[] | null;
  OR?: LibraryDisbursementWhereInput[] | null;
  NOT?: LibraryDisbursementWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  name?: StringFilter | null;
  amount?: FloatFilter | null;
  vatStatus?: EnumTaxLabelStatusFilter | null;
}

export interface LibraryExclusionCreateInput {
  text: string;
  mandatory?: boolean | null;
  default?: boolean | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  organisationalUnits?: OrganisationalUnitCreateNestedManyWithoutLibraryExclusionsInput | null;
}

export interface LibraryExclusionCreateNestedManyWithoutOrganisationalUnitsInput {
  create?: LibraryExclusionCreateWithoutOrganisationalUnitsInput[] | null;
  connectOrCreate?: LibraryExclusionCreateOrConnectWithoutOrganisationalUnitsInput[] | null;
  connect?: LibraryExclusionWhereUniqueInput[] | null;
}

export interface LibraryExclusionCreateOrConnectWithoutOrganisationalUnitsInput {
  where: LibraryExclusionWhereUniqueInput;
  create: LibraryExclusionCreateWithoutOrganisationalUnitsInput;
}

export interface LibraryExclusionCreateWithoutOrganisationalUnitsInput {
  text: string;
  mandatory?: boolean | null;
  default?: boolean | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
}

export interface LibraryExclusionListRelationFilter {
  every?: LibraryExclusionWhereInput | null;
  some?: LibraryExclusionWhereInput | null;
  none?: LibraryExclusionWhereInput | null;
}

export interface LibraryExclusionScalarWhereInput {
  AND?: LibraryExclusionScalarWhereInput[] | null;
  OR?: LibraryExclusionScalarWhereInput[] | null;
  NOT?: LibraryExclusionScalarWhereInput[] | null;
  id?: IntFilter | null;
  text?: StringFilter | null;
  mandatory?: BoolNullableFilter | null;
  default?: BoolNullableFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
}

export interface LibraryExclusionUpdate {
  id: number;
  default?: boolean | null;
  mandatory?: boolean | null;
  delete?: boolean | null;
  organisationalUnitIds?: number[] | null;
  firmWide?: boolean | null;
  text: string;
}

export interface LibraryExclusionUpdateManyMutationInput {
  text?: StringFieldUpdateOperationsInput | null;
  mandatory?: NullableBoolFieldUpdateOperationsInput | null;
  default?: NullableBoolFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
}

export interface LibraryExclusionUpdateManyWithWhereWithoutOrganisationalUnitsInput {
  where: LibraryExclusionScalarWhereInput;
  data: LibraryExclusionUpdateManyMutationInput;
}

export interface LibraryExclusionUpdateManyWithoutOrganisationalUnitsNestedInput {
  create?: LibraryExclusionCreateWithoutOrganisationalUnitsInput[] | null;
  connectOrCreate?: LibraryExclusionCreateOrConnectWithoutOrganisationalUnitsInput[] | null;
  upsert?: LibraryExclusionUpsertWithWhereUniqueWithoutOrganisationalUnitsInput[] | null;
  set?: LibraryExclusionWhereUniqueInput[] | null;
  disconnect?: LibraryExclusionWhereUniqueInput[] | null;
  delete?: LibraryExclusionWhereUniqueInput[] | null;
  connect?: LibraryExclusionWhereUniqueInput[] | null;
  update?: LibraryExclusionUpdateWithWhereUniqueWithoutOrganisationalUnitsInput[] | null;
  updateMany?: LibraryExclusionUpdateManyWithWhereWithoutOrganisationalUnitsInput[] | null;
  deleteMany?: LibraryExclusionScalarWhereInput[] | null;
}

export interface LibraryExclusionUpdateWithWhereUniqueWithoutOrganisationalUnitsInput {
  where: LibraryExclusionWhereUniqueInput;
  data: LibraryExclusionUpdateWithoutOrganisationalUnitsInput;
}

export interface LibraryExclusionUpdateWithoutOrganisationalUnitsInput {
  text?: StringFieldUpdateOperationsInput | null;
  mandatory?: NullableBoolFieldUpdateOperationsInput | null;
  default?: NullableBoolFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
}

export interface LibraryExclusionUpsertWithWhereUniqueWithoutOrganisationalUnitsInput {
  where: LibraryExclusionWhereUniqueInput;
  update: LibraryExclusionUpdateWithoutOrganisationalUnitsInput;
  create: LibraryExclusionCreateWithoutOrganisationalUnitsInput;
}

export interface LibraryExclusionWhereInput {
  AND?: LibraryExclusionWhereInput[] | null;
  OR?: LibraryExclusionWhereInput[] | null;
  NOT?: LibraryExclusionWhereInput[] | null;
  id?: IntFilter | null;
  text?: StringFilter | null;
  mandatory?: BoolNullableFilter | null;
  default?: BoolNullableFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  organisationalUnits?: OrganisationalUnitListRelationFilter | null;
}

export interface LibraryExclusionWhereUniqueInput {
  id?: number | null;
}

export interface LibraryUpliftCreateNestedOneWithoutUpliftsInput {
  create?: LibraryUpliftCreateWithoutUpliftsInput | null;
  connectOrCreate?: LibraryUpliftCreateOrConnectWithoutUpliftsInput | null;
  connect?: LibraryUpliftWhereUniqueInput | null;
}

export interface LibraryUpliftCreateOrConnectWithoutUpliftsInput {
  where: LibraryUpliftWhereUniqueInput;
  create: LibraryUpliftCreateWithoutUpliftsInput;
}

export interface LibraryUpliftCreateWithoutUpliftsInput {
  reason: string;
  group: string;
}

export interface LibraryUpliftRelationFilter {
  is?: LibraryUpliftWhereInput | null;
  isNot?: LibraryUpliftWhereInput | null;
}

export interface LibraryUpliftUpdateOneWithoutUpliftsNestedInput {
  create?: LibraryUpliftCreateWithoutUpliftsInput | null;
  connectOrCreate?: LibraryUpliftCreateOrConnectWithoutUpliftsInput | null;
  upsert?: LibraryUpliftUpsertWithoutUpliftsInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: LibraryUpliftWhereUniqueInput | null;
  update?: LibraryUpliftUpdateWithoutUpliftsInput | null;
}

export interface LibraryUpliftUpdateWithoutUpliftsInput {
  reason?: StringFieldUpdateOperationsInput | null;
  group?: StringFieldUpdateOperationsInput | null;
}

export interface LibraryUpliftUpsertWithoutUpliftsInput {
  update: LibraryUpliftUpdateWithoutUpliftsInput;
  create: LibraryUpliftCreateWithoutUpliftsInput;
}

export interface LibraryUpliftWhereInput {
  AND?: LibraryUpliftWhereInput[] | null;
  OR?: LibraryUpliftWhereInput[] | null;
  NOT?: LibraryUpliftWhereInput[] | null;
  id?: IntFilter | null;
  reason?: StringFilter | null;
  group?: StringFilter | null;
  uplifts?: UpliftListRelationFilter | null;
}

export interface LibraryUpliftWhereUniqueInput {
  id?: number | null;
}

export interface MatterCreateInput {
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  template?: boolean | null;
  templateType?: TemplateType | null;
  title: string;
  externalReference?: string | null;
  status?: MatterStatus | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  agreedPrice?: number | null;
  feeCharged?: number | null;
  taxStatus?: TaxStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  createFromTemplateId?: number | null;
  templateGpmThreshold?: number | null;
  matterType?: MatterType | null;
  order?: number | null;
  agreedPriceRange?: PriceRangeCreateNestedOneWithoutMattersInput | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutMattersInput | null;
  externalMatter?: ExternalMatterCreateNestedOneWithoutMatterInput | null;
  brand?: BrandCreateNestedOneWithoutMattersInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutMattersInput | null;
  client?: ClientCreateNestedOneWithoutMattersInput | null;
  assumptions?: AssumptionCreateNestedManyWithoutMatterInput | null;
  collaborators?: CollaboratorCreateNestedManyWithoutMatterInput | null;
  disbursements?: DisbursementCreateNestedManyWithoutMatterInput | null;
  discounts?: DiscountCreateNestedManyWithoutMatterInput | null;
  exclusions?: ExclusionCreateNestedManyWithoutMatterInput | null;
  notifications?: NotificationCreateNestedManyWithoutMatterInput | null;
  phases?: PhaseCreateNestedManyWithoutMatterInput | null;
  uplifts?: UpliftCreateNestedManyWithoutMatterInput | null;
  priceOptions?: PriceOptionsCreateNestedOneWithoutMatterInput | null;
  parent?: ParentMatterCreateNestedOneWithoutMattersInput | null;
}

export interface MatterCreateManyBrandInput {
  id?: number | null;
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  template?: boolean | null;
  templateType?: TemplateType | null;
  title: string;
  externalMatterId?: number | null;
  organisationalUnitId?: number | null;
  leadFeeEarnerId?: number | null;
  clientId?: number | null;
  externalReference?: string | null;
  status?: MatterStatus | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  agreedPrice?: number | null;
  feeCharged?: number | null;
  taxStatus?: TaxStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  createdById: number;
  priceOptionsId?: number | null;
  priceRangeId?: number | null;
  createFromTemplateId?: number | null;
  templateGpmThreshold?: number | null;
  matterType?: MatterType | null;
  parentMatterId?: number | null;
  order?: number | null;
}

export interface MatterCreateManyBrandInputEnvelope {
  data: MatterCreateManyBrandInput[];
  skipDuplicates?: boolean | null;
}

export interface MatterCreateManyClientInput {
  id?: number | null;
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  template?: boolean | null;
  templateType?: TemplateType | null;
  title: string;
  externalMatterId?: number | null;
  organisationalUnitId?: number | null;
  leadFeeEarnerId?: number | null;
  externalReference?: string | null;
  status?: MatterStatus | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  agreedPrice?: number | null;
  feeCharged?: number | null;
  taxStatus?: TaxStatus | null;
  brandId?: number | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  createdById: number;
  priceOptionsId?: number | null;
  priceRangeId?: number | null;
  createFromTemplateId?: number | null;
  templateGpmThreshold?: number | null;
  matterType?: MatterType | null;
  parentMatterId?: number | null;
  order?: number | null;
}

export interface MatterCreateManyClientInputEnvelope {
  data: MatterCreateManyClientInput[];
  skipDuplicates?: boolean | null;
}

export interface MatterCreateManyCreatedByInput {
  id?: number | null;
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  template?: boolean | null;
  templateType?: TemplateType | null;
  title: string;
  externalMatterId?: number | null;
  organisationalUnitId?: number | null;
  leadFeeEarnerId?: number | null;
  clientId?: number | null;
  externalReference?: string | null;
  status?: MatterStatus | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  agreedPrice?: number | null;
  feeCharged?: number | null;
  taxStatus?: TaxStatus | null;
  brandId?: number | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  priceOptionsId?: number | null;
  priceRangeId?: number | null;
  createFromTemplateId?: number | null;
  templateGpmThreshold?: number | null;
  matterType?: MatterType | null;
  parentMatterId?: number | null;
  order?: number | null;
}

export interface MatterCreateManyCreatedByInputEnvelope {
  data: MatterCreateManyCreatedByInput[];
  skipDuplicates?: boolean | null;
}

export interface MatterCreateManyFeeEarnerInput {
  id?: number | null;
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  template?: boolean | null;
  templateType?: TemplateType | null;
  title: string;
  externalMatterId?: number | null;
  organisationalUnitId?: number | null;
  clientId?: number | null;
  externalReference?: string | null;
  status?: MatterStatus | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  agreedPrice?: number | null;
  feeCharged?: number | null;
  taxStatus?: TaxStatus | null;
  brandId?: number | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  createdById: number;
  priceOptionsId?: number | null;
  priceRangeId?: number | null;
  createFromTemplateId?: number | null;
  templateGpmThreshold?: number | null;
  matterType?: MatterType | null;
  parentMatterId?: number | null;
  order?: number | null;
}

export interface MatterCreateManyFeeEarnerInputEnvelope {
  data: MatterCreateManyFeeEarnerInput[];
  skipDuplicates?: boolean | null;
}

export interface MatterCreateManyOrganisationalUnitInput {
  id?: number | null;
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  template?: boolean | null;
  templateType?: TemplateType | null;
  title: string;
  externalMatterId?: number | null;
  leadFeeEarnerId?: number | null;
  clientId?: number | null;
  externalReference?: string | null;
  status?: MatterStatus | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  agreedPrice?: number | null;
  feeCharged?: number | null;
  taxStatus?: TaxStatus | null;
  brandId?: number | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  createdById: number;
  priceOptionsId?: number | null;
  priceRangeId?: number | null;
  createFromTemplateId?: number | null;
  templateGpmThreshold?: number | null;
  matterType?: MatterType | null;
  parentMatterId?: number | null;
  order?: number | null;
}

export interface MatterCreateManyOrganisationalUnitInputEnvelope {
  data: MatterCreateManyOrganisationalUnitInput[];
  skipDuplicates?: boolean | null;
}

export interface MatterCreateManyParentInput {
  id?: number | null;
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  template?: boolean | null;
  templateType?: TemplateType | null;
  title: string;
  externalMatterId?: number | null;
  organisationalUnitId?: number | null;
  leadFeeEarnerId?: number | null;
  clientId?: number | null;
  externalReference?: string | null;
  status?: MatterStatus | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  agreedPrice?: number | null;
  feeCharged?: number | null;
  taxStatus?: TaxStatus | null;
  brandId?: number | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  createdById: number;
  priceOptionsId?: number | null;
  priceRangeId?: number | null;
  createFromTemplateId?: number | null;
  templateGpmThreshold?: number | null;
  matterType?: MatterType | null;
  order?: number | null;
}

export interface MatterCreateManyParentInputEnvelope {
  data: MatterCreateManyParentInput[];
  skipDuplicates?: boolean | null;
}

export interface MatterCreateNestedManyWithoutBrandInput {
  create?: MatterCreateWithoutBrandInput[] | null;
  connectOrCreate?: MatterCreateOrConnectWithoutBrandInput[] | null;
  createMany?: MatterCreateManyBrandInputEnvelope | null;
  connect?: MatterWhereUniqueInput[] | null;
}

export interface MatterCreateNestedManyWithoutClientInput {
  create?: MatterCreateWithoutClientInput[] | null;
  connectOrCreate?: MatterCreateOrConnectWithoutClientInput[] | null;
  createMany?: MatterCreateManyClientInputEnvelope | null;
  connect?: MatterWhereUniqueInput[] | null;
}

export interface MatterCreateNestedManyWithoutCreatedByInput {
  create?: MatterCreateWithoutCreatedByInput[] | null;
  connectOrCreate?: MatterCreateOrConnectWithoutCreatedByInput[] | null;
  createMany?: MatterCreateManyCreatedByInputEnvelope | null;
  connect?: MatterWhereUniqueInput[] | null;
}

export interface MatterCreateNestedManyWithoutFeeEarnerInput {
  create?: MatterCreateWithoutFeeEarnerInput[] | null;
  connectOrCreate?: MatterCreateOrConnectWithoutFeeEarnerInput[] | null;
  createMany?: MatterCreateManyFeeEarnerInputEnvelope | null;
  connect?: MatterWhereUniqueInput[] | null;
}

export interface MatterCreateNestedManyWithoutOrganisationalUnitInput {
  create?: MatterCreateWithoutOrganisationalUnitInput[] | null;
  connectOrCreate?: MatterCreateOrConnectWithoutOrganisationalUnitInput[] | null;
  createMany?: MatterCreateManyOrganisationalUnitInputEnvelope | null;
  connect?: MatterWhereUniqueInput[] | null;
}

export interface MatterCreateNestedManyWithoutParentInput {
  create?: MatterCreateWithoutParentInput[] | null;
  connectOrCreate?: MatterCreateOrConnectWithoutParentInput[] | null;
  createMany?: MatterCreateManyParentInputEnvelope | null;
  connect?: MatterWhereUniqueInput[] | null;
}

export interface MatterCreateNestedOneWithoutAssumptionsInput {
  create?: MatterCreateWithoutAssumptionsInput | null;
  connectOrCreate?: MatterCreateOrConnectWithoutAssumptionsInput | null;
  connect?: MatterWhereUniqueInput | null;
}

export interface MatterCreateNestedOneWithoutCollaboratorsInput {
  create?: MatterCreateWithoutCollaboratorsInput | null;
  connectOrCreate?: MatterCreateOrConnectWithoutCollaboratorsInput | null;
  connect?: MatterWhereUniqueInput | null;
}

export interface MatterCreateNestedOneWithoutDisbursementsInput {
  create?: MatterCreateWithoutDisbursementsInput | null;
  connectOrCreate?: MatterCreateOrConnectWithoutDisbursementsInput | null;
  connect?: MatterWhereUniqueInput | null;
}

export interface MatterCreateNestedOneWithoutDiscountsInput {
  create?: MatterCreateWithoutDiscountsInput | null;
  connectOrCreate?: MatterCreateOrConnectWithoutDiscountsInput | null;
  connect?: MatterWhereUniqueInput | null;
}

export interface MatterCreateNestedOneWithoutExclusionsInput {
  create?: MatterCreateWithoutExclusionsInput | null;
  connectOrCreate?: MatterCreateOrConnectWithoutExclusionsInput | null;
  connect?: MatterWhereUniqueInput | null;
}

export interface MatterCreateNestedOneWithoutExternalMatterInput {
  create?: MatterCreateWithoutExternalMatterInput | null;
  connectOrCreate?: MatterCreateOrConnectWithoutExternalMatterInput | null;
  connect?: MatterWhereUniqueInput | null;
}

export interface MatterCreateNestedOneWithoutNotificationsInput {
  create?: MatterCreateWithoutNotificationsInput | null;
  connectOrCreate?: MatterCreateOrConnectWithoutNotificationsInput | null;
  connect?: MatterWhereUniqueInput | null;
}

export interface MatterCreateNestedOneWithoutPhasesInput {
  create?: MatterCreateWithoutPhasesInput | null;
  connectOrCreate?: MatterCreateOrConnectWithoutPhasesInput | null;
  connect?: MatterWhereUniqueInput | null;
}

export interface MatterCreateNestedOneWithoutPriceOptionsInput {
  create?: MatterCreateWithoutPriceOptionsInput | null;
  connectOrCreate?: MatterCreateOrConnectWithoutPriceOptionsInput | null;
  connect?: MatterWhereUniqueInput | null;
}

export interface MatterCreateNestedOneWithoutUpliftsInput {
  create?: MatterCreateWithoutUpliftsInput | null;
  connectOrCreate?: MatterCreateOrConnectWithoutUpliftsInput | null;
  connect?: MatterWhereUniqueInput | null;
}

export interface MatterCreateOrConnectWithoutAssumptionsInput {
  where: MatterWhereUniqueInput;
  create: MatterCreateWithoutAssumptionsInput;
}

export interface MatterCreateOrConnectWithoutBrandInput {
  where: MatterWhereUniqueInput;
  create: MatterCreateWithoutBrandInput;
}

export interface MatterCreateOrConnectWithoutClientInput {
  where: MatterWhereUniqueInput;
  create: MatterCreateWithoutClientInput;
}

export interface MatterCreateOrConnectWithoutCollaboratorsInput {
  where: MatterWhereUniqueInput;
  create: MatterCreateWithoutCollaboratorsInput;
}

export interface MatterCreateOrConnectWithoutCreatedByInput {
  where: MatterWhereUniqueInput;
  create: MatterCreateWithoutCreatedByInput;
}

export interface MatterCreateOrConnectWithoutDisbursementsInput {
  where: MatterWhereUniqueInput;
  create: MatterCreateWithoutDisbursementsInput;
}

export interface MatterCreateOrConnectWithoutDiscountsInput {
  where: MatterWhereUniqueInput;
  create: MatterCreateWithoutDiscountsInput;
}

export interface MatterCreateOrConnectWithoutExclusionsInput {
  where: MatterWhereUniqueInput;
  create: MatterCreateWithoutExclusionsInput;
}

export interface MatterCreateOrConnectWithoutExternalMatterInput {
  where: MatterWhereUniqueInput;
  create: MatterCreateWithoutExternalMatterInput;
}

export interface MatterCreateOrConnectWithoutFeeEarnerInput {
  where: MatterWhereUniqueInput;
  create: MatterCreateWithoutFeeEarnerInput;
}

export interface MatterCreateOrConnectWithoutNotificationsInput {
  where: MatterWhereUniqueInput;
  create: MatterCreateWithoutNotificationsInput;
}

export interface MatterCreateOrConnectWithoutOrganisationalUnitInput {
  where: MatterWhereUniqueInput;
  create: MatterCreateWithoutOrganisationalUnitInput;
}

export interface MatterCreateOrConnectWithoutParentInput {
  where: MatterWhereUniqueInput;
  create: MatterCreateWithoutParentInput;
}

export interface MatterCreateOrConnectWithoutPhasesInput {
  where: MatterWhereUniqueInput;
  create: MatterCreateWithoutPhasesInput;
}

export interface MatterCreateOrConnectWithoutPriceOptionsInput {
  where: MatterWhereUniqueInput;
  create: MatterCreateWithoutPriceOptionsInput;
}

export interface MatterCreateOrConnectWithoutUpliftsInput {
  where: MatterWhereUniqueInput;
  create: MatterCreateWithoutUpliftsInput;
}

export interface MatterCreateWithoutAssumptionsInput {
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  template?: boolean | null;
  templateType?: TemplateType | null;
  title: string;
  externalReference?: string | null;
  status?: MatterStatus | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  agreedPrice?: number | null;
  feeCharged?: number | null;
  taxStatus?: TaxStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  createFromTemplateId?: number | null;
  templateGpmThreshold?: number | null;
  matterType?: MatterType | null;
  order?: number | null;
  agreedPriceRange?: PriceRangeCreateNestedOneWithoutMattersInput | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutMattersInput | null;
  externalMatter?: ExternalMatterCreateNestedOneWithoutMatterInput | null;
  brand?: BrandCreateNestedOneWithoutMattersInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutMattersInput | null;
  client?: ClientCreateNestedOneWithoutMattersInput | null;
  collaborators?: CollaboratorCreateNestedManyWithoutMatterInput | null;
  disbursements?: DisbursementCreateNestedManyWithoutMatterInput | null;
  discounts?: DiscountCreateNestedManyWithoutMatterInput | null;
  exclusions?: ExclusionCreateNestedManyWithoutMatterInput | null;
  notifications?: NotificationCreateNestedManyWithoutMatterInput | null;
  phases?: PhaseCreateNestedManyWithoutMatterInput | null;
  uplifts?: UpliftCreateNestedManyWithoutMatterInput | null;
  priceOptions?: PriceOptionsCreateNestedOneWithoutMatterInput | null;
  parent?: ParentMatterCreateNestedOneWithoutMattersInput | null;
}

export interface MatterCreateWithoutBrandInput {
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  template?: boolean | null;
  templateType?: TemplateType | null;
  title: string;
  externalReference?: string | null;
  status?: MatterStatus | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  agreedPrice?: number | null;
  feeCharged?: number | null;
  taxStatus?: TaxStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  createFromTemplateId?: number | null;
  templateGpmThreshold?: number | null;
  matterType?: MatterType | null;
  order?: number | null;
  agreedPriceRange?: PriceRangeCreateNestedOneWithoutMattersInput | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutMattersInput | null;
  externalMatter?: ExternalMatterCreateNestedOneWithoutMatterInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutMattersInput | null;
  client?: ClientCreateNestedOneWithoutMattersInput | null;
  assumptions?: AssumptionCreateNestedManyWithoutMatterInput | null;
  collaborators?: CollaboratorCreateNestedManyWithoutMatterInput | null;
  disbursements?: DisbursementCreateNestedManyWithoutMatterInput | null;
  discounts?: DiscountCreateNestedManyWithoutMatterInput | null;
  exclusions?: ExclusionCreateNestedManyWithoutMatterInput | null;
  notifications?: NotificationCreateNestedManyWithoutMatterInput | null;
  phases?: PhaseCreateNestedManyWithoutMatterInput | null;
  uplifts?: UpliftCreateNestedManyWithoutMatterInput | null;
  priceOptions?: PriceOptionsCreateNestedOneWithoutMatterInput | null;
  parent?: ParentMatterCreateNestedOneWithoutMattersInput | null;
}

export interface MatterCreateWithoutClientInput {
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  template?: boolean | null;
  templateType?: TemplateType | null;
  title: string;
  externalReference?: string | null;
  status?: MatterStatus | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  agreedPrice?: number | null;
  feeCharged?: number | null;
  taxStatus?: TaxStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  createFromTemplateId?: number | null;
  templateGpmThreshold?: number | null;
  matterType?: MatterType | null;
  order?: number | null;
  agreedPriceRange?: PriceRangeCreateNestedOneWithoutMattersInput | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutMattersInput | null;
  externalMatter?: ExternalMatterCreateNestedOneWithoutMatterInput | null;
  brand?: BrandCreateNestedOneWithoutMattersInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutMattersInput | null;
  assumptions?: AssumptionCreateNestedManyWithoutMatterInput | null;
  collaborators?: CollaboratorCreateNestedManyWithoutMatterInput | null;
  disbursements?: DisbursementCreateNestedManyWithoutMatterInput | null;
  discounts?: DiscountCreateNestedManyWithoutMatterInput | null;
  exclusions?: ExclusionCreateNestedManyWithoutMatterInput | null;
  notifications?: NotificationCreateNestedManyWithoutMatterInput | null;
  phases?: PhaseCreateNestedManyWithoutMatterInput | null;
  uplifts?: UpliftCreateNestedManyWithoutMatterInput | null;
  priceOptions?: PriceOptionsCreateNestedOneWithoutMatterInput | null;
  parent?: ParentMatterCreateNestedOneWithoutMattersInput | null;
}

export interface MatterCreateWithoutCollaboratorsInput {
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  template?: boolean | null;
  templateType?: TemplateType | null;
  title: string;
  externalReference?: string | null;
  status?: MatterStatus | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  agreedPrice?: number | null;
  feeCharged?: number | null;
  taxStatus?: TaxStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  createFromTemplateId?: number | null;
  templateGpmThreshold?: number | null;
  matterType?: MatterType | null;
  order?: number | null;
  agreedPriceRange?: PriceRangeCreateNestedOneWithoutMattersInput | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutMattersInput | null;
  externalMatter?: ExternalMatterCreateNestedOneWithoutMatterInput | null;
  brand?: BrandCreateNestedOneWithoutMattersInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutMattersInput | null;
  client?: ClientCreateNestedOneWithoutMattersInput | null;
  assumptions?: AssumptionCreateNestedManyWithoutMatterInput | null;
  disbursements?: DisbursementCreateNestedManyWithoutMatterInput | null;
  discounts?: DiscountCreateNestedManyWithoutMatterInput | null;
  exclusions?: ExclusionCreateNestedManyWithoutMatterInput | null;
  notifications?: NotificationCreateNestedManyWithoutMatterInput | null;
  phases?: PhaseCreateNestedManyWithoutMatterInput | null;
  uplifts?: UpliftCreateNestedManyWithoutMatterInput | null;
  priceOptions?: PriceOptionsCreateNestedOneWithoutMatterInput | null;
  parent?: ParentMatterCreateNestedOneWithoutMattersInput | null;
}

export interface MatterCreateWithoutCreatedByInput {
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  template?: boolean | null;
  templateType?: TemplateType | null;
  title: string;
  externalReference?: string | null;
  status?: MatterStatus | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  agreedPrice?: number | null;
  feeCharged?: number | null;
  taxStatus?: TaxStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  createFromTemplateId?: number | null;
  templateGpmThreshold?: number | null;
  matterType?: MatterType | null;
  order?: number | null;
  agreedPriceRange?: PriceRangeCreateNestedOneWithoutMattersInput | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutMattersInput | null;
  externalMatter?: ExternalMatterCreateNestedOneWithoutMatterInput | null;
  brand?: BrandCreateNestedOneWithoutMattersInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutMattersInput | null;
  client?: ClientCreateNestedOneWithoutMattersInput | null;
  assumptions?: AssumptionCreateNestedManyWithoutMatterInput | null;
  collaborators?: CollaboratorCreateNestedManyWithoutMatterInput | null;
  disbursements?: DisbursementCreateNestedManyWithoutMatterInput | null;
  discounts?: DiscountCreateNestedManyWithoutMatterInput | null;
  exclusions?: ExclusionCreateNestedManyWithoutMatterInput | null;
  notifications?: NotificationCreateNestedManyWithoutMatterInput | null;
  phases?: PhaseCreateNestedManyWithoutMatterInput | null;
  uplifts?: UpliftCreateNestedManyWithoutMatterInput | null;
  priceOptions?: PriceOptionsCreateNestedOneWithoutMatterInput | null;
  parent?: ParentMatterCreateNestedOneWithoutMattersInput | null;
}

export interface MatterCreateWithoutDisbursementsInput {
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  template?: boolean | null;
  templateType?: TemplateType | null;
  title: string;
  externalReference?: string | null;
  status?: MatterStatus | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  agreedPrice?: number | null;
  feeCharged?: number | null;
  taxStatus?: TaxStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  createFromTemplateId?: number | null;
  templateGpmThreshold?: number | null;
  matterType?: MatterType | null;
  order?: number | null;
  agreedPriceRange?: PriceRangeCreateNestedOneWithoutMattersInput | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutMattersInput | null;
  externalMatter?: ExternalMatterCreateNestedOneWithoutMatterInput | null;
  brand?: BrandCreateNestedOneWithoutMattersInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutMattersInput | null;
  client?: ClientCreateNestedOneWithoutMattersInput | null;
  assumptions?: AssumptionCreateNestedManyWithoutMatterInput | null;
  collaborators?: CollaboratorCreateNestedManyWithoutMatterInput | null;
  discounts?: DiscountCreateNestedManyWithoutMatterInput | null;
  exclusions?: ExclusionCreateNestedManyWithoutMatterInput | null;
  notifications?: NotificationCreateNestedManyWithoutMatterInput | null;
  phases?: PhaseCreateNestedManyWithoutMatterInput | null;
  uplifts?: UpliftCreateNestedManyWithoutMatterInput | null;
  priceOptions?: PriceOptionsCreateNestedOneWithoutMatterInput | null;
  parent?: ParentMatterCreateNestedOneWithoutMattersInput | null;
}

export interface MatterCreateWithoutDiscountsInput {
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  template?: boolean | null;
  templateType?: TemplateType | null;
  title: string;
  externalReference?: string | null;
  status?: MatterStatus | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  agreedPrice?: number | null;
  feeCharged?: number | null;
  taxStatus?: TaxStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  createFromTemplateId?: number | null;
  templateGpmThreshold?: number | null;
  matterType?: MatterType | null;
  order?: number | null;
  agreedPriceRange?: PriceRangeCreateNestedOneWithoutMattersInput | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutMattersInput | null;
  externalMatter?: ExternalMatterCreateNestedOneWithoutMatterInput | null;
  brand?: BrandCreateNestedOneWithoutMattersInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutMattersInput | null;
  client?: ClientCreateNestedOneWithoutMattersInput | null;
  assumptions?: AssumptionCreateNestedManyWithoutMatterInput | null;
  collaborators?: CollaboratorCreateNestedManyWithoutMatterInput | null;
  disbursements?: DisbursementCreateNestedManyWithoutMatterInput | null;
  exclusions?: ExclusionCreateNestedManyWithoutMatterInput | null;
  notifications?: NotificationCreateNestedManyWithoutMatterInput | null;
  phases?: PhaseCreateNestedManyWithoutMatterInput | null;
  uplifts?: UpliftCreateNestedManyWithoutMatterInput | null;
  priceOptions?: PriceOptionsCreateNestedOneWithoutMatterInput | null;
  parent?: ParentMatterCreateNestedOneWithoutMattersInput | null;
}

export interface MatterCreateWithoutExclusionsInput {
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  template?: boolean | null;
  templateType?: TemplateType | null;
  title: string;
  externalReference?: string | null;
  status?: MatterStatus | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  agreedPrice?: number | null;
  feeCharged?: number | null;
  taxStatus?: TaxStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  createFromTemplateId?: number | null;
  templateGpmThreshold?: number | null;
  matterType?: MatterType | null;
  order?: number | null;
  agreedPriceRange?: PriceRangeCreateNestedOneWithoutMattersInput | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutMattersInput | null;
  externalMatter?: ExternalMatterCreateNestedOneWithoutMatterInput | null;
  brand?: BrandCreateNestedOneWithoutMattersInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutMattersInput | null;
  client?: ClientCreateNestedOneWithoutMattersInput | null;
  assumptions?: AssumptionCreateNestedManyWithoutMatterInput | null;
  collaborators?: CollaboratorCreateNestedManyWithoutMatterInput | null;
  disbursements?: DisbursementCreateNestedManyWithoutMatterInput | null;
  discounts?: DiscountCreateNestedManyWithoutMatterInput | null;
  notifications?: NotificationCreateNestedManyWithoutMatterInput | null;
  phases?: PhaseCreateNestedManyWithoutMatterInput | null;
  uplifts?: UpliftCreateNestedManyWithoutMatterInput | null;
  priceOptions?: PriceOptionsCreateNestedOneWithoutMatterInput | null;
  parent?: ParentMatterCreateNestedOneWithoutMattersInput | null;
}

export interface MatterCreateWithoutExternalMatterInput {
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  template?: boolean | null;
  templateType?: TemplateType | null;
  title: string;
  externalReference?: string | null;
  status?: MatterStatus | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  agreedPrice?: number | null;
  feeCharged?: number | null;
  taxStatus?: TaxStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  createFromTemplateId?: number | null;
  templateGpmThreshold?: number | null;
  matterType?: MatterType | null;
  order?: number | null;
  agreedPriceRange?: PriceRangeCreateNestedOneWithoutMattersInput | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutMattersInput | null;
  brand?: BrandCreateNestedOneWithoutMattersInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutMattersInput | null;
  client?: ClientCreateNestedOneWithoutMattersInput | null;
  assumptions?: AssumptionCreateNestedManyWithoutMatterInput | null;
  collaborators?: CollaboratorCreateNestedManyWithoutMatterInput | null;
  disbursements?: DisbursementCreateNestedManyWithoutMatterInput | null;
  discounts?: DiscountCreateNestedManyWithoutMatterInput | null;
  exclusions?: ExclusionCreateNestedManyWithoutMatterInput | null;
  notifications?: NotificationCreateNestedManyWithoutMatterInput | null;
  phases?: PhaseCreateNestedManyWithoutMatterInput | null;
  uplifts?: UpliftCreateNestedManyWithoutMatterInput | null;
  priceOptions?: PriceOptionsCreateNestedOneWithoutMatterInput | null;
  parent?: ParentMatterCreateNestedOneWithoutMattersInput | null;
}

export interface MatterCreateWithoutFeeEarnerInput {
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  template?: boolean | null;
  templateType?: TemplateType | null;
  title: string;
  externalReference?: string | null;
  status?: MatterStatus | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  agreedPrice?: number | null;
  feeCharged?: number | null;
  taxStatus?: TaxStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  createFromTemplateId?: number | null;
  templateGpmThreshold?: number | null;
  matterType?: MatterType | null;
  order?: number | null;
  agreedPriceRange?: PriceRangeCreateNestedOneWithoutMattersInput | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutMattersInput | null;
  externalMatter?: ExternalMatterCreateNestedOneWithoutMatterInput | null;
  brand?: BrandCreateNestedOneWithoutMattersInput | null;
  client?: ClientCreateNestedOneWithoutMattersInput | null;
  assumptions?: AssumptionCreateNestedManyWithoutMatterInput | null;
  collaborators?: CollaboratorCreateNestedManyWithoutMatterInput | null;
  disbursements?: DisbursementCreateNestedManyWithoutMatterInput | null;
  discounts?: DiscountCreateNestedManyWithoutMatterInput | null;
  exclusions?: ExclusionCreateNestedManyWithoutMatterInput | null;
  notifications?: NotificationCreateNestedManyWithoutMatterInput | null;
  phases?: PhaseCreateNestedManyWithoutMatterInput | null;
  uplifts?: UpliftCreateNestedManyWithoutMatterInput | null;
  priceOptions?: PriceOptionsCreateNestedOneWithoutMatterInput | null;
  parent?: ParentMatterCreateNestedOneWithoutMattersInput | null;
}

export interface MatterCreateWithoutNotificationsInput {
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  template?: boolean | null;
  templateType?: TemplateType | null;
  title: string;
  externalReference?: string | null;
  status?: MatterStatus | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  agreedPrice?: number | null;
  feeCharged?: number | null;
  taxStatus?: TaxStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  createFromTemplateId?: number | null;
  templateGpmThreshold?: number | null;
  matterType?: MatterType | null;
  order?: number | null;
  agreedPriceRange?: PriceRangeCreateNestedOneWithoutMattersInput | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutMattersInput | null;
  externalMatter?: ExternalMatterCreateNestedOneWithoutMatterInput | null;
  brand?: BrandCreateNestedOneWithoutMattersInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutMattersInput | null;
  client?: ClientCreateNestedOneWithoutMattersInput | null;
  assumptions?: AssumptionCreateNestedManyWithoutMatterInput | null;
  collaborators?: CollaboratorCreateNestedManyWithoutMatterInput | null;
  disbursements?: DisbursementCreateNestedManyWithoutMatterInput | null;
  discounts?: DiscountCreateNestedManyWithoutMatterInput | null;
  exclusions?: ExclusionCreateNestedManyWithoutMatterInput | null;
  phases?: PhaseCreateNestedManyWithoutMatterInput | null;
  uplifts?: UpliftCreateNestedManyWithoutMatterInput | null;
  priceOptions?: PriceOptionsCreateNestedOneWithoutMatterInput | null;
  parent?: ParentMatterCreateNestedOneWithoutMattersInput | null;
}

export interface MatterCreateWithoutOrganisationalUnitInput {
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  template?: boolean | null;
  templateType?: TemplateType | null;
  title: string;
  externalReference?: string | null;
  status?: MatterStatus | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  agreedPrice?: number | null;
  feeCharged?: number | null;
  taxStatus?: TaxStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  createFromTemplateId?: number | null;
  templateGpmThreshold?: number | null;
  matterType?: MatterType | null;
  order?: number | null;
  agreedPriceRange?: PriceRangeCreateNestedOneWithoutMattersInput | null;
  externalMatter?: ExternalMatterCreateNestedOneWithoutMatterInput | null;
  brand?: BrandCreateNestedOneWithoutMattersInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutMattersInput | null;
  client?: ClientCreateNestedOneWithoutMattersInput | null;
  assumptions?: AssumptionCreateNestedManyWithoutMatterInput | null;
  collaborators?: CollaboratorCreateNestedManyWithoutMatterInput | null;
  disbursements?: DisbursementCreateNestedManyWithoutMatterInput | null;
  discounts?: DiscountCreateNestedManyWithoutMatterInput | null;
  exclusions?: ExclusionCreateNestedManyWithoutMatterInput | null;
  notifications?: NotificationCreateNestedManyWithoutMatterInput | null;
  phases?: PhaseCreateNestedManyWithoutMatterInput | null;
  uplifts?: UpliftCreateNestedManyWithoutMatterInput | null;
  priceOptions?: PriceOptionsCreateNestedOneWithoutMatterInput | null;
  parent?: ParentMatterCreateNestedOneWithoutMattersInput | null;
}

export interface MatterCreateWithoutParentInput {
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  template?: boolean | null;
  templateType?: TemplateType | null;
  title: string;
  externalReference?: string | null;
  status?: MatterStatus | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  agreedPrice?: number | null;
  feeCharged?: number | null;
  taxStatus?: TaxStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  createFromTemplateId?: number | null;
  templateGpmThreshold?: number | null;
  matterType?: MatterType | null;
  order?: number | null;
  agreedPriceRange?: PriceRangeCreateNestedOneWithoutMattersInput | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutMattersInput | null;
  externalMatter?: ExternalMatterCreateNestedOneWithoutMatterInput | null;
  brand?: BrandCreateNestedOneWithoutMattersInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutMattersInput | null;
  client?: ClientCreateNestedOneWithoutMattersInput | null;
  assumptions?: AssumptionCreateNestedManyWithoutMatterInput | null;
  collaborators?: CollaboratorCreateNestedManyWithoutMatterInput | null;
  disbursements?: DisbursementCreateNestedManyWithoutMatterInput | null;
  discounts?: DiscountCreateNestedManyWithoutMatterInput | null;
  exclusions?: ExclusionCreateNestedManyWithoutMatterInput | null;
  notifications?: NotificationCreateNestedManyWithoutMatterInput | null;
  phases?: PhaseCreateNestedManyWithoutMatterInput | null;
  uplifts?: UpliftCreateNestedManyWithoutMatterInput | null;
  priceOptions?: PriceOptionsCreateNestedOneWithoutMatterInput | null;
}

export interface MatterCreateWithoutPhasesInput {
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  template?: boolean | null;
  templateType?: TemplateType | null;
  title: string;
  externalReference?: string | null;
  status?: MatterStatus | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  agreedPrice?: number | null;
  feeCharged?: number | null;
  taxStatus?: TaxStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  createFromTemplateId?: number | null;
  templateGpmThreshold?: number | null;
  matterType?: MatterType | null;
  order?: number | null;
  agreedPriceRange?: PriceRangeCreateNestedOneWithoutMattersInput | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutMattersInput | null;
  externalMatter?: ExternalMatterCreateNestedOneWithoutMatterInput | null;
  brand?: BrandCreateNestedOneWithoutMattersInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutMattersInput | null;
  client?: ClientCreateNestedOneWithoutMattersInput | null;
  assumptions?: AssumptionCreateNestedManyWithoutMatterInput | null;
  collaborators?: CollaboratorCreateNestedManyWithoutMatterInput | null;
  disbursements?: DisbursementCreateNestedManyWithoutMatterInput | null;
  discounts?: DiscountCreateNestedManyWithoutMatterInput | null;
  exclusions?: ExclusionCreateNestedManyWithoutMatterInput | null;
  notifications?: NotificationCreateNestedManyWithoutMatterInput | null;
  uplifts?: UpliftCreateNestedManyWithoutMatterInput | null;
  priceOptions?: PriceOptionsCreateNestedOneWithoutMatterInput | null;
  parent?: ParentMatterCreateNestedOneWithoutMattersInput | null;
}

export interface MatterCreateWithoutPriceOptionsInput {
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  template?: boolean | null;
  templateType?: TemplateType | null;
  title: string;
  externalReference?: string | null;
  status?: MatterStatus | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  agreedPrice?: number | null;
  feeCharged?: number | null;
  taxStatus?: TaxStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  createFromTemplateId?: number | null;
  templateGpmThreshold?: number | null;
  matterType?: MatterType | null;
  order?: number | null;
  agreedPriceRange?: PriceRangeCreateNestedOneWithoutMattersInput | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutMattersInput | null;
  externalMatter?: ExternalMatterCreateNestedOneWithoutMatterInput | null;
  brand?: BrandCreateNestedOneWithoutMattersInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutMattersInput | null;
  client?: ClientCreateNestedOneWithoutMattersInput | null;
  assumptions?: AssumptionCreateNestedManyWithoutMatterInput | null;
  collaborators?: CollaboratorCreateNestedManyWithoutMatterInput | null;
  disbursements?: DisbursementCreateNestedManyWithoutMatterInput | null;
  discounts?: DiscountCreateNestedManyWithoutMatterInput | null;
  exclusions?: ExclusionCreateNestedManyWithoutMatterInput | null;
  notifications?: NotificationCreateNestedManyWithoutMatterInput | null;
  phases?: PhaseCreateNestedManyWithoutMatterInput | null;
  uplifts?: UpliftCreateNestedManyWithoutMatterInput | null;
  parent?: ParentMatterCreateNestedOneWithoutMattersInput | null;
}

export interface MatterCreateWithoutUpliftsInput {
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  template?: boolean | null;
  templateType?: TemplateType | null;
  title: string;
  externalReference?: string | null;
  status?: MatterStatus | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  agreedPrice?: number | null;
  feeCharged?: number | null;
  taxStatus?: TaxStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  createFromTemplateId?: number | null;
  templateGpmThreshold?: number | null;
  matterType?: MatterType | null;
  order?: number | null;
  agreedPriceRange?: PriceRangeCreateNestedOneWithoutMattersInput | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutMattersInput | null;
  externalMatter?: ExternalMatterCreateNestedOneWithoutMatterInput | null;
  brand?: BrandCreateNestedOneWithoutMattersInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutMattersInput | null;
  client?: ClientCreateNestedOneWithoutMattersInput | null;
  assumptions?: AssumptionCreateNestedManyWithoutMatterInput | null;
  collaborators?: CollaboratorCreateNestedManyWithoutMatterInput | null;
  disbursements?: DisbursementCreateNestedManyWithoutMatterInput | null;
  discounts?: DiscountCreateNestedManyWithoutMatterInput | null;
  exclusions?: ExclusionCreateNestedManyWithoutMatterInput | null;
  notifications?: NotificationCreateNestedManyWithoutMatterInput | null;
  phases?: PhaseCreateNestedManyWithoutMatterInput | null;
  priceOptions?: PriceOptionsCreateNestedOneWithoutMatterInput | null;
  parent?: ParentMatterCreateNestedOneWithoutMattersInput | null;
}

export interface MatterListRelationFilter {
  every?: MatterWhereInput | null;
  some?: MatterWhereInput | null;
  none?: MatterWhereInput | null;
}

export interface MatterRelationFilter {
  is?: MatterWhereInput | null;
  isNot?: MatterWhereInput | null;
}

export interface MatterScalarWhereInput {
  AND?: MatterScalarWhereInput[] | null;
  OR?: MatterScalarWhereInput[] | null;
  NOT?: MatterScalarWhereInput[] | null;
  id?: IntFilter | null;
  reference?: UuidFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  template?: BoolFilter | null;
  templateType?: EnumTemplateTypeNullableFilter | null;
  title?: StringFilter | null;
  externalMatterId?: IntNullableFilter | null;
  organisationalUnitId?: IntNullableFilter | null;
  leadFeeEarnerId?: IntNullableFilter | null;
  clientId?: IntNullableFilter | null;
  externalReference?: StringNullableFilter | null;
  status?: EnumMatterStatusFilter | null;
  pricingType?: EnumPricingTypeFilter | null;
  pricingLevel?: EnumPricingLevelFilter | null;
  agreedPrice?: FloatNullableFilter | null;
  feeCharged?: FloatNullableFilter | null;
  taxStatus?: EnumTaxStatusFilter | null;
  brandId?: IntNullableFilter | null;
  includeTasksInProposalOutput?: BoolNullableFilter | null;
  includeRatesInProposalOutput?: BoolNullableFilter | null;
  createdById?: IntFilter | null;
  priceOptionsId?: IntNullableFilter | null;
  priceRangeId?: IntNullableFilter | null;
  createFromTemplateId?: IntNullableFilter | null;
  templateGpmThreshold?: IntNullableFilter | null;
  matterType?: EnumMatterTypeFilter | null;
  parentMatterId?: IntNullableFilter | null;
  order?: IntNullableFilter | null;
}

export interface MatterUpdateInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  template?: BoolFieldUpdateOperationsInput | null;
  templateType?: NullableEnumTemplateTypeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  pricingType?: EnumPricingTypeFieldUpdateOperationsInput | null;
  pricingLevel?: EnumPricingLevelFieldUpdateOperationsInput | null;
  agreedPrice?: NullableFloatFieldUpdateOperationsInput | null;
  feeCharged?: NullableFloatFieldUpdateOperationsInput | null;
  taxStatus?: EnumTaxStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  createFromTemplateId?: NullableIntFieldUpdateOperationsInput | null;
  templateGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  matterType?: EnumMatterTypeFieldUpdateOperationsInput | null;
  order?: NullableIntFieldUpdateOperationsInput | null;
  agreedPriceRange?: PriceRangeUpdateOneWithoutMattersNestedInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutMattersNestedInput | null;
  externalMatter?: ExternalMatterUpdateOneWithoutMatterNestedInput | null;
  brand?: BrandUpdateOneWithoutMattersNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutMattersNestedInput | null;
  client?: ClientUpdateOneWithoutMattersNestedInput | null;
  assumptions?: AssumptionUpdateManyWithoutMatterNestedInput | null;
  collaborators?: CollaboratorUpdateManyWithoutMatterNestedInput | null;
  disbursements?: DisbursementUpdateManyWithoutMatterNestedInput | null;
  discounts?: DiscountUpdateManyWithoutMatterNestedInput | null;
  exclusions?: ExclusionUpdateManyWithoutMatterNestedInput | null;
  notifications?: NotificationUpdateManyWithoutMatterNestedInput | null;
  phases?: PhaseUpdateManyWithoutMatterNestedInput | null;
  uplifts?: UpliftUpdateManyWithoutMatterNestedInput | null;
  priceOptions?: PriceOptionsUpdateOneWithoutMatterNestedInput | null;
  parent?: ParentMatterUpdateOneWithoutMattersNestedInput | null;
}

export interface MatterUpdateManyMutationInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  template?: BoolFieldUpdateOperationsInput | null;
  templateType?: NullableEnumTemplateTypeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  pricingType?: EnumPricingTypeFieldUpdateOperationsInput | null;
  pricingLevel?: EnumPricingLevelFieldUpdateOperationsInput | null;
  agreedPrice?: NullableFloatFieldUpdateOperationsInput | null;
  feeCharged?: NullableFloatFieldUpdateOperationsInput | null;
  taxStatus?: EnumTaxStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  createFromTemplateId?: NullableIntFieldUpdateOperationsInput | null;
  templateGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  matterType?: EnumMatterTypeFieldUpdateOperationsInput | null;
  order?: NullableIntFieldUpdateOperationsInput | null;
}

export interface MatterUpdateManyWithWhereWithoutBrandInput {
  where: MatterScalarWhereInput;
  data: MatterUpdateManyMutationInput;
}

export interface MatterUpdateManyWithWhereWithoutClientInput {
  where: MatterScalarWhereInput;
  data: MatterUpdateManyMutationInput;
}

export interface MatterUpdateManyWithWhereWithoutCreatedByInput {
  where: MatterScalarWhereInput;
  data: MatterUpdateManyMutationInput;
}

export interface MatterUpdateManyWithWhereWithoutFeeEarnerInput {
  where: MatterScalarWhereInput;
  data: MatterUpdateManyMutationInput;
}

export interface MatterUpdateManyWithWhereWithoutOrganisationalUnitInput {
  where: MatterScalarWhereInput;
  data: MatterUpdateManyMutationInput;
}

export interface MatterUpdateManyWithWhereWithoutParentInput {
  where: MatterScalarWhereInput;
  data: MatterUpdateManyMutationInput;
}

export interface MatterUpdateManyWithoutBrandNestedInput {
  create?: MatterCreateWithoutBrandInput[] | null;
  connectOrCreate?: MatterCreateOrConnectWithoutBrandInput[] | null;
  upsert?: MatterUpsertWithWhereUniqueWithoutBrandInput[] | null;
  createMany?: MatterCreateManyBrandInputEnvelope | null;
  set?: MatterWhereUniqueInput[] | null;
  disconnect?: MatterWhereUniqueInput[] | null;
  delete?: MatterWhereUniqueInput[] | null;
  connect?: MatterWhereUniqueInput[] | null;
  update?: MatterUpdateWithWhereUniqueWithoutBrandInput[] | null;
  updateMany?: MatterUpdateManyWithWhereWithoutBrandInput[] | null;
  deleteMany?: MatterScalarWhereInput[] | null;
}

export interface MatterUpdateManyWithoutClientNestedInput {
  create?: MatterCreateWithoutClientInput[] | null;
  connectOrCreate?: MatterCreateOrConnectWithoutClientInput[] | null;
  upsert?: MatterUpsertWithWhereUniqueWithoutClientInput[] | null;
  createMany?: MatterCreateManyClientInputEnvelope | null;
  set?: MatterWhereUniqueInput[] | null;
  disconnect?: MatterWhereUniqueInput[] | null;
  delete?: MatterWhereUniqueInput[] | null;
  connect?: MatterWhereUniqueInput[] | null;
  update?: MatterUpdateWithWhereUniqueWithoutClientInput[] | null;
  updateMany?: MatterUpdateManyWithWhereWithoutClientInput[] | null;
  deleteMany?: MatterScalarWhereInput[] | null;
}

export interface MatterUpdateManyWithoutCreatedByNestedInput {
  create?: MatterCreateWithoutCreatedByInput[] | null;
  connectOrCreate?: MatterCreateOrConnectWithoutCreatedByInput[] | null;
  upsert?: MatterUpsertWithWhereUniqueWithoutCreatedByInput[] | null;
  createMany?: MatterCreateManyCreatedByInputEnvelope | null;
  set?: MatterWhereUniqueInput[] | null;
  disconnect?: MatterWhereUniqueInput[] | null;
  delete?: MatterWhereUniqueInput[] | null;
  connect?: MatterWhereUniqueInput[] | null;
  update?: MatterUpdateWithWhereUniqueWithoutCreatedByInput[] | null;
  updateMany?: MatterUpdateManyWithWhereWithoutCreatedByInput[] | null;
  deleteMany?: MatterScalarWhereInput[] | null;
}

export interface MatterUpdateManyWithoutFeeEarnerNestedInput {
  create?: MatterCreateWithoutFeeEarnerInput[] | null;
  connectOrCreate?: MatterCreateOrConnectWithoutFeeEarnerInput[] | null;
  upsert?: MatterUpsertWithWhereUniqueWithoutFeeEarnerInput[] | null;
  createMany?: MatterCreateManyFeeEarnerInputEnvelope | null;
  set?: MatterWhereUniqueInput[] | null;
  disconnect?: MatterWhereUniqueInput[] | null;
  delete?: MatterWhereUniqueInput[] | null;
  connect?: MatterWhereUniqueInput[] | null;
  update?: MatterUpdateWithWhereUniqueWithoutFeeEarnerInput[] | null;
  updateMany?: MatterUpdateManyWithWhereWithoutFeeEarnerInput[] | null;
  deleteMany?: MatterScalarWhereInput[] | null;
}

export interface MatterUpdateManyWithoutOrganisationalUnitNestedInput {
  create?: MatterCreateWithoutOrganisationalUnitInput[] | null;
  connectOrCreate?: MatterCreateOrConnectWithoutOrganisationalUnitInput[] | null;
  upsert?: MatterUpsertWithWhereUniqueWithoutOrganisationalUnitInput[] | null;
  createMany?: MatterCreateManyOrganisationalUnitInputEnvelope | null;
  set?: MatterWhereUniqueInput[] | null;
  disconnect?: MatterWhereUniqueInput[] | null;
  delete?: MatterWhereUniqueInput[] | null;
  connect?: MatterWhereUniqueInput[] | null;
  update?: MatterUpdateWithWhereUniqueWithoutOrganisationalUnitInput[] | null;
  updateMany?: MatterUpdateManyWithWhereWithoutOrganisationalUnitInput[] | null;
  deleteMany?: MatterScalarWhereInput[] | null;
}

export interface MatterUpdateManyWithoutParentNestedInput {
  create?: MatterCreateWithoutParentInput[] | null;
  connectOrCreate?: MatterCreateOrConnectWithoutParentInput[] | null;
  upsert?: MatterUpsertWithWhereUniqueWithoutParentInput[] | null;
  createMany?: MatterCreateManyParentInputEnvelope | null;
  set?: MatterWhereUniqueInput[] | null;
  disconnect?: MatterWhereUniqueInput[] | null;
  delete?: MatterWhereUniqueInput[] | null;
  connect?: MatterWhereUniqueInput[] | null;
  update?: MatterUpdateWithWhereUniqueWithoutParentInput[] | null;
  updateMany?: MatterUpdateManyWithWhereWithoutParentInput[] | null;
  deleteMany?: MatterScalarWhereInput[] | null;
}

export interface MatterUpdateOneRequiredWithoutAssumptionsNestedInput {
  create?: MatterCreateWithoutAssumptionsInput | null;
  connectOrCreate?: MatterCreateOrConnectWithoutAssumptionsInput | null;
  upsert?: MatterUpsertWithoutAssumptionsInput | null;
  connect?: MatterWhereUniqueInput | null;
  update?: MatterUpdateWithoutAssumptionsInput | null;
}

export interface MatterUpdateOneRequiredWithoutDisbursementsNestedInput {
  create?: MatterCreateWithoutDisbursementsInput | null;
  connectOrCreate?: MatterCreateOrConnectWithoutDisbursementsInput | null;
  upsert?: MatterUpsertWithoutDisbursementsInput | null;
  connect?: MatterWhereUniqueInput | null;
  update?: MatterUpdateWithoutDisbursementsInput | null;
}

export interface MatterUpdateOneRequiredWithoutDiscountsNestedInput {
  create?: MatterCreateWithoutDiscountsInput | null;
  connectOrCreate?: MatterCreateOrConnectWithoutDiscountsInput | null;
  upsert?: MatterUpsertWithoutDiscountsInput | null;
  connect?: MatterWhereUniqueInput | null;
  update?: MatterUpdateWithoutDiscountsInput | null;
}

export interface MatterUpdateOneRequiredWithoutExclusionsNestedInput {
  create?: MatterCreateWithoutExclusionsInput | null;
  connectOrCreate?: MatterCreateOrConnectWithoutExclusionsInput | null;
  upsert?: MatterUpsertWithoutExclusionsInput | null;
  connect?: MatterWhereUniqueInput | null;
  update?: MatterUpdateWithoutExclusionsInput | null;
}

export interface MatterUpdateOneRequiredWithoutPhasesNestedInput {
  create?: MatterCreateWithoutPhasesInput | null;
  connectOrCreate?: MatterCreateOrConnectWithoutPhasesInput | null;
  upsert?: MatterUpsertWithoutPhasesInput | null;
  connect?: MatterWhereUniqueInput | null;
  update?: MatterUpdateWithoutPhasesInput | null;
}

export interface MatterUpdateOneRequiredWithoutUpliftsNestedInput {
  create?: MatterCreateWithoutUpliftsInput | null;
  connectOrCreate?: MatterCreateOrConnectWithoutUpliftsInput | null;
  upsert?: MatterUpsertWithoutUpliftsInput | null;
  connect?: MatterWhereUniqueInput | null;
  update?: MatterUpdateWithoutUpliftsInput | null;
}

export interface MatterUpdateOneWithoutCollaboratorsNestedInput {
  create?: MatterCreateWithoutCollaboratorsInput | null;
  connectOrCreate?: MatterCreateOrConnectWithoutCollaboratorsInput | null;
  upsert?: MatterUpsertWithoutCollaboratorsInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: MatterWhereUniqueInput | null;
  update?: MatterUpdateWithoutCollaboratorsInput | null;
}

export interface MatterUpdateOneWithoutExternalMatterNestedInput {
  create?: MatterCreateWithoutExternalMatterInput | null;
  connectOrCreate?: MatterCreateOrConnectWithoutExternalMatterInput | null;
  upsert?: MatterUpsertWithoutExternalMatterInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: MatterWhereUniqueInput | null;
  update?: MatterUpdateWithoutExternalMatterInput | null;
}

export interface MatterUpdateOneWithoutNotificationsNestedInput {
  create?: MatterCreateWithoutNotificationsInput | null;
  connectOrCreate?: MatterCreateOrConnectWithoutNotificationsInput | null;
  upsert?: MatterUpsertWithoutNotificationsInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: MatterWhereUniqueInput | null;
  update?: MatterUpdateWithoutNotificationsInput | null;
}

export interface MatterUpdateOneWithoutPriceOptionsNestedInput {
  create?: MatterCreateWithoutPriceOptionsInput | null;
  connectOrCreate?: MatterCreateOrConnectWithoutPriceOptionsInput | null;
  upsert?: MatterUpsertWithoutPriceOptionsInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: MatterWhereUniqueInput | null;
  update?: MatterUpdateWithoutPriceOptionsInput | null;
}

export interface MatterUpdateWithWhereUniqueWithoutBrandInput {
  where: MatterWhereUniqueInput;
  data: MatterUpdateWithoutBrandInput;
}

export interface MatterUpdateWithWhereUniqueWithoutClientInput {
  where: MatterWhereUniqueInput;
  data: MatterUpdateWithoutClientInput;
}

export interface MatterUpdateWithWhereUniqueWithoutCreatedByInput {
  where: MatterWhereUniqueInput;
  data: MatterUpdateWithoutCreatedByInput;
}

export interface MatterUpdateWithWhereUniqueWithoutFeeEarnerInput {
  where: MatterWhereUniqueInput;
  data: MatterUpdateWithoutFeeEarnerInput;
}

export interface MatterUpdateWithWhereUniqueWithoutOrganisationalUnitInput {
  where: MatterWhereUniqueInput;
  data: MatterUpdateWithoutOrganisationalUnitInput;
}

export interface MatterUpdateWithWhereUniqueWithoutParentInput {
  where: MatterWhereUniqueInput;
  data: MatterUpdateWithoutParentInput;
}

export interface MatterUpdateWithoutAssumptionsInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  template?: BoolFieldUpdateOperationsInput | null;
  templateType?: NullableEnumTemplateTypeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  pricingType?: EnumPricingTypeFieldUpdateOperationsInput | null;
  pricingLevel?: EnumPricingLevelFieldUpdateOperationsInput | null;
  agreedPrice?: NullableFloatFieldUpdateOperationsInput | null;
  feeCharged?: NullableFloatFieldUpdateOperationsInput | null;
  taxStatus?: EnumTaxStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  createFromTemplateId?: NullableIntFieldUpdateOperationsInput | null;
  templateGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  matterType?: EnumMatterTypeFieldUpdateOperationsInput | null;
  order?: NullableIntFieldUpdateOperationsInput | null;
  agreedPriceRange?: PriceRangeUpdateOneWithoutMattersNestedInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutMattersNestedInput | null;
  externalMatter?: ExternalMatterUpdateOneWithoutMatterNestedInput | null;
  brand?: BrandUpdateOneWithoutMattersNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutMattersNestedInput | null;
  client?: ClientUpdateOneWithoutMattersNestedInput | null;
  collaborators?: CollaboratorUpdateManyWithoutMatterNestedInput | null;
  disbursements?: DisbursementUpdateManyWithoutMatterNestedInput | null;
  discounts?: DiscountUpdateManyWithoutMatterNestedInput | null;
  exclusions?: ExclusionUpdateManyWithoutMatterNestedInput | null;
  notifications?: NotificationUpdateManyWithoutMatterNestedInput | null;
  phases?: PhaseUpdateManyWithoutMatterNestedInput | null;
  uplifts?: UpliftUpdateManyWithoutMatterNestedInput | null;
  priceOptions?: PriceOptionsUpdateOneWithoutMatterNestedInput | null;
  parent?: ParentMatterUpdateOneWithoutMattersNestedInput | null;
}

export interface MatterUpdateWithoutBrandInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  template?: BoolFieldUpdateOperationsInput | null;
  templateType?: NullableEnumTemplateTypeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  pricingType?: EnumPricingTypeFieldUpdateOperationsInput | null;
  pricingLevel?: EnumPricingLevelFieldUpdateOperationsInput | null;
  agreedPrice?: NullableFloatFieldUpdateOperationsInput | null;
  feeCharged?: NullableFloatFieldUpdateOperationsInput | null;
  taxStatus?: EnumTaxStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  createFromTemplateId?: NullableIntFieldUpdateOperationsInput | null;
  templateGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  matterType?: EnumMatterTypeFieldUpdateOperationsInput | null;
  order?: NullableIntFieldUpdateOperationsInput | null;
  agreedPriceRange?: PriceRangeUpdateOneWithoutMattersNestedInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutMattersNestedInput | null;
  externalMatter?: ExternalMatterUpdateOneWithoutMatterNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutMattersNestedInput | null;
  client?: ClientUpdateOneWithoutMattersNestedInput | null;
  assumptions?: AssumptionUpdateManyWithoutMatterNestedInput | null;
  collaborators?: CollaboratorUpdateManyWithoutMatterNestedInput | null;
  disbursements?: DisbursementUpdateManyWithoutMatterNestedInput | null;
  discounts?: DiscountUpdateManyWithoutMatterNestedInput | null;
  exclusions?: ExclusionUpdateManyWithoutMatterNestedInput | null;
  notifications?: NotificationUpdateManyWithoutMatterNestedInput | null;
  phases?: PhaseUpdateManyWithoutMatterNestedInput | null;
  uplifts?: UpliftUpdateManyWithoutMatterNestedInput | null;
  priceOptions?: PriceOptionsUpdateOneWithoutMatterNestedInput | null;
  parent?: ParentMatterUpdateOneWithoutMattersNestedInput | null;
}

export interface MatterUpdateWithoutClientInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  template?: BoolFieldUpdateOperationsInput | null;
  templateType?: NullableEnumTemplateTypeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  pricingType?: EnumPricingTypeFieldUpdateOperationsInput | null;
  pricingLevel?: EnumPricingLevelFieldUpdateOperationsInput | null;
  agreedPrice?: NullableFloatFieldUpdateOperationsInput | null;
  feeCharged?: NullableFloatFieldUpdateOperationsInput | null;
  taxStatus?: EnumTaxStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  createFromTemplateId?: NullableIntFieldUpdateOperationsInput | null;
  templateGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  matterType?: EnumMatterTypeFieldUpdateOperationsInput | null;
  order?: NullableIntFieldUpdateOperationsInput | null;
  agreedPriceRange?: PriceRangeUpdateOneWithoutMattersNestedInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutMattersNestedInput | null;
  externalMatter?: ExternalMatterUpdateOneWithoutMatterNestedInput | null;
  brand?: BrandUpdateOneWithoutMattersNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutMattersNestedInput | null;
  assumptions?: AssumptionUpdateManyWithoutMatterNestedInput | null;
  collaborators?: CollaboratorUpdateManyWithoutMatterNestedInput | null;
  disbursements?: DisbursementUpdateManyWithoutMatterNestedInput | null;
  discounts?: DiscountUpdateManyWithoutMatterNestedInput | null;
  exclusions?: ExclusionUpdateManyWithoutMatterNestedInput | null;
  notifications?: NotificationUpdateManyWithoutMatterNestedInput | null;
  phases?: PhaseUpdateManyWithoutMatterNestedInput | null;
  uplifts?: UpliftUpdateManyWithoutMatterNestedInput | null;
  priceOptions?: PriceOptionsUpdateOneWithoutMatterNestedInput | null;
  parent?: ParentMatterUpdateOneWithoutMattersNestedInput | null;
}

export interface MatterUpdateWithoutCollaboratorsInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  template?: BoolFieldUpdateOperationsInput | null;
  templateType?: NullableEnumTemplateTypeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  pricingType?: EnumPricingTypeFieldUpdateOperationsInput | null;
  pricingLevel?: EnumPricingLevelFieldUpdateOperationsInput | null;
  agreedPrice?: NullableFloatFieldUpdateOperationsInput | null;
  feeCharged?: NullableFloatFieldUpdateOperationsInput | null;
  taxStatus?: EnumTaxStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  createFromTemplateId?: NullableIntFieldUpdateOperationsInput | null;
  templateGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  matterType?: EnumMatterTypeFieldUpdateOperationsInput | null;
  order?: NullableIntFieldUpdateOperationsInput | null;
  agreedPriceRange?: PriceRangeUpdateOneWithoutMattersNestedInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutMattersNestedInput | null;
  externalMatter?: ExternalMatterUpdateOneWithoutMatterNestedInput | null;
  brand?: BrandUpdateOneWithoutMattersNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutMattersNestedInput | null;
  client?: ClientUpdateOneWithoutMattersNestedInput | null;
  assumptions?: AssumptionUpdateManyWithoutMatterNestedInput | null;
  disbursements?: DisbursementUpdateManyWithoutMatterNestedInput | null;
  discounts?: DiscountUpdateManyWithoutMatterNestedInput | null;
  exclusions?: ExclusionUpdateManyWithoutMatterNestedInput | null;
  notifications?: NotificationUpdateManyWithoutMatterNestedInput | null;
  phases?: PhaseUpdateManyWithoutMatterNestedInput | null;
  uplifts?: UpliftUpdateManyWithoutMatterNestedInput | null;
  priceOptions?: PriceOptionsUpdateOneWithoutMatterNestedInput | null;
  parent?: ParentMatterUpdateOneWithoutMattersNestedInput | null;
}

export interface MatterUpdateWithoutCreatedByInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  template?: BoolFieldUpdateOperationsInput | null;
  templateType?: NullableEnumTemplateTypeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  pricingType?: EnumPricingTypeFieldUpdateOperationsInput | null;
  pricingLevel?: EnumPricingLevelFieldUpdateOperationsInput | null;
  agreedPrice?: NullableFloatFieldUpdateOperationsInput | null;
  feeCharged?: NullableFloatFieldUpdateOperationsInput | null;
  taxStatus?: EnumTaxStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  createFromTemplateId?: NullableIntFieldUpdateOperationsInput | null;
  templateGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  matterType?: EnumMatterTypeFieldUpdateOperationsInput | null;
  order?: NullableIntFieldUpdateOperationsInput | null;
  agreedPriceRange?: PriceRangeUpdateOneWithoutMattersNestedInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutMattersNestedInput | null;
  externalMatter?: ExternalMatterUpdateOneWithoutMatterNestedInput | null;
  brand?: BrandUpdateOneWithoutMattersNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutMattersNestedInput | null;
  client?: ClientUpdateOneWithoutMattersNestedInput | null;
  assumptions?: AssumptionUpdateManyWithoutMatterNestedInput | null;
  collaborators?: CollaboratorUpdateManyWithoutMatterNestedInput | null;
  disbursements?: DisbursementUpdateManyWithoutMatterNestedInput | null;
  discounts?: DiscountUpdateManyWithoutMatterNestedInput | null;
  exclusions?: ExclusionUpdateManyWithoutMatterNestedInput | null;
  notifications?: NotificationUpdateManyWithoutMatterNestedInput | null;
  phases?: PhaseUpdateManyWithoutMatterNestedInput | null;
  uplifts?: UpliftUpdateManyWithoutMatterNestedInput | null;
  priceOptions?: PriceOptionsUpdateOneWithoutMatterNestedInput | null;
  parent?: ParentMatterUpdateOneWithoutMattersNestedInput | null;
}

export interface MatterUpdateWithoutDisbursementsInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  template?: BoolFieldUpdateOperationsInput | null;
  templateType?: NullableEnumTemplateTypeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  pricingType?: EnumPricingTypeFieldUpdateOperationsInput | null;
  pricingLevel?: EnumPricingLevelFieldUpdateOperationsInput | null;
  agreedPrice?: NullableFloatFieldUpdateOperationsInput | null;
  feeCharged?: NullableFloatFieldUpdateOperationsInput | null;
  taxStatus?: EnumTaxStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  createFromTemplateId?: NullableIntFieldUpdateOperationsInput | null;
  templateGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  matterType?: EnumMatterTypeFieldUpdateOperationsInput | null;
  order?: NullableIntFieldUpdateOperationsInput | null;
  agreedPriceRange?: PriceRangeUpdateOneWithoutMattersNestedInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutMattersNestedInput | null;
  externalMatter?: ExternalMatterUpdateOneWithoutMatterNestedInput | null;
  brand?: BrandUpdateOneWithoutMattersNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutMattersNestedInput | null;
  client?: ClientUpdateOneWithoutMattersNestedInput | null;
  assumptions?: AssumptionUpdateManyWithoutMatterNestedInput | null;
  collaborators?: CollaboratorUpdateManyWithoutMatterNestedInput | null;
  discounts?: DiscountUpdateManyWithoutMatterNestedInput | null;
  exclusions?: ExclusionUpdateManyWithoutMatterNestedInput | null;
  notifications?: NotificationUpdateManyWithoutMatterNestedInput | null;
  phases?: PhaseUpdateManyWithoutMatterNestedInput | null;
  uplifts?: UpliftUpdateManyWithoutMatterNestedInput | null;
  priceOptions?: PriceOptionsUpdateOneWithoutMatterNestedInput | null;
  parent?: ParentMatterUpdateOneWithoutMattersNestedInput | null;
}

export interface MatterUpdateWithoutDiscountsInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  template?: BoolFieldUpdateOperationsInput | null;
  templateType?: NullableEnumTemplateTypeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  pricingType?: EnumPricingTypeFieldUpdateOperationsInput | null;
  pricingLevel?: EnumPricingLevelFieldUpdateOperationsInput | null;
  agreedPrice?: NullableFloatFieldUpdateOperationsInput | null;
  feeCharged?: NullableFloatFieldUpdateOperationsInput | null;
  taxStatus?: EnumTaxStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  createFromTemplateId?: NullableIntFieldUpdateOperationsInput | null;
  templateGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  matterType?: EnumMatterTypeFieldUpdateOperationsInput | null;
  order?: NullableIntFieldUpdateOperationsInput | null;
  agreedPriceRange?: PriceRangeUpdateOneWithoutMattersNestedInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutMattersNestedInput | null;
  externalMatter?: ExternalMatterUpdateOneWithoutMatterNestedInput | null;
  brand?: BrandUpdateOneWithoutMattersNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutMattersNestedInput | null;
  client?: ClientUpdateOneWithoutMattersNestedInput | null;
  assumptions?: AssumptionUpdateManyWithoutMatterNestedInput | null;
  collaborators?: CollaboratorUpdateManyWithoutMatterNestedInput | null;
  disbursements?: DisbursementUpdateManyWithoutMatterNestedInput | null;
  exclusions?: ExclusionUpdateManyWithoutMatterNestedInput | null;
  notifications?: NotificationUpdateManyWithoutMatterNestedInput | null;
  phases?: PhaseUpdateManyWithoutMatterNestedInput | null;
  uplifts?: UpliftUpdateManyWithoutMatterNestedInput | null;
  priceOptions?: PriceOptionsUpdateOneWithoutMatterNestedInput | null;
  parent?: ParentMatterUpdateOneWithoutMattersNestedInput | null;
}

export interface MatterUpdateWithoutExclusionsInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  template?: BoolFieldUpdateOperationsInput | null;
  templateType?: NullableEnumTemplateTypeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  pricingType?: EnumPricingTypeFieldUpdateOperationsInput | null;
  pricingLevel?: EnumPricingLevelFieldUpdateOperationsInput | null;
  agreedPrice?: NullableFloatFieldUpdateOperationsInput | null;
  feeCharged?: NullableFloatFieldUpdateOperationsInput | null;
  taxStatus?: EnumTaxStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  createFromTemplateId?: NullableIntFieldUpdateOperationsInput | null;
  templateGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  matterType?: EnumMatterTypeFieldUpdateOperationsInput | null;
  order?: NullableIntFieldUpdateOperationsInput | null;
  agreedPriceRange?: PriceRangeUpdateOneWithoutMattersNestedInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutMattersNestedInput | null;
  externalMatter?: ExternalMatterUpdateOneWithoutMatterNestedInput | null;
  brand?: BrandUpdateOneWithoutMattersNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutMattersNestedInput | null;
  client?: ClientUpdateOneWithoutMattersNestedInput | null;
  assumptions?: AssumptionUpdateManyWithoutMatterNestedInput | null;
  collaborators?: CollaboratorUpdateManyWithoutMatterNestedInput | null;
  disbursements?: DisbursementUpdateManyWithoutMatterNestedInput | null;
  discounts?: DiscountUpdateManyWithoutMatterNestedInput | null;
  notifications?: NotificationUpdateManyWithoutMatterNestedInput | null;
  phases?: PhaseUpdateManyWithoutMatterNestedInput | null;
  uplifts?: UpliftUpdateManyWithoutMatterNestedInput | null;
  priceOptions?: PriceOptionsUpdateOneWithoutMatterNestedInput | null;
  parent?: ParentMatterUpdateOneWithoutMattersNestedInput | null;
}

export interface MatterUpdateWithoutExternalMatterInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  template?: BoolFieldUpdateOperationsInput | null;
  templateType?: NullableEnumTemplateTypeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  pricingType?: EnumPricingTypeFieldUpdateOperationsInput | null;
  pricingLevel?: EnumPricingLevelFieldUpdateOperationsInput | null;
  agreedPrice?: NullableFloatFieldUpdateOperationsInput | null;
  feeCharged?: NullableFloatFieldUpdateOperationsInput | null;
  taxStatus?: EnumTaxStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  createFromTemplateId?: NullableIntFieldUpdateOperationsInput | null;
  templateGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  matterType?: EnumMatterTypeFieldUpdateOperationsInput | null;
  order?: NullableIntFieldUpdateOperationsInput | null;
  agreedPriceRange?: PriceRangeUpdateOneWithoutMattersNestedInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutMattersNestedInput | null;
  brand?: BrandUpdateOneWithoutMattersNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutMattersNestedInput | null;
  client?: ClientUpdateOneWithoutMattersNestedInput | null;
  assumptions?: AssumptionUpdateManyWithoutMatterNestedInput | null;
  collaborators?: CollaboratorUpdateManyWithoutMatterNestedInput | null;
  disbursements?: DisbursementUpdateManyWithoutMatterNestedInput | null;
  discounts?: DiscountUpdateManyWithoutMatterNestedInput | null;
  exclusions?: ExclusionUpdateManyWithoutMatterNestedInput | null;
  notifications?: NotificationUpdateManyWithoutMatterNestedInput | null;
  phases?: PhaseUpdateManyWithoutMatterNestedInput | null;
  uplifts?: UpliftUpdateManyWithoutMatterNestedInput | null;
  priceOptions?: PriceOptionsUpdateOneWithoutMatterNestedInput | null;
  parent?: ParentMatterUpdateOneWithoutMattersNestedInput | null;
}

export interface MatterUpdateWithoutFeeEarnerInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  template?: BoolFieldUpdateOperationsInput | null;
  templateType?: NullableEnumTemplateTypeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  pricingType?: EnumPricingTypeFieldUpdateOperationsInput | null;
  pricingLevel?: EnumPricingLevelFieldUpdateOperationsInput | null;
  agreedPrice?: NullableFloatFieldUpdateOperationsInput | null;
  feeCharged?: NullableFloatFieldUpdateOperationsInput | null;
  taxStatus?: EnumTaxStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  createFromTemplateId?: NullableIntFieldUpdateOperationsInput | null;
  templateGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  matterType?: EnumMatterTypeFieldUpdateOperationsInput | null;
  order?: NullableIntFieldUpdateOperationsInput | null;
  agreedPriceRange?: PriceRangeUpdateOneWithoutMattersNestedInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutMattersNestedInput | null;
  externalMatter?: ExternalMatterUpdateOneWithoutMatterNestedInput | null;
  brand?: BrandUpdateOneWithoutMattersNestedInput | null;
  client?: ClientUpdateOneWithoutMattersNestedInput | null;
  assumptions?: AssumptionUpdateManyWithoutMatterNestedInput | null;
  collaborators?: CollaboratorUpdateManyWithoutMatterNestedInput | null;
  disbursements?: DisbursementUpdateManyWithoutMatterNestedInput | null;
  discounts?: DiscountUpdateManyWithoutMatterNestedInput | null;
  exclusions?: ExclusionUpdateManyWithoutMatterNestedInput | null;
  notifications?: NotificationUpdateManyWithoutMatterNestedInput | null;
  phases?: PhaseUpdateManyWithoutMatterNestedInput | null;
  uplifts?: UpliftUpdateManyWithoutMatterNestedInput | null;
  priceOptions?: PriceOptionsUpdateOneWithoutMatterNestedInput | null;
  parent?: ParentMatterUpdateOneWithoutMattersNestedInput | null;
}

export interface MatterUpdateWithoutNotificationsInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  template?: BoolFieldUpdateOperationsInput | null;
  templateType?: NullableEnumTemplateTypeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  pricingType?: EnumPricingTypeFieldUpdateOperationsInput | null;
  pricingLevel?: EnumPricingLevelFieldUpdateOperationsInput | null;
  agreedPrice?: NullableFloatFieldUpdateOperationsInput | null;
  feeCharged?: NullableFloatFieldUpdateOperationsInput | null;
  taxStatus?: EnumTaxStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  createFromTemplateId?: NullableIntFieldUpdateOperationsInput | null;
  templateGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  matterType?: EnumMatterTypeFieldUpdateOperationsInput | null;
  order?: NullableIntFieldUpdateOperationsInput | null;
  agreedPriceRange?: PriceRangeUpdateOneWithoutMattersNestedInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutMattersNestedInput | null;
  externalMatter?: ExternalMatterUpdateOneWithoutMatterNestedInput | null;
  brand?: BrandUpdateOneWithoutMattersNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutMattersNestedInput | null;
  client?: ClientUpdateOneWithoutMattersNestedInput | null;
  assumptions?: AssumptionUpdateManyWithoutMatterNestedInput | null;
  collaborators?: CollaboratorUpdateManyWithoutMatterNestedInput | null;
  disbursements?: DisbursementUpdateManyWithoutMatterNestedInput | null;
  discounts?: DiscountUpdateManyWithoutMatterNestedInput | null;
  exclusions?: ExclusionUpdateManyWithoutMatterNestedInput | null;
  phases?: PhaseUpdateManyWithoutMatterNestedInput | null;
  uplifts?: UpliftUpdateManyWithoutMatterNestedInput | null;
  priceOptions?: PriceOptionsUpdateOneWithoutMatterNestedInput | null;
  parent?: ParentMatterUpdateOneWithoutMattersNestedInput | null;
}

export interface MatterUpdateWithoutOrganisationalUnitInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  template?: BoolFieldUpdateOperationsInput | null;
  templateType?: NullableEnumTemplateTypeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  pricingType?: EnumPricingTypeFieldUpdateOperationsInput | null;
  pricingLevel?: EnumPricingLevelFieldUpdateOperationsInput | null;
  agreedPrice?: NullableFloatFieldUpdateOperationsInput | null;
  feeCharged?: NullableFloatFieldUpdateOperationsInput | null;
  taxStatus?: EnumTaxStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  createFromTemplateId?: NullableIntFieldUpdateOperationsInput | null;
  templateGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  matterType?: EnumMatterTypeFieldUpdateOperationsInput | null;
  order?: NullableIntFieldUpdateOperationsInput | null;
  agreedPriceRange?: PriceRangeUpdateOneWithoutMattersNestedInput | null;
  externalMatter?: ExternalMatterUpdateOneWithoutMatterNestedInput | null;
  brand?: BrandUpdateOneWithoutMattersNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutMattersNestedInput | null;
  client?: ClientUpdateOneWithoutMattersNestedInput | null;
  assumptions?: AssumptionUpdateManyWithoutMatterNestedInput | null;
  collaborators?: CollaboratorUpdateManyWithoutMatterNestedInput | null;
  disbursements?: DisbursementUpdateManyWithoutMatterNestedInput | null;
  discounts?: DiscountUpdateManyWithoutMatterNestedInput | null;
  exclusions?: ExclusionUpdateManyWithoutMatterNestedInput | null;
  notifications?: NotificationUpdateManyWithoutMatterNestedInput | null;
  phases?: PhaseUpdateManyWithoutMatterNestedInput | null;
  uplifts?: UpliftUpdateManyWithoutMatterNestedInput | null;
  priceOptions?: PriceOptionsUpdateOneWithoutMatterNestedInput | null;
  parent?: ParentMatterUpdateOneWithoutMattersNestedInput | null;
}

export interface MatterUpdateWithoutParentInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  template?: BoolFieldUpdateOperationsInput | null;
  templateType?: NullableEnumTemplateTypeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  pricingType?: EnumPricingTypeFieldUpdateOperationsInput | null;
  pricingLevel?: EnumPricingLevelFieldUpdateOperationsInput | null;
  agreedPrice?: NullableFloatFieldUpdateOperationsInput | null;
  feeCharged?: NullableFloatFieldUpdateOperationsInput | null;
  taxStatus?: EnumTaxStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  createFromTemplateId?: NullableIntFieldUpdateOperationsInput | null;
  templateGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  matterType?: EnumMatterTypeFieldUpdateOperationsInput | null;
  order?: NullableIntFieldUpdateOperationsInput | null;
  agreedPriceRange?: PriceRangeUpdateOneWithoutMattersNestedInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutMattersNestedInput | null;
  externalMatter?: ExternalMatterUpdateOneWithoutMatterNestedInput | null;
  brand?: BrandUpdateOneWithoutMattersNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutMattersNestedInput | null;
  client?: ClientUpdateOneWithoutMattersNestedInput | null;
  assumptions?: AssumptionUpdateManyWithoutMatterNestedInput | null;
  collaborators?: CollaboratorUpdateManyWithoutMatterNestedInput | null;
  disbursements?: DisbursementUpdateManyWithoutMatterNestedInput | null;
  discounts?: DiscountUpdateManyWithoutMatterNestedInput | null;
  exclusions?: ExclusionUpdateManyWithoutMatterNestedInput | null;
  notifications?: NotificationUpdateManyWithoutMatterNestedInput | null;
  phases?: PhaseUpdateManyWithoutMatterNestedInput | null;
  uplifts?: UpliftUpdateManyWithoutMatterNestedInput | null;
  priceOptions?: PriceOptionsUpdateOneWithoutMatterNestedInput | null;
}

export interface MatterUpdateWithoutPhasesInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  template?: BoolFieldUpdateOperationsInput | null;
  templateType?: NullableEnumTemplateTypeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  pricingType?: EnumPricingTypeFieldUpdateOperationsInput | null;
  pricingLevel?: EnumPricingLevelFieldUpdateOperationsInput | null;
  agreedPrice?: NullableFloatFieldUpdateOperationsInput | null;
  feeCharged?: NullableFloatFieldUpdateOperationsInput | null;
  taxStatus?: EnumTaxStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  createFromTemplateId?: NullableIntFieldUpdateOperationsInput | null;
  templateGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  matterType?: EnumMatterTypeFieldUpdateOperationsInput | null;
  order?: NullableIntFieldUpdateOperationsInput | null;
  agreedPriceRange?: PriceRangeUpdateOneWithoutMattersNestedInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutMattersNestedInput | null;
  externalMatter?: ExternalMatterUpdateOneWithoutMatterNestedInput | null;
  brand?: BrandUpdateOneWithoutMattersNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutMattersNestedInput | null;
  client?: ClientUpdateOneWithoutMattersNestedInput | null;
  assumptions?: AssumptionUpdateManyWithoutMatterNestedInput | null;
  collaborators?: CollaboratorUpdateManyWithoutMatterNestedInput | null;
  disbursements?: DisbursementUpdateManyWithoutMatterNestedInput | null;
  discounts?: DiscountUpdateManyWithoutMatterNestedInput | null;
  exclusions?: ExclusionUpdateManyWithoutMatterNestedInput | null;
  notifications?: NotificationUpdateManyWithoutMatterNestedInput | null;
  uplifts?: UpliftUpdateManyWithoutMatterNestedInput | null;
  priceOptions?: PriceOptionsUpdateOneWithoutMatterNestedInput | null;
  parent?: ParentMatterUpdateOneWithoutMattersNestedInput | null;
}

export interface MatterUpdateWithoutPriceOptionsInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  template?: BoolFieldUpdateOperationsInput | null;
  templateType?: NullableEnumTemplateTypeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  pricingType?: EnumPricingTypeFieldUpdateOperationsInput | null;
  pricingLevel?: EnumPricingLevelFieldUpdateOperationsInput | null;
  agreedPrice?: NullableFloatFieldUpdateOperationsInput | null;
  feeCharged?: NullableFloatFieldUpdateOperationsInput | null;
  taxStatus?: EnumTaxStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  createFromTemplateId?: NullableIntFieldUpdateOperationsInput | null;
  templateGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  matterType?: EnumMatterTypeFieldUpdateOperationsInput | null;
  order?: NullableIntFieldUpdateOperationsInput | null;
  agreedPriceRange?: PriceRangeUpdateOneWithoutMattersNestedInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutMattersNestedInput | null;
  externalMatter?: ExternalMatterUpdateOneWithoutMatterNestedInput | null;
  brand?: BrandUpdateOneWithoutMattersNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutMattersNestedInput | null;
  client?: ClientUpdateOneWithoutMattersNestedInput | null;
  assumptions?: AssumptionUpdateManyWithoutMatterNestedInput | null;
  collaborators?: CollaboratorUpdateManyWithoutMatterNestedInput | null;
  disbursements?: DisbursementUpdateManyWithoutMatterNestedInput | null;
  discounts?: DiscountUpdateManyWithoutMatterNestedInput | null;
  exclusions?: ExclusionUpdateManyWithoutMatterNestedInput | null;
  notifications?: NotificationUpdateManyWithoutMatterNestedInput | null;
  phases?: PhaseUpdateManyWithoutMatterNestedInput | null;
  uplifts?: UpliftUpdateManyWithoutMatterNestedInput | null;
  parent?: ParentMatterUpdateOneWithoutMattersNestedInput | null;
}

export interface MatterUpdateWithoutUpliftsInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  template?: BoolFieldUpdateOperationsInput | null;
  templateType?: NullableEnumTemplateTypeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  pricingType?: EnumPricingTypeFieldUpdateOperationsInput | null;
  pricingLevel?: EnumPricingLevelFieldUpdateOperationsInput | null;
  agreedPrice?: NullableFloatFieldUpdateOperationsInput | null;
  feeCharged?: NullableFloatFieldUpdateOperationsInput | null;
  taxStatus?: EnumTaxStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  createFromTemplateId?: NullableIntFieldUpdateOperationsInput | null;
  templateGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  matterType?: EnumMatterTypeFieldUpdateOperationsInput | null;
  order?: NullableIntFieldUpdateOperationsInput | null;
  agreedPriceRange?: PriceRangeUpdateOneWithoutMattersNestedInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutMattersNestedInput | null;
  externalMatter?: ExternalMatterUpdateOneWithoutMatterNestedInput | null;
  brand?: BrandUpdateOneWithoutMattersNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutMattersNestedInput | null;
  client?: ClientUpdateOneWithoutMattersNestedInput | null;
  assumptions?: AssumptionUpdateManyWithoutMatterNestedInput | null;
  collaborators?: CollaboratorUpdateManyWithoutMatterNestedInput | null;
  disbursements?: DisbursementUpdateManyWithoutMatterNestedInput | null;
  discounts?: DiscountUpdateManyWithoutMatterNestedInput | null;
  exclusions?: ExclusionUpdateManyWithoutMatterNestedInput | null;
  notifications?: NotificationUpdateManyWithoutMatterNestedInput | null;
  phases?: PhaseUpdateManyWithoutMatterNestedInput | null;
  priceOptions?: PriceOptionsUpdateOneWithoutMatterNestedInput | null;
  parent?: ParentMatterUpdateOneWithoutMattersNestedInput | null;
}

export interface MatterUpsertWithWhereUniqueWithoutBrandInput {
  where: MatterWhereUniqueInput;
  update: MatterUpdateWithoutBrandInput;
  create: MatterCreateWithoutBrandInput;
}

export interface MatterUpsertWithWhereUniqueWithoutClientInput {
  where: MatterWhereUniqueInput;
  update: MatterUpdateWithoutClientInput;
  create: MatterCreateWithoutClientInput;
}

export interface MatterUpsertWithWhereUniqueWithoutCreatedByInput {
  where: MatterWhereUniqueInput;
  update: MatterUpdateWithoutCreatedByInput;
  create: MatterCreateWithoutCreatedByInput;
}

export interface MatterUpsertWithWhereUniqueWithoutFeeEarnerInput {
  where: MatterWhereUniqueInput;
  update: MatterUpdateWithoutFeeEarnerInput;
  create: MatterCreateWithoutFeeEarnerInput;
}

export interface MatterUpsertWithWhereUniqueWithoutOrganisationalUnitInput {
  where: MatterWhereUniqueInput;
  update: MatterUpdateWithoutOrganisationalUnitInput;
  create: MatterCreateWithoutOrganisationalUnitInput;
}

export interface MatterUpsertWithWhereUniqueWithoutParentInput {
  where: MatterWhereUniqueInput;
  update: MatterUpdateWithoutParentInput;
  create: MatterCreateWithoutParentInput;
}

export interface MatterUpsertWithoutAssumptionsInput {
  update: MatterUpdateWithoutAssumptionsInput;
  create: MatterCreateWithoutAssumptionsInput;
}

export interface MatterUpsertWithoutCollaboratorsInput {
  update: MatterUpdateWithoutCollaboratorsInput;
  create: MatterCreateWithoutCollaboratorsInput;
}

export interface MatterUpsertWithoutDisbursementsInput {
  update: MatterUpdateWithoutDisbursementsInput;
  create: MatterCreateWithoutDisbursementsInput;
}

export interface MatterUpsertWithoutDiscountsInput {
  update: MatterUpdateWithoutDiscountsInput;
  create: MatterCreateWithoutDiscountsInput;
}

export interface MatterUpsertWithoutExclusionsInput {
  update: MatterUpdateWithoutExclusionsInput;
  create: MatterCreateWithoutExclusionsInput;
}

export interface MatterUpsertWithoutExternalMatterInput {
  update: MatterUpdateWithoutExternalMatterInput;
  create: MatterCreateWithoutExternalMatterInput;
}

export interface MatterUpsertWithoutNotificationsInput {
  update: MatterUpdateWithoutNotificationsInput;
  create: MatterCreateWithoutNotificationsInput;
}

export interface MatterUpsertWithoutPhasesInput {
  update: MatterUpdateWithoutPhasesInput;
  create: MatterCreateWithoutPhasesInput;
}

export interface MatterUpsertWithoutPriceOptionsInput {
  update: MatterUpdateWithoutPriceOptionsInput;
  create: MatterCreateWithoutPriceOptionsInput;
}

export interface MatterUpsertWithoutUpliftsInput {
  update: MatterUpdateWithoutUpliftsInput;
  create: MatterCreateWithoutUpliftsInput;
}

export interface MatterWhereInput {
  AND?: MatterWhereInput[] | null;
  OR?: MatterWhereInput[] | null;
  NOT?: MatterWhereInput[] | null;
  id?: IntFilter | null;
  reference?: UuidFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  template?: BoolFilter | null;
  templateType?: EnumTemplateTypeNullableFilter | null;
  title?: StringFilter | null;
  externalMatterId?: IntNullableFilter | null;
  organisationalUnitId?: IntNullableFilter | null;
  leadFeeEarnerId?: IntNullableFilter | null;
  clientId?: IntNullableFilter | null;
  externalReference?: StringNullableFilter | null;
  status?: EnumMatterStatusFilter | null;
  pricingType?: EnumPricingTypeFilter | null;
  pricingLevel?: EnumPricingLevelFilter | null;
  agreedPrice?: FloatNullableFilter | null;
  feeCharged?: FloatNullableFilter | null;
  taxStatus?: EnumTaxStatusFilter | null;
  brandId?: IntNullableFilter | null;
  includeTasksInProposalOutput?: BoolNullableFilter | null;
  includeRatesInProposalOutput?: BoolNullableFilter | null;
  createdById?: IntFilter | null;
  priceOptionsId?: IntNullableFilter | null;
  priceRangeId?: IntNullableFilter | null;
  createFromTemplateId?: IntNullableFilter | null;
  templateGpmThreshold?: IntNullableFilter | null;
  matterType?: EnumMatterTypeFilter | null;
  parentMatterId?: IntNullableFilter | null;
  order?: IntNullableFilter | null;
  agreedPriceRange?: PriceRangeRelationFilter | null;
  organisationalUnit?: OrganisationalUnitRelationFilter | null;
  externalMatter?: ExternalMatterRelationFilter | null;
  brand?: BrandRelationFilter | null;
  feeEarner?: FeeEarnerRelationFilter | null;
  client?: ClientRelationFilter | null;
  assumptions?: AssumptionListRelationFilter | null;
  collaborators?: CollaboratorListRelationFilter | null;
  disbursements?: DisbursementListRelationFilter | null;
  discounts?: DiscountListRelationFilter | null;
  exclusions?: ExclusionListRelationFilter | null;
  notifications?: NotificationListRelationFilter | null;
  phases?: PhaseListRelationFilter | null;
  uplifts?: UpliftListRelationFilter | null;
  priceOptions?: PriceOptionsRelationFilter | null;
  parent?: ParentMatterRelationFilter | null;
}

export interface MatterWhereUniqueInput {
  id?: number | null;
  reference?: string | null;
  externalMatterId?: number | null;
  priceOptionsId?: number | null;
}

export interface NestedBoolFilter {
  equals?: boolean | null;
  not?: NestedBoolFilter | null;
}

export interface NestedBoolNullableFilter {
  equals?: boolean | null;
  not?: NestedBoolNullableFilter | null;
}

export interface NestedDateTimeFilter {
  equals?: any | null;
  in?: any[] | null;
  notIn?: any[] | null;
  lt?: any | null;
  lte?: any | null;
  gt?: any | null;
  gte?: any | null;
  not?: NestedDateTimeFilter | null;
}

export interface NestedDateTimeNullableFilter {
  equals?: any | null;
  in?: any[] | null;
  notIn?: any[] | null;
  lt?: any | null;
  lte?: any | null;
  gt?: any | null;
  gte?: any | null;
  not?: NestedDateTimeNullableFilter | null;
}

export interface NestedEnumDiscountTypeFilter {
  equals?: DiscountType | null;
  in?: DiscountType[] | null;
  notIn?: DiscountType[] | null;
  not?: NestedEnumDiscountTypeFilter | null;
}

export interface NestedEnumExternalMatterStatusFilter {
  equals?: ExternalMatterStatus | null;
  in?: ExternalMatterStatus[] | null;
  notIn?: ExternalMatterStatus[] | null;
  not?: NestedEnumExternalMatterStatusFilter | null;
}

export interface NestedEnumExternalMatterTaxStatusFilter {
  equals?: ExternalMatterTaxStatus | null;
  in?: ExternalMatterTaxStatus[] | null;
  notIn?: ExternalMatterTaxStatus[] | null;
  not?: NestedEnumExternalMatterTaxStatusFilter | null;
}

export interface NestedEnumMatterStatusFilter {
  equals?: MatterStatus | null;
  in?: MatterStatus[] | null;
  notIn?: MatterStatus[] | null;
  not?: NestedEnumMatterStatusFilter | null;
}

export interface NestedEnumMatterTypeFilter {
  equals?: MatterType | null;
  in?: MatterType[] | null;
  notIn?: MatterType[] | null;
  not?: NestedEnumMatterTypeFilter | null;
}

export interface NestedEnumNotificationTypeFilter {
  equals?: NotificationType | null;
  in?: NotificationType[] | null;
  notIn?: NotificationType[] | null;
  not?: NestedEnumNotificationTypeFilter | null;
}

export interface NestedEnumPricingLevelFilter {
  equals?: PricingLevel | null;
  in?: PricingLevel[] | null;
  notIn?: PricingLevel[] | null;
  not?: NestedEnumPricingLevelFilter | null;
}

export interface NestedEnumPricingTypeFilter {
  equals?: PricingType | null;
  in?: PricingType[] | null;
  notIn?: PricingType[] | null;
  not?: NestedEnumPricingTypeFilter | null;
}

export interface NestedEnumTaxLabelStatusFilter {
  equals?: TaxLabelStatus | null;
  in?: TaxLabelStatus[] | null;
  notIn?: TaxLabelStatus[] | null;
  not?: NestedEnumTaxLabelStatusFilter | null;
}

export interface NestedEnumTaxStatusFilter {
  equals?: TaxStatus | null;
  in?: TaxStatus[] | null;
  notIn?: TaxStatus[] | null;
  not?: NestedEnumTaxStatusFilter | null;
}

export interface NestedEnumTemplateTypeNullableFilter {
  equals?: TemplateType | null;
  in?: TemplateType[] | null;
  notIn?: TemplateType[] | null;
  not?: NestedEnumTemplateTypeNullableFilter | null;
}

export interface NestedEnumUpliftTypeFilter {
  equals?: UpliftType | null;
  in?: UpliftType[] | null;
  notIn?: UpliftType[] | null;
  not?: NestedEnumUpliftTypeFilter | null;
}

export interface NestedFloatFilter {
  equals?: number | null;
  in?: number[] | null;
  notIn?: number[] | null;
  lt?: number | null;
  lte?: number | null;
  gt?: number | null;
  gte?: number | null;
  not?: NestedFloatFilter | null;
}

export interface NestedFloatNullableFilter {
  equals?: number | null;
  in?: number[] | null;
  notIn?: number[] | null;
  lt?: number | null;
  lte?: number | null;
  gt?: number | null;
  gte?: number | null;
  not?: NestedFloatNullableFilter | null;
}

export interface NestedIntFilter {
  equals?: number | null;
  in?: number[] | null;
  notIn?: number[] | null;
  lt?: number | null;
  lte?: number | null;
  gt?: number | null;
  gte?: number | null;
  not?: NestedIntFilter | null;
}

export interface NestedIntNullableFilter {
  equals?: number | null;
  in?: number[] | null;
  notIn?: number[] | null;
  lt?: number | null;
  lte?: number | null;
  gt?: number | null;
  gte?: number | null;
  not?: NestedIntNullableFilter | null;
}

export interface NestedStringFilter {
  equals?: string | null;
  in?: string[] | null;
  notIn?: string[] | null;
  lt?: string | null;
  lte?: string | null;
  gt?: string | null;
  gte?: string | null;
  contains?: string | null;
  startsWith?: string | null;
  endsWith?: string | null;
  not?: NestedStringFilter | null;
}

export interface NestedStringNullableFilter {
  equals?: string | null;
  in?: string[] | null;
  notIn?: string[] | null;
  lt?: string | null;
  lte?: string | null;
  gt?: string | null;
  gte?: string | null;
  contains?: string | null;
  startsWith?: string | null;
  endsWith?: string | null;
  not?: NestedStringNullableFilter | null;
}

export interface NestedUuidFilter {
  equals?: string | null;
  in?: string[] | null;
  notIn?: string[] | null;
  lt?: string | null;
  lte?: string | null;
  gt?: string | null;
  gte?: string | null;
  not?: NestedUuidFilter | null;
}

export interface NotificationCreateManyMatterInput {
  id?: number | null;
  title: string;
  type: NotificationType;
  description: string;
  userId: number;
  message?: string | null;
  notificationRuleId?: number | null;
  archived?: boolean | null;
  parentMatterId?: number | null;
}

export interface NotificationCreateManyMatterInputEnvelope {
  data: NotificationCreateManyMatterInput[];
  skipDuplicates?: boolean | null;
}

export interface NotificationCreateManyNotificationRuleInput {
  id?: number | null;
  title: string;
  type: NotificationType;
  description: string;
  userId: number;
  matterId?: number | null;
  message?: string | null;
  archived?: boolean | null;
  parentMatterId?: number | null;
}

export interface NotificationCreateManyNotificationRuleInputEnvelope {
  data: NotificationCreateManyNotificationRuleInput[];
  skipDuplicates?: boolean | null;
}

export interface NotificationCreateManyParentMatterInput {
  id?: number | null;
  title: string;
  type: NotificationType;
  description: string;
  userId: number;
  matterId?: number | null;
  message?: string | null;
  notificationRuleId?: number | null;
  archived?: boolean | null;
}

export interface NotificationCreateManyParentMatterInputEnvelope {
  data: NotificationCreateManyParentMatterInput[];
  skipDuplicates?: boolean | null;
}

export interface NotificationCreateManyUserInput {
  id?: number | null;
  title: string;
  type: NotificationType;
  description: string;
  matterId?: number | null;
  message?: string | null;
  notificationRuleId?: number | null;
  archived?: boolean | null;
  parentMatterId?: number | null;
}

export interface NotificationCreateManyUserInputEnvelope {
  data: NotificationCreateManyUserInput[];
  skipDuplicates?: boolean | null;
}

export interface NotificationCreateNestedManyWithoutMatterInput {
  create?: NotificationCreateWithoutMatterInput[] | null;
  connectOrCreate?: NotificationCreateOrConnectWithoutMatterInput[] | null;
  createMany?: NotificationCreateManyMatterInputEnvelope | null;
  connect?: NotificationWhereUniqueInput[] | null;
}

export interface NotificationCreateNestedManyWithoutNotificationRuleInput {
  create?: NotificationCreateWithoutNotificationRuleInput[] | null;
  connectOrCreate?: NotificationCreateOrConnectWithoutNotificationRuleInput[] | null;
  createMany?: NotificationCreateManyNotificationRuleInputEnvelope | null;
  connect?: NotificationWhereUniqueInput[] | null;
}

export interface NotificationCreateNestedManyWithoutParentMatterInput {
  create?: NotificationCreateWithoutParentMatterInput[] | null;
  connectOrCreate?: NotificationCreateOrConnectWithoutParentMatterInput[] | null;
  createMany?: NotificationCreateManyParentMatterInputEnvelope | null;
  connect?: NotificationWhereUniqueInput[] | null;
}

export interface NotificationCreateNestedManyWithoutUserInput {
  create?: NotificationCreateWithoutUserInput[] | null;
  connectOrCreate?: NotificationCreateOrConnectWithoutUserInput[] | null;
  createMany?: NotificationCreateManyUserInputEnvelope | null;
  connect?: NotificationWhereUniqueInput[] | null;
}

export interface NotificationCreateOrConnectWithoutMatterInput {
  where: NotificationWhereUniqueInput;
  create: NotificationCreateWithoutMatterInput;
}

export interface NotificationCreateOrConnectWithoutNotificationRuleInput {
  where: NotificationWhereUniqueInput;
  create: NotificationCreateWithoutNotificationRuleInput;
}

export interface NotificationCreateOrConnectWithoutParentMatterInput {
  where: NotificationWhereUniqueInput;
  create: NotificationCreateWithoutParentMatterInput;
}

export interface NotificationCreateOrConnectWithoutUserInput {
  where: NotificationWhereUniqueInput;
  create: NotificationCreateWithoutUserInput;
}

export interface NotificationCreateWithoutMatterInput {
  title: string;
  type: NotificationType;
  description: string;
  message?: string | null;
  archived?: boolean | null;
  user: UserCreateNestedOneWithoutNotificationsInput;
  parentMatter?: ParentMatterCreateNestedOneWithoutNotificationsInput | null;
  notificationRule?: NotificationRuleCreateNestedOneWithoutNotificationsInput | null;
}

export interface NotificationCreateWithoutNotificationRuleInput {
  title: string;
  type: NotificationType;
  description: string;
  message?: string | null;
  archived?: boolean | null;
  user: UserCreateNestedOneWithoutNotificationsInput;
  matter?: MatterCreateNestedOneWithoutNotificationsInput | null;
  parentMatter?: ParentMatterCreateNestedOneWithoutNotificationsInput | null;
}

export interface NotificationCreateWithoutParentMatterInput {
  title: string;
  type: NotificationType;
  description: string;
  message?: string | null;
  archived?: boolean | null;
  user: UserCreateNestedOneWithoutNotificationsInput;
  matter?: MatterCreateNestedOneWithoutNotificationsInput | null;
  notificationRule?: NotificationRuleCreateNestedOneWithoutNotificationsInput | null;
}

export interface NotificationCreateWithoutUserInput {
  title: string;
  type: NotificationType;
  description: string;
  message?: string | null;
  archived?: boolean | null;
  matter?: MatterCreateNestedOneWithoutNotificationsInput | null;
  parentMatter?: ParentMatterCreateNestedOneWithoutNotificationsInput | null;
  notificationRule?: NotificationRuleCreateNestedOneWithoutNotificationsInput | null;
}

export interface NotificationListRelationFilter {
  every?: NotificationWhereInput | null;
  some?: NotificationWhereInput | null;
  none?: NotificationWhereInput | null;
}

export interface NotificationRuleClientsCreateManyClientInput {
  id?: number | null;
  notificationRuleId: number;
  updatedAt?: any | null;
}

export interface NotificationRuleClientsCreateManyClientInputEnvelope {
  data: NotificationRuleClientsCreateManyClientInput[];
  skipDuplicates?: boolean | null;
}

export interface NotificationRuleClientsCreateManyNotificationRuleInput {
  id?: number | null;
  clientId: number;
  updatedAt?: any | null;
}

export interface NotificationRuleClientsCreateManyNotificationRuleInputEnvelope {
  data: NotificationRuleClientsCreateManyNotificationRuleInput[];
  skipDuplicates?: boolean | null;
}

export interface NotificationRuleClientsCreateNestedManyWithoutClientInput {
  create?: NotificationRuleClientsCreateWithoutClientInput[] | null;
  connectOrCreate?: NotificationRuleClientsCreateOrConnectWithoutClientInput[] | null;
  createMany?: NotificationRuleClientsCreateManyClientInputEnvelope | null;
  connect?: NotificationRuleClientsWhereUniqueInput[] | null;
}

export interface NotificationRuleClientsCreateNestedManyWithoutNotificationRuleInput {
  create?: NotificationRuleClientsCreateWithoutNotificationRuleInput[] | null;
  connectOrCreate?: NotificationRuleClientsCreateOrConnectWithoutNotificationRuleInput[] | null;
  createMany?: NotificationRuleClientsCreateManyNotificationRuleInputEnvelope | null;
  connect?: NotificationRuleClientsWhereUniqueInput[] | null;
}

export interface NotificationRuleClientsCreateOrConnectWithoutClientInput {
  where: NotificationRuleClientsWhereUniqueInput;
  create: NotificationRuleClientsCreateWithoutClientInput;
}

export interface NotificationRuleClientsCreateOrConnectWithoutNotificationRuleInput {
  where: NotificationRuleClientsWhereUniqueInput;
  create: NotificationRuleClientsCreateWithoutNotificationRuleInput;
}

export interface NotificationRuleClientsCreateWithoutClientInput {
  updatedAt?: any | null;
  notificationRule: NotificationRuleCreateNestedOneWithoutTriggerClientsInput;
}

export interface NotificationRuleClientsCreateWithoutNotificationRuleInput {
  updatedAt?: any | null;
  Client: ClientCreateNestedOneWithoutNotificationRuleInput;
}

export interface NotificationRuleClientsListRelationFilter {
  every?: NotificationRuleClientsWhereInput | null;
  some?: NotificationRuleClientsWhereInput | null;
  none?: NotificationRuleClientsWhereInput | null;
}

export interface NotificationRuleClientsScalarWhereInput {
  AND?: NotificationRuleClientsScalarWhereInput[] | null;
  OR?: NotificationRuleClientsScalarWhereInput[] | null;
  NOT?: NotificationRuleClientsScalarWhereInput[] | null;
  id?: IntFilter | null;
  notificationRuleId?: IntFilter | null;
  clientId?: IntFilter | null;
  updatedAt?: DateTimeFilter | null;
}

export interface NotificationRuleClientsUpdateManyMutationInput {
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
}

export interface NotificationRuleClientsUpdateManyWithWhereWithoutClientInput {
  where: NotificationRuleClientsScalarWhereInput;
  data: NotificationRuleClientsUpdateManyMutationInput;
}

export interface NotificationRuleClientsUpdateManyWithWhereWithoutNotificationRuleInput {
  where: NotificationRuleClientsScalarWhereInput;
  data: NotificationRuleClientsUpdateManyMutationInput;
}

export interface NotificationRuleClientsUpdateManyWithoutClientNestedInput {
  create?: NotificationRuleClientsCreateWithoutClientInput[] | null;
  connectOrCreate?: NotificationRuleClientsCreateOrConnectWithoutClientInput[] | null;
  upsert?: NotificationRuleClientsUpsertWithWhereUniqueWithoutClientInput[] | null;
  createMany?: NotificationRuleClientsCreateManyClientInputEnvelope | null;
  set?: NotificationRuleClientsWhereUniqueInput[] | null;
  disconnect?: NotificationRuleClientsWhereUniqueInput[] | null;
  delete?: NotificationRuleClientsWhereUniqueInput[] | null;
  connect?: NotificationRuleClientsWhereUniqueInput[] | null;
  update?: NotificationRuleClientsUpdateWithWhereUniqueWithoutClientInput[] | null;
  updateMany?: NotificationRuleClientsUpdateManyWithWhereWithoutClientInput[] | null;
  deleteMany?: NotificationRuleClientsScalarWhereInput[] | null;
}

export interface NotificationRuleClientsUpdateManyWithoutNotificationRuleNestedInput {
  create?: NotificationRuleClientsCreateWithoutNotificationRuleInput[] | null;
  connectOrCreate?: NotificationRuleClientsCreateOrConnectWithoutNotificationRuleInput[] | null;
  upsert?: NotificationRuleClientsUpsertWithWhereUniqueWithoutNotificationRuleInput[] | null;
  createMany?: NotificationRuleClientsCreateManyNotificationRuleInputEnvelope | null;
  set?: NotificationRuleClientsWhereUniqueInput[] | null;
  disconnect?: NotificationRuleClientsWhereUniqueInput[] | null;
  delete?: NotificationRuleClientsWhereUniqueInput[] | null;
  connect?: NotificationRuleClientsWhereUniqueInput[] | null;
  update?: NotificationRuleClientsUpdateWithWhereUniqueWithoutNotificationRuleInput[] | null;
  updateMany?: NotificationRuleClientsUpdateManyWithWhereWithoutNotificationRuleInput[] | null;
  deleteMany?: NotificationRuleClientsScalarWhereInput[] | null;
}

export interface NotificationRuleClientsUpdateWithWhereUniqueWithoutClientInput {
  where: NotificationRuleClientsWhereUniqueInput;
  data: NotificationRuleClientsUpdateWithoutClientInput;
}

export interface NotificationRuleClientsUpdateWithWhereUniqueWithoutNotificationRuleInput {
  where: NotificationRuleClientsWhereUniqueInput;
  data: NotificationRuleClientsUpdateWithoutNotificationRuleInput;
}

export interface NotificationRuleClientsUpdateWithoutClientInput {
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  notificationRule?: NotificationRuleUpdateOneRequiredWithoutTriggerClientsNestedInput | null;
}

export interface NotificationRuleClientsUpdateWithoutNotificationRuleInput {
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  Client?: ClientUpdateOneRequiredWithoutNotificationRuleNestedInput | null;
}

export interface NotificationRuleClientsUpsertWithWhereUniqueWithoutClientInput {
  where: NotificationRuleClientsWhereUniqueInput;
  update: NotificationRuleClientsUpdateWithoutClientInput;
  create: NotificationRuleClientsCreateWithoutClientInput;
}

export interface NotificationRuleClientsUpsertWithWhereUniqueWithoutNotificationRuleInput {
  where: NotificationRuleClientsWhereUniqueInput;
  update: NotificationRuleClientsUpdateWithoutNotificationRuleInput;
  create: NotificationRuleClientsCreateWithoutNotificationRuleInput;
}

export interface NotificationRuleClientsWhereInput {
  AND?: NotificationRuleClientsWhereInput[] | null;
  OR?: NotificationRuleClientsWhereInput[] | null;
  NOT?: NotificationRuleClientsWhereInput[] | null;
  id?: IntFilter | null;
  notificationRuleId?: IntFilter | null;
  clientId?: IntFilter | null;
  updatedAt?: DateTimeFilter | null;
  notificationRule?: NotificationRuleRelationFilter | null;
  Client?: ClientRelationFilter | null;
}

export interface NotificationRuleClientsWhereUniqueInput {
  id?: number | null;
}

export interface NotificationRuleCreateInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  name: string;
  proposalGpmThreshold?: number | null;
  proposalFeeThreshold?: number | null;
  activeGpmThreshold?: number | null;
  accruedTimeThreshold?: number | null;
  accruedBudgetThreshold?: number | null;
  deletedAt?: any | null;
  notifications?: NotificationCreateNestedManyWithoutNotificationRuleInput | null;
  triggerUsers?: NotificationRuleUserTriggerCreateNestedManyWithoutNotificationRuleInput | null;
  notifyUsers?: NotificationRuleUserNotifyCreateNestedManyWithoutNotificationRuleInput | null;
  triggerFeeEarnerLevels?: NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutNotificationRuleInput | null;
  notifyFeeEarnerLevels?: NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutNotificationRuleInput | null;
  triggerClients?: NotificationRuleClientsCreateNestedManyWithoutNotificationRuleInput | null;
  triggerOrganisationalUnits?: NotificationRuleOrganisationalUnitsCreateNestedManyWithoutNotificationRuleInput | null;
}

export interface NotificationRuleCreateNestedOneWithoutNotificationsInput {
  create?: NotificationRuleCreateWithoutNotificationsInput | null;
  connectOrCreate?: NotificationRuleCreateOrConnectWithoutNotificationsInput | null;
  connect?: NotificationRuleWhereUniqueInput | null;
}

export interface NotificationRuleCreateNestedOneWithoutNotifyFeeEarnerLevelsInput {
  create?: NotificationRuleCreateWithoutNotifyFeeEarnerLevelsInput | null;
  connectOrCreate?: NotificationRuleCreateOrConnectWithoutNotifyFeeEarnerLevelsInput | null;
  connect?: NotificationRuleWhereUniqueInput | null;
}

export interface NotificationRuleCreateNestedOneWithoutNotifyUsersInput {
  create?: NotificationRuleCreateWithoutNotifyUsersInput | null;
  connectOrCreate?: NotificationRuleCreateOrConnectWithoutNotifyUsersInput | null;
  connect?: NotificationRuleWhereUniqueInput | null;
}

export interface NotificationRuleCreateNestedOneWithoutTriggerClientsInput {
  create?: NotificationRuleCreateWithoutTriggerClientsInput | null;
  connectOrCreate?: NotificationRuleCreateOrConnectWithoutTriggerClientsInput | null;
  connect?: NotificationRuleWhereUniqueInput | null;
}

export interface NotificationRuleCreateNestedOneWithoutTriggerFeeEarnerLevelsInput {
  create?: NotificationRuleCreateWithoutTriggerFeeEarnerLevelsInput | null;
  connectOrCreate?: NotificationRuleCreateOrConnectWithoutTriggerFeeEarnerLevelsInput | null;
  connect?: NotificationRuleWhereUniqueInput | null;
}

export interface NotificationRuleCreateNestedOneWithoutTriggerOrganisationalUnitsInput {
  create?: NotificationRuleCreateWithoutTriggerOrganisationalUnitsInput | null;
  connectOrCreate?: NotificationRuleCreateOrConnectWithoutTriggerOrganisationalUnitsInput | null;
  connect?: NotificationRuleWhereUniqueInput | null;
}

export interface NotificationRuleCreateNestedOneWithoutTriggerUsersInput {
  create?: NotificationRuleCreateWithoutTriggerUsersInput | null;
  connectOrCreate?: NotificationRuleCreateOrConnectWithoutTriggerUsersInput | null;
  connect?: NotificationRuleWhereUniqueInput | null;
}

export interface NotificationRuleCreateOrConnectWithoutNotificationsInput {
  where: NotificationRuleWhereUniqueInput;
  create: NotificationRuleCreateWithoutNotificationsInput;
}

export interface NotificationRuleCreateOrConnectWithoutNotifyFeeEarnerLevelsInput {
  where: NotificationRuleWhereUniqueInput;
  create: NotificationRuleCreateWithoutNotifyFeeEarnerLevelsInput;
}

export interface NotificationRuleCreateOrConnectWithoutNotifyUsersInput {
  where: NotificationRuleWhereUniqueInput;
  create: NotificationRuleCreateWithoutNotifyUsersInput;
}

export interface NotificationRuleCreateOrConnectWithoutTriggerClientsInput {
  where: NotificationRuleWhereUniqueInput;
  create: NotificationRuleCreateWithoutTriggerClientsInput;
}

export interface NotificationRuleCreateOrConnectWithoutTriggerFeeEarnerLevelsInput {
  where: NotificationRuleWhereUniqueInput;
  create: NotificationRuleCreateWithoutTriggerFeeEarnerLevelsInput;
}

export interface NotificationRuleCreateOrConnectWithoutTriggerOrganisationalUnitsInput {
  where: NotificationRuleWhereUniqueInput;
  create: NotificationRuleCreateWithoutTriggerOrganisationalUnitsInput;
}

export interface NotificationRuleCreateOrConnectWithoutTriggerUsersInput {
  where: NotificationRuleWhereUniqueInput;
  create: NotificationRuleCreateWithoutTriggerUsersInput;
}

export interface NotificationRuleCreateWithoutNotificationsInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  name: string;
  proposalGpmThreshold?: number | null;
  proposalFeeThreshold?: number | null;
  activeGpmThreshold?: number | null;
  accruedTimeThreshold?: number | null;
  accruedBudgetThreshold?: number | null;
  deletedAt?: any | null;
  triggerUsers?: NotificationRuleUserTriggerCreateNestedManyWithoutNotificationRuleInput | null;
  notifyUsers?: NotificationRuleUserNotifyCreateNestedManyWithoutNotificationRuleInput | null;
  triggerFeeEarnerLevels?: NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutNotificationRuleInput | null;
  notifyFeeEarnerLevels?: NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutNotificationRuleInput | null;
  triggerClients?: NotificationRuleClientsCreateNestedManyWithoutNotificationRuleInput | null;
  triggerOrganisationalUnits?: NotificationRuleOrganisationalUnitsCreateNestedManyWithoutNotificationRuleInput | null;
}

export interface NotificationRuleCreateWithoutNotifyFeeEarnerLevelsInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  name: string;
  proposalGpmThreshold?: number | null;
  proposalFeeThreshold?: number | null;
  activeGpmThreshold?: number | null;
  accruedTimeThreshold?: number | null;
  accruedBudgetThreshold?: number | null;
  deletedAt?: any | null;
  notifications?: NotificationCreateNestedManyWithoutNotificationRuleInput | null;
  triggerUsers?: NotificationRuleUserTriggerCreateNestedManyWithoutNotificationRuleInput | null;
  notifyUsers?: NotificationRuleUserNotifyCreateNestedManyWithoutNotificationRuleInput | null;
  triggerFeeEarnerLevels?: NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutNotificationRuleInput | null;
  triggerClients?: NotificationRuleClientsCreateNestedManyWithoutNotificationRuleInput | null;
  triggerOrganisationalUnits?: NotificationRuleOrganisationalUnitsCreateNestedManyWithoutNotificationRuleInput | null;
}

export interface NotificationRuleCreateWithoutNotifyUsersInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  name: string;
  proposalGpmThreshold?: number | null;
  proposalFeeThreshold?: number | null;
  activeGpmThreshold?: number | null;
  accruedTimeThreshold?: number | null;
  accruedBudgetThreshold?: number | null;
  deletedAt?: any | null;
  notifications?: NotificationCreateNestedManyWithoutNotificationRuleInput | null;
  triggerUsers?: NotificationRuleUserTriggerCreateNestedManyWithoutNotificationRuleInput | null;
  triggerFeeEarnerLevels?: NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutNotificationRuleInput | null;
  notifyFeeEarnerLevels?: NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutNotificationRuleInput | null;
  triggerClients?: NotificationRuleClientsCreateNestedManyWithoutNotificationRuleInput | null;
  triggerOrganisationalUnits?: NotificationRuleOrganisationalUnitsCreateNestedManyWithoutNotificationRuleInput | null;
}

export interface NotificationRuleCreateWithoutTriggerClientsInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  name: string;
  proposalGpmThreshold?: number | null;
  proposalFeeThreshold?: number | null;
  activeGpmThreshold?: number | null;
  accruedTimeThreshold?: number | null;
  accruedBudgetThreshold?: number | null;
  deletedAt?: any | null;
  notifications?: NotificationCreateNestedManyWithoutNotificationRuleInput | null;
  triggerUsers?: NotificationRuleUserTriggerCreateNestedManyWithoutNotificationRuleInput | null;
  notifyUsers?: NotificationRuleUserNotifyCreateNestedManyWithoutNotificationRuleInput | null;
  triggerFeeEarnerLevels?: NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutNotificationRuleInput | null;
  notifyFeeEarnerLevels?: NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutNotificationRuleInput | null;
  triggerOrganisationalUnits?: NotificationRuleOrganisationalUnitsCreateNestedManyWithoutNotificationRuleInput | null;
}

export interface NotificationRuleCreateWithoutTriggerFeeEarnerLevelsInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  name: string;
  proposalGpmThreshold?: number | null;
  proposalFeeThreshold?: number | null;
  activeGpmThreshold?: number | null;
  accruedTimeThreshold?: number | null;
  accruedBudgetThreshold?: number | null;
  deletedAt?: any | null;
  notifications?: NotificationCreateNestedManyWithoutNotificationRuleInput | null;
  triggerUsers?: NotificationRuleUserTriggerCreateNestedManyWithoutNotificationRuleInput | null;
  notifyUsers?: NotificationRuleUserNotifyCreateNestedManyWithoutNotificationRuleInput | null;
  notifyFeeEarnerLevels?: NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutNotificationRuleInput | null;
  triggerClients?: NotificationRuleClientsCreateNestedManyWithoutNotificationRuleInput | null;
  triggerOrganisationalUnits?: NotificationRuleOrganisationalUnitsCreateNestedManyWithoutNotificationRuleInput | null;
}

export interface NotificationRuleCreateWithoutTriggerOrganisationalUnitsInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  name: string;
  proposalGpmThreshold?: number | null;
  proposalFeeThreshold?: number | null;
  activeGpmThreshold?: number | null;
  accruedTimeThreshold?: number | null;
  accruedBudgetThreshold?: number | null;
  deletedAt?: any | null;
  notifications?: NotificationCreateNestedManyWithoutNotificationRuleInput | null;
  triggerUsers?: NotificationRuleUserTriggerCreateNestedManyWithoutNotificationRuleInput | null;
  notifyUsers?: NotificationRuleUserNotifyCreateNestedManyWithoutNotificationRuleInput | null;
  triggerFeeEarnerLevels?: NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutNotificationRuleInput | null;
  notifyFeeEarnerLevels?: NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutNotificationRuleInput | null;
  triggerClients?: NotificationRuleClientsCreateNestedManyWithoutNotificationRuleInput | null;
}

export interface NotificationRuleCreateWithoutTriggerUsersInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  name: string;
  proposalGpmThreshold?: number | null;
  proposalFeeThreshold?: number | null;
  activeGpmThreshold?: number | null;
  accruedTimeThreshold?: number | null;
  accruedBudgetThreshold?: number | null;
  deletedAt?: any | null;
  notifications?: NotificationCreateNestedManyWithoutNotificationRuleInput | null;
  notifyUsers?: NotificationRuleUserNotifyCreateNestedManyWithoutNotificationRuleInput | null;
  triggerFeeEarnerLevels?: NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutNotificationRuleInput | null;
  notifyFeeEarnerLevels?: NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutNotificationRuleInput | null;
  triggerClients?: NotificationRuleClientsCreateNestedManyWithoutNotificationRuleInput | null;
  triggerOrganisationalUnits?: NotificationRuleOrganisationalUnitsCreateNestedManyWithoutNotificationRuleInput | null;
}

export interface NotificationRuleFeeEarnerLevelNotifyCreateManyFeeEarnerLevelInput {
  id?: number | null;
  notificationRuleId: number;
  updatedAt?: any | null;
}

export interface NotificationRuleFeeEarnerLevelNotifyCreateManyFeeEarnerLevelInputEnvelope {
  data: NotificationRuleFeeEarnerLevelNotifyCreateManyFeeEarnerLevelInput[];
  skipDuplicates?: boolean | null;
}

export interface NotificationRuleFeeEarnerLevelNotifyCreateManyNotificationRuleInput {
  id?: number | null;
  feeEarnerLevelId: number;
  updatedAt?: any | null;
}

export interface NotificationRuleFeeEarnerLevelNotifyCreateManyNotificationRuleInputEnvelope {
  data: NotificationRuleFeeEarnerLevelNotifyCreateManyNotificationRuleInput[];
  skipDuplicates?: boolean | null;
}

export interface NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutFeeEarnerLevelInput {
  create?: NotificationRuleFeeEarnerLevelNotifyCreateWithoutFeeEarnerLevelInput[] | null;
  connectOrCreate?:
    | NotificationRuleFeeEarnerLevelNotifyCreateOrConnectWithoutFeeEarnerLevelInput[]
    | null;
  createMany?: NotificationRuleFeeEarnerLevelNotifyCreateManyFeeEarnerLevelInputEnvelope | null;
  connect?: NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput[] | null;
}

export interface NotificationRuleFeeEarnerLevelNotifyCreateNestedManyWithoutNotificationRuleInput {
  create?: NotificationRuleFeeEarnerLevelNotifyCreateWithoutNotificationRuleInput[] | null;
  connectOrCreate?:
    | NotificationRuleFeeEarnerLevelNotifyCreateOrConnectWithoutNotificationRuleInput[]
    | null;
  createMany?: NotificationRuleFeeEarnerLevelNotifyCreateManyNotificationRuleInputEnvelope | null;
  connect?: NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput[] | null;
}

export interface NotificationRuleFeeEarnerLevelNotifyCreateOrConnectWithoutFeeEarnerLevelInput {
  where: NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput;
  create: NotificationRuleFeeEarnerLevelNotifyCreateWithoutFeeEarnerLevelInput;
}

export interface NotificationRuleFeeEarnerLevelNotifyCreateOrConnectWithoutNotificationRuleInput {
  where: NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput;
  create: NotificationRuleFeeEarnerLevelNotifyCreateWithoutNotificationRuleInput;
}

export interface NotificationRuleFeeEarnerLevelNotifyCreateWithoutFeeEarnerLevelInput {
  updatedAt?: any | null;
  notificationRule: NotificationRuleCreateNestedOneWithoutNotifyFeeEarnerLevelsInput;
}

export interface NotificationRuleFeeEarnerLevelNotifyCreateWithoutNotificationRuleInput {
  updatedAt?: any | null;
  feeEarnerLevel: FeeEarnerLevelCreateNestedOneWithoutNotifyNotificationRulesInput;
}

export interface NotificationRuleFeeEarnerLevelNotifyListRelationFilter {
  every?: NotificationRuleFeeEarnerLevelNotifyWhereInput | null;
  some?: NotificationRuleFeeEarnerLevelNotifyWhereInput | null;
  none?: NotificationRuleFeeEarnerLevelNotifyWhereInput | null;
}

export interface NotificationRuleFeeEarnerLevelNotifyScalarWhereInput {
  AND?: NotificationRuleFeeEarnerLevelNotifyScalarWhereInput[] | null;
  OR?: NotificationRuleFeeEarnerLevelNotifyScalarWhereInput[] | null;
  NOT?: NotificationRuleFeeEarnerLevelNotifyScalarWhereInput[] | null;
  id?: IntFilter | null;
  notificationRuleId?: IntFilter | null;
  feeEarnerLevelId?: IntFilter | null;
  updatedAt?: DateTimeFilter | null;
}

export interface NotificationRuleFeeEarnerLevelNotifyUpdateManyMutationInput {
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
}

export interface NotificationRuleFeeEarnerLevelNotifyUpdateManyWithWhereWithoutFeeEarnerLevelInput {
  where: NotificationRuleFeeEarnerLevelNotifyScalarWhereInput;
  data: NotificationRuleFeeEarnerLevelNotifyUpdateManyMutationInput;
}

export interface NotificationRuleFeeEarnerLevelNotifyUpdateManyWithWhereWithoutNotificationRuleInput {
  where: NotificationRuleFeeEarnerLevelNotifyScalarWhereInput;
  data: NotificationRuleFeeEarnerLevelNotifyUpdateManyMutationInput;
}

export interface NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutFeeEarnerLevelNestedInput {
  create?: NotificationRuleFeeEarnerLevelNotifyCreateWithoutFeeEarnerLevelInput[] | null;
  connectOrCreate?:
    | NotificationRuleFeeEarnerLevelNotifyCreateOrConnectWithoutFeeEarnerLevelInput[]
    | null;
  upsert?:
    | NotificationRuleFeeEarnerLevelNotifyUpsertWithWhereUniqueWithoutFeeEarnerLevelInput[]
    | null;
  createMany?: NotificationRuleFeeEarnerLevelNotifyCreateManyFeeEarnerLevelInputEnvelope | null;
  set?: NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput[] | null;
  disconnect?: NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput[] | null;
  delete?: NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput[] | null;
  connect?: NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput[] | null;
  update?:
    | NotificationRuleFeeEarnerLevelNotifyUpdateWithWhereUniqueWithoutFeeEarnerLevelInput[]
    | null;
  updateMany?:
    | NotificationRuleFeeEarnerLevelNotifyUpdateManyWithWhereWithoutFeeEarnerLevelInput[]
    | null;
  deleteMany?: NotificationRuleFeeEarnerLevelNotifyScalarWhereInput[] | null;
}

export interface NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutNotificationRuleNestedInput {
  create?: NotificationRuleFeeEarnerLevelNotifyCreateWithoutNotificationRuleInput[] | null;
  connectOrCreate?:
    | NotificationRuleFeeEarnerLevelNotifyCreateOrConnectWithoutNotificationRuleInput[]
    | null;
  upsert?:
    | NotificationRuleFeeEarnerLevelNotifyUpsertWithWhereUniqueWithoutNotificationRuleInput[]
    | null;
  createMany?: NotificationRuleFeeEarnerLevelNotifyCreateManyNotificationRuleInputEnvelope | null;
  set?: NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput[] | null;
  disconnect?: NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput[] | null;
  delete?: NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput[] | null;
  connect?: NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput[] | null;
  update?:
    | NotificationRuleFeeEarnerLevelNotifyUpdateWithWhereUniqueWithoutNotificationRuleInput[]
    | null;
  updateMany?:
    | NotificationRuleFeeEarnerLevelNotifyUpdateManyWithWhereWithoutNotificationRuleInput[]
    | null;
  deleteMany?: NotificationRuleFeeEarnerLevelNotifyScalarWhereInput[] | null;
}

export interface NotificationRuleFeeEarnerLevelNotifyUpdateWithWhereUniqueWithoutFeeEarnerLevelInput {
  where: NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput;
  data: NotificationRuleFeeEarnerLevelNotifyUpdateWithoutFeeEarnerLevelInput;
}

export interface NotificationRuleFeeEarnerLevelNotifyUpdateWithWhereUniqueWithoutNotificationRuleInput {
  where: NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput;
  data: NotificationRuleFeeEarnerLevelNotifyUpdateWithoutNotificationRuleInput;
}

export interface NotificationRuleFeeEarnerLevelNotifyUpdateWithoutFeeEarnerLevelInput {
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  notificationRule?: NotificationRuleUpdateOneRequiredWithoutNotifyFeeEarnerLevelsNestedInput | null;
}

export interface NotificationRuleFeeEarnerLevelNotifyUpdateWithoutNotificationRuleInput {
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  feeEarnerLevel?: FeeEarnerLevelUpdateOneRequiredWithoutNotifyNotificationRulesNestedInput | null;
}

export interface NotificationRuleFeeEarnerLevelNotifyUpsertWithWhereUniqueWithoutFeeEarnerLevelInput {
  where: NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput;
  update: NotificationRuleFeeEarnerLevelNotifyUpdateWithoutFeeEarnerLevelInput;
  create: NotificationRuleFeeEarnerLevelNotifyCreateWithoutFeeEarnerLevelInput;
}

export interface NotificationRuleFeeEarnerLevelNotifyUpsertWithWhereUniqueWithoutNotificationRuleInput {
  where: NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput;
  update: NotificationRuleFeeEarnerLevelNotifyUpdateWithoutNotificationRuleInput;
  create: NotificationRuleFeeEarnerLevelNotifyCreateWithoutNotificationRuleInput;
}

export interface NotificationRuleFeeEarnerLevelNotifyWhereInput {
  AND?: NotificationRuleFeeEarnerLevelNotifyWhereInput[] | null;
  OR?: NotificationRuleFeeEarnerLevelNotifyWhereInput[] | null;
  NOT?: NotificationRuleFeeEarnerLevelNotifyWhereInput[] | null;
  id?: IntFilter | null;
  notificationRuleId?: IntFilter | null;
  feeEarnerLevelId?: IntFilter | null;
  updatedAt?: DateTimeFilter | null;
  notificationRule?: NotificationRuleRelationFilter | null;
  feeEarnerLevel?: FeeEarnerLevelRelationFilter | null;
}

export interface NotificationRuleFeeEarnerLevelNotifyWhereUniqueInput {
  id?: number | null;
}

export interface NotificationRuleFeeEarnerLevelTriggerCreateManyFeeEarnerLevelInput {
  id?: number | null;
  notificationRuleId: number;
  updatedAt?: any | null;
}

export interface NotificationRuleFeeEarnerLevelTriggerCreateManyFeeEarnerLevelInputEnvelope {
  data: NotificationRuleFeeEarnerLevelTriggerCreateManyFeeEarnerLevelInput[];
  skipDuplicates?: boolean | null;
}

export interface NotificationRuleFeeEarnerLevelTriggerCreateManyNotificationRuleInput {
  id?: number | null;
  feeEarnerLevelId: number;
  updatedAt?: any | null;
}

export interface NotificationRuleFeeEarnerLevelTriggerCreateManyNotificationRuleInputEnvelope {
  data: NotificationRuleFeeEarnerLevelTriggerCreateManyNotificationRuleInput[];
  skipDuplicates?: boolean | null;
}

export interface NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutFeeEarnerLevelInput {
  create?: NotificationRuleFeeEarnerLevelTriggerCreateWithoutFeeEarnerLevelInput[] | null;
  connectOrCreate?:
    | NotificationRuleFeeEarnerLevelTriggerCreateOrConnectWithoutFeeEarnerLevelInput[]
    | null;
  createMany?: NotificationRuleFeeEarnerLevelTriggerCreateManyFeeEarnerLevelInputEnvelope | null;
  connect?: NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput[] | null;
}

export interface NotificationRuleFeeEarnerLevelTriggerCreateNestedManyWithoutNotificationRuleInput {
  create?: NotificationRuleFeeEarnerLevelTriggerCreateWithoutNotificationRuleInput[] | null;
  connectOrCreate?:
    | NotificationRuleFeeEarnerLevelTriggerCreateOrConnectWithoutNotificationRuleInput[]
    | null;
  createMany?: NotificationRuleFeeEarnerLevelTriggerCreateManyNotificationRuleInputEnvelope | null;
  connect?: NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput[] | null;
}

export interface NotificationRuleFeeEarnerLevelTriggerCreateOrConnectWithoutFeeEarnerLevelInput {
  where: NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput;
  create: NotificationRuleFeeEarnerLevelTriggerCreateWithoutFeeEarnerLevelInput;
}

export interface NotificationRuleFeeEarnerLevelTriggerCreateOrConnectWithoutNotificationRuleInput {
  where: NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput;
  create: NotificationRuleFeeEarnerLevelTriggerCreateWithoutNotificationRuleInput;
}

export interface NotificationRuleFeeEarnerLevelTriggerCreateWithoutFeeEarnerLevelInput {
  updatedAt?: any | null;
  notificationRule: NotificationRuleCreateNestedOneWithoutTriggerFeeEarnerLevelsInput;
}

export interface NotificationRuleFeeEarnerLevelTriggerCreateWithoutNotificationRuleInput {
  updatedAt?: any | null;
  feeEarnerLevel: FeeEarnerLevelCreateNestedOneWithoutTriggeredNotificationRulesInput;
}

export interface NotificationRuleFeeEarnerLevelTriggerListRelationFilter {
  every?: NotificationRuleFeeEarnerLevelTriggerWhereInput | null;
  some?: NotificationRuleFeeEarnerLevelTriggerWhereInput | null;
  none?: NotificationRuleFeeEarnerLevelTriggerWhereInput | null;
}

export interface NotificationRuleFeeEarnerLevelTriggerScalarWhereInput {
  AND?: NotificationRuleFeeEarnerLevelTriggerScalarWhereInput[] | null;
  OR?: NotificationRuleFeeEarnerLevelTriggerScalarWhereInput[] | null;
  NOT?: NotificationRuleFeeEarnerLevelTriggerScalarWhereInput[] | null;
  id?: IntFilter | null;
  notificationRuleId?: IntFilter | null;
  feeEarnerLevelId?: IntFilter | null;
  updatedAt?: DateTimeFilter | null;
}

export interface NotificationRuleFeeEarnerLevelTriggerUpdateManyMutationInput {
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
}

export interface NotificationRuleFeeEarnerLevelTriggerUpdateManyWithWhereWithoutFeeEarnerLevelInput {
  where: NotificationRuleFeeEarnerLevelTriggerScalarWhereInput;
  data: NotificationRuleFeeEarnerLevelTriggerUpdateManyMutationInput;
}

export interface NotificationRuleFeeEarnerLevelTriggerUpdateManyWithWhereWithoutNotificationRuleInput {
  where: NotificationRuleFeeEarnerLevelTriggerScalarWhereInput;
  data: NotificationRuleFeeEarnerLevelTriggerUpdateManyMutationInput;
}

export interface NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutFeeEarnerLevelNestedInput {
  create?: NotificationRuleFeeEarnerLevelTriggerCreateWithoutFeeEarnerLevelInput[] | null;
  connectOrCreate?:
    | NotificationRuleFeeEarnerLevelTriggerCreateOrConnectWithoutFeeEarnerLevelInput[]
    | null;
  upsert?:
    | NotificationRuleFeeEarnerLevelTriggerUpsertWithWhereUniqueWithoutFeeEarnerLevelInput[]
    | null;
  createMany?: NotificationRuleFeeEarnerLevelTriggerCreateManyFeeEarnerLevelInputEnvelope | null;
  set?: NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput[] | null;
  disconnect?: NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput[] | null;
  delete?: NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput[] | null;
  connect?: NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput[] | null;
  update?:
    | NotificationRuleFeeEarnerLevelTriggerUpdateWithWhereUniqueWithoutFeeEarnerLevelInput[]
    | null;
  updateMany?:
    | NotificationRuleFeeEarnerLevelTriggerUpdateManyWithWhereWithoutFeeEarnerLevelInput[]
    | null;
  deleteMany?: NotificationRuleFeeEarnerLevelTriggerScalarWhereInput[] | null;
}

export interface NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutNotificationRuleNestedInput {
  create?: NotificationRuleFeeEarnerLevelTriggerCreateWithoutNotificationRuleInput[] | null;
  connectOrCreate?:
    | NotificationRuleFeeEarnerLevelTriggerCreateOrConnectWithoutNotificationRuleInput[]
    | null;
  upsert?:
    | NotificationRuleFeeEarnerLevelTriggerUpsertWithWhereUniqueWithoutNotificationRuleInput[]
    | null;
  createMany?: NotificationRuleFeeEarnerLevelTriggerCreateManyNotificationRuleInputEnvelope | null;
  set?: NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput[] | null;
  disconnect?: NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput[] | null;
  delete?: NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput[] | null;
  connect?: NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput[] | null;
  update?:
    | NotificationRuleFeeEarnerLevelTriggerUpdateWithWhereUniqueWithoutNotificationRuleInput[]
    | null;
  updateMany?:
    | NotificationRuleFeeEarnerLevelTriggerUpdateManyWithWhereWithoutNotificationRuleInput[]
    | null;
  deleteMany?: NotificationRuleFeeEarnerLevelTriggerScalarWhereInput[] | null;
}

export interface NotificationRuleFeeEarnerLevelTriggerUpdateWithWhereUniqueWithoutFeeEarnerLevelInput {
  where: NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput;
  data: NotificationRuleFeeEarnerLevelTriggerUpdateWithoutFeeEarnerLevelInput;
}

export interface NotificationRuleFeeEarnerLevelTriggerUpdateWithWhereUniqueWithoutNotificationRuleInput {
  where: NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput;
  data: NotificationRuleFeeEarnerLevelTriggerUpdateWithoutNotificationRuleInput;
}

export interface NotificationRuleFeeEarnerLevelTriggerUpdateWithoutFeeEarnerLevelInput {
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  notificationRule?: NotificationRuleUpdateOneRequiredWithoutTriggerFeeEarnerLevelsNestedInput | null;
}

export interface NotificationRuleFeeEarnerLevelTriggerUpdateWithoutNotificationRuleInput {
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  feeEarnerLevel?: FeeEarnerLevelUpdateOneRequiredWithoutTriggeredNotificationRulesNestedInput | null;
}

export interface NotificationRuleFeeEarnerLevelTriggerUpsertWithWhereUniqueWithoutFeeEarnerLevelInput {
  where: NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput;
  update: NotificationRuleFeeEarnerLevelTriggerUpdateWithoutFeeEarnerLevelInput;
  create: NotificationRuleFeeEarnerLevelTriggerCreateWithoutFeeEarnerLevelInput;
}

export interface NotificationRuleFeeEarnerLevelTriggerUpsertWithWhereUniqueWithoutNotificationRuleInput {
  where: NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput;
  update: NotificationRuleFeeEarnerLevelTriggerUpdateWithoutNotificationRuleInput;
  create: NotificationRuleFeeEarnerLevelTriggerCreateWithoutNotificationRuleInput;
}

export interface NotificationRuleFeeEarnerLevelTriggerWhereInput {
  AND?: NotificationRuleFeeEarnerLevelTriggerWhereInput[] | null;
  OR?: NotificationRuleFeeEarnerLevelTriggerWhereInput[] | null;
  NOT?: NotificationRuleFeeEarnerLevelTriggerWhereInput[] | null;
  id?: IntFilter | null;
  notificationRuleId?: IntFilter | null;
  feeEarnerLevelId?: IntFilter | null;
  updatedAt?: DateTimeFilter | null;
  notificationRule?: NotificationRuleRelationFilter | null;
  feeEarnerLevel?: FeeEarnerLevelRelationFilter | null;
}

export interface NotificationRuleFeeEarnerLevelTriggerWhereUniqueInput {
  id?: number | null;
}

export interface NotificationRuleOrganisationalUnitsCreateManyNotificationRuleInput {
  id?: number | null;
  organisationalUnitId: number;
  updatedAt?: any | null;
}

export interface NotificationRuleOrganisationalUnitsCreateManyNotificationRuleInputEnvelope {
  data: NotificationRuleOrganisationalUnitsCreateManyNotificationRuleInput[];
  skipDuplicates?: boolean | null;
}

export interface NotificationRuleOrganisationalUnitsCreateManyOrganisationalUnitInput {
  id?: number | null;
  notificationRuleId: number;
  updatedAt?: any | null;
}

export interface NotificationRuleOrganisationalUnitsCreateManyOrganisationalUnitInputEnvelope {
  data: NotificationRuleOrganisationalUnitsCreateManyOrganisationalUnitInput[];
  skipDuplicates?: boolean | null;
}

export interface NotificationRuleOrganisationalUnitsCreateNestedManyWithoutNotificationRuleInput {
  create?: NotificationRuleOrganisationalUnitsCreateWithoutNotificationRuleInput[] | null;
  connectOrCreate?:
    | NotificationRuleOrganisationalUnitsCreateOrConnectWithoutNotificationRuleInput[]
    | null;
  createMany?: NotificationRuleOrganisationalUnitsCreateManyNotificationRuleInputEnvelope | null;
  connect?: NotificationRuleOrganisationalUnitsWhereUniqueInput[] | null;
}

export interface NotificationRuleOrganisationalUnitsCreateNestedManyWithoutOrganisationalUnitInput {
  create?: NotificationRuleOrganisationalUnitsCreateWithoutOrganisationalUnitInput[] | null;
  connectOrCreate?:
    | NotificationRuleOrganisationalUnitsCreateOrConnectWithoutOrganisationalUnitInput[]
    | null;
  createMany?: NotificationRuleOrganisationalUnitsCreateManyOrganisationalUnitInputEnvelope | null;
  connect?: NotificationRuleOrganisationalUnitsWhereUniqueInput[] | null;
}

export interface NotificationRuleOrganisationalUnitsCreateOrConnectWithoutNotificationRuleInput {
  where: NotificationRuleOrganisationalUnitsWhereUniqueInput;
  create: NotificationRuleOrganisationalUnitsCreateWithoutNotificationRuleInput;
}

export interface NotificationRuleOrganisationalUnitsCreateOrConnectWithoutOrganisationalUnitInput {
  where: NotificationRuleOrganisationalUnitsWhereUniqueInput;
  create: NotificationRuleOrganisationalUnitsCreateWithoutOrganisationalUnitInput;
}

export interface NotificationRuleOrganisationalUnitsCreateWithoutNotificationRuleInput {
  updatedAt?: any | null;
  OrganisationalUnit: OrganisationalUnitCreateNestedOneWithoutTriggeredNotificationRulesInput;
}

export interface NotificationRuleOrganisationalUnitsCreateWithoutOrganisationalUnitInput {
  updatedAt?: any | null;
  notificationRule: NotificationRuleCreateNestedOneWithoutTriggerOrganisationalUnitsInput;
}

export interface NotificationRuleOrganisationalUnitsListRelationFilter {
  every?: NotificationRuleOrganisationalUnitsWhereInput | null;
  some?: NotificationRuleOrganisationalUnitsWhereInput | null;
  none?: NotificationRuleOrganisationalUnitsWhereInput | null;
}

export interface NotificationRuleOrganisationalUnitsScalarWhereInput {
  AND?: NotificationRuleOrganisationalUnitsScalarWhereInput[] | null;
  OR?: NotificationRuleOrganisationalUnitsScalarWhereInput[] | null;
  NOT?: NotificationRuleOrganisationalUnitsScalarWhereInput[] | null;
  id?: IntFilter | null;
  notificationRuleId?: IntFilter | null;
  organisationalUnitId?: IntFilter | null;
  updatedAt?: DateTimeFilter | null;
}

export interface NotificationRuleOrganisationalUnitsUpdateManyMutationInput {
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
}

export interface NotificationRuleOrganisationalUnitsUpdateManyWithWhereWithoutNotificationRuleInput {
  where: NotificationRuleOrganisationalUnitsScalarWhereInput;
  data: NotificationRuleOrganisationalUnitsUpdateManyMutationInput;
}

export interface NotificationRuleOrganisationalUnitsUpdateManyWithWhereWithoutOrganisationalUnitInput {
  where: NotificationRuleOrganisationalUnitsScalarWhereInput;
  data: NotificationRuleOrganisationalUnitsUpdateManyMutationInput;
}

export interface NotificationRuleOrganisationalUnitsUpdateManyWithoutNotificationRuleNestedInput {
  create?: NotificationRuleOrganisationalUnitsCreateWithoutNotificationRuleInput[] | null;
  connectOrCreate?:
    | NotificationRuleOrganisationalUnitsCreateOrConnectWithoutNotificationRuleInput[]
    | null;
  upsert?:
    | NotificationRuleOrganisationalUnitsUpsertWithWhereUniqueWithoutNotificationRuleInput[]
    | null;
  createMany?: NotificationRuleOrganisationalUnitsCreateManyNotificationRuleInputEnvelope | null;
  set?: NotificationRuleOrganisationalUnitsWhereUniqueInput[] | null;
  disconnect?: NotificationRuleOrganisationalUnitsWhereUniqueInput[] | null;
  delete?: NotificationRuleOrganisationalUnitsWhereUniqueInput[] | null;
  connect?: NotificationRuleOrganisationalUnitsWhereUniqueInput[] | null;
  update?:
    | NotificationRuleOrganisationalUnitsUpdateWithWhereUniqueWithoutNotificationRuleInput[]
    | null;
  updateMany?:
    | NotificationRuleOrganisationalUnitsUpdateManyWithWhereWithoutNotificationRuleInput[]
    | null;
  deleteMany?: NotificationRuleOrganisationalUnitsScalarWhereInput[] | null;
}

export interface NotificationRuleOrganisationalUnitsUpdateManyWithoutOrganisationalUnitNestedInput {
  create?: NotificationRuleOrganisationalUnitsCreateWithoutOrganisationalUnitInput[] | null;
  connectOrCreate?:
    | NotificationRuleOrganisationalUnitsCreateOrConnectWithoutOrganisationalUnitInput[]
    | null;
  upsert?:
    | NotificationRuleOrganisationalUnitsUpsertWithWhereUniqueWithoutOrganisationalUnitInput[]
    | null;
  createMany?: NotificationRuleOrganisationalUnitsCreateManyOrganisationalUnitInputEnvelope | null;
  set?: NotificationRuleOrganisationalUnitsWhereUniqueInput[] | null;
  disconnect?: NotificationRuleOrganisationalUnitsWhereUniqueInput[] | null;
  delete?: NotificationRuleOrganisationalUnitsWhereUniqueInput[] | null;
  connect?: NotificationRuleOrganisationalUnitsWhereUniqueInput[] | null;
  update?:
    | NotificationRuleOrganisationalUnitsUpdateWithWhereUniqueWithoutOrganisationalUnitInput[]
    | null;
  updateMany?:
    | NotificationRuleOrganisationalUnitsUpdateManyWithWhereWithoutOrganisationalUnitInput[]
    | null;
  deleteMany?: NotificationRuleOrganisationalUnitsScalarWhereInput[] | null;
}

export interface NotificationRuleOrganisationalUnitsUpdateWithWhereUniqueWithoutNotificationRuleInput {
  where: NotificationRuleOrganisationalUnitsWhereUniqueInput;
  data: NotificationRuleOrganisationalUnitsUpdateWithoutNotificationRuleInput;
}

export interface NotificationRuleOrganisationalUnitsUpdateWithWhereUniqueWithoutOrganisationalUnitInput {
  where: NotificationRuleOrganisationalUnitsWhereUniqueInput;
  data: NotificationRuleOrganisationalUnitsUpdateWithoutOrganisationalUnitInput;
}

export interface NotificationRuleOrganisationalUnitsUpdateWithoutNotificationRuleInput {
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  OrganisationalUnit?: OrganisationalUnitUpdateOneRequiredWithoutTriggeredNotificationRulesNestedInput | null;
}

export interface NotificationRuleOrganisationalUnitsUpdateWithoutOrganisationalUnitInput {
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  notificationRule?: NotificationRuleUpdateOneRequiredWithoutTriggerOrganisationalUnitsNestedInput | null;
}

export interface NotificationRuleOrganisationalUnitsUpsertWithWhereUniqueWithoutNotificationRuleInput {
  where: NotificationRuleOrganisationalUnitsWhereUniqueInput;
  update: NotificationRuleOrganisationalUnitsUpdateWithoutNotificationRuleInput;
  create: NotificationRuleOrganisationalUnitsCreateWithoutNotificationRuleInput;
}

export interface NotificationRuleOrganisationalUnitsUpsertWithWhereUniqueWithoutOrganisationalUnitInput {
  where: NotificationRuleOrganisationalUnitsWhereUniqueInput;
  update: NotificationRuleOrganisationalUnitsUpdateWithoutOrganisationalUnitInput;
  create: NotificationRuleOrganisationalUnitsCreateWithoutOrganisationalUnitInput;
}

export interface NotificationRuleOrganisationalUnitsWhereInput {
  AND?: NotificationRuleOrganisationalUnitsWhereInput[] | null;
  OR?: NotificationRuleOrganisationalUnitsWhereInput[] | null;
  NOT?: NotificationRuleOrganisationalUnitsWhereInput[] | null;
  id?: IntFilter | null;
  notificationRuleId?: IntFilter | null;
  organisationalUnitId?: IntFilter | null;
  updatedAt?: DateTimeFilter | null;
  notificationRule?: NotificationRuleRelationFilter | null;
  OrganisationalUnit?: OrganisationalUnitRelationFilter | null;
}

export interface NotificationRuleOrganisationalUnitsWhereUniqueInput {
  id?: number | null;
}

export interface NotificationRuleRelationFilter {
  is?: NotificationRuleWhereInput | null;
  isNot?: NotificationRuleWhereInput | null;
}

export interface NotificationRuleUpdateOneRequiredWithoutNotifyFeeEarnerLevelsNestedInput {
  create?: NotificationRuleCreateWithoutNotifyFeeEarnerLevelsInput | null;
  connectOrCreate?: NotificationRuleCreateOrConnectWithoutNotifyFeeEarnerLevelsInput | null;
  upsert?: NotificationRuleUpsertWithoutNotifyFeeEarnerLevelsInput | null;
  connect?: NotificationRuleWhereUniqueInput | null;
  update?: NotificationRuleUpdateWithoutNotifyFeeEarnerLevelsInput | null;
}

export interface NotificationRuleUpdateOneRequiredWithoutNotifyUsersNestedInput {
  create?: NotificationRuleCreateWithoutNotifyUsersInput | null;
  connectOrCreate?: NotificationRuleCreateOrConnectWithoutNotifyUsersInput | null;
  upsert?: NotificationRuleUpsertWithoutNotifyUsersInput | null;
  connect?: NotificationRuleWhereUniqueInput | null;
  update?: NotificationRuleUpdateWithoutNotifyUsersInput | null;
}

export interface NotificationRuleUpdateOneRequiredWithoutTriggerClientsNestedInput {
  create?: NotificationRuleCreateWithoutTriggerClientsInput | null;
  connectOrCreate?: NotificationRuleCreateOrConnectWithoutTriggerClientsInput | null;
  upsert?: NotificationRuleUpsertWithoutTriggerClientsInput | null;
  connect?: NotificationRuleWhereUniqueInput | null;
  update?: NotificationRuleUpdateWithoutTriggerClientsInput | null;
}

export interface NotificationRuleUpdateOneRequiredWithoutTriggerFeeEarnerLevelsNestedInput {
  create?: NotificationRuleCreateWithoutTriggerFeeEarnerLevelsInput | null;
  connectOrCreate?: NotificationRuleCreateOrConnectWithoutTriggerFeeEarnerLevelsInput | null;
  upsert?: NotificationRuleUpsertWithoutTriggerFeeEarnerLevelsInput | null;
  connect?: NotificationRuleWhereUniqueInput | null;
  update?: NotificationRuleUpdateWithoutTriggerFeeEarnerLevelsInput | null;
}

export interface NotificationRuleUpdateOneRequiredWithoutTriggerOrganisationalUnitsNestedInput {
  create?: NotificationRuleCreateWithoutTriggerOrganisationalUnitsInput | null;
  connectOrCreate?: NotificationRuleCreateOrConnectWithoutTriggerOrganisationalUnitsInput | null;
  upsert?: NotificationRuleUpsertWithoutTriggerOrganisationalUnitsInput | null;
  connect?: NotificationRuleWhereUniqueInput | null;
  update?: NotificationRuleUpdateWithoutTriggerOrganisationalUnitsInput | null;
}

export interface NotificationRuleUpdateOneRequiredWithoutTriggerUsersNestedInput {
  create?: NotificationRuleCreateWithoutTriggerUsersInput | null;
  connectOrCreate?: NotificationRuleCreateOrConnectWithoutTriggerUsersInput | null;
  upsert?: NotificationRuleUpsertWithoutTriggerUsersInput | null;
  connect?: NotificationRuleWhereUniqueInput | null;
  update?: NotificationRuleUpdateWithoutTriggerUsersInput | null;
}

export interface NotificationRuleUpdateOneWithoutNotificationsNestedInput {
  create?: NotificationRuleCreateWithoutNotificationsInput | null;
  connectOrCreate?: NotificationRuleCreateOrConnectWithoutNotificationsInput | null;
  upsert?: NotificationRuleUpsertWithoutNotificationsInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: NotificationRuleWhereUniqueInput | null;
  update?: NotificationRuleUpdateWithoutNotificationsInput | null;
}

export interface NotificationRuleUpdateWithoutNotificationsInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  proposalGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  proposalFeeThreshold?: NullableFloatFieldUpdateOperationsInput | null;
  activeGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  accruedTimeThreshold?: NullableFloatFieldUpdateOperationsInput | null;
  accruedBudgetThreshold?: NullableFloatFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  triggerUsers?: NotificationRuleUserTriggerUpdateManyWithoutNotificationRuleNestedInput | null;
  notifyUsers?: NotificationRuleUserNotifyUpdateManyWithoutNotificationRuleNestedInput | null;
  triggerFeeEarnerLevels?: NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutNotificationRuleNestedInput | null;
  notifyFeeEarnerLevels?: NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutNotificationRuleNestedInput | null;
  triggerClients?: NotificationRuleClientsUpdateManyWithoutNotificationRuleNestedInput | null;
  triggerOrganisationalUnits?: NotificationRuleOrganisationalUnitsUpdateManyWithoutNotificationRuleNestedInput | null;
}

export interface NotificationRuleUpdateWithoutNotifyFeeEarnerLevelsInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  proposalGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  proposalFeeThreshold?: NullableFloatFieldUpdateOperationsInput | null;
  activeGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  accruedTimeThreshold?: NullableFloatFieldUpdateOperationsInput | null;
  accruedBudgetThreshold?: NullableFloatFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  notifications?: NotificationUpdateManyWithoutNotificationRuleNestedInput | null;
  triggerUsers?: NotificationRuleUserTriggerUpdateManyWithoutNotificationRuleNestedInput | null;
  notifyUsers?: NotificationRuleUserNotifyUpdateManyWithoutNotificationRuleNestedInput | null;
  triggerFeeEarnerLevels?: NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutNotificationRuleNestedInput | null;
  triggerClients?: NotificationRuleClientsUpdateManyWithoutNotificationRuleNestedInput | null;
  triggerOrganisationalUnits?: NotificationRuleOrganisationalUnitsUpdateManyWithoutNotificationRuleNestedInput | null;
}

export interface NotificationRuleUpdateWithoutNotifyUsersInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  proposalGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  proposalFeeThreshold?: NullableFloatFieldUpdateOperationsInput | null;
  activeGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  accruedTimeThreshold?: NullableFloatFieldUpdateOperationsInput | null;
  accruedBudgetThreshold?: NullableFloatFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  notifications?: NotificationUpdateManyWithoutNotificationRuleNestedInput | null;
  triggerUsers?: NotificationRuleUserTriggerUpdateManyWithoutNotificationRuleNestedInput | null;
  triggerFeeEarnerLevels?: NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutNotificationRuleNestedInput | null;
  notifyFeeEarnerLevels?: NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutNotificationRuleNestedInput | null;
  triggerClients?: NotificationRuleClientsUpdateManyWithoutNotificationRuleNestedInput | null;
  triggerOrganisationalUnits?: NotificationRuleOrganisationalUnitsUpdateManyWithoutNotificationRuleNestedInput | null;
}

export interface NotificationRuleUpdateWithoutTriggerClientsInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  proposalGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  proposalFeeThreshold?: NullableFloatFieldUpdateOperationsInput | null;
  activeGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  accruedTimeThreshold?: NullableFloatFieldUpdateOperationsInput | null;
  accruedBudgetThreshold?: NullableFloatFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  notifications?: NotificationUpdateManyWithoutNotificationRuleNestedInput | null;
  triggerUsers?: NotificationRuleUserTriggerUpdateManyWithoutNotificationRuleNestedInput | null;
  notifyUsers?: NotificationRuleUserNotifyUpdateManyWithoutNotificationRuleNestedInput | null;
  triggerFeeEarnerLevels?: NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutNotificationRuleNestedInput | null;
  notifyFeeEarnerLevels?: NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutNotificationRuleNestedInput | null;
  triggerOrganisationalUnits?: NotificationRuleOrganisationalUnitsUpdateManyWithoutNotificationRuleNestedInput | null;
}

export interface NotificationRuleUpdateWithoutTriggerFeeEarnerLevelsInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  proposalGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  proposalFeeThreshold?: NullableFloatFieldUpdateOperationsInput | null;
  activeGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  accruedTimeThreshold?: NullableFloatFieldUpdateOperationsInput | null;
  accruedBudgetThreshold?: NullableFloatFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  notifications?: NotificationUpdateManyWithoutNotificationRuleNestedInput | null;
  triggerUsers?: NotificationRuleUserTriggerUpdateManyWithoutNotificationRuleNestedInput | null;
  notifyUsers?: NotificationRuleUserNotifyUpdateManyWithoutNotificationRuleNestedInput | null;
  notifyFeeEarnerLevels?: NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutNotificationRuleNestedInput | null;
  triggerClients?: NotificationRuleClientsUpdateManyWithoutNotificationRuleNestedInput | null;
  triggerOrganisationalUnits?: NotificationRuleOrganisationalUnitsUpdateManyWithoutNotificationRuleNestedInput | null;
}

export interface NotificationRuleUpdateWithoutTriggerOrganisationalUnitsInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  proposalGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  proposalFeeThreshold?: NullableFloatFieldUpdateOperationsInput | null;
  activeGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  accruedTimeThreshold?: NullableFloatFieldUpdateOperationsInput | null;
  accruedBudgetThreshold?: NullableFloatFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  notifications?: NotificationUpdateManyWithoutNotificationRuleNestedInput | null;
  triggerUsers?: NotificationRuleUserTriggerUpdateManyWithoutNotificationRuleNestedInput | null;
  notifyUsers?: NotificationRuleUserNotifyUpdateManyWithoutNotificationRuleNestedInput | null;
  triggerFeeEarnerLevels?: NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutNotificationRuleNestedInput | null;
  notifyFeeEarnerLevels?: NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutNotificationRuleNestedInput | null;
  triggerClients?: NotificationRuleClientsUpdateManyWithoutNotificationRuleNestedInput | null;
}

export interface NotificationRuleUpdateWithoutTriggerUsersInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  proposalGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  proposalFeeThreshold?: NullableFloatFieldUpdateOperationsInput | null;
  activeGpmThreshold?: NullableIntFieldUpdateOperationsInput | null;
  accruedTimeThreshold?: NullableFloatFieldUpdateOperationsInput | null;
  accruedBudgetThreshold?: NullableFloatFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  notifications?: NotificationUpdateManyWithoutNotificationRuleNestedInput | null;
  notifyUsers?: NotificationRuleUserNotifyUpdateManyWithoutNotificationRuleNestedInput | null;
  triggerFeeEarnerLevels?: NotificationRuleFeeEarnerLevelTriggerUpdateManyWithoutNotificationRuleNestedInput | null;
  notifyFeeEarnerLevels?: NotificationRuleFeeEarnerLevelNotifyUpdateManyWithoutNotificationRuleNestedInput | null;
  triggerClients?: NotificationRuleClientsUpdateManyWithoutNotificationRuleNestedInput | null;
  triggerOrganisationalUnits?: NotificationRuleOrganisationalUnitsUpdateManyWithoutNotificationRuleNestedInput | null;
}

export interface NotificationRuleUpsertWithoutNotificationsInput {
  update: NotificationRuleUpdateWithoutNotificationsInput;
  create: NotificationRuleCreateWithoutNotificationsInput;
}

export interface NotificationRuleUpsertWithoutNotifyFeeEarnerLevelsInput {
  update: NotificationRuleUpdateWithoutNotifyFeeEarnerLevelsInput;
  create: NotificationRuleCreateWithoutNotifyFeeEarnerLevelsInput;
}

export interface NotificationRuleUpsertWithoutNotifyUsersInput {
  update: NotificationRuleUpdateWithoutNotifyUsersInput;
  create: NotificationRuleCreateWithoutNotifyUsersInput;
}

export interface NotificationRuleUpsertWithoutTriggerClientsInput {
  update: NotificationRuleUpdateWithoutTriggerClientsInput;
  create: NotificationRuleCreateWithoutTriggerClientsInput;
}

export interface NotificationRuleUpsertWithoutTriggerFeeEarnerLevelsInput {
  update: NotificationRuleUpdateWithoutTriggerFeeEarnerLevelsInput;
  create: NotificationRuleCreateWithoutTriggerFeeEarnerLevelsInput;
}

export interface NotificationRuleUpsertWithoutTriggerOrganisationalUnitsInput {
  update: NotificationRuleUpdateWithoutTriggerOrganisationalUnitsInput;
  create: NotificationRuleCreateWithoutTriggerOrganisationalUnitsInput;
}

export interface NotificationRuleUpsertWithoutTriggerUsersInput {
  update: NotificationRuleUpdateWithoutTriggerUsersInput;
  create: NotificationRuleCreateWithoutTriggerUsersInput;
}

export interface NotificationRuleUserNotifyCreateManyNotificationRuleInput {
  id?: number | null;
  userId: number;
  updatedAt?: any | null;
}

export interface NotificationRuleUserNotifyCreateManyNotificationRuleInputEnvelope {
  data: NotificationRuleUserNotifyCreateManyNotificationRuleInput[];
  skipDuplicates?: boolean | null;
}

export interface NotificationRuleUserNotifyCreateManyUserInput {
  id?: number | null;
  notificationRuleId: number;
  updatedAt?: any | null;
}

export interface NotificationRuleUserNotifyCreateManyUserInputEnvelope {
  data: NotificationRuleUserNotifyCreateManyUserInput[];
  skipDuplicates?: boolean | null;
}

export interface NotificationRuleUserNotifyCreateNestedManyWithoutNotificationRuleInput {
  create?: NotificationRuleUserNotifyCreateWithoutNotificationRuleInput[] | null;
  connectOrCreate?: NotificationRuleUserNotifyCreateOrConnectWithoutNotificationRuleInput[] | null;
  createMany?: NotificationRuleUserNotifyCreateManyNotificationRuleInputEnvelope | null;
  connect?: NotificationRuleUserNotifyWhereUniqueInput[] | null;
}

export interface NotificationRuleUserNotifyCreateNestedManyWithoutUserInput {
  create?: NotificationRuleUserNotifyCreateWithoutUserInput[] | null;
  connectOrCreate?: NotificationRuleUserNotifyCreateOrConnectWithoutUserInput[] | null;
  createMany?: NotificationRuleUserNotifyCreateManyUserInputEnvelope | null;
  connect?: NotificationRuleUserNotifyWhereUniqueInput[] | null;
}

export interface NotificationRuleUserNotifyCreateOrConnectWithoutNotificationRuleInput {
  where: NotificationRuleUserNotifyWhereUniqueInput;
  create: NotificationRuleUserNotifyCreateWithoutNotificationRuleInput;
}

export interface NotificationRuleUserNotifyCreateOrConnectWithoutUserInput {
  where: NotificationRuleUserNotifyWhereUniqueInput;
  create: NotificationRuleUserNotifyCreateWithoutUserInput;
}

export interface NotificationRuleUserNotifyCreateWithoutNotificationRuleInput {
  updatedAt?: any | null;
  user: UserCreateNestedOneWithoutNotifyRulesInput;
}

export interface NotificationRuleUserNotifyCreateWithoutUserInput {
  updatedAt?: any | null;
  notificationRule: NotificationRuleCreateNestedOneWithoutNotifyUsersInput;
}

export interface NotificationRuleUserNotifyListRelationFilter {
  every?: NotificationRuleUserNotifyWhereInput | null;
  some?: NotificationRuleUserNotifyWhereInput | null;
  none?: NotificationRuleUserNotifyWhereInput | null;
}

export interface NotificationRuleUserNotifyScalarWhereInput {
  AND?: NotificationRuleUserNotifyScalarWhereInput[] | null;
  OR?: NotificationRuleUserNotifyScalarWhereInput[] | null;
  NOT?: NotificationRuleUserNotifyScalarWhereInput[] | null;
  id?: IntFilter | null;
  notificationRuleId?: IntFilter | null;
  userId?: IntFilter | null;
  updatedAt?: DateTimeFilter | null;
}

export interface NotificationRuleUserNotifyUpdateManyMutationInput {
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
}

export interface NotificationRuleUserNotifyUpdateManyWithWhereWithoutNotificationRuleInput {
  where: NotificationRuleUserNotifyScalarWhereInput;
  data: NotificationRuleUserNotifyUpdateManyMutationInput;
}

export interface NotificationRuleUserNotifyUpdateManyWithWhereWithoutUserInput {
  where: NotificationRuleUserNotifyScalarWhereInput;
  data: NotificationRuleUserNotifyUpdateManyMutationInput;
}

export interface NotificationRuleUserNotifyUpdateManyWithoutNotificationRuleNestedInput {
  create?: NotificationRuleUserNotifyCreateWithoutNotificationRuleInput[] | null;
  connectOrCreate?: NotificationRuleUserNotifyCreateOrConnectWithoutNotificationRuleInput[] | null;
  upsert?: NotificationRuleUserNotifyUpsertWithWhereUniqueWithoutNotificationRuleInput[] | null;
  createMany?: NotificationRuleUserNotifyCreateManyNotificationRuleInputEnvelope | null;
  set?: NotificationRuleUserNotifyWhereUniqueInput[] | null;
  disconnect?: NotificationRuleUserNotifyWhereUniqueInput[] | null;
  delete?: NotificationRuleUserNotifyWhereUniqueInput[] | null;
  connect?: NotificationRuleUserNotifyWhereUniqueInput[] | null;
  update?: NotificationRuleUserNotifyUpdateWithWhereUniqueWithoutNotificationRuleInput[] | null;
  updateMany?: NotificationRuleUserNotifyUpdateManyWithWhereWithoutNotificationRuleInput[] | null;
  deleteMany?: NotificationRuleUserNotifyScalarWhereInput[] | null;
}

export interface NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput {
  create?: NotificationRuleUserNotifyCreateWithoutUserInput[] | null;
  connectOrCreate?: NotificationRuleUserNotifyCreateOrConnectWithoutUserInput[] | null;
  upsert?: NotificationRuleUserNotifyUpsertWithWhereUniqueWithoutUserInput[] | null;
  createMany?: NotificationRuleUserNotifyCreateManyUserInputEnvelope | null;
  set?: NotificationRuleUserNotifyWhereUniqueInput[] | null;
  disconnect?: NotificationRuleUserNotifyWhereUniqueInput[] | null;
  delete?: NotificationRuleUserNotifyWhereUniqueInput[] | null;
  connect?: NotificationRuleUserNotifyWhereUniqueInput[] | null;
  update?: NotificationRuleUserNotifyUpdateWithWhereUniqueWithoutUserInput[] | null;
  updateMany?: NotificationRuleUserNotifyUpdateManyWithWhereWithoutUserInput[] | null;
  deleteMany?: NotificationRuleUserNotifyScalarWhereInput[] | null;
}

export interface NotificationRuleUserNotifyUpdateWithWhereUniqueWithoutNotificationRuleInput {
  where: NotificationRuleUserNotifyWhereUniqueInput;
  data: NotificationRuleUserNotifyUpdateWithoutNotificationRuleInput;
}

export interface NotificationRuleUserNotifyUpdateWithWhereUniqueWithoutUserInput {
  where: NotificationRuleUserNotifyWhereUniqueInput;
  data: NotificationRuleUserNotifyUpdateWithoutUserInput;
}

export interface NotificationRuleUserNotifyUpdateWithoutNotificationRuleInput {
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  user?: UserUpdateOneRequiredWithoutNotifyRulesNestedInput | null;
}

export interface NotificationRuleUserNotifyUpdateWithoutUserInput {
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  notificationRule?: NotificationRuleUpdateOneRequiredWithoutNotifyUsersNestedInput | null;
}

export interface NotificationRuleUserNotifyUpsertWithWhereUniqueWithoutNotificationRuleInput {
  where: NotificationRuleUserNotifyWhereUniqueInput;
  update: NotificationRuleUserNotifyUpdateWithoutNotificationRuleInput;
  create: NotificationRuleUserNotifyCreateWithoutNotificationRuleInput;
}

export interface NotificationRuleUserNotifyUpsertWithWhereUniqueWithoutUserInput {
  where: NotificationRuleUserNotifyWhereUniqueInput;
  update: NotificationRuleUserNotifyUpdateWithoutUserInput;
  create: NotificationRuleUserNotifyCreateWithoutUserInput;
}

export interface NotificationRuleUserNotifyWhereInput {
  AND?: NotificationRuleUserNotifyWhereInput[] | null;
  OR?: NotificationRuleUserNotifyWhereInput[] | null;
  NOT?: NotificationRuleUserNotifyWhereInput[] | null;
  id?: IntFilter | null;
  notificationRuleId?: IntFilter | null;
  userId?: IntFilter | null;
  updatedAt?: DateTimeFilter | null;
  notificationRule?: NotificationRuleRelationFilter | null;
  user?: UserRelationFilter | null;
}

export interface NotificationRuleUserNotifyWhereUniqueInput {
  id?: number | null;
}

export interface NotificationRuleUserTriggerCreateManyNotificationRuleInput {
  id?: number | null;
  userId: number;
  updatedAt?: any | null;
}

export interface NotificationRuleUserTriggerCreateManyNotificationRuleInputEnvelope {
  data: NotificationRuleUserTriggerCreateManyNotificationRuleInput[];
  skipDuplicates?: boolean | null;
}

export interface NotificationRuleUserTriggerCreateManyUserInput {
  id?: number | null;
  notificationRuleId: number;
  updatedAt?: any | null;
}

export interface NotificationRuleUserTriggerCreateManyUserInputEnvelope {
  data: NotificationRuleUserTriggerCreateManyUserInput[];
  skipDuplicates?: boolean | null;
}

export interface NotificationRuleUserTriggerCreateNestedManyWithoutNotificationRuleInput {
  create?: NotificationRuleUserTriggerCreateWithoutNotificationRuleInput[] | null;
  connectOrCreate?: NotificationRuleUserTriggerCreateOrConnectWithoutNotificationRuleInput[] | null;
  createMany?: NotificationRuleUserTriggerCreateManyNotificationRuleInputEnvelope | null;
  connect?: NotificationRuleUserTriggerWhereUniqueInput[] | null;
}

export interface NotificationRuleUserTriggerCreateNestedManyWithoutUserInput {
  create?: NotificationRuleUserTriggerCreateWithoutUserInput[] | null;
  connectOrCreate?: NotificationRuleUserTriggerCreateOrConnectWithoutUserInput[] | null;
  createMany?: NotificationRuleUserTriggerCreateManyUserInputEnvelope | null;
  connect?: NotificationRuleUserTriggerWhereUniqueInput[] | null;
}

export interface NotificationRuleUserTriggerCreateOrConnectWithoutNotificationRuleInput {
  where: NotificationRuleUserTriggerWhereUniqueInput;
  create: NotificationRuleUserTriggerCreateWithoutNotificationRuleInput;
}

export interface NotificationRuleUserTriggerCreateOrConnectWithoutUserInput {
  where: NotificationRuleUserTriggerWhereUniqueInput;
  create: NotificationRuleUserTriggerCreateWithoutUserInput;
}

export interface NotificationRuleUserTriggerCreateWithoutNotificationRuleInput {
  updatedAt?: any | null;
  user: UserCreateNestedOneWithoutTriggeredRulesInput;
}

export interface NotificationRuleUserTriggerCreateWithoutUserInput {
  updatedAt?: any | null;
  notificationRule: NotificationRuleCreateNestedOneWithoutTriggerUsersInput;
}

export interface NotificationRuleUserTriggerListRelationFilter {
  every?: NotificationRuleUserTriggerWhereInput | null;
  some?: NotificationRuleUserTriggerWhereInput | null;
  none?: NotificationRuleUserTriggerWhereInput | null;
}

export interface NotificationRuleUserTriggerScalarWhereInput {
  AND?: NotificationRuleUserTriggerScalarWhereInput[] | null;
  OR?: NotificationRuleUserTriggerScalarWhereInput[] | null;
  NOT?: NotificationRuleUserTriggerScalarWhereInput[] | null;
  id?: IntFilter | null;
  notificationRuleId?: IntFilter | null;
  userId?: IntFilter | null;
  updatedAt?: DateTimeFilter | null;
}

export interface NotificationRuleUserTriggerUpdateManyMutationInput {
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
}

export interface NotificationRuleUserTriggerUpdateManyWithWhereWithoutNotificationRuleInput {
  where: NotificationRuleUserTriggerScalarWhereInput;
  data: NotificationRuleUserTriggerUpdateManyMutationInput;
}

export interface NotificationRuleUserTriggerUpdateManyWithWhereWithoutUserInput {
  where: NotificationRuleUserTriggerScalarWhereInput;
  data: NotificationRuleUserTriggerUpdateManyMutationInput;
}

export interface NotificationRuleUserTriggerUpdateManyWithoutNotificationRuleNestedInput {
  create?: NotificationRuleUserTriggerCreateWithoutNotificationRuleInput[] | null;
  connectOrCreate?: NotificationRuleUserTriggerCreateOrConnectWithoutNotificationRuleInput[] | null;
  upsert?: NotificationRuleUserTriggerUpsertWithWhereUniqueWithoutNotificationRuleInput[] | null;
  createMany?: NotificationRuleUserTriggerCreateManyNotificationRuleInputEnvelope | null;
  set?: NotificationRuleUserTriggerWhereUniqueInput[] | null;
  disconnect?: NotificationRuleUserTriggerWhereUniqueInput[] | null;
  delete?: NotificationRuleUserTriggerWhereUniqueInput[] | null;
  connect?: NotificationRuleUserTriggerWhereUniqueInput[] | null;
  update?: NotificationRuleUserTriggerUpdateWithWhereUniqueWithoutNotificationRuleInput[] | null;
  updateMany?: NotificationRuleUserTriggerUpdateManyWithWhereWithoutNotificationRuleInput[] | null;
  deleteMany?: NotificationRuleUserTriggerScalarWhereInput[] | null;
}

export interface NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput {
  create?: NotificationRuleUserTriggerCreateWithoutUserInput[] | null;
  connectOrCreate?: NotificationRuleUserTriggerCreateOrConnectWithoutUserInput[] | null;
  upsert?: NotificationRuleUserTriggerUpsertWithWhereUniqueWithoutUserInput[] | null;
  createMany?: NotificationRuleUserTriggerCreateManyUserInputEnvelope | null;
  set?: NotificationRuleUserTriggerWhereUniqueInput[] | null;
  disconnect?: NotificationRuleUserTriggerWhereUniqueInput[] | null;
  delete?: NotificationRuleUserTriggerWhereUniqueInput[] | null;
  connect?: NotificationRuleUserTriggerWhereUniqueInput[] | null;
  update?: NotificationRuleUserTriggerUpdateWithWhereUniqueWithoutUserInput[] | null;
  updateMany?: NotificationRuleUserTriggerUpdateManyWithWhereWithoutUserInput[] | null;
  deleteMany?: NotificationRuleUserTriggerScalarWhereInput[] | null;
}

export interface NotificationRuleUserTriggerUpdateWithWhereUniqueWithoutNotificationRuleInput {
  where: NotificationRuleUserTriggerWhereUniqueInput;
  data: NotificationRuleUserTriggerUpdateWithoutNotificationRuleInput;
}

export interface NotificationRuleUserTriggerUpdateWithWhereUniqueWithoutUserInput {
  where: NotificationRuleUserTriggerWhereUniqueInput;
  data: NotificationRuleUserTriggerUpdateWithoutUserInput;
}

export interface NotificationRuleUserTriggerUpdateWithoutNotificationRuleInput {
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  user?: UserUpdateOneRequiredWithoutTriggeredRulesNestedInput | null;
}

export interface NotificationRuleUserTriggerUpdateWithoutUserInput {
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  notificationRule?: NotificationRuleUpdateOneRequiredWithoutTriggerUsersNestedInput | null;
}

export interface NotificationRuleUserTriggerUpsertWithWhereUniqueWithoutNotificationRuleInput {
  where: NotificationRuleUserTriggerWhereUniqueInput;
  update: NotificationRuleUserTriggerUpdateWithoutNotificationRuleInput;
  create: NotificationRuleUserTriggerCreateWithoutNotificationRuleInput;
}

export interface NotificationRuleUserTriggerUpsertWithWhereUniqueWithoutUserInput {
  where: NotificationRuleUserTriggerWhereUniqueInput;
  update: NotificationRuleUserTriggerUpdateWithoutUserInput;
  create: NotificationRuleUserTriggerCreateWithoutUserInput;
}

export interface NotificationRuleUserTriggerWhereInput {
  AND?: NotificationRuleUserTriggerWhereInput[] | null;
  OR?: NotificationRuleUserTriggerWhereInput[] | null;
  NOT?: NotificationRuleUserTriggerWhereInput[] | null;
  id?: IntFilter | null;
  notificationRuleId?: IntFilter | null;
  userId?: IntFilter | null;
  updatedAt?: DateTimeFilter | null;
  notificationRule?: NotificationRuleRelationFilter | null;
  user?: UserRelationFilter | null;
}

export interface NotificationRuleUserTriggerWhereUniqueInput {
  id?: number | null;
}

export interface NotificationRuleWhereInput {
  AND?: NotificationRuleWhereInput[] | null;
  OR?: NotificationRuleWhereInput[] | null;
  NOT?: NotificationRuleWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  name?: StringFilter | null;
  proposalGpmThreshold?: IntNullableFilter | null;
  proposalFeeThreshold?: FloatNullableFilter | null;
  activeGpmThreshold?: IntNullableFilter | null;
  accruedTimeThreshold?: FloatNullableFilter | null;
  accruedBudgetThreshold?: FloatNullableFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  notifications?: NotificationListRelationFilter | null;
  triggerUsers?: NotificationRuleUserTriggerListRelationFilter | null;
  notifyUsers?: NotificationRuleUserNotifyListRelationFilter | null;
  triggerFeeEarnerLevels?: NotificationRuleFeeEarnerLevelTriggerListRelationFilter | null;
  notifyFeeEarnerLevels?: NotificationRuleFeeEarnerLevelNotifyListRelationFilter | null;
  triggerClients?: NotificationRuleClientsListRelationFilter | null;
  triggerOrganisationalUnits?: NotificationRuleOrganisationalUnitsListRelationFilter | null;
}

export interface NotificationRuleWhereUniqueInput {
  id?: number | null;
}

export interface NotificationScalarWhereInput {
  AND?: NotificationScalarWhereInput[] | null;
  OR?: NotificationScalarWhereInput[] | null;
  NOT?: NotificationScalarWhereInput[] | null;
  id?: IntFilter | null;
  title?: StringFilter | null;
  type?: EnumNotificationTypeFilter | null;
  description?: StringFilter | null;
  userId?: IntFilter | null;
  matterId?: IntNullableFilter | null;
  message?: StringNullableFilter | null;
  notificationRuleId?: IntNullableFilter | null;
  archived?: BoolFilter | null;
  parentMatterId?: IntNullableFilter | null;
}

export interface NotificationUpdateManyMutationInput {
  title?: StringFieldUpdateOperationsInput | null;
  type?: EnumNotificationTypeFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  message?: NullableStringFieldUpdateOperationsInput | null;
  archived?: BoolFieldUpdateOperationsInput | null;
}

export interface NotificationUpdateManyWithWhereWithoutMatterInput {
  where: NotificationScalarWhereInput;
  data: NotificationUpdateManyMutationInput;
}

export interface NotificationUpdateManyWithWhereWithoutNotificationRuleInput {
  where: NotificationScalarWhereInput;
  data: NotificationUpdateManyMutationInput;
}

export interface NotificationUpdateManyWithWhereWithoutParentMatterInput {
  where: NotificationScalarWhereInput;
  data: NotificationUpdateManyMutationInput;
}

export interface NotificationUpdateManyWithWhereWithoutUserInput {
  where: NotificationScalarWhereInput;
  data: NotificationUpdateManyMutationInput;
}

export interface NotificationUpdateManyWithoutMatterNestedInput {
  create?: NotificationCreateWithoutMatterInput[] | null;
  connectOrCreate?: NotificationCreateOrConnectWithoutMatterInput[] | null;
  upsert?: NotificationUpsertWithWhereUniqueWithoutMatterInput[] | null;
  createMany?: NotificationCreateManyMatterInputEnvelope | null;
  set?: NotificationWhereUniqueInput[] | null;
  disconnect?: NotificationWhereUniqueInput[] | null;
  delete?: NotificationWhereUniqueInput[] | null;
  connect?: NotificationWhereUniqueInput[] | null;
  update?: NotificationUpdateWithWhereUniqueWithoutMatterInput[] | null;
  updateMany?: NotificationUpdateManyWithWhereWithoutMatterInput[] | null;
  deleteMany?: NotificationScalarWhereInput[] | null;
}

export interface NotificationUpdateManyWithoutNotificationRuleNestedInput {
  create?: NotificationCreateWithoutNotificationRuleInput[] | null;
  connectOrCreate?: NotificationCreateOrConnectWithoutNotificationRuleInput[] | null;
  upsert?: NotificationUpsertWithWhereUniqueWithoutNotificationRuleInput[] | null;
  createMany?: NotificationCreateManyNotificationRuleInputEnvelope | null;
  set?: NotificationWhereUniqueInput[] | null;
  disconnect?: NotificationWhereUniqueInput[] | null;
  delete?: NotificationWhereUniqueInput[] | null;
  connect?: NotificationWhereUniqueInput[] | null;
  update?: NotificationUpdateWithWhereUniqueWithoutNotificationRuleInput[] | null;
  updateMany?: NotificationUpdateManyWithWhereWithoutNotificationRuleInput[] | null;
  deleteMany?: NotificationScalarWhereInput[] | null;
}

export interface NotificationUpdateManyWithoutParentMatterNestedInput {
  create?: NotificationCreateWithoutParentMatterInput[] | null;
  connectOrCreate?: NotificationCreateOrConnectWithoutParentMatterInput[] | null;
  upsert?: NotificationUpsertWithWhereUniqueWithoutParentMatterInput[] | null;
  createMany?: NotificationCreateManyParentMatterInputEnvelope | null;
  set?: NotificationWhereUniqueInput[] | null;
  disconnect?: NotificationWhereUniqueInput[] | null;
  delete?: NotificationWhereUniqueInput[] | null;
  connect?: NotificationWhereUniqueInput[] | null;
  update?: NotificationUpdateWithWhereUniqueWithoutParentMatterInput[] | null;
  updateMany?: NotificationUpdateManyWithWhereWithoutParentMatterInput[] | null;
  deleteMany?: NotificationScalarWhereInput[] | null;
}

export interface NotificationUpdateManyWithoutUserNestedInput {
  create?: NotificationCreateWithoutUserInput[] | null;
  connectOrCreate?: NotificationCreateOrConnectWithoutUserInput[] | null;
  upsert?: NotificationUpsertWithWhereUniqueWithoutUserInput[] | null;
  createMany?: NotificationCreateManyUserInputEnvelope | null;
  set?: NotificationWhereUniqueInput[] | null;
  disconnect?: NotificationWhereUniqueInput[] | null;
  delete?: NotificationWhereUniqueInput[] | null;
  connect?: NotificationWhereUniqueInput[] | null;
  update?: NotificationUpdateWithWhereUniqueWithoutUserInput[] | null;
  updateMany?: NotificationUpdateManyWithWhereWithoutUserInput[] | null;
  deleteMany?: NotificationScalarWhereInput[] | null;
}

export interface NotificationUpdateWithWhereUniqueWithoutMatterInput {
  where: NotificationWhereUniqueInput;
  data: NotificationUpdateWithoutMatterInput;
}

export interface NotificationUpdateWithWhereUniqueWithoutNotificationRuleInput {
  where: NotificationWhereUniqueInput;
  data: NotificationUpdateWithoutNotificationRuleInput;
}

export interface NotificationUpdateWithWhereUniqueWithoutParentMatterInput {
  where: NotificationWhereUniqueInput;
  data: NotificationUpdateWithoutParentMatterInput;
}

export interface NotificationUpdateWithWhereUniqueWithoutUserInput {
  where: NotificationWhereUniqueInput;
  data: NotificationUpdateWithoutUserInput;
}

export interface NotificationUpdateWithoutMatterInput {
  title?: StringFieldUpdateOperationsInput | null;
  type?: EnumNotificationTypeFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  message?: NullableStringFieldUpdateOperationsInput | null;
  archived?: BoolFieldUpdateOperationsInput | null;
  user?: UserUpdateOneRequiredWithoutNotificationsNestedInput | null;
  parentMatter?: ParentMatterUpdateOneWithoutNotificationsNestedInput | null;
  notificationRule?: NotificationRuleUpdateOneWithoutNotificationsNestedInput | null;
}

export interface NotificationUpdateWithoutNotificationRuleInput {
  title?: StringFieldUpdateOperationsInput | null;
  type?: EnumNotificationTypeFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  message?: NullableStringFieldUpdateOperationsInput | null;
  archived?: BoolFieldUpdateOperationsInput | null;
  user?: UserUpdateOneRequiredWithoutNotificationsNestedInput | null;
  matter?: MatterUpdateOneWithoutNotificationsNestedInput | null;
  parentMatter?: ParentMatterUpdateOneWithoutNotificationsNestedInput | null;
}

export interface NotificationUpdateWithoutParentMatterInput {
  title?: StringFieldUpdateOperationsInput | null;
  type?: EnumNotificationTypeFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  message?: NullableStringFieldUpdateOperationsInput | null;
  archived?: BoolFieldUpdateOperationsInput | null;
  user?: UserUpdateOneRequiredWithoutNotificationsNestedInput | null;
  matter?: MatterUpdateOneWithoutNotificationsNestedInput | null;
  notificationRule?: NotificationRuleUpdateOneWithoutNotificationsNestedInput | null;
}

export interface NotificationUpdateWithoutUserInput {
  title?: StringFieldUpdateOperationsInput | null;
  type?: EnumNotificationTypeFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  message?: NullableStringFieldUpdateOperationsInput | null;
  archived?: BoolFieldUpdateOperationsInput | null;
  matter?: MatterUpdateOneWithoutNotificationsNestedInput | null;
  parentMatter?: ParentMatterUpdateOneWithoutNotificationsNestedInput | null;
  notificationRule?: NotificationRuleUpdateOneWithoutNotificationsNestedInput | null;
}

export interface NotificationUpsertWithWhereUniqueWithoutMatterInput {
  where: NotificationWhereUniqueInput;
  update: NotificationUpdateWithoutMatterInput;
  create: NotificationCreateWithoutMatterInput;
}

export interface NotificationUpsertWithWhereUniqueWithoutNotificationRuleInput {
  where: NotificationWhereUniqueInput;
  update: NotificationUpdateWithoutNotificationRuleInput;
  create: NotificationCreateWithoutNotificationRuleInput;
}

export interface NotificationUpsertWithWhereUniqueWithoutParentMatterInput {
  where: NotificationWhereUniqueInput;
  update: NotificationUpdateWithoutParentMatterInput;
  create: NotificationCreateWithoutParentMatterInput;
}

export interface NotificationUpsertWithWhereUniqueWithoutUserInput {
  where: NotificationWhereUniqueInput;
  update: NotificationUpdateWithoutUserInput;
  create: NotificationCreateWithoutUserInput;
}

export interface NotificationWhereInput {
  AND?: NotificationWhereInput[] | null;
  OR?: NotificationWhereInput[] | null;
  NOT?: NotificationWhereInput[] | null;
  id?: IntFilter | null;
  title?: StringFilter | null;
  type?: EnumNotificationTypeFilter | null;
  description?: StringFilter | null;
  userId?: IntFilter | null;
  matterId?: IntNullableFilter | null;
  message?: StringNullableFilter | null;
  notificationRuleId?: IntNullableFilter | null;
  archived?: BoolFilter | null;
  parentMatterId?: IntNullableFilter | null;
  user?: UserRelationFilter | null;
  matter?: MatterRelationFilter | null;
  parentMatter?: ParentMatterRelationFilter | null;
  notificationRule?: NotificationRuleRelationFilter | null;
}

export interface NotificationWhereUniqueInput {
  id?: number | null;
}

export interface NullableBoolFieldUpdateOperationsInput {
  set?: boolean | null;
}

export interface NullableDateTimeFieldUpdateOperationsInput {
  set?: any | null;
}

export interface NullableEnumTemplateTypeFieldUpdateOperationsInput {
  set?: TemplateType | null;
}

export interface NullableFloatFieldUpdateOperationsInput {
  set?: number | null;
  increment?: number | null;
  decrement?: number | null;
  multiply?: number | null;
  divide?: number | null;
}

export interface NullableIntFieldUpdateOperationsInput {
  set?: number | null;
  increment?: number | null;
  decrement?: number | null;
  multiply?: number | null;
  divide?: number | null;
}

export interface NullableStringFieldUpdateOperationsInput {
  set?: string | null;
}

export interface OfficeLocationCreateNestedOneWithoutFeeEarnersInput {
  create?: OfficeLocationCreateWithoutFeeEarnersInput | null;
  connectOrCreate?: OfficeLocationCreateOrConnectWithoutFeeEarnersInput | null;
  connect?: OfficeLocationWhereUniqueInput | null;
}

export interface OfficeLocationCreateNestedOneWithoutRatesInput {
  create?: OfficeLocationCreateWithoutRatesInput | null;
  connectOrCreate?: OfficeLocationCreateOrConnectWithoutRatesInput | null;
  connect?: OfficeLocationWhereUniqueInput | null;
}

export interface OfficeLocationCreateOrConnectWithoutFeeEarnersInput {
  where: OfficeLocationWhereUniqueInput;
  create: OfficeLocationCreateWithoutFeeEarnersInput;
}

export interface OfficeLocationCreateOrConnectWithoutRatesInput {
  where: OfficeLocationWhereUniqueInput;
  create: OfficeLocationCreateWithoutRatesInput;
}

export interface OfficeLocationCreateWithoutFeeEarnersInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  countryCode: string;
  name: string;
  rates?: RateCreateNestedManyWithoutOfficeLocationInput | null;
}

export interface OfficeLocationCreateWithoutRatesInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  countryCode: string;
  name: string;
  feeEarners?: FeeEarnerCreateNestedManyWithoutOfficeLocationInput | null;
}

export interface OfficeLocationRelationFilter {
  is?: OfficeLocationWhereInput | null;
  isNot?: OfficeLocationWhereInput | null;
}

export interface OfficeLocationUpdateOneWithoutFeeEarnersNestedInput {
  create?: OfficeLocationCreateWithoutFeeEarnersInput | null;
  connectOrCreate?: OfficeLocationCreateOrConnectWithoutFeeEarnersInput | null;
  upsert?: OfficeLocationUpsertWithoutFeeEarnersInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: OfficeLocationWhereUniqueInput | null;
  update?: OfficeLocationUpdateWithoutFeeEarnersInput | null;
}

export interface OfficeLocationUpdateOneWithoutRatesNestedInput {
  create?: OfficeLocationCreateWithoutRatesInput | null;
  connectOrCreate?: OfficeLocationCreateOrConnectWithoutRatesInput | null;
  upsert?: OfficeLocationUpsertWithoutRatesInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: OfficeLocationWhereUniqueInput | null;
  update?: OfficeLocationUpdateWithoutRatesInput | null;
}

export interface OfficeLocationUpdateWithoutFeeEarnersInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  countryCode?: StringFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  rates?: RateUpdateManyWithoutOfficeLocationNestedInput | null;
}

export interface OfficeLocationUpdateWithoutRatesInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  countryCode?: StringFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  feeEarners?: FeeEarnerUpdateManyWithoutOfficeLocationNestedInput | null;
}

export interface OfficeLocationUpsertWithoutFeeEarnersInput {
  update: OfficeLocationUpdateWithoutFeeEarnersInput;
  create: OfficeLocationCreateWithoutFeeEarnersInput;
}

export interface OfficeLocationUpsertWithoutRatesInput {
  update: OfficeLocationUpdateWithoutRatesInput;
  create: OfficeLocationCreateWithoutRatesInput;
}

export interface OfficeLocationWhereInput {
  AND?: OfficeLocationWhereInput[] | null;
  OR?: OfficeLocationWhereInput[] | null;
  NOT?: OfficeLocationWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  externalId?: StringNullableFilter | null;
  externalReference?: StringNullableFilter | null;
  externalCreatedAt?: DateTimeNullableFilter | null;
  externalUpdatedAt?: DateTimeNullableFilter | null;
  externalDeletedAt?: DateTimeNullableFilter | null;
  countryCode?: StringFilter | null;
  name?: StringFilter | null;
  feeEarners?: FeeEarnerListRelationFilter | null;
  rates?: RateListRelationFilter | null;
}

export interface OfficeLocationWhereUniqueInput {
  id?: number | null;
  externalId?: string | null;
  name?: string | null;
}

export interface OrganisationalUnitCreateManyParentInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  name: string;
  gpmDangerThreshold?: number | null;
  order: number;
}

export interface OrganisationalUnitCreateManyParentInputEnvelope {
  data: OrganisationalUnitCreateManyParentInput[];
  skipDuplicates?: boolean | null;
}

export interface OrganisationalUnitCreateNestedManyWithoutLibraryAssumptionsInput {
  create?: OrganisationalUnitCreateWithoutLibraryAssumptionsInput[] | null;
  connectOrCreate?: OrganisationalUnitCreateOrConnectWithoutLibraryAssumptionsInput[] | null;
  connect?: OrganisationalUnitWhereUniqueInput[] | null;
}

export interface OrganisationalUnitCreateNestedManyWithoutLibraryExclusionsInput {
  create?: OrganisationalUnitCreateWithoutLibraryExclusionsInput[] | null;
  connectOrCreate?: OrganisationalUnitCreateOrConnectWithoutLibraryExclusionsInput[] | null;
  connect?: OrganisationalUnitWhereUniqueInput[] | null;
}

export interface OrganisationalUnitCreateNestedManyWithoutParentInput {
  create?: OrganisationalUnitCreateWithoutParentInput[] | null;
  connectOrCreate?: OrganisationalUnitCreateOrConnectWithoutParentInput[] | null;
  createMany?: OrganisationalUnitCreateManyParentInputEnvelope | null;
  connect?: OrganisationalUnitWhereUniqueInput[] | null;
}

export interface OrganisationalUnitCreateNestedOneWithoutChildrenInput {
  create?: OrganisationalUnitCreateWithoutChildrenInput | null;
  connectOrCreate?: OrganisationalUnitCreateOrConnectWithoutChildrenInput | null;
  connect?: OrganisationalUnitWhereUniqueInput | null;
}

export interface OrganisationalUnitCreateNestedOneWithoutExternalMattersInput {
  create?: OrganisationalUnitCreateWithoutExternalMattersInput | null;
  connectOrCreate?: OrganisationalUnitCreateOrConnectWithoutExternalMattersInput | null;
  connect?: OrganisationalUnitWhereUniqueInput | null;
}

export interface OrganisationalUnitCreateNestedOneWithoutFeeEarnersInput {
  create?: OrganisationalUnitCreateWithoutFeeEarnersInput | null;
  connectOrCreate?: OrganisationalUnitCreateOrConnectWithoutFeeEarnersInput | null;
  connect?: OrganisationalUnitWhereUniqueInput | null;
}

export interface OrganisationalUnitCreateNestedOneWithoutMattersInput {
  create?: OrganisationalUnitCreateWithoutMattersInput | null;
  connectOrCreate?: OrganisationalUnitCreateOrConnectWithoutMattersInput | null;
  connect?: OrganisationalUnitWhereUniqueInput | null;
}

export interface OrganisationalUnitCreateNestedOneWithoutRatesInput {
  create?: OrganisationalUnitCreateWithoutRatesInput | null;
  connectOrCreate?: OrganisationalUnitCreateOrConnectWithoutRatesInput | null;
  connect?: OrganisationalUnitWhereUniqueInput | null;
}

export interface OrganisationalUnitCreateNestedOneWithoutTriggeredNotificationRulesInput {
  create?: OrganisationalUnitCreateWithoutTriggeredNotificationRulesInput | null;
  connectOrCreate?: OrganisationalUnitCreateOrConnectWithoutTriggeredNotificationRulesInput | null;
  connect?: OrganisationalUnitWhereUniqueInput | null;
}

export interface OrganisationalUnitCreateOrConnectWithoutChildrenInput {
  where: OrganisationalUnitWhereUniqueInput;
  create: OrganisationalUnitCreateWithoutChildrenInput;
}

export interface OrganisationalUnitCreateOrConnectWithoutExternalMattersInput {
  where: OrganisationalUnitWhereUniqueInput;
  create: OrganisationalUnitCreateWithoutExternalMattersInput;
}

export interface OrganisationalUnitCreateOrConnectWithoutFeeEarnersInput {
  where: OrganisationalUnitWhereUniqueInput;
  create: OrganisationalUnitCreateWithoutFeeEarnersInput;
}

export interface OrganisationalUnitCreateOrConnectWithoutLibraryAssumptionsInput {
  where: OrganisationalUnitWhereUniqueInput;
  create: OrganisationalUnitCreateWithoutLibraryAssumptionsInput;
}

export interface OrganisationalUnitCreateOrConnectWithoutLibraryExclusionsInput {
  where: OrganisationalUnitWhereUniqueInput;
  create: OrganisationalUnitCreateWithoutLibraryExclusionsInput;
}

export interface OrganisationalUnitCreateOrConnectWithoutMattersInput {
  where: OrganisationalUnitWhereUniqueInput;
  create: OrganisationalUnitCreateWithoutMattersInput;
}

export interface OrganisationalUnitCreateOrConnectWithoutParentInput {
  where: OrganisationalUnitWhereUniqueInput;
  create: OrganisationalUnitCreateWithoutParentInput;
}

export interface OrganisationalUnitCreateOrConnectWithoutRatesInput {
  where: OrganisationalUnitWhereUniqueInput;
  create: OrganisationalUnitCreateWithoutRatesInput;
}

export interface OrganisationalUnitCreateOrConnectWithoutTriggeredNotificationRulesInput {
  where: OrganisationalUnitWhereUniqueInput;
  create: OrganisationalUnitCreateWithoutTriggeredNotificationRulesInput;
}

export interface OrganisationalUnitCreateWithoutChildrenInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  name: string;
  gpmDangerThreshold?: number | null;
  order: number;
  parent?: OrganisationalUnitCreateNestedOneWithoutChildrenInput | null;
  externalMatters?: ExternalMatterCreateNestedManyWithoutOrganisationalUnitInput | null;
  feeEarners?: FeeEarnerCreateNestedManyWithoutOrganisationalUnitInput | null;
  matters?: MatterCreateNestedManyWithoutOrganisationalUnitInput | null;
  rates?: RateCreateNestedManyWithoutOrganisationalUnitInput | null;
  triggeredNotificationRules?: NotificationRuleOrganisationalUnitsCreateNestedManyWithoutOrganisationalUnitInput | null;
  libraryAssumptions?: LibraryAssumptionCreateNestedManyWithoutOrganisationalUnitsInput | null;
  libraryExclusions?: LibraryExclusionCreateNestedManyWithoutOrganisationalUnitsInput | null;
}

export interface OrganisationalUnitCreateWithoutExternalMattersInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  name: string;
  gpmDangerThreshold?: number | null;
  order: number;
  parent?: OrganisationalUnitCreateNestedOneWithoutChildrenInput | null;
  feeEarners?: FeeEarnerCreateNestedManyWithoutOrganisationalUnitInput | null;
  matters?: MatterCreateNestedManyWithoutOrganisationalUnitInput | null;
  children?: OrganisationalUnitCreateNestedManyWithoutParentInput | null;
  rates?: RateCreateNestedManyWithoutOrganisationalUnitInput | null;
  triggeredNotificationRules?: NotificationRuleOrganisationalUnitsCreateNestedManyWithoutOrganisationalUnitInput | null;
  libraryAssumptions?: LibraryAssumptionCreateNestedManyWithoutOrganisationalUnitsInput | null;
  libraryExclusions?: LibraryExclusionCreateNestedManyWithoutOrganisationalUnitsInput | null;
}

export interface OrganisationalUnitCreateWithoutFeeEarnersInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  name: string;
  gpmDangerThreshold?: number | null;
  order: number;
  parent?: OrganisationalUnitCreateNestedOneWithoutChildrenInput | null;
  externalMatters?: ExternalMatterCreateNestedManyWithoutOrganisationalUnitInput | null;
  matters?: MatterCreateNestedManyWithoutOrganisationalUnitInput | null;
  children?: OrganisationalUnitCreateNestedManyWithoutParentInput | null;
  rates?: RateCreateNestedManyWithoutOrganisationalUnitInput | null;
  triggeredNotificationRules?: NotificationRuleOrganisationalUnitsCreateNestedManyWithoutOrganisationalUnitInput | null;
  libraryAssumptions?: LibraryAssumptionCreateNestedManyWithoutOrganisationalUnitsInput | null;
  libraryExclusions?: LibraryExclusionCreateNestedManyWithoutOrganisationalUnitsInput | null;
}

export interface OrganisationalUnitCreateWithoutLibraryAssumptionsInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  name: string;
  gpmDangerThreshold?: number | null;
  order: number;
  parent?: OrganisationalUnitCreateNestedOneWithoutChildrenInput | null;
  externalMatters?: ExternalMatterCreateNestedManyWithoutOrganisationalUnitInput | null;
  feeEarners?: FeeEarnerCreateNestedManyWithoutOrganisationalUnitInput | null;
  matters?: MatterCreateNestedManyWithoutOrganisationalUnitInput | null;
  children?: OrganisationalUnitCreateNestedManyWithoutParentInput | null;
  rates?: RateCreateNestedManyWithoutOrganisationalUnitInput | null;
  triggeredNotificationRules?: NotificationRuleOrganisationalUnitsCreateNestedManyWithoutOrganisationalUnitInput | null;
  libraryExclusions?: LibraryExclusionCreateNestedManyWithoutOrganisationalUnitsInput | null;
}

export interface OrganisationalUnitCreateWithoutLibraryExclusionsInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  name: string;
  gpmDangerThreshold?: number | null;
  order: number;
  parent?: OrganisationalUnitCreateNestedOneWithoutChildrenInput | null;
  externalMatters?: ExternalMatterCreateNestedManyWithoutOrganisationalUnitInput | null;
  feeEarners?: FeeEarnerCreateNestedManyWithoutOrganisationalUnitInput | null;
  matters?: MatterCreateNestedManyWithoutOrganisationalUnitInput | null;
  children?: OrganisationalUnitCreateNestedManyWithoutParentInput | null;
  rates?: RateCreateNestedManyWithoutOrganisationalUnitInput | null;
  triggeredNotificationRules?: NotificationRuleOrganisationalUnitsCreateNestedManyWithoutOrganisationalUnitInput | null;
  libraryAssumptions?: LibraryAssumptionCreateNestedManyWithoutOrganisationalUnitsInput | null;
}

export interface OrganisationalUnitCreateWithoutMattersInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  name: string;
  gpmDangerThreshold?: number | null;
  order: number;
  parent?: OrganisationalUnitCreateNestedOneWithoutChildrenInput | null;
  externalMatters?: ExternalMatterCreateNestedManyWithoutOrganisationalUnitInput | null;
  feeEarners?: FeeEarnerCreateNestedManyWithoutOrganisationalUnitInput | null;
  children?: OrganisationalUnitCreateNestedManyWithoutParentInput | null;
  rates?: RateCreateNestedManyWithoutOrganisationalUnitInput | null;
  triggeredNotificationRules?: NotificationRuleOrganisationalUnitsCreateNestedManyWithoutOrganisationalUnitInput | null;
  libraryAssumptions?: LibraryAssumptionCreateNestedManyWithoutOrganisationalUnitsInput | null;
  libraryExclusions?: LibraryExclusionCreateNestedManyWithoutOrganisationalUnitsInput | null;
}

export interface OrganisationalUnitCreateWithoutParentInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  name: string;
  gpmDangerThreshold?: number | null;
  order: number;
  externalMatters?: ExternalMatterCreateNestedManyWithoutOrganisationalUnitInput | null;
  feeEarners?: FeeEarnerCreateNestedManyWithoutOrganisationalUnitInput | null;
  matters?: MatterCreateNestedManyWithoutOrganisationalUnitInput | null;
  children?: OrganisationalUnitCreateNestedManyWithoutParentInput | null;
  rates?: RateCreateNestedManyWithoutOrganisationalUnitInput | null;
  triggeredNotificationRules?: NotificationRuleOrganisationalUnitsCreateNestedManyWithoutOrganisationalUnitInput | null;
  libraryAssumptions?: LibraryAssumptionCreateNestedManyWithoutOrganisationalUnitsInput | null;
  libraryExclusions?: LibraryExclusionCreateNestedManyWithoutOrganisationalUnitsInput | null;
}

export interface OrganisationalUnitCreateWithoutRatesInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  name: string;
  gpmDangerThreshold?: number | null;
  order: number;
  parent?: OrganisationalUnitCreateNestedOneWithoutChildrenInput | null;
  externalMatters?: ExternalMatterCreateNestedManyWithoutOrganisationalUnitInput | null;
  feeEarners?: FeeEarnerCreateNestedManyWithoutOrganisationalUnitInput | null;
  matters?: MatterCreateNestedManyWithoutOrganisationalUnitInput | null;
  children?: OrganisationalUnitCreateNestedManyWithoutParentInput | null;
  triggeredNotificationRules?: NotificationRuleOrganisationalUnitsCreateNestedManyWithoutOrganisationalUnitInput | null;
  libraryAssumptions?: LibraryAssumptionCreateNestedManyWithoutOrganisationalUnitsInput | null;
  libraryExclusions?: LibraryExclusionCreateNestedManyWithoutOrganisationalUnitsInput | null;
}

export interface OrganisationalUnitCreateWithoutTriggeredNotificationRulesInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  name: string;
  gpmDangerThreshold?: number | null;
  order: number;
  parent?: OrganisationalUnitCreateNestedOneWithoutChildrenInput | null;
  externalMatters?: ExternalMatterCreateNestedManyWithoutOrganisationalUnitInput | null;
  feeEarners?: FeeEarnerCreateNestedManyWithoutOrganisationalUnitInput | null;
  matters?: MatterCreateNestedManyWithoutOrganisationalUnitInput | null;
  children?: OrganisationalUnitCreateNestedManyWithoutParentInput | null;
  rates?: RateCreateNestedManyWithoutOrganisationalUnitInput | null;
  libraryAssumptions?: LibraryAssumptionCreateNestedManyWithoutOrganisationalUnitsInput | null;
  libraryExclusions?: LibraryExclusionCreateNestedManyWithoutOrganisationalUnitsInput | null;
}

export interface OrganisationalUnitListRelationFilter {
  every?: OrganisationalUnitWhereInput | null;
  some?: OrganisationalUnitWhereInput | null;
  none?: OrganisationalUnitWhereInput | null;
}

export interface OrganisationalUnitRelationFilter {
  is?: OrganisationalUnitWhereInput | null;
  isNot?: OrganisationalUnitWhereInput | null;
}

export interface OrganisationalUnitScalarWhereInput {
  AND?: OrganisationalUnitScalarWhereInput[] | null;
  OR?: OrganisationalUnitScalarWhereInput[] | null;
  NOT?: OrganisationalUnitScalarWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  externalId?: StringNullableFilter | null;
  externalReference?: StringNullableFilter | null;
  externalCreatedAt?: DateTimeNullableFilter | null;
  externalUpdatedAt?: DateTimeNullableFilter | null;
  externalDeletedAt?: DateTimeNullableFilter | null;
  name?: StringFilter | null;
  gpmDangerThreshold?: IntNullableFilter | null;
  order?: IntFilter | null;
  parentId?: IntNullableFilter | null;
}

export interface OrganisationalUnitUpdateInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  gpmDangerThreshold?: NullableIntFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  parent?: OrganisationalUnitUpdateOneWithoutChildrenNestedInput | null;
  externalMatters?: ExternalMatterUpdateManyWithoutOrganisationalUnitNestedInput | null;
  feeEarners?: FeeEarnerUpdateManyWithoutOrganisationalUnitNestedInput | null;
  matters?: MatterUpdateManyWithoutOrganisationalUnitNestedInput | null;
  children?: OrganisationalUnitUpdateManyWithoutParentNestedInput | null;
  rates?: RateUpdateManyWithoutOrganisationalUnitNestedInput | null;
  triggeredNotificationRules?: NotificationRuleOrganisationalUnitsUpdateManyWithoutOrganisationalUnitNestedInput | null;
  libraryAssumptions?: LibraryAssumptionUpdateManyWithoutOrganisationalUnitsNestedInput | null;
  libraryExclusions?: LibraryExclusionUpdateManyWithoutOrganisationalUnitsNestedInput | null;
}

export interface OrganisationalUnitUpdateManyMutationInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  gpmDangerThreshold?: NullableIntFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
}

export interface OrganisationalUnitUpdateManyWithWhereWithoutParentInput {
  where: OrganisationalUnitScalarWhereInput;
  data: OrganisationalUnitUpdateManyMutationInput;
}

export interface OrganisationalUnitUpdateManyWithoutParentNestedInput {
  create?: OrganisationalUnitCreateWithoutParentInput[] | null;
  connectOrCreate?: OrganisationalUnitCreateOrConnectWithoutParentInput[] | null;
  upsert?: OrganisationalUnitUpsertWithWhereUniqueWithoutParentInput[] | null;
  createMany?: OrganisationalUnitCreateManyParentInputEnvelope | null;
  set?: OrganisationalUnitWhereUniqueInput[] | null;
  disconnect?: OrganisationalUnitWhereUniqueInput[] | null;
  delete?: OrganisationalUnitWhereUniqueInput[] | null;
  connect?: OrganisationalUnitWhereUniqueInput[] | null;
  update?: OrganisationalUnitUpdateWithWhereUniqueWithoutParentInput[] | null;
  updateMany?: OrganisationalUnitUpdateManyWithWhereWithoutParentInput[] | null;
  deleteMany?: OrganisationalUnitScalarWhereInput[] | null;
}

export interface OrganisationalUnitUpdateOneRequiredWithoutTriggeredNotificationRulesNestedInput {
  create?: OrganisationalUnitCreateWithoutTriggeredNotificationRulesInput | null;
  connectOrCreate?: OrganisationalUnitCreateOrConnectWithoutTriggeredNotificationRulesInput | null;
  upsert?: OrganisationalUnitUpsertWithoutTriggeredNotificationRulesInput | null;
  connect?: OrganisationalUnitWhereUniqueInput | null;
  update?: OrganisationalUnitUpdateWithoutTriggeredNotificationRulesInput | null;
}

export interface OrganisationalUnitUpdateOneWithoutChildrenNestedInput {
  create?: OrganisationalUnitCreateWithoutChildrenInput | null;
  connectOrCreate?: OrganisationalUnitCreateOrConnectWithoutChildrenInput | null;
  upsert?: OrganisationalUnitUpsertWithoutChildrenInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: OrganisationalUnitWhereUniqueInput | null;
  update?: OrganisationalUnitUpdateWithoutChildrenInput | null;
}

export interface OrganisationalUnitUpdateOneWithoutExternalMattersNestedInput {
  create?: OrganisationalUnitCreateWithoutExternalMattersInput | null;
  connectOrCreate?: OrganisationalUnitCreateOrConnectWithoutExternalMattersInput | null;
  upsert?: OrganisationalUnitUpsertWithoutExternalMattersInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: OrganisationalUnitWhereUniqueInput | null;
  update?: OrganisationalUnitUpdateWithoutExternalMattersInput | null;
}

export interface OrganisationalUnitUpdateOneWithoutFeeEarnersNestedInput {
  create?: OrganisationalUnitCreateWithoutFeeEarnersInput | null;
  connectOrCreate?: OrganisationalUnitCreateOrConnectWithoutFeeEarnersInput | null;
  upsert?: OrganisationalUnitUpsertWithoutFeeEarnersInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: OrganisationalUnitWhereUniqueInput | null;
  update?: OrganisationalUnitUpdateWithoutFeeEarnersInput | null;
}

export interface OrganisationalUnitUpdateOneWithoutMattersNestedInput {
  create?: OrganisationalUnitCreateWithoutMattersInput | null;
  connectOrCreate?: OrganisationalUnitCreateOrConnectWithoutMattersInput | null;
  upsert?: OrganisationalUnitUpsertWithoutMattersInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: OrganisationalUnitWhereUniqueInput | null;
  update?: OrganisationalUnitUpdateWithoutMattersInput | null;
}

export interface OrganisationalUnitUpdateOneWithoutRatesNestedInput {
  create?: OrganisationalUnitCreateWithoutRatesInput | null;
  connectOrCreate?: OrganisationalUnitCreateOrConnectWithoutRatesInput | null;
  upsert?: OrganisationalUnitUpsertWithoutRatesInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: OrganisationalUnitWhereUniqueInput | null;
  update?: OrganisationalUnitUpdateWithoutRatesInput | null;
}

export interface OrganisationalUnitUpdateWithWhereUniqueWithoutParentInput {
  where: OrganisationalUnitWhereUniqueInput;
  data: OrganisationalUnitUpdateWithoutParentInput;
}

export interface OrganisationalUnitUpdateWithoutChildrenInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  gpmDangerThreshold?: NullableIntFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  parent?: OrganisationalUnitUpdateOneWithoutChildrenNestedInput | null;
  externalMatters?: ExternalMatterUpdateManyWithoutOrganisationalUnitNestedInput | null;
  feeEarners?: FeeEarnerUpdateManyWithoutOrganisationalUnitNestedInput | null;
  matters?: MatterUpdateManyWithoutOrganisationalUnitNestedInput | null;
  rates?: RateUpdateManyWithoutOrganisationalUnitNestedInput | null;
  triggeredNotificationRules?: NotificationRuleOrganisationalUnitsUpdateManyWithoutOrganisationalUnitNestedInput | null;
  libraryAssumptions?: LibraryAssumptionUpdateManyWithoutOrganisationalUnitsNestedInput | null;
  libraryExclusions?: LibraryExclusionUpdateManyWithoutOrganisationalUnitsNestedInput | null;
}

export interface OrganisationalUnitUpdateWithoutExternalMattersInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  gpmDangerThreshold?: NullableIntFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  parent?: OrganisationalUnitUpdateOneWithoutChildrenNestedInput | null;
  feeEarners?: FeeEarnerUpdateManyWithoutOrganisationalUnitNestedInput | null;
  matters?: MatterUpdateManyWithoutOrganisationalUnitNestedInput | null;
  children?: OrganisationalUnitUpdateManyWithoutParentNestedInput | null;
  rates?: RateUpdateManyWithoutOrganisationalUnitNestedInput | null;
  triggeredNotificationRules?: NotificationRuleOrganisationalUnitsUpdateManyWithoutOrganisationalUnitNestedInput | null;
  libraryAssumptions?: LibraryAssumptionUpdateManyWithoutOrganisationalUnitsNestedInput | null;
  libraryExclusions?: LibraryExclusionUpdateManyWithoutOrganisationalUnitsNestedInput | null;
}

export interface OrganisationalUnitUpdateWithoutFeeEarnersInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  gpmDangerThreshold?: NullableIntFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  parent?: OrganisationalUnitUpdateOneWithoutChildrenNestedInput | null;
  externalMatters?: ExternalMatterUpdateManyWithoutOrganisationalUnitNestedInput | null;
  matters?: MatterUpdateManyWithoutOrganisationalUnitNestedInput | null;
  children?: OrganisationalUnitUpdateManyWithoutParentNestedInput | null;
  rates?: RateUpdateManyWithoutOrganisationalUnitNestedInput | null;
  triggeredNotificationRules?: NotificationRuleOrganisationalUnitsUpdateManyWithoutOrganisationalUnitNestedInput | null;
  libraryAssumptions?: LibraryAssumptionUpdateManyWithoutOrganisationalUnitsNestedInput | null;
  libraryExclusions?: LibraryExclusionUpdateManyWithoutOrganisationalUnitsNestedInput | null;
}

export interface OrganisationalUnitUpdateWithoutMattersInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  gpmDangerThreshold?: NullableIntFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  parent?: OrganisationalUnitUpdateOneWithoutChildrenNestedInput | null;
  externalMatters?: ExternalMatterUpdateManyWithoutOrganisationalUnitNestedInput | null;
  feeEarners?: FeeEarnerUpdateManyWithoutOrganisationalUnitNestedInput | null;
  children?: OrganisationalUnitUpdateManyWithoutParentNestedInput | null;
  rates?: RateUpdateManyWithoutOrganisationalUnitNestedInput | null;
  triggeredNotificationRules?: NotificationRuleOrganisationalUnitsUpdateManyWithoutOrganisationalUnitNestedInput | null;
  libraryAssumptions?: LibraryAssumptionUpdateManyWithoutOrganisationalUnitsNestedInput | null;
  libraryExclusions?: LibraryExclusionUpdateManyWithoutOrganisationalUnitsNestedInput | null;
}

export interface OrganisationalUnitUpdateWithoutParentInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  gpmDangerThreshold?: NullableIntFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  externalMatters?: ExternalMatterUpdateManyWithoutOrganisationalUnitNestedInput | null;
  feeEarners?: FeeEarnerUpdateManyWithoutOrganisationalUnitNestedInput | null;
  matters?: MatterUpdateManyWithoutOrganisationalUnitNestedInput | null;
  children?: OrganisationalUnitUpdateManyWithoutParentNestedInput | null;
  rates?: RateUpdateManyWithoutOrganisationalUnitNestedInput | null;
  triggeredNotificationRules?: NotificationRuleOrganisationalUnitsUpdateManyWithoutOrganisationalUnitNestedInput | null;
  libraryAssumptions?: LibraryAssumptionUpdateManyWithoutOrganisationalUnitsNestedInput | null;
  libraryExclusions?: LibraryExclusionUpdateManyWithoutOrganisationalUnitsNestedInput | null;
}

export interface OrganisationalUnitUpdateWithoutRatesInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  gpmDangerThreshold?: NullableIntFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  parent?: OrganisationalUnitUpdateOneWithoutChildrenNestedInput | null;
  externalMatters?: ExternalMatterUpdateManyWithoutOrganisationalUnitNestedInput | null;
  feeEarners?: FeeEarnerUpdateManyWithoutOrganisationalUnitNestedInput | null;
  matters?: MatterUpdateManyWithoutOrganisationalUnitNestedInput | null;
  children?: OrganisationalUnitUpdateManyWithoutParentNestedInput | null;
  triggeredNotificationRules?: NotificationRuleOrganisationalUnitsUpdateManyWithoutOrganisationalUnitNestedInput | null;
  libraryAssumptions?: LibraryAssumptionUpdateManyWithoutOrganisationalUnitsNestedInput | null;
  libraryExclusions?: LibraryExclusionUpdateManyWithoutOrganisationalUnitsNestedInput | null;
}

export interface OrganisationalUnitUpdateWithoutTriggeredNotificationRulesInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  name?: StringFieldUpdateOperationsInput | null;
  gpmDangerThreshold?: NullableIntFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  parent?: OrganisationalUnitUpdateOneWithoutChildrenNestedInput | null;
  externalMatters?: ExternalMatterUpdateManyWithoutOrganisationalUnitNestedInput | null;
  feeEarners?: FeeEarnerUpdateManyWithoutOrganisationalUnitNestedInput | null;
  matters?: MatterUpdateManyWithoutOrganisationalUnitNestedInput | null;
  children?: OrganisationalUnitUpdateManyWithoutParentNestedInput | null;
  rates?: RateUpdateManyWithoutOrganisationalUnitNestedInput | null;
  libraryAssumptions?: LibraryAssumptionUpdateManyWithoutOrganisationalUnitsNestedInput | null;
  libraryExclusions?: LibraryExclusionUpdateManyWithoutOrganisationalUnitsNestedInput | null;
}

export interface OrganisationalUnitUpsertWithWhereUniqueWithoutParentInput {
  where: OrganisationalUnitWhereUniqueInput;
  update: OrganisationalUnitUpdateWithoutParentInput;
  create: OrganisationalUnitCreateWithoutParentInput;
}

export interface OrganisationalUnitUpsertWithoutChildrenInput {
  update: OrganisationalUnitUpdateWithoutChildrenInput;
  create: OrganisationalUnitCreateWithoutChildrenInput;
}

export interface OrganisationalUnitUpsertWithoutExternalMattersInput {
  update: OrganisationalUnitUpdateWithoutExternalMattersInput;
  create: OrganisationalUnitCreateWithoutExternalMattersInput;
}

export interface OrganisationalUnitUpsertWithoutFeeEarnersInput {
  update: OrganisationalUnitUpdateWithoutFeeEarnersInput;
  create: OrganisationalUnitCreateWithoutFeeEarnersInput;
}

export interface OrganisationalUnitUpsertWithoutMattersInput {
  update: OrganisationalUnitUpdateWithoutMattersInput;
  create: OrganisationalUnitCreateWithoutMattersInput;
}

export interface OrganisationalUnitUpsertWithoutRatesInput {
  update: OrganisationalUnitUpdateWithoutRatesInput;
  create: OrganisationalUnitCreateWithoutRatesInput;
}

export interface OrganisationalUnitUpsertWithoutTriggeredNotificationRulesInput {
  update: OrganisationalUnitUpdateWithoutTriggeredNotificationRulesInput;
  create: OrganisationalUnitCreateWithoutTriggeredNotificationRulesInput;
}

export interface OrganisationalUnitWhereInput {
  AND?: OrganisationalUnitWhereInput[] | null;
  OR?: OrganisationalUnitWhereInput[] | null;
  NOT?: OrganisationalUnitWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  externalId?: StringNullableFilter | null;
  externalReference?: StringNullableFilter | null;
  externalCreatedAt?: DateTimeNullableFilter | null;
  externalUpdatedAt?: DateTimeNullableFilter | null;
  externalDeletedAt?: DateTimeNullableFilter | null;
  name?: StringFilter | null;
  gpmDangerThreshold?: IntNullableFilter | null;
  order?: IntFilter | null;
  parentId?: IntNullableFilter | null;
  parent?: OrganisationalUnitRelationFilter | null;
  externalMatters?: ExternalMatterListRelationFilter | null;
  feeEarners?: FeeEarnerListRelationFilter | null;
  matters?: MatterListRelationFilter | null;
  children?: OrganisationalUnitListRelationFilter | null;
  rates?: RateListRelationFilter | null;
  triggeredNotificationRules?: NotificationRuleOrganisationalUnitsListRelationFilter | null;
  libraryAssumptions?: LibraryAssumptionListRelationFilter | null;
  libraryExclusions?: LibraryExclusionListRelationFilter | null;
}

export interface OrganisationalUnitWhereUniqueInput {
  id?: number | null;
  externalId?: string | null;
}

export interface ParentMatterCreateManyBrandInput {
  id?: number | null;
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  title: string;
  status?: MatterStatus | null;
  clientId?: number | null;
  createdById: number;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
}

export interface ParentMatterCreateManyBrandInputEnvelope {
  data: ParentMatterCreateManyBrandInput[];
  skipDuplicates?: boolean | null;
}

export interface ParentMatterCreateManyClientInput {
  id?: number | null;
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  title: string;
  status?: MatterStatus | null;
  createdById: number;
  brandId?: number | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
}

export interface ParentMatterCreateManyClientInputEnvelope {
  data: ParentMatterCreateManyClientInput[];
  skipDuplicates?: boolean | null;
}

export interface ParentMatterCreateManyCreatedByInput {
  id?: number | null;
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  title: string;
  status?: MatterStatus | null;
  clientId?: number | null;
  brandId?: number | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
}

export interface ParentMatterCreateManyCreatedByInputEnvelope {
  data: ParentMatterCreateManyCreatedByInput[];
  skipDuplicates?: boolean | null;
}

export interface ParentMatterCreateNestedManyWithoutBrandInput {
  create?: ParentMatterCreateWithoutBrandInput[] | null;
  connectOrCreate?: ParentMatterCreateOrConnectWithoutBrandInput[] | null;
  createMany?: ParentMatterCreateManyBrandInputEnvelope | null;
  connect?: ParentMatterWhereUniqueInput[] | null;
}

export interface ParentMatterCreateNestedManyWithoutClientInput {
  create?: ParentMatterCreateWithoutClientInput[] | null;
  connectOrCreate?: ParentMatterCreateOrConnectWithoutClientInput[] | null;
  createMany?: ParentMatterCreateManyClientInputEnvelope | null;
  connect?: ParentMatterWhereUniqueInput[] | null;
}

export interface ParentMatterCreateNestedManyWithoutCreatedByInput {
  create?: ParentMatterCreateWithoutCreatedByInput[] | null;
  connectOrCreate?: ParentMatterCreateOrConnectWithoutCreatedByInput[] | null;
  createMany?: ParentMatterCreateManyCreatedByInputEnvelope | null;
  connect?: ParentMatterWhereUniqueInput[] | null;
}

export interface ParentMatterCreateNestedOneWithoutCollaboratorsInput {
  create?: ParentMatterCreateWithoutCollaboratorsInput | null;
  connectOrCreate?: ParentMatterCreateOrConnectWithoutCollaboratorsInput | null;
  connect?: ParentMatterWhereUniqueInput | null;
}

export interface ParentMatterCreateNestedOneWithoutMattersInput {
  create?: ParentMatterCreateWithoutMattersInput | null;
  connectOrCreate?: ParentMatterCreateOrConnectWithoutMattersInput | null;
  connect?: ParentMatterWhereUniqueInput | null;
}

export interface ParentMatterCreateNestedOneWithoutNotificationsInput {
  create?: ParentMatterCreateWithoutNotificationsInput | null;
  connectOrCreate?: ParentMatterCreateOrConnectWithoutNotificationsInput | null;
  connect?: ParentMatterWhereUniqueInput | null;
}

export interface ParentMatterCreateOrConnectWithoutBrandInput {
  where: ParentMatterWhereUniqueInput;
  create: ParentMatterCreateWithoutBrandInput;
}

export interface ParentMatterCreateOrConnectWithoutClientInput {
  where: ParentMatterWhereUniqueInput;
  create: ParentMatterCreateWithoutClientInput;
}

export interface ParentMatterCreateOrConnectWithoutCollaboratorsInput {
  where: ParentMatterWhereUniqueInput;
  create: ParentMatterCreateWithoutCollaboratorsInput;
}

export interface ParentMatterCreateOrConnectWithoutCreatedByInput {
  where: ParentMatterWhereUniqueInput;
  create: ParentMatterCreateWithoutCreatedByInput;
}

export interface ParentMatterCreateOrConnectWithoutMattersInput {
  where: ParentMatterWhereUniqueInput;
  create: ParentMatterCreateWithoutMattersInput;
}

export interface ParentMatterCreateOrConnectWithoutNotificationsInput {
  where: ParentMatterWhereUniqueInput;
  create: ParentMatterCreateWithoutNotificationsInput;
}

export interface ParentMatterCreateWithoutBrandInput {
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  title: string;
  status?: MatterStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  matters?: MatterCreateNestedManyWithoutParentInput | null;
  client?: ClientCreateNestedOneWithoutParentMatterInput | null;
  collaborators?: CollaboratorCreateNestedManyWithoutParentMatterInput | null;
  notifications?: NotificationCreateNestedManyWithoutParentMatterInput | null;
}

export interface ParentMatterCreateWithoutClientInput {
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  title: string;
  status?: MatterStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  matters?: MatterCreateNestedManyWithoutParentInput | null;
  brand?: BrandCreateNestedOneWithoutParentMattersInput | null;
  collaborators?: CollaboratorCreateNestedManyWithoutParentMatterInput | null;
  notifications?: NotificationCreateNestedManyWithoutParentMatterInput | null;
}

export interface ParentMatterCreateWithoutCollaboratorsInput {
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  title: string;
  status?: MatterStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  matters?: MatterCreateNestedManyWithoutParentInput | null;
  client?: ClientCreateNestedOneWithoutParentMatterInput | null;
  brand?: BrandCreateNestedOneWithoutParentMattersInput | null;
  notifications?: NotificationCreateNestedManyWithoutParentMatterInput | null;
}

export interface ParentMatterCreateWithoutCreatedByInput {
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  title: string;
  status?: MatterStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  matters?: MatterCreateNestedManyWithoutParentInput | null;
  client?: ClientCreateNestedOneWithoutParentMatterInput | null;
  brand?: BrandCreateNestedOneWithoutParentMattersInput | null;
  collaborators?: CollaboratorCreateNestedManyWithoutParentMatterInput | null;
  notifications?: NotificationCreateNestedManyWithoutParentMatterInput | null;
}

export interface ParentMatterCreateWithoutMattersInput {
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  title: string;
  status?: MatterStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  client?: ClientCreateNestedOneWithoutParentMatterInput | null;
  brand?: BrandCreateNestedOneWithoutParentMattersInput | null;
  collaborators?: CollaboratorCreateNestedManyWithoutParentMatterInput | null;
  notifications?: NotificationCreateNestedManyWithoutParentMatterInput | null;
}

export interface ParentMatterCreateWithoutNotificationsInput {
  reference?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  title: string;
  status?: MatterStatus | null;
  includeTasksInProposalOutput?: boolean | null;
  includeRatesInProposalOutput?: boolean | null;
  matters?: MatterCreateNestedManyWithoutParentInput | null;
  client?: ClientCreateNestedOneWithoutParentMatterInput | null;
  brand?: BrandCreateNestedOneWithoutParentMattersInput | null;
  collaborators?: CollaboratorCreateNestedManyWithoutParentMatterInput | null;
}

export interface ParentMatterListRelationFilter {
  every?: ParentMatterWhereInput | null;
  some?: ParentMatterWhereInput | null;
  none?: ParentMatterWhereInput | null;
}

export interface ParentMatterRelationFilter {
  is?: ParentMatterWhereInput | null;
  isNot?: ParentMatterWhereInput | null;
}

export interface ParentMatterScalarWhereInput {
  AND?: ParentMatterScalarWhereInput[] | null;
  OR?: ParentMatterScalarWhereInput[] | null;
  NOT?: ParentMatterScalarWhereInput[] | null;
  id?: IntFilter | null;
  reference?: UuidFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  title?: StringFilter | null;
  status?: EnumMatterStatusFilter | null;
  clientId?: IntNullableFilter | null;
  createdById?: IntFilter | null;
  brandId?: IntNullableFilter | null;
  includeTasksInProposalOutput?: BoolNullableFilter | null;
  includeRatesInProposalOutput?: BoolNullableFilter | null;
}

export interface ParentMatterUpdateInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  matters?: MatterUpdateManyWithoutParentNestedInput | null;
  client?: ClientUpdateOneWithoutParentMatterNestedInput | null;
  brand?: BrandUpdateOneWithoutParentMattersNestedInput | null;
  collaborators?: CollaboratorUpdateManyWithoutParentMatterNestedInput | null;
  notifications?: NotificationUpdateManyWithoutParentMatterNestedInput | null;
}

export interface ParentMatterUpdateManyMutationInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
}

export interface ParentMatterUpdateManyWithWhereWithoutBrandInput {
  where: ParentMatterScalarWhereInput;
  data: ParentMatterUpdateManyMutationInput;
}

export interface ParentMatterUpdateManyWithWhereWithoutClientInput {
  where: ParentMatterScalarWhereInput;
  data: ParentMatterUpdateManyMutationInput;
}

export interface ParentMatterUpdateManyWithWhereWithoutCreatedByInput {
  where: ParentMatterScalarWhereInput;
  data: ParentMatterUpdateManyMutationInput;
}

export interface ParentMatterUpdateManyWithoutBrandNestedInput {
  create?: ParentMatterCreateWithoutBrandInput[] | null;
  connectOrCreate?: ParentMatterCreateOrConnectWithoutBrandInput[] | null;
  upsert?: ParentMatterUpsertWithWhereUniqueWithoutBrandInput[] | null;
  createMany?: ParentMatterCreateManyBrandInputEnvelope | null;
  set?: ParentMatterWhereUniqueInput[] | null;
  disconnect?: ParentMatterWhereUniqueInput[] | null;
  delete?: ParentMatterWhereUniqueInput[] | null;
  connect?: ParentMatterWhereUniqueInput[] | null;
  update?: ParentMatterUpdateWithWhereUniqueWithoutBrandInput[] | null;
  updateMany?: ParentMatterUpdateManyWithWhereWithoutBrandInput[] | null;
  deleteMany?: ParentMatterScalarWhereInput[] | null;
}

export interface ParentMatterUpdateManyWithoutClientNestedInput {
  create?: ParentMatterCreateWithoutClientInput[] | null;
  connectOrCreate?: ParentMatterCreateOrConnectWithoutClientInput[] | null;
  upsert?: ParentMatterUpsertWithWhereUniqueWithoutClientInput[] | null;
  createMany?: ParentMatterCreateManyClientInputEnvelope | null;
  set?: ParentMatterWhereUniqueInput[] | null;
  disconnect?: ParentMatterWhereUniqueInput[] | null;
  delete?: ParentMatterWhereUniqueInput[] | null;
  connect?: ParentMatterWhereUniqueInput[] | null;
  update?: ParentMatterUpdateWithWhereUniqueWithoutClientInput[] | null;
  updateMany?: ParentMatterUpdateManyWithWhereWithoutClientInput[] | null;
  deleteMany?: ParentMatterScalarWhereInput[] | null;
}

export interface ParentMatterUpdateManyWithoutCreatedByNestedInput {
  create?: ParentMatterCreateWithoutCreatedByInput[] | null;
  connectOrCreate?: ParentMatterCreateOrConnectWithoutCreatedByInput[] | null;
  upsert?: ParentMatterUpsertWithWhereUniqueWithoutCreatedByInput[] | null;
  createMany?: ParentMatterCreateManyCreatedByInputEnvelope | null;
  set?: ParentMatterWhereUniqueInput[] | null;
  disconnect?: ParentMatterWhereUniqueInput[] | null;
  delete?: ParentMatterWhereUniqueInput[] | null;
  connect?: ParentMatterWhereUniqueInput[] | null;
  update?: ParentMatterUpdateWithWhereUniqueWithoutCreatedByInput[] | null;
  updateMany?: ParentMatterUpdateManyWithWhereWithoutCreatedByInput[] | null;
  deleteMany?: ParentMatterScalarWhereInput[] | null;
}

export interface ParentMatterUpdateOneWithoutCollaboratorsNestedInput {
  create?: ParentMatterCreateWithoutCollaboratorsInput | null;
  connectOrCreate?: ParentMatterCreateOrConnectWithoutCollaboratorsInput | null;
  upsert?: ParentMatterUpsertWithoutCollaboratorsInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: ParentMatterWhereUniqueInput | null;
  update?: ParentMatterUpdateWithoutCollaboratorsInput | null;
}

export interface ParentMatterUpdateOneWithoutMattersNestedInput {
  create?: ParentMatterCreateWithoutMattersInput | null;
  connectOrCreate?: ParentMatterCreateOrConnectWithoutMattersInput | null;
  upsert?: ParentMatterUpsertWithoutMattersInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: ParentMatterWhereUniqueInput | null;
  update?: ParentMatterUpdateWithoutMattersInput | null;
}

export interface ParentMatterUpdateOneWithoutNotificationsNestedInput {
  create?: ParentMatterCreateWithoutNotificationsInput | null;
  connectOrCreate?: ParentMatterCreateOrConnectWithoutNotificationsInput | null;
  upsert?: ParentMatterUpsertWithoutNotificationsInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: ParentMatterWhereUniqueInput | null;
  update?: ParentMatterUpdateWithoutNotificationsInput | null;
}

export interface ParentMatterUpdateWithWhereUniqueWithoutBrandInput {
  where: ParentMatterWhereUniqueInput;
  data: ParentMatterUpdateWithoutBrandInput;
}

export interface ParentMatterUpdateWithWhereUniqueWithoutClientInput {
  where: ParentMatterWhereUniqueInput;
  data: ParentMatterUpdateWithoutClientInput;
}

export interface ParentMatterUpdateWithWhereUniqueWithoutCreatedByInput {
  where: ParentMatterWhereUniqueInput;
  data: ParentMatterUpdateWithoutCreatedByInput;
}

export interface ParentMatterUpdateWithoutBrandInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  matters?: MatterUpdateManyWithoutParentNestedInput | null;
  client?: ClientUpdateOneWithoutParentMatterNestedInput | null;
  collaborators?: CollaboratorUpdateManyWithoutParentMatterNestedInput | null;
  notifications?: NotificationUpdateManyWithoutParentMatterNestedInput | null;
}

export interface ParentMatterUpdateWithoutClientInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  matters?: MatterUpdateManyWithoutParentNestedInput | null;
  brand?: BrandUpdateOneWithoutParentMattersNestedInput | null;
  collaborators?: CollaboratorUpdateManyWithoutParentMatterNestedInput | null;
  notifications?: NotificationUpdateManyWithoutParentMatterNestedInput | null;
}

export interface ParentMatterUpdateWithoutCollaboratorsInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  matters?: MatterUpdateManyWithoutParentNestedInput | null;
  client?: ClientUpdateOneWithoutParentMatterNestedInput | null;
  brand?: BrandUpdateOneWithoutParentMattersNestedInput | null;
  notifications?: NotificationUpdateManyWithoutParentMatterNestedInput | null;
}

export interface ParentMatterUpdateWithoutCreatedByInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  matters?: MatterUpdateManyWithoutParentNestedInput | null;
  client?: ClientUpdateOneWithoutParentMatterNestedInput | null;
  brand?: BrandUpdateOneWithoutParentMattersNestedInput | null;
  collaborators?: CollaboratorUpdateManyWithoutParentMatterNestedInput | null;
  notifications?: NotificationUpdateManyWithoutParentMatterNestedInput | null;
}

export interface ParentMatterUpdateWithoutMattersInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  client?: ClientUpdateOneWithoutParentMatterNestedInput | null;
  brand?: BrandUpdateOneWithoutParentMattersNestedInput | null;
  collaborators?: CollaboratorUpdateManyWithoutParentMatterNestedInput | null;
  notifications?: NotificationUpdateManyWithoutParentMatterNestedInput | null;
}

export interface ParentMatterUpdateWithoutNotificationsInput {
  reference?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  status?: EnumMatterStatusFieldUpdateOperationsInput | null;
  includeTasksInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  includeRatesInProposalOutput?: NullableBoolFieldUpdateOperationsInput | null;
  matters?: MatterUpdateManyWithoutParentNestedInput | null;
  client?: ClientUpdateOneWithoutParentMatterNestedInput | null;
  brand?: BrandUpdateOneWithoutParentMattersNestedInput | null;
  collaborators?: CollaboratorUpdateManyWithoutParentMatterNestedInput | null;
}

export interface ParentMatterUpsertWithWhereUniqueWithoutBrandInput {
  where: ParentMatterWhereUniqueInput;
  update: ParentMatterUpdateWithoutBrandInput;
  create: ParentMatterCreateWithoutBrandInput;
}

export interface ParentMatterUpsertWithWhereUniqueWithoutClientInput {
  where: ParentMatterWhereUniqueInput;
  update: ParentMatterUpdateWithoutClientInput;
  create: ParentMatterCreateWithoutClientInput;
}

export interface ParentMatterUpsertWithWhereUniqueWithoutCreatedByInput {
  where: ParentMatterWhereUniqueInput;
  update: ParentMatterUpdateWithoutCreatedByInput;
  create: ParentMatterCreateWithoutCreatedByInput;
}

export interface ParentMatterUpsertWithoutCollaboratorsInput {
  update: ParentMatterUpdateWithoutCollaboratorsInput;
  create: ParentMatterCreateWithoutCollaboratorsInput;
}

export interface ParentMatterUpsertWithoutMattersInput {
  update: ParentMatterUpdateWithoutMattersInput;
  create: ParentMatterCreateWithoutMattersInput;
}

export interface ParentMatterUpsertWithoutNotificationsInput {
  update: ParentMatterUpdateWithoutNotificationsInput;
  create: ParentMatterCreateWithoutNotificationsInput;
}

export interface ParentMatterWhereInput {
  AND?: ParentMatterWhereInput[] | null;
  OR?: ParentMatterWhereInput[] | null;
  NOT?: ParentMatterWhereInput[] | null;
  id?: IntFilter | null;
  reference?: UuidFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  title?: StringFilter | null;
  status?: EnumMatterStatusFilter | null;
  clientId?: IntNullableFilter | null;
  createdById?: IntFilter | null;
  brandId?: IntNullableFilter | null;
  includeTasksInProposalOutput?: BoolNullableFilter | null;
  includeRatesInProposalOutput?: BoolNullableFilter | null;
  matters?: MatterListRelationFilter | null;
  client?: ClientRelationFilter | null;
  brand?: BrandRelationFilter | null;
  collaborators?: CollaboratorListRelationFilter | null;
  notifications?: NotificationListRelationFilter | null;
}

export interface ParentMatterWhereUniqueInput {
  id?: number | null;
  reference?: string | null;
}

export interface PhaseCreateInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  title: string;
  description?: string | null;
  order: number;
  priceOptions?: PriceOptionsCreateNestedOneWithoutPhaseInput | null;
  matter: MatterCreateNestedOneWithoutPhasesInput;
  tasks?: TaskCreateNestedManyWithoutPhaseInput | null;
  work?: WorkCreateNestedManyWithoutPhaseInput | null;
}

export interface PhaseCreateManyMatterInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  title: string;
  description?: string | null;
  order: number;
  priceOptionsId?: number | null;
}

export interface PhaseCreateManyMatterInputEnvelope {
  data: PhaseCreateManyMatterInput[];
  skipDuplicates?: boolean | null;
}

export interface PhaseCreateNestedManyWithoutMatterInput {
  create?: PhaseCreateWithoutMatterInput[] | null;
  connectOrCreate?: PhaseCreateOrConnectWithoutMatterInput[] | null;
  createMany?: PhaseCreateManyMatterInputEnvelope | null;
  connect?: PhaseWhereUniqueInput[] | null;
}

export interface PhaseCreateNestedOneWithoutPriceOptionsInput {
  create?: PhaseCreateWithoutPriceOptionsInput | null;
  connectOrCreate?: PhaseCreateOrConnectWithoutPriceOptionsInput | null;
  connect?: PhaseWhereUniqueInput | null;
}

export interface PhaseCreateNestedOneWithoutTasksInput {
  create?: PhaseCreateWithoutTasksInput | null;
  connectOrCreate?: PhaseCreateOrConnectWithoutTasksInput | null;
  connect?: PhaseWhereUniqueInput | null;
}

export interface PhaseCreateNestedOneWithoutWorkInput {
  create?: PhaseCreateWithoutWorkInput | null;
  connectOrCreate?: PhaseCreateOrConnectWithoutWorkInput | null;
  connect?: PhaseWhereUniqueInput | null;
}

export interface PhaseCreateOrConnectWithoutMatterInput {
  where: PhaseWhereUniqueInput;
  create: PhaseCreateWithoutMatterInput;
}

export interface PhaseCreateOrConnectWithoutPriceOptionsInput {
  where: PhaseWhereUniqueInput;
  create: PhaseCreateWithoutPriceOptionsInput;
}

export interface PhaseCreateOrConnectWithoutTasksInput {
  where: PhaseWhereUniqueInput;
  create: PhaseCreateWithoutTasksInput;
}

export interface PhaseCreateOrConnectWithoutWorkInput {
  where: PhaseWhereUniqueInput;
  create: PhaseCreateWithoutWorkInput;
}

export interface PhaseCreateWithoutMatterInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  title: string;
  description?: string | null;
  order: number;
  priceOptions?: PriceOptionsCreateNestedOneWithoutPhaseInput | null;
  tasks?: TaskCreateNestedManyWithoutPhaseInput | null;
  work?: WorkCreateNestedManyWithoutPhaseInput | null;
}

export interface PhaseCreateWithoutPriceOptionsInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  title: string;
  description?: string | null;
  order: number;
  matter: MatterCreateNestedOneWithoutPhasesInput;
  tasks?: TaskCreateNestedManyWithoutPhaseInput | null;
  work?: WorkCreateNestedManyWithoutPhaseInput | null;
}

export interface PhaseCreateWithoutTasksInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  title: string;
  description?: string | null;
  order: number;
  priceOptions?: PriceOptionsCreateNestedOneWithoutPhaseInput | null;
  matter: MatterCreateNestedOneWithoutPhasesInput;
  work?: WorkCreateNestedManyWithoutPhaseInput | null;
}

export interface PhaseCreateWithoutWorkInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  title: string;
  description?: string | null;
  order: number;
  priceOptions?: PriceOptionsCreateNestedOneWithoutPhaseInput | null;
  matter: MatterCreateNestedOneWithoutPhasesInput;
  tasks?: TaskCreateNestedManyWithoutPhaseInput | null;
}

export interface PhaseListRelationFilter {
  every?: PhaseWhereInput | null;
  some?: PhaseWhereInput | null;
  none?: PhaseWhereInput | null;
}

export interface PhaseRelationFilter {
  is?: PhaseWhereInput | null;
  isNot?: PhaseWhereInput | null;
}

export interface PhaseScalarWhereInput {
  AND?: PhaseScalarWhereInput[] | null;
  OR?: PhaseScalarWhereInput[] | null;
  NOT?: PhaseScalarWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  title?: StringFilter | null;
  description?: StringFilter | null;
  matterId?: IntFilter | null;
  order?: IntFilter | null;
  priceOptionsId?: IntNullableFilter | null;
}

export interface PhaseUpdateInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  priceOptions?: PriceOptionsUpdateOneWithoutPhaseNestedInput | null;
  matter?: MatterUpdateOneRequiredWithoutPhasesNestedInput | null;
  tasks?: TaskUpdateManyWithoutPhaseNestedInput | null;
  work?: WorkUpdateManyWithoutPhaseNestedInput | null;
}

export interface PhaseUpdateManyMutationInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
}

export interface PhaseUpdateManyWithWhereWithoutMatterInput {
  where: PhaseScalarWhereInput;
  data: PhaseUpdateManyMutationInput;
}

export interface PhaseUpdateManyWithoutMatterNestedInput {
  create?: PhaseCreateWithoutMatterInput[] | null;
  connectOrCreate?: PhaseCreateOrConnectWithoutMatterInput[] | null;
  upsert?: PhaseUpsertWithWhereUniqueWithoutMatterInput[] | null;
  createMany?: PhaseCreateManyMatterInputEnvelope | null;
  set?: PhaseWhereUniqueInput[] | null;
  disconnect?: PhaseWhereUniqueInput[] | null;
  delete?: PhaseWhereUniqueInput[] | null;
  connect?: PhaseWhereUniqueInput[] | null;
  update?: PhaseUpdateWithWhereUniqueWithoutMatterInput[] | null;
  updateMany?: PhaseUpdateManyWithWhereWithoutMatterInput[] | null;
  deleteMany?: PhaseScalarWhereInput[] | null;
}

export interface PhaseUpdateOneRequiredWithoutTasksNestedInput {
  create?: PhaseCreateWithoutTasksInput | null;
  connectOrCreate?: PhaseCreateOrConnectWithoutTasksInput | null;
  upsert?: PhaseUpsertWithoutTasksInput | null;
  connect?: PhaseWhereUniqueInput | null;
  update?: PhaseUpdateWithoutTasksInput | null;
}

export interface PhaseUpdateOneRequiredWithoutWorkNestedInput {
  create?: PhaseCreateWithoutWorkInput | null;
  connectOrCreate?: PhaseCreateOrConnectWithoutWorkInput | null;
  upsert?: PhaseUpsertWithoutWorkInput | null;
  connect?: PhaseWhereUniqueInput | null;
  update?: PhaseUpdateWithoutWorkInput | null;
}

export interface PhaseUpdateOneWithoutPriceOptionsNestedInput {
  create?: PhaseCreateWithoutPriceOptionsInput | null;
  connectOrCreate?: PhaseCreateOrConnectWithoutPriceOptionsInput | null;
  upsert?: PhaseUpsertWithoutPriceOptionsInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: PhaseWhereUniqueInput | null;
  update?: PhaseUpdateWithoutPriceOptionsInput | null;
}

export interface PhaseUpdateWithWhereUniqueWithoutMatterInput {
  where: PhaseWhereUniqueInput;
  data: PhaseUpdateWithoutMatterInput;
}

export interface PhaseUpdateWithoutMatterInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  priceOptions?: PriceOptionsUpdateOneWithoutPhaseNestedInput | null;
  tasks?: TaskUpdateManyWithoutPhaseNestedInput | null;
  work?: WorkUpdateManyWithoutPhaseNestedInput | null;
}

export interface PhaseUpdateWithoutPriceOptionsInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  matter?: MatterUpdateOneRequiredWithoutPhasesNestedInput | null;
  tasks?: TaskUpdateManyWithoutPhaseNestedInput | null;
  work?: WorkUpdateManyWithoutPhaseNestedInput | null;
}

export interface PhaseUpdateWithoutTasksInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  priceOptions?: PriceOptionsUpdateOneWithoutPhaseNestedInput | null;
  matter?: MatterUpdateOneRequiredWithoutPhasesNestedInput | null;
  work?: WorkUpdateManyWithoutPhaseNestedInput | null;
}

export interface PhaseUpdateWithoutWorkInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  title?: StringFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  priceOptions?: PriceOptionsUpdateOneWithoutPhaseNestedInput | null;
  matter?: MatterUpdateOneRequiredWithoutPhasesNestedInput | null;
  tasks?: TaskUpdateManyWithoutPhaseNestedInput | null;
}

export interface PhaseUpsertWithWhereUniqueWithoutMatterInput {
  where: PhaseWhereUniqueInput;
  update: PhaseUpdateWithoutMatterInput;
  create: PhaseCreateWithoutMatterInput;
}

export interface PhaseUpsertWithoutPriceOptionsInput {
  update: PhaseUpdateWithoutPriceOptionsInput;
  create: PhaseCreateWithoutPriceOptionsInput;
}

export interface PhaseUpsertWithoutTasksInput {
  update: PhaseUpdateWithoutTasksInput;
  create: PhaseCreateWithoutTasksInput;
}

export interface PhaseUpsertWithoutWorkInput {
  update: PhaseUpdateWithoutWorkInput;
  create: PhaseCreateWithoutWorkInput;
}

export interface PhaseWhereInput {
  AND?: PhaseWhereInput[] | null;
  OR?: PhaseWhereInput[] | null;
  NOT?: PhaseWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  title?: StringFilter | null;
  description?: StringFilter | null;
  matterId?: IntFilter | null;
  order?: IntFilter | null;
  priceOptionsId?: IntNullableFilter | null;
  priceOptions?: PriceOptionsRelationFilter | null;
  matter?: MatterRelationFilter | null;
  tasks?: TaskListRelationFilter | null;
  work?: WorkListRelationFilter | null;
}

export interface PhaseWhereUniqueInput {
  id?: number | null;
  priceOptionsId?: number | null;
}

export interface PriceOptionsCreateNestedOneWithoutMatterInput {
  create?: PriceOptionsCreateWithoutMatterInput | null;
  connectOrCreate?: PriceOptionsCreateOrConnectWithoutMatterInput | null;
  connect?: PriceOptionsWhereUniqueInput | null;
}

export interface PriceOptionsCreateNestedOneWithoutPhaseInput {
  create?: PriceOptionsCreateWithoutPhaseInput | null;
  connectOrCreate?: PriceOptionsCreateOrConnectWithoutPhaseInput | null;
  connect?: PriceOptionsWhereUniqueInput | null;
}

export interface PriceOptionsCreateOrConnectWithoutMatterInput {
  where: PriceOptionsWhereUniqueInput;
  create: PriceOptionsCreateWithoutMatterInput;
}

export interface PriceOptionsCreateOrConnectWithoutPhaseInput {
  where: PriceOptionsWhereUniqueInput;
  create: PriceOptionsCreateWithoutPhaseInput;
}

export interface PriceOptionsCreateWithoutMatterInput {
  estimatedSuggested?: number | null;
  estimatedChosen?: number | null;
  estimatedGpm?: number | null;
  estimatedRangeGpm?: number | null;
  estimatedRangeSuggestedLower?: number | null;
  estimatedRangeSuggestedUpper?: number | null;
  estimatedRangeChosenLower?: number | null;
  estimatedRangeChosenUpper?: number | null;
  cappedSuggested?: number | null;
  cappedChosen?: number | null;
  cappedGpm?: number | null;
  fixedSuggested?: number | null;
  fixedChosen?: number | null;
  fixedGpm?: number | null;
  phase?: PhaseCreateNestedOneWithoutPriceOptionsInput | null;
}

export interface PriceOptionsCreateWithoutPhaseInput {
  estimatedSuggested?: number | null;
  estimatedChosen?: number | null;
  estimatedGpm?: number | null;
  estimatedRangeGpm?: number | null;
  estimatedRangeSuggestedLower?: number | null;
  estimatedRangeSuggestedUpper?: number | null;
  estimatedRangeChosenLower?: number | null;
  estimatedRangeChosenUpper?: number | null;
  cappedSuggested?: number | null;
  cappedChosen?: number | null;
  cappedGpm?: number | null;
  fixedSuggested?: number | null;
  fixedChosen?: number | null;
  fixedGpm?: number | null;
  matter?: MatterCreateNestedOneWithoutPriceOptionsInput | null;
}

export interface PriceOptionsRelationFilter {
  is?: PriceOptionsWhereInput | null;
  isNot?: PriceOptionsWhereInput | null;
}

export interface PriceOptionsUpdateOneWithoutMatterNestedInput {
  create?: PriceOptionsCreateWithoutMatterInput | null;
  connectOrCreate?: PriceOptionsCreateOrConnectWithoutMatterInput | null;
  upsert?: PriceOptionsUpsertWithoutMatterInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: PriceOptionsWhereUniqueInput | null;
  update?: PriceOptionsUpdateWithoutMatterInput | null;
}

export interface PriceOptionsUpdateOneWithoutPhaseNestedInput {
  create?: PriceOptionsCreateWithoutPhaseInput | null;
  connectOrCreate?: PriceOptionsCreateOrConnectWithoutPhaseInput | null;
  upsert?: PriceOptionsUpsertWithoutPhaseInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: PriceOptionsWhereUniqueInput | null;
  update?: PriceOptionsUpdateWithoutPhaseInput | null;
}

export interface PriceOptionsUpdateWithoutMatterInput {
  estimatedSuggested?: NullableFloatFieldUpdateOperationsInput | null;
  estimatedChosen?: NullableFloatFieldUpdateOperationsInput | null;
  estimatedGpm?: NullableIntFieldUpdateOperationsInput | null;
  estimatedRangeGpm?: NullableIntFieldUpdateOperationsInput | null;
  estimatedRangeSuggestedLower?: NullableFloatFieldUpdateOperationsInput | null;
  estimatedRangeSuggestedUpper?: NullableFloatFieldUpdateOperationsInput | null;
  estimatedRangeChosenLower?: NullableFloatFieldUpdateOperationsInput | null;
  estimatedRangeChosenUpper?: NullableFloatFieldUpdateOperationsInput | null;
  cappedSuggested?: NullableFloatFieldUpdateOperationsInput | null;
  cappedChosen?: NullableFloatFieldUpdateOperationsInput | null;
  cappedGpm?: NullableIntFieldUpdateOperationsInput | null;
  fixedSuggested?: NullableFloatFieldUpdateOperationsInput | null;
  fixedChosen?: NullableFloatFieldUpdateOperationsInput | null;
  fixedGpm?: NullableIntFieldUpdateOperationsInput | null;
  phase?: PhaseUpdateOneWithoutPriceOptionsNestedInput | null;
}

export interface PriceOptionsUpdateWithoutPhaseInput {
  estimatedSuggested?: NullableFloatFieldUpdateOperationsInput | null;
  estimatedChosen?: NullableFloatFieldUpdateOperationsInput | null;
  estimatedGpm?: NullableIntFieldUpdateOperationsInput | null;
  estimatedRangeGpm?: NullableIntFieldUpdateOperationsInput | null;
  estimatedRangeSuggestedLower?: NullableFloatFieldUpdateOperationsInput | null;
  estimatedRangeSuggestedUpper?: NullableFloatFieldUpdateOperationsInput | null;
  estimatedRangeChosenLower?: NullableFloatFieldUpdateOperationsInput | null;
  estimatedRangeChosenUpper?: NullableFloatFieldUpdateOperationsInput | null;
  cappedSuggested?: NullableFloatFieldUpdateOperationsInput | null;
  cappedChosen?: NullableFloatFieldUpdateOperationsInput | null;
  cappedGpm?: NullableIntFieldUpdateOperationsInput | null;
  fixedSuggested?: NullableFloatFieldUpdateOperationsInput | null;
  fixedChosen?: NullableFloatFieldUpdateOperationsInput | null;
  fixedGpm?: NullableIntFieldUpdateOperationsInput | null;
  matter?: MatterUpdateOneWithoutPriceOptionsNestedInput | null;
}

export interface PriceOptionsUpsertWithoutMatterInput {
  update: PriceOptionsUpdateWithoutMatterInput;
  create: PriceOptionsCreateWithoutMatterInput;
}

export interface PriceOptionsUpsertWithoutPhaseInput {
  update: PriceOptionsUpdateWithoutPhaseInput;
  create: PriceOptionsCreateWithoutPhaseInput;
}

export interface PriceOptionsWhereInput {
  AND?: PriceOptionsWhereInput[] | null;
  OR?: PriceOptionsWhereInput[] | null;
  NOT?: PriceOptionsWhereInput[] | null;
  id?: IntFilter | null;
  estimatedSuggested?: FloatNullableFilter | null;
  estimatedChosen?: FloatNullableFilter | null;
  estimatedGpm?: IntNullableFilter | null;
  estimatedRangeGpm?: IntNullableFilter | null;
  estimatedRangeSuggestedLower?: FloatNullableFilter | null;
  estimatedRangeSuggestedUpper?: FloatNullableFilter | null;
  estimatedRangeChosenLower?: FloatNullableFilter | null;
  estimatedRangeChosenUpper?: FloatNullableFilter | null;
  cappedSuggested?: FloatNullableFilter | null;
  cappedChosen?: FloatNullableFilter | null;
  cappedGpm?: IntNullableFilter | null;
  fixedSuggested?: FloatNullableFilter | null;
  fixedChosen?: FloatNullableFilter | null;
  fixedGpm?: IntNullableFilter | null;
  matter?: MatterRelationFilter | null;
  phase?: PhaseRelationFilter | null;
}

export interface PriceOptionsWhereUniqueInput {
  id?: number | null;
}

export interface PriceRangeCreateNestedOneWithoutMattersInput {
  create?: PriceRangeCreateWithoutMattersInput | null;
  connectOrCreate?: PriceRangeCreateOrConnectWithoutMattersInput | null;
  connect?: PriceRangeWhereUniqueInput | null;
}

export interface PriceRangeCreateOrConnectWithoutMattersInput {
  where: PriceRangeWhereUniqueInput;
  create: PriceRangeCreateWithoutMattersInput;
}

export interface PriceRangeCreateWithoutMattersInput {
  lower?: number | null;
  upper?: number | null;
}

export interface PriceRangeRelationFilter {
  is?: PriceRangeWhereInput | null;
  isNot?: PriceRangeWhereInput | null;
}

export interface PriceRangeUpdateOneWithoutMattersNestedInput {
  create?: PriceRangeCreateWithoutMattersInput | null;
  connectOrCreate?: PriceRangeCreateOrConnectWithoutMattersInput | null;
  upsert?: PriceRangeUpsertWithoutMattersInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: PriceRangeWhereUniqueInput | null;
  update?: PriceRangeUpdateWithoutMattersInput | null;
}

export interface PriceRangeUpdateWithoutMattersInput {
  lower?: NullableFloatFieldUpdateOperationsInput | null;
  upper?: NullableFloatFieldUpdateOperationsInput | null;
}

export interface PriceRangeUpsertWithoutMattersInput {
  update: PriceRangeUpdateWithoutMattersInput;
  create: PriceRangeCreateWithoutMattersInput;
}

export interface PriceRangeWhereInput {
  AND?: PriceRangeWhereInput[] | null;
  OR?: PriceRangeWhereInput[] | null;
  NOT?: PriceRangeWhereInput[] | null;
  id?: IntFilter | null;
  lower?: FloatNullableFilter | null;
  upper?: FloatNullableFilter | null;
  matters?: MatterListRelationFilter | null;
}

export interface PriceRangeWhereUniqueInput {
  id?: number | null;
}

export interface RateCreateInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  amount: number;
  description: string;
  deprecated?: boolean | null;
  specificMatterId?: number | null;
  externalMatter?: ExternalMatterCreateNestedOneWithoutRatesInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutRatesInput | null;
  client?: ClientCreateNestedOneWithoutRatesInput | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutRatesInput | null;
  feeEarnerLevel?: FeeEarnerLevelCreateNestedOneWithoutRatesInput | null;
  officeLocation?: OfficeLocationCreateNestedOneWithoutRatesInput | null;
  work?: WorkCreateNestedManyWithoutSelectedRateInput | null;
}

export interface RateCreateManyClientInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  amount: number;
  description: string;
  deprecated?: boolean | null;
  externalMatterId?: number | null;
  feeEarnerId?: number | null;
  feeEarnerLevelId?: number | null;
  organisationalUnitId?: number | null;
  officeLocationId?: number | null;
  specificMatterId?: number | null;
}

export interface RateCreateManyClientInputEnvelope {
  data: RateCreateManyClientInput[];
  skipDuplicates?: boolean | null;
}

export interface RateCreateManyExternalMatterInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  amount: number;
  description: string;
  deprecated?: boolean | null;
  clientId?: number | null;
  feeEarnerId?: number | null;
  feeEarnerLevelId?: number | null;
  organisationalUnitId?: number | null;
  officeLocationId?: number | null;
  specificMatterId?: number | null;
}

export interface RateCreateManyExternalMatterInputEnvelope {
  data: RateCreateManyExternalMatterInput[];
  skipDuplicates?: boolean | null;
}

export interface RateCreateManyFeeEarnerInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  amount: number;
  description: string;
  deprecated?: boolean | null;
  clientId?: number | null;
  externalMatterId?: number | null;
  feeEarnerLevelId?: number | null;
  organisationalUnitId?: number | null;
  officeLocationId?: number | null;
  specificMatterId?: number | null;
}

export interface RateCreateManyFeeEarnerInputEnvelope {
  data: RateCreateManyFeeEarnerInput[];
  skipDuplicates?: boolean | null;
}

export interface RateCreateManyFeeEarnerLevelInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  amount: number;
  description: string;
  deprecated?: boolean | null;
  clientId?: number | null;
  externalMatterId?: number | null;
  feeEarnerId?: number | null;
  organisationalUnitId?: number | null;
  officeLocationId?: number | null;
  specificMatterId?: number | null;
}

export interface RateCreateManyFeeEarnerLevelInputEnvelope {
  data: RateCreateManyFeeEarnerLevelInput[];
  skipDuplicates?: boolean | null;
}

export interface RateCreateManyOfficeLocationInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  amount: number;
  description: string;
  deprecated?: boolean | null;
  clientId?: number | null;
  externalMatterId?: number | null;
  feeEarnerId?: number | null;
  feeEarnerLevelId?: number | null;
  organisationalUnitId?: number | null;
  specificMatterId?: number | null;
}

export interface RateCreateManyOfficeLocationInputEnvelope {
  data: RateCreateManyOfficeLocationInput[];
  skipDuplicates?: boolean | null;
}

export interface RateCreateManyOrganisationalUnitInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  amount: number;
  description: string;
  deprecated?: boolean | null;
  clientId?: number | null;
  externalMatterId?: number | null;
  feeEarnerId?: number | null;
  feeEarnerLevelId?: number | null;
  officeLocationId?: number | null;
  specificMatterId?: number | null;
}

export interface RateCreateManyOrganisationalUnitInputEnvelope {
  data: RateCreateManyOrganisationalUnitInput[];
  skipDuplicates?: boolean | null;
}

export interface RateCreateNestedManyWithoutClientInput {
  create?: RateCreateWithoutClientInput[] | null;
  connectOrCreate?: RateCreateOrConnectWithoutClientInput[] | null;
  createMany?: RateCreateManyClientInputEnvelope | null;
  connect?: RateWhereUniqueInput[] | null;
}

export interface RateCreateNestedManyWithoutExternalMatterInput {
  create?: RateCreateWithoutExternalMatterInput[] | null;
  connectOrCreate?: RateCreateOrConnectWithoutExternalMatterInput[] | null;
  createMany?: RateCreateManyExternalMatterInputEnvelope | null;
  connect?: RateWhereUniqueInput[] | null;
}

export interface RateCreateNestedManyWithoutFeeEarnerInput {
  create?: RateCreateWithoutFeeEarnerInput[] | null;
  connectOrCreate?: RateCreateOrConnectWithoutFeeEarnerInput[] | null;
  createMany?: RateCreateManyFeeEarnerInputEnvelope | null;
  connect?: RateWhereUniqueInput[] | null;
}

export interface RateCreateNestedManyWithoutFeeEarnerLevelInput {
  create?: RateCreateWithoutFeeEarnerLevelInput[] | null;
  connectOrCreate?: RateCreateOrConnectWithoutFeeEarnerLevelInput[] | null;
  createMany?: RateCreateManyFeeEarnerLevelInputEnvelope | null;
  connect?: RateWhereUniqueInput[] | null;
}

export interface RateCreateNestedManyWithoutOfficeLocationInput {
  create?: RateCreateWithoutOfficeLocationInput[] | null;
  connectOrCreate?: RateCreateOrConnectWithoutOfficeLocationInput[] | null;
  createMany?: RateCreateManyOfficeLocationInputEnvelope | null;
  connect?: RateWhereUniqueInput[] | null;
}

export interface RateCreateNestedManyWithoutOrganisationalUnitInput {
  create?: RateCreateWithoutOrganisationalUnitInput[] | null;
  connectOrCreate?: RateCreateOrConnectWithoutOrganisationalUnitInput[] | null;
  createMany?: RateCreateManyOrganisationalUnitInputEnvelope | null;
  connect?: RateWhereUniqueInput[] | null;
}

export interface RateCreateNestedOneWithoutWorkInput {
  create?: RateCreateWithoutWorkInput | null;
  connectOrCreate?: RateCreateOrConnectWithoutWorkInput | null;
  connect?: RateWhereUniqueInput | null;
}

export interface RateCreateOrConnectWithoutClientInput {
  where: RateWhereUniqueInput;
  create: RateCreateWithoutClientInput;
}

export interface RateCreateOrConnectWithoutExternalMatterInput {
  where: RateWhereUniqueInput;
  create: RateCreateWithoutExternalMatterInput;
}

export interface RateCreateOrConnectWithoutFeeEarnerInput {
  where: RateWhereUniqueInput;
  create: RateCreateWithoutFeeEarnerInput;
}

export interface RateCreateOrConnectWithoutFeeEarnerLevelInput {
  where: RateWhereUniqueInput;
  create: RateCreateWithoutFeeEarnerLevelInput;
}

export interface RateCreateOrConnectWithoutOfficeLocationInput {
  where: RateWhereUniqueInput;
  create: RateCreateWithoutOfficeLocationInput;
}

export interface RateCreateOrConnectWithoutOrganisationalUnitInput {
  where: RateWhereUniqueInput;
  create: RateCreateWithoutOrganisationalUnitInput;
}

export interface RateCreateOrConnectWithoutWorkInput {
  where: RateWhereUniqueInput;
  create: RateCreateWithoutWorkInput;
}

export interface RateCreateWithoutClientInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  amount: number;
  description: string;
  deprecated?: boolean | null;
  specificMatterId?: number | null;
  externalMatter?: ExternalMatterCreateNestedOneWithoutRatesInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutRatesInput | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutRatesInput | null;
  feeEarnerLevel?: FeeEarnerLevelCreateNestedOneWithoutRatesInput | null;
  officeLocation?: OfficeLocationCreateNestedOneWithoutRatesInput | null;
  work?: WorkCreateNestedManyWithoutSelectedRateInput | null;
}

export interface RateCreateWithoutExternalMatterInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  amount: number;
  description: string;
  deprecated?: boolean | null;
  specificMatterId?: number | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutRatesInput | null;
  client?: ClientCreateNestedOneWithoutRatesInput | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutRatesInput | null;
  feeEarnerLevel?: FeeEarnerLevelCreateNestedOneWithoutRatesInput | null;
  officeLocation?: OfficeLocationCreateNestedOneWithoutRatesInput | null;
  work?: WorkCreateNestedManyWithoutSelectedRateInput | null;
}

export interface RateCreateWithoutFeeEarnerInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  amount: number;
  description: string;
  deprecated?: boolean | null;
  specificMatterId?: number | null;
  externalMatter?: ExternalMatterCreateNestedOneWithoutRatesInput | null;
  client?: ClientCreateNestedOneWithoutRatesInput | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutRatesInput | null;
  feeEarnerLevel?: FeeEarnerLevelCreateNestedOneWithoutRatesInput | null;
  officeLocation?: OfficeLocationCreateNestedOneWithoutRatesInput | null;
  work?: WorkCreateNestedManyWithoutSelectedRateInput | null;
}

export interface RateCreateWithoutFeeEarnerLevelInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  amount: number;
  description: string;
  deprecated?: boolean | null;
  specificMatterId?: number | null;
  externalMatter?: ExternalMatterCreateNestedOneWithoutRatesInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutRatesInput | null;
  client?: ClientCreateNestedOneWithoutRatesInput | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutRatesInput | null;
  officeLocation?: OfficeLocationCreateNestedOneWithoutRatesInput | null;
  work?: WorkCreateNestedManyWithoutSelectedRateInput | null;
}

export interface RateCreateWithoutOfficeLocationInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  amount: number;
  description: string;
  deprecated?: boolean | null;
  specificMatterId?: number | null;
  externalMatter?: ExternalMatterCreateNestedOneWithoutRatesInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutRatesInput | null;
  client?: ClientCreateNestedOneWithoutRatesInput | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutRatesInput | null;
  feeEarnerLevel?: FeeEarnerLevelCreateNestedOneWithoutRatesInput | null;
  work?: WorkCreateNestedManyWithoutSelectedRateInput | null;
}

export interface RateCreateWithoutOrganisationalUnitInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  amount: number;
  description: string;
  deprecated?: boolean | null;
  specificMatterId?: number | null;
  externalMatter?: ExternalMatterCreateNestedOneWithoutRatesInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutRatesInput | null;
  client?: ClientCreateNestedOneWithoutRatesInput | null;
  feeEarnerLevel?: FeeEarnerLevelCreateNestedOneWithoutRatesInput | null;
  officeLocation?: OfficeLocationCreateNestedOneWithoutRatesInput | null;
  work?: WorkCreateNestedManyWithoutSelectedRateInput | null;
}

export interface RateCreateWithoutWorkInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  amount: number;
  description: string;
  deprecated?: boolean | null;
  specificMatterId?: number | null;
  externalMatter?: ExternalMatterCreateNestedOneWithoutRatesInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutRatesInput | null;
  client?: ClientCreateNestedOneWithoutRatesInput | null;
  organisationalUnit?: OrganisationalUnitCreateNestedOneWithoutRatesInput | null;
  feeEarnerLevel?: FeeEarnerLevelCreateNestedOneWithoutRatesInput | null;
  officeLocation?: OfficeLocationCreateNestedOneWithoutRatesInput | null;
}

export interface RateFilter {
  externalMatterId?: number | null;
  clientId?: number | null;
  feeEarnerId?: number | null;
  feeEarnerLevelId?: number | null;
  officeLocationId?: number | null;
  organisationalUnitId?: number | null;
}

export interface RateListRelationFilter {
  every?: RateWhereInput | null;
  some?: RateWhereInput | null;
  none?: RateWhereInput | null;
}

export interface RateRelationFilter {
  is?: RateWhereInput | null;
  isNot?: RateWhereInput | null;
}

export interface RateScalarWhereInput {
  AND?: RateScalarWhereInput[] | null;
  OR?: RateScalarWhereInput[] | null;
  NOT?: RateScalarWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  externalId?: StringNullableFilter | null;
  externalReference?: StringNullableFilter | null;
  externalCreatedAt?: DateTimeNullableFilter | null;
  externalUpdatedAt?: DateTimeNullableFilter | null;
  externalDeletedAt?: DateTimeNullableFilter | null;
  amount?: FloatFilter | null;
  description?: StringFilter | null;
  deprecated?: BoolFilter | null;
  clientId?: IntNullableFilter | null;
  externalMatterId?: IntNullableFilter | null;
  feeEarnerId?: IntNullableFilter | null;
  feeEarnerLevelId?: IntNullableFilter | null;
  organisationalUnitId?: IntNullableFilter | null;
  officeLocationId?: IntNullableFilter | null;
  specificMatterId?: IntNullableFilter | null;
}

export interface RateUpdateManyMutationInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  amount?: FloatFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  deprecated?: BoolFieldUpdateOperationsInput | null;
  specificMatterId?: NullableIntFieldUpdateOperationsInput | null;
}

export interface RateUpdateManyWithWhereWithoutClientInput {
  where: RateScalarWhereInput;
  data: RateUpdateManyMutationInput;
}

export interface RateUpdateManyWithWhereWithoutExternalMatterInput {
  where: RateScalarWhereInput;
  data: RateUpdateManyMutationInput;
}

export interface RateUpdateManyWithWhereWithoutFeeEarnerInput {
  where: RateScalarWhereInput;
  data: RateUpdateManyMutationInput;
}

export interface RateUpdateManyWithWhereWithoutFeeEarnerLevelInput {
  where: RateScalarWhereInput;
  data: RateUpdateManyMutationInput;
}

export interface RateUpdateManyWithWhereWithoutOfficeLocationInput {
  where: RateScalarWhereInput;
  data: RateUpdateManyMutationInput;
}

export interface RateUpdateManyWithWhereWithoutOrganisationalUnitInput {
  where: RateScalarWhereInput;
  data: RateUpdateManyMutationInput;
}

export interface RateUpdateManyWithoutClientNestedInput {
  create?: RateCreateWithoutClientInput[] | null;
  connectOrCreate?: RateCreateOrConnectWithoutClientInput[] | null;
  upsert?: RateUpsertWithWhereUniqueWithoutClientInput[] | null;
  createMany?: RateCreateManyClientInputEnvelope | null;
  set?: RateWhereUniqueInput[] | null;
  disconnect?: RateWhereUniqueInput[] | null;
  delete?: RateWhereUniqueInput[] | null;
  connect?: RateWhereUniqueInput[] | null;
  update?: RateUpdateWithWhereUniqueWithoutClientInput[] | null;
  updateMany?: RateUpdateManyWithWhereWithoutClientInput[] | null;
  deleteMany?: RateScalarWhereInput[] | null;
}

export interface RateUpdateManyWithoutExternalMatterNestedInput {
  create?: RateCreateWithoutExternalMatterInput[] | null;
  connectOrCreate?: RateCreateOrConnectWithoutExternalMatterInput[] | null;
  upsert?: RateUpsertWithWhereUniqueWithoutExternalMatterInput[] | null;
  createMany?: RateCreateManyExternalMatterInputEnvelope | null;
  set?: RateWhereUniqueInput[] | null;
  disconnect?: RateWhereUniqueInput[] | null;
  delete?: RateWhereUniqueInput[] | null;
  connect?: RateWhereUniqueInput[] | null;
  update?: RateUpdateWithWhereUniqueWithoutExternalMatterInput[] | null;
  updateMany?: RateUpdateManyWithWhereWithoutExternalMatterInput[] | null;
  deleteMany?: RateScalarWhereInput[] | null;
}

export interface RateUpdateManyWithoutFeeEarnerLevelNestedInput {
  create?: RateCreateWithoutFeeEarnerLevelInput[] | null;
  connectOrCreate?: RateCreateOrConnectWithoutFeeEarnerLevelInput[] | null;
  upsert?: RateUpsertWithWhereUniqueWithoutFeeEarnerLevelInput[] | null;
  createMany?: RateCreateManyFeeEarnerLevelInputEnvelope | null;
  set?: RateWhereUniqueInput[] | null;
  disconnect?: RateWhereUniqueInput[] | null;
  delete?: RateWhereUniqueInput[] | null;
  connect?: RateWhereUniqueInput[] | null;
  update?: RateUpdateWithWhereUniqueWithoutFeeEarnerLevelInput[] | null;
  updateMany?: RateUpdateManyWithWhereWithoutFeeEarnerLevelInput[] | null;
  deleteMany?: RateScalarWhereInput[] | null;
}

export interface RateUpdateManyWithoutFeeEarnerNestedInput {
  create?: RateCreateWithoutFeeEarnerInput[] | null;
  connectOrCreate?: RateCreateOrConnectWithoutFeeEarnerInput[] | null;
  upsert?: RateUpsertWithWhereUniqueWithoutFeeEarnerInput[] | null;
  createMany?: RateCreateManyFeeEarnerInputEnvelope | null;
  set?: RateWhereUniqueInput[] | null;
  disconnect?: RateWhereUniqueInput[] | null;
  delete?: RateWhereUniqueInput[] | null;
  connect?: RateWhereUniqueInput[] | null;
  update?: RateUpdateWithWhereUniqueWithoutFeeEarnerInput[] | null;
  updateMany?: RateUpdateManyWithWhereWithoutFeeEarnerInput[] | null;
  deleteMany?: RateScalarWhereInput[] | null;
}

export interface RateUpdateManyWithoutOfficeLocationNestedInput {
  create?: RateCreateWithoutOfficeLocationInput[] | null;
  connectOrCreate?: RateCreateOrConnectWithoutOfficeLocationInput[] | null;
  upsert?: RateUpsertWithWhereUniqueWithoutOfficeLocationInput[] | null;
  createMany?: RateCreateManyOfficeLocationInputEnvelope | null;
  set?: RateWhereUniqueInput[] | null;
  disconnect?: RateWhereUniqueInput[] | null;
  delete?: RateWhereUniqueInput[] | null;
  connect?: RateWhereUniqueInput[] | null;
  update?: RateUpdateWithWhereUniqueWithoutOfficeLocationInput[] | null;
  updateMany?: RateUpdateManyWithWhereWithoutOfficeLocationInput[] | null;
  deleteMany?: RateScalarWhereInput[] | null;
}

export interface RateUpdateManyWithoutOrganisationalUnitNestedInput {
  create?: RateCreateWithoutOrganisationalUnitInput[] | null;
  connectOrCreate?: RateCreateOrConnectWithoutOrganisationalUnitInput[] | null;
  upsert?: RateUpsertWithWhereUniqueWithoutOrganisationalUnitInput[] | null;
  createMany?: RateCreateManyOrganisationalUnitInputEnvelope | null;
  set?: RateWhereUniqueInput[] | null;
  disconnect?: RateWhereUniqueInput[] | null;
  delete?: RateWhereUniqueInput[] | null;
  connect?: RateWhereUniqueInput[] | null;
  update?: RateUpdateWithWhereUniqueWithoutOrganisationalUnitInput[] | null;
  updateMany?: RateUpdateManyWithWhereWithoutOrganisationalUnitInput[] | null;
  deleteMany?: RateScalarWhereInput[] | null;
}

export interface RateUpdateOneWithoutWorkNestedInput {
  create?: RateCreateWithoutWorkInput | null;
  connectOrCreate?: RateCreateOrConnectWithoutWorkInput | null;
  upsert?: RateUpsertWithoutWorkInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: RateWhereUniqueInput | null;
  update?: RateUpdateWithoutWorkInput | null;
}

export interface RateUpdateWithWhereUniqueWithoutClientInput {
  where: RateWhereUniqueInput;
  data: RateUpdateWithoutClientInput;
}

export interface RateUpdateWithWhereUniqueWithoutExternalMatterInput {
  where: RateWhereUniqueInput;
  data: RateUpdateWithoutExternalMatterInput;
}

export interface RateUpdateWithWhereUniqueWithoutFeeEarnerInput {
  where: RateWhereUniqueInput;
  data: RateUpdateWithoutFeeEarnerInput;
}

export interface RateUpdateWithWhereUniqueWithoutFeeEarnerLevelInput {
  where: RateWhereUniqueInput;
  data: RateUpdateWithoutFeeEarnerLevelInput;
}

export interface RateUpdateWithWhereUniqueWithoutOfficeLocationInput {
  where: RateWhereUniqueInput;
  data: RateUpdateWithoutOfficeLocationInput;
}

export interface RateUpdateWithWhereUniqueWithoutOrganisationalUnitInput {
  where: RateWhereUniqueInput;
  data: RateUpdateWithoutOrganisationalUnitInput;
}

export interface RateUpdateWithoutClientInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  amount?: FloatFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  deprecated?: BoolFieldUpdateOperationsInput | null;
  specificMatterId?: NullableIntFieldUpdateOperationsInput | null;
  externalMatter?: ExternalMatterUpdateOneWithoutRatesNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutRatesNestedInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutRatesNestedInput | null;
  feeEarnerLevel?: FeeEarnerLevelUpdateOneWithoutRatesNestedInput | null;
  officeLocation?: OfficeLocationUpdateOneWithoutRatesNestedInput | null;
  work?: WorkUpdateManyWithoutSelectedRateNestedInput | null;
}

export interface RateUpdateWithoutExternalMatterInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  amount?: FloatFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  deprecated?: BoolFieldUpdateOperationsInput | null;
  specificMatterId?: NullableIntFieldUpdateOperationsInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutRatesNestedInput | null;
  client?: ClientUpdateOneWithoutRatesNestedInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutRatesNestedInput | null;
  feeEarnerLevel?: FeeEarnerLevelUpdateOneWithoutRatesNestedInput | null;
  officeLocation?: OfficeLocationUpdateOneWithoutRatesNestedInput | null;
  work?: WorkUpdateManyWithoutSelectedRateNestedInput | null;
}

export interface RateUpdateWithoutFeeEarnerInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  amount?: FloatFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  deprecated?: BoolFieldUpdateOperationsInput | null;
  specificMatterId?: NullableIntFieldUpdateOperationsInput | null;
  externalMatter?: ExternalMatterUpdateOneWithoutRatesNestedInput | null;
  client?: ClientUpdateOneWithoutRatesNestedInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutRatesNestedInput | null;
  feeEarnerLevel?: FeeEarnerLevelUpdateOneWithoutRatesNestedInput | null;
  officeLocation?: OfficeLocationUpdateOneWithoutRatesNestedInput | null;
  work?: WorkUpdateManyWithoutSelectedRateNestedInput | null;
}

export interface RateUpdateWithoutFeeEarnerLevelInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  amount?: FloatFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  deprecated?: BoolFieldUpdateOperationsInput | null;
  specificMatterId?: NullableIntFieldUpdateOperationsInput | null;
  externalMatter?: ExternalMatterUpdateOneWithoutRatesNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutRatesNestedInput | null;
  client?: ClientUpdateOneWithoutRatesNestedInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutRatesNestedInput | null;
  officeLocation?: OfficeLocationUpdateOneWithoutRatesNestedInput | null;
  work?: WorkUpdateManyWithoutSelectedRateNestedInput | null;
}

export interface RateUpdateWithoutOfficeLocationInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  amount?: FloatFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  deprecated?: BoolFieldUpdateOperationsInput | null;
  specificMatterId?: NullableIntFieldUpdateOperationsInput | null;
  externalMatter?: ExternalMatterUpdateOneWithoutRatesNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutRatesNestedInput | null;
  client?: ClientUpdateOneWithoutRatesNestedInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutRatesNestedInput | null;
  feeEarnerLevel?: FeeEarnerLevelUpdateOneWithoutRatesNestedInput | null;
  work?: WorkUpdateManyWithoutSelectedRateNestedInput | null;
}

export interface RateUpdateWithoutOrganisationalUnitInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  amount?: FloatFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  deprecated?: BoolFieldUpdateOperationsInput | null;
  specificMatterId?: NullableIntFieldUpdateOperationsInput | null;
  externalMatter?: ExternalMatterUpdateOneWithoutRatesNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutRatesNestedInput | null;
  client?: ClientUpdateOneWithoutRatesNestedInput | null;
  feeEarnerLevel?: FeeEarnerLevelUpdateOneWithoutRatesNestedInput | null;
  officeLocation?: OfficeLocationUpdateOneWithoutRatesNestedInput | null;
  work?: WorkUpdateManyWithoutSelectedRateNestedInput | null;
}

export interface RateUpdateWithoutWorkInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  amount?: FloatFieldUpdateOperationsInput | null;
  description?: StringFieldUpdateOperationsInput | null;
  deprecated?: BoolFieldUpdateOperationsInput | null;
  specificMatterId?: NullableIntFieldUpdateOperationsInput | null;
  externalMatter?: ExternalMatterUpdateOneWithoutRatesNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutRatesNestedInput | null;
  client?: ClientUpdateOneWithoutRatesNestedInput | null;
  organisationalUnit?: OrganisationalUnitUpdateOneWithoutRatesNestedInput | null;
  feeEarnerLevel?: FeeEarnerLevelUpdateOneWithoutRatesNestedInput | null;
  officeLocation?: OfficeLocationUpdateOneWithoutRatesNestedInput | null;
}

export interface RateUpsertWithWhereUniqueWithoutClientInput {
  where: RateWhereUniqueInput;
  update: RateUpdateWithoutClientInput;
  create: RateCreateWithoutClientInput;
}

export interface RateUpsertWithWhereUniqueWithoutExternalMatterInput {
  where: RateWhereUniqueInput;
  update: RateUpdateWithoutExternalMatterInput;
  create: RateCreateWithoutExternalMatterInput;
}

export interface RateUpsertWithWhereUniqueWithoutFeeEarnerInput {
  where: RateWhereUniqueInput;
  update: RateUpdateWithoutFeeEarnerInput;
  create: RateCreateWithoutFeeEarnerInput;
}

export interface RateUpsertWithWhereUniqueWithoutFeeEarnerLevelInput {
  where: RateWhereUniqueInput;
  update: RateUpdateWithoutFeeEarnerLevelInput;
  create: RateCreateWithoutFeeEarnerLevelInput;
}

export interface RateUpsertWithWhereUniqueWithoutOfficeLocationInput {
  where: RateWhereUniqueInput;
  update: RateUpdateWithoutOfficeLocationInput;
  create: RateCreateWithoutOfficeLocationInput;
}

export interface RateUpsertWithWhereUniqueWithoutOrganisationalUnitInput {
  where: RateWhereUniqueInput;
  update: RateUpdateWithoutOrganisationalUnitInput;
  create: RateCreateWithoutOrganisationalUnitInput;
}

export interface RateUpsertWithoutWorkInput {
  update: RateUpdateWithoutWorkInput;
  create: RateCreateWithoutWorkInput;
}

export interface RateWhereInput {
  AND?: RateWhereInput[] | null;
  OR?: RateWhereInput[] | null;
  NOT?: RateWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  externalId?: StringNullableFilter | null;
  externalReference?: StringNullableFilter | null;
  externalCreatedAt?: DateTimeNullableFilter | null;
  externalUpdatedAt?: DateTimeNullableFilter | null;
  externalDeletedAt?: DateTimeNullableFilter | null;
  amount?: FloatFilter | null;
  description?: StringFilter | null;
  deprecated?: BoolFilter | null;
  clientId?: IntNullableFilter | null;
  externalMatterId?: IntNullableFilter | null;
  feeEarnerId?: IntNullableFilter | null;
  feeEarnerLevelId?: IntNullableFilter | null;
  organisationalUnitId?: IntNullableFilter | null;
  officeLocationId?: IntNullableFilter | null;
  specificMatterId?: IntNullableFilter | null;
  externalMatter?: ExternalMatterRelationFilter | null;
  feeEarner?: FeeEarnerRelationFilter | null;
  client?: ClientRelationFilter | null;
  organisationalUnit?: OrganisationalUnitRelationFilter | null;
  feeEarnerLevel?: FeeEarnerLevelRelationFilter | null;
  officeLocation?: OfficeLocationRelationFilter | null;
  work?: WorkListRelationFilter | null;
}

export interface RateWhereUniqueInput {
  id?: number | null;
  externalId?: string | null;
}

export interface SettingsUpdateInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  gpmDangerThreshold?: IntFieldUpdateOperationsInput | null;
  organisationPmsName?: NullableStringFieldUpdateOperationsInput | null;
  taxLabel?: EnumTaxLabelFieldUpdateOperationsInput | null;
  taxLevelPercent?: IntFieldUpdateOperationsInput | null;
  currency?: EnumCurrencyFieldUpdateOperationsInput | null;
  seedDataSetsLoaded?: NullableBoolFieldUpdateOperationsInput | null;
}

export interface StringFieldUpdateOperationsInput {
  set?: string | null;
}

export interface StringFilter {
  equals?: string | null;
  in?: string[] | null;
  notIn?: string[] | null;
  lt?: string | null;
  lte?: string | null;
  gt?: string | null;
  gte?: string | null;
  contains?: string | null;
  startsWith?: string | null;
  endsWith?: string | null;
  mode?: QueryMode | null;
  not?: NestedStringFilter | null;
}

export interface StringNullableFilter {
  equals?: string | null;
  in?: string[] | null;
  notIn?: string[] | null;
  lt?: string | null;
  lte?: string | null;
  gt?: string | null;
  gte?: string | null;
  contains?: string | null;
  startsWith?: string | null;
  endsWith?: string | null;
  mode?: QueryMode | null;
  not?: NestedStringNullableFilter | null;
}

export interface TaskCreateInput {
  title: string;
  createdAt?: any | null;
  updatedAt?: any | null;
  order: number;
  phase: PhaseCreateNestedOneWithoutTasksInput;
}

export interface TaskCreateManyPhaseInput {
  id?: number | null;
  title: string;
  createdAt?: any | null;
  updatedAt?: any | null;
  order: number;
}

export interface TaskCreateManyPhaseInputEnvelope {
  data: TaskCreateManyPhaseInput[];
  skipDuplicates?: boolean | null;
}

export interface TaskCreateNestedManyWithoutPhaseInput {
  create?: TaskCreateWithoutPhaseInput[] | null;
  connectOrCreate?: TaskCreateOrConnectWithoutPhaseInput[] | null;
  createMany?: TaskCreateManyPhaseInputEnvelope | null;
  connect?: TaskWhereUniqueInput[] | null;
}

export interface TaskCreateOrConnectWithoutPhaseInput {
  where: TaskWhereUniqueInput;
  create: TaskCreateWithoutPhaseInput;
}

export interface TaskCreateWithoutPhaseInput {
  title: string;
  createdAt?: any | null;
  updatedAt?: any | null;
  order: number;
}

export interface TaskListRelationFilter {
  every?: TaskWhereInput | null;
  some?: TaskWhereInput | null;
  none?: TaskWhereInput | null;
}

export interface TaskScalarWhereInput {
  AND?: TaskScalarWhereInput[] | null;
  OR?: TaskScalarWhereInput[] | null;
  NOT?: TaskScalarWhereInput[] | null;
  id?: IntFilter | null;
  title?: StringFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  phaseId?: IntFilter | null;
  order?: IntFilter | null;
}

export interface TaskUpdateInput {
  title?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  phase?: PhaseUpdateOneRequiredWithoutTasksNestedInput | null;
}

export interface TaskUpdateManyMutationInput {
  title?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
}

export interface TaskUpdateManyWithWhereWithoutPhaseInput {
  where: TaskScalarWhereInput;
  data: TaskUpdateManyMutationInput;
}

export interface TaskUpdateManyWithoutPhaseNestedInput {
  create?: TaskCreateWithoutPhaseInput[] | null;
  connectOrCreate?: TaskCreateOrConnectWithoutPhaseInput[] | null;
  upsert?: TaskUpsertWithWhereUniqueWithoutPhaseInput[] | null;
  createMany?: TaskCreateManyPhaseInputEnvelope | null;
  set?: TaskWhereUniqueInput[] | null;
  disconnect?: TaskWhereUniqueInput[] | null;
  delete?: TaskWhereUniqueInput[] | null;
  connect?: TaskWhereUniqueInput[] | null;
  update?: TaskUpdateWithWhereUniqueWithoutPhaseInput[] | null;
  updateMany?: TaskUpdateManyWithWhereWithoutPhaseInput[] | null;
  deleteMany?: TaskScalarWhereInput[] | null;
}

export interface TaskUpdateWithWhereUniqueWithoutPhaseInput {
  where: TaskWhereUniqueInput;
  data: TaskUpdateWithoutPhaseInput;
}

export interface TaskUpdateWithoutPhaseInput {
  title?: StringFieldUpdateOperationsInput | null;
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
}

export interface TaskUpsertWithWhereUniqueWithoutPhaseInput {
  where: TaskWhereUniqueInput;
  update: TaskUpdateWithoutPhaseInput;
  create: TaskCreateWithoutPhaseInput;
}

export interface TaskWhereInput {
  AND?: TaskWhereInput[] | null;
  OR?: TaskWhereInput[] | null;
  NOT?: TaskWhereInput[] | null;
  id?: IntFilter | null;
  title?: StringFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  phaseId?: IntFilter | null;
  order?: IntFilter | null;
  phase?: PhaseRelationFilter | null;
}

export interface TaskWhereUniqueInput {
  id?: number | null;
}

export interface TimeEntryCreateManyExternalMatterInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  hourlyChargeRate: number;
  durationInMinutes: number;
  charge: number;
  cost: number;
  feeEarnerId: number;
}

export interface TimeEntryCreateManyExternalMatterInputEnvelope {
  data: TimeEntryCreateManyExternalMatterInput[];
  skipDuplicates?: boolean | null;
}

export interface TimeEntryCreateManyFeeEarnerInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  hourlyChargeRate: number;
  durationInMinutes: number;
  charge: number;
  cost: number;
  externalMatterId: number;
}

export interface TimeEntryCreateManyFeeEarnerInputEnvelope {
  data: TimeEntryCreateManyFeeEarnerInput[];
  skipDuplicates?: boolean | null;
}

export interface TimeEntryCreateNestedManyWithoutExternalMatterInput {
  create?: TimeEntryCreateWithoutExternalMatterInput[] | null;
  connectOrCreate?: TimeEntryCreateOrConnectWithoutExternalMatterInput[] | null;
  createMany?: TimeEntryCreateManyExternalMatterInputEnvelope | null;
  connect?: TimeEntryWhereUniqueInput[] | null;
}

export interface TimeEntryCreateNestedManyWithoutFeeEarnerInput {
  create?: TimeEntryCreateWithoutFeeEarnerInput[] | null;
  connectOrCreate?: TimeEntryCreateOrConnectWithoutFeeEarnerInput[] | null;
  createMany?: TimeEntryCreateManyFeeEarnerInputEnvelope | null;
  connect?: TimeEntryWhereUniqueInput[] | null;
}

export interface TimeEntryCreateOrConnectWithoutExternalMatterInput {
  where: TimeEntryWhereUniqueInput;
  create: TimeEntryCreateWithoutExternalMatterInput;
}

export interface TimeEntryCreateOrConnectWithoutFeeEarnerInput {
  where: TimeEntryWhereUniqueInput;
  create: TimeEntryCreateWithoutFeeEarnerInput;
}

export interface TimeEntryCreateWithoutExternalMatterInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  hourlyChargeRate: number;
  durationInMinutes: number;
  charge: number;
  cost: number;
  feeEarner: FeeEarnerCreateNestedOneWithoutTimeEntriesInput;
}

export interface TimeEntryCreateWithoutFeeEarnerInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  hourlyChargeRate: number;
  durationInMinutes: number;
  charge: number;
  cost: number;
  externalMatter: ExternalMatterCreateNestedOneWithoutTimeEntriesInput;
}

export interface TimeEntryListRelationFilter {
  every?: TimeEntryWhereInput | null;
  some?: TimeEntryWhereInput | null;
  none?: TimeEntryWhereInput | null;
}

export interface TimeEntryScalarWhereInput {
  AND?: TimeEntryScalarWhereInput[] | null;
  OR?: TimeEntryScalarWhereInput[] | null;
  NOT?: TimeEntryScalarWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  externalId?: StringNullableFilter | null;
  externalReference?: StringNullableFilter | null;
  externalCreatedAt?: DateTimeNullableFilter | null;
  externalUpdatedAt?: DateTimeNullableFilter | null;
  externalDeletedAt?: DateTimeNullableFilter | null;
  hourlyChargeRate?: FloatFilter | null;
  durationInMinutes?: IntFilter | null;
  charge?: FloatFilter | null;
  cost?: FloatFilter | null;
  externalMatterId?: IntFilter | null;
  feeEarnerId?: IntFilter | null;
}

export interface TimeEntryUpdateManyMutationInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  hourlyChargeRate?: FloatFieldUpdateOperationsInput | null;
  durationInMinutes?: IntFieldUpdateOperationsInput | null;
  charge?: FloatFieldUpdateOperationsInput | null;
  cost?: FloatFieldUpdateOperationsInput | null;
}

export interface TimeEntryUpdateManyWithWhereWithoutExternalMatterInput {
  where: TimeEntryScalarWhereInput;
  data: TimeEntryUpdateManyMutationInput;
}

export interface TimeEntryUpdateManyWithWhereWithoutFeeEarnerInput {
  where: TimeEntryScalarWhereInput;
  data: TimeEntryUpdateManyMutationInput;
}

export interface TimeEntryUpdateManyWithoutExternalMatterNestedInput {
  create?: TimeEntryCreateWithoutExternalMatterInput[] | null;
  connectOrCreate?: TimeEntryCreateOrConnectWithoutExternalMatterInput[] | null;
  upsert?: TimeEntryUpsertWithWhereUniqueWithoutExternalMatterInput[] | null;
  createMany?: TimeEntryCreateManyExternalMatterInputEnvelope | null;
  set?: TimeEntryWhereUniqueInput[] | null;
  disconnect?: TimeEntryWhereUniqueInput[] | null;
  delete?: TimeEntryWhereUniqueInput[] | null;
  connect?: TimeEntryWhereUniqueInput[] | null;
  update?: TimeEntryUpdateWithWhereUniqueWithoutExternalMatterInput[] | null;
  updateMany?: TimeEntryUpdateManyWithWhereWithoutExternalMatterInput[] | null;
  deleteMany?: TimeEntryScalarWhereInput[] | null;
}

export interface TimeEntryUpdateManyWithoutFeeEarnerNestedInput {
  create?: TimeEntryCreateWithoutFeeEarnerInput[] | null;
  connectOrCreate?: TimeEntryCreateOrConnectWithoutFeeEarnerInput[] | null;
  upsert?: TimeEntryUpsertWithWhereUniqueWithoutFeeEarnerInput[] | null;
  createMany?: TimeEntryCreateManyFeeEarnerInputEnvelope | null;
  set?: TimeEntryWhereUniqueInput[] | null;
  disconnect?: TimeEntryWhereUniqueInput[] | null;
  delete?: TimeEntryWhereUniqueInput[] | null;
  connect?: TimeEntryWhereUniqueInput[] | null;
  update?: TimeEntryUpdateWithWhereUniqueWithoutFeeEarnerInput[] | null;
  updateMany?: TimeEntryUpdateManyWithWhereWithoutFeeEarnerInput[] | null;
  deleteMany?: TimeEntryScalarWhereInput[] | null;
}

export interface TimeEntryUpdateWithWhereUniqueWithoutExternalMatterInput {
  where: TimeEntryWhereUniqueInput;
  data: TimeEntryUpdateWithoutExternalMatterInput;
}

export interface TimeEntryUpdateWithWhereUniqueWithoutFeeEarnerInput {
  where: TimeEntryWhereUniqueInput;
  data: TimeEntryUpdateWithoutFeeEarnerInput;
}

export interface TimeEntryUpdateWithoutExternalMatterInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  hourlyChargeRate?: FloatFieldUpdateOperationsInput | null;
  durationInMinutes?: IntFieldUpdateOperationsInput | null;
  charge?: FloatFieldUpdateOperationsInput | null;
  cost?: FloatFieldUpdateOperationsInput | null;
  feeEarner?: FeeEarnerUpdateOneRequiredWithoutTimeEntriesNestedInput | null;
}

export interface TimeEntryUpdateWithoutFeeEarnerInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  hourlyChargeRate?: FloatFieldUpdateOperationsInput | null;
  durationInMinutes?: IntFieldUpdateOperationsInput | null;
  charge?: FloatFieldUpdateOperationsInput | null;
  cost?: FloatFieldUpdateOperationsInput | null;
  externalMatter?: ExternalMatterUpdateOneRequiredWithoutTimeEntriesNestedInput | null;
}

export interface TimeEntryUpsertWithWhereUniqueWithoutExternalMatterInput {
  where: TimeEntryWhereUniqueInput;
  update: TimeEntryUpdateWithoutExternalMatterInput;
  create: TimeEntryCreateWithoutExternalMatterInput;
}

export interface TimeEntryUpsertWithWhereUniqueWithoutFeeEarnerInput {
  where: TimeEntryWhereUniqueInput;
  update: TimeEntryUpdateWithoutFeeEarnerInput;
  create: TimeEntryCreateWithoutFeeEarnerInput;
}

export interface TimeEntryWhereInput {
  AND?: TimeEntryWhereInput[] | null;
  OR?: TimeEntryWhereInput[] | null;
  NOT?: TimeEntryWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  externalId?: StringNullableFilter | null;
  externalReference?: StringNullableFilter | null;
  externalCreatedAt?: DateTimeNullableFilter | null;
  externalUpdatedAt?: DateTimeNullableFilter | null;
  externalDeletedAt?: DateTimeNullableFilter | null;
  hourlyChargeRate?: FloatFilter | null;
  durationInMinutes?: IntFilter | null;
  charge?: FloatFilter | null;
  cost?: FloatFilter | null;
  externalMatterId?: IntFilter | null;
  feeEarnerId?: IntFilter | null;
  externalMatter?: ExternalMatterRelationFilter | null;
  feeEarner?: FeeEarnerRelationFilter | null;
}

export interface TimeEntryWhereUniqueInput {
  id?: number | null;
  externalId?: string | null;
}

export interface UpdateBrandInput {
  organisationName?: string | null;
  organisationLogo?: any | null;
  includeTasksInProposalOutput?: boolean | null;
  proposalFont?: string | null;
  isDefault?: boolean | null;
  id: number;
}

export interface UpdateDisbursementInput {
  id: number;
  data: DisbursementUpdateInput;
}

export interface UpdateDiscountsInput {
  data: DiscountUpdateInput;
  id: number;
}

export interface UpdateManyAssumptionsInput {
  id: number;
  payload: AssumptionUpdateInput;
}

export interface UpdateManyExclusionsInput {
  id: number;
  data: ExclusionUpdateInput;
}

export interface UpdateManyFeeEarnerLevelsInput {
  id: number;
  payload: FeeEarnerLevelUpdateInput;
}

export interface UpdateManyOrganisationalUnitsInput {
  id: number;
  payload: OrganisationalUnitUpdateInput;
}

export interface UpdateManyTemplatesInput {
  id: number;
  payload: MatterUpdateInput;
}

export interface UpdateManyUpliftsInput {
  data: UpliftUpdateInput;
  id: number;
}

export interface UpdateMatterCollaboratorsInput {
  matterId: number;
  userIds: number[];
  message?: string | null;
}

export interface UpdateNotificationRulesInput {
  id: number;
  name: string;
  proposalGpmThreshold?: number | null;
  proposalFeeThreshold?: number | null;
  activeGpmThreshold?: number | null;
  accruedTimeThreshold?: number | null;
  accruedBudgetThreshold?: number | null;
  triggerUsers?: number[] | null;
  notifyUsers?: number[] | null;
  triggerFeeEarnerLevels?: number[] | null;
  notifyFeeEarnerLevels?: number[] | null;
  triggerClients?: number[] | null;
  triggerOrganisationalUnits?: number[] | null;
}

export interface UpdatePhasesInput {
  id: number;
  payload: PhaseUpdateInput;
}

export interface UpdateTaskInput {
  id: number;
  data: TaskUpdateInput;
}

export interface UpliftCreateInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  amount: number;
  type: UpliftType;
  order: number;
  matter: MatterCreateNestedOneWithoutUpliftsInput;
  libraryUplift?: LibraryUpliftCreateNestedOneWithoutUpliftsInput | null;
}

export interface UpliftCreateManyMatterInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  amount: number;
  type: UpliftType;
  baseUpliftId?: number | null;
  order: number;
}

export interface UpliftCreateManyMatterInputEnvelope {
  data: UpliftCreateManyMatterInput[];
  skipDuplicates?: boolean | null;
}

export interface UpliftCreateNestedManyWithoutMatterInput {
  create?: UpliftCreateWithoutMatterInput[] | null;
  connectOrCreate?: UpliftCreateOrConnectWithoutMatterInput[] | null;
  createMany?: UpliftCreateManyMatterInputEnvelope | null;
  connect?: UpliftWhereUniqueInput[] | null;
}

export interface UpliftCreateOrConnectWithoutMatterInput {
  where: UpliftWhereUniqueInput;
  create: UpliftCreateWithoutMatterInput;
}

export interface UpliftCreateWithoutMatterInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  amount: number;
  type: UpliftType;
  order: number;
  libraryUplift?: LibraryUpliftCreateNestedOneWithoutUpliftsInput | null;
}

export interface UpliftListRelationFilter {
  every?: UpliftWhereInput | null;
  some?: UpliftWhereInput | null;
  none?: UpliftWhereInput | null;
}

export interface UpliftScalarWhereInput {
  AND?: UpliftScalarWhereInput[] | null;
  OR?: UpliftScalarWhereInput[] | null;
  NOT?: UpliftScalarWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  amount?: FloatFilter | null;
  type?: EnumUpliftTypeFilter | null;
  matterId?: IntFilter | null;
  baseUpliftId?: IntNullableFilter | null;
  order?: IntFilter | null;
}

export interface UpliftUpdateInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  amount?: FloatFieldUpdateOperationsInput | null;
  type?: EnumUpliftTypeFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  matter?: MatterUpdateOneRequiredWithoutUpliftsNestedInput | null;
  libraryUplift?: LibraryUpliftUpdateOneWithoutUpliftsNestedInput | null;
}

export interface UpliftUpdateManyMutationInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  amount?: FloatFieldUpdateOperationsInput | null;
  type?: EnumUpliftTypeFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
}

export interface UpliftUpdateManyWithWhereWithoutMatterInput {
  where: UpliftScalarWhereInput;
  data: UpliftUpdateManyMutationInput;
}

export interface UpliftUpdateManyWithoutMatterNestedInput {
  create?: UpliftCreateWithoutMatterInput[] | null;
  connectOrCreate?: UpliftCreateOrConnectWithoutMatterInput[] | null;
  upsert?: UpliftUpsertWithWhereUniqueWithoutMatterInput[] | null;
  createMany?: UpliftCreateManyMatterInputEnvelope | null;
  set?: UpliftWhereUniqueInput[] | null;
  disconnect?: UpliftWhereUniqueInput[] | null;
  delete?: UpliftWhereUniqueInput[] | null;
  connect?: UpliftWhereUniqueInput[] | null;
  update?: UpliftUpdateWithWhereUniqueWithoutMatterInput[] | null;
  updateMany?: UpliftUpdateManyWithWhereWithoutMatterInput[] | null;
  deleteMany?: UpliftScalarWhereInput[] | null;
}

export interface UpliftUpdateWithWhereUniqueWithoutMatterInput {
  where: UpliftWhereUniqueInput;
  data: UpliftUpdateWithoutMatterInput;
}

export interface UpliftUpdateWithoutMatterInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  amount?: FloatFieldUpdateOperationsInput | null;
  type?: EnumUpliftTypeFieldUpdateOperationsInput | null;
  order?: IntFieldUpdateOperationsInput | null;
  libraryUplift?: LibraryUpliftUpdateOneWithoutUpliftsNestedInput | null;
}

export interface UpliftUpsertWithWhereUniqueWithoutMatterInput {
  where: UpliftWhereUniqueInput;
  update: UpliftUpdateWithoutMatterInput;
  create: UpliftCreateWithoutMatterInput;
}

export interface UpliftWhereInput {
  AND?: UpliftWhereInput[] | null;
  OR?: UpliftWhereInput[] | null;
  NOT?: UpliftWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  amount?: FloatFilter | null;
  type?: EnumUpliftTypeFilter | null;
  matterId?: IntFilter | null;
  baseUpliftId?: IntNullableFilter | null;
  order?: IntFilter | null;
  matter?: MatterRelationFilter | null;
  libraryUplift?: LibraryUpliftRelationFilter | null;
}

export interface UpliftWhereUniqueInput {
  id?: number | null;
}

export interface UserCreateNestedOneWithoutCollaboratorCreatedByUserInput {
  create?: UserCreateWithoutCollaboratorCreatedByUserInput | null;
  connectOrCreate?: UserCreateOrConnectWithoutCollaboratorCreatedByUserInput | null;
  connect?: UserWhereUniqueInput | null;
}

export interface UserCreateNestedOneWithoutCollaboratorUserInput {
  create?: UserCreateWithoutCollaboratorUserInput | null;
  connectOrCreate?: UserCreateOrConnectWithoutCollaboratorUserInput | null;
  connect?: UserWhereUniqueInput | null;
}

export interface UserCreateNestedOneWithoutFeeEarnerInput {
  create?: UserCreateWithoutFeeEarnerInput | null;
  connectOrCreate?: UserCreateOrConnectWithoutFeeEarnerInput | null;
  connect?: UserWhereUniqueInput | null;
}

export interface UserCreateNestedOneWithoutNotificationsInput {
  create?: UserCreateWithoutNotificationsInput | null;
  connectOrCreate?: UserCreateOrConnectWithoutNotificationsInput | null;
  connect?: UserWhereUniqueInput | null;
}

export interface UserCreateNestedOneWithoutNotifyRulesInput {
  create?: UserCreateWithoutNotifyRulesInput | null;
  connectOrCreate?: UserCreateOrConnectWithoutNotifyRulesInput | null;
  connect?: UserWhereUniqueInput | null;
}

export interface UserCreateNestedOneWithoutTriggeredRulesInput {
  create?: UserCreateWithoutTriggeredRulesInput | null;
  connectOrCreate?: UserCreateOrConnectWithoutTriggeredRulesInput | null;
  connect?: UserWhereUniqueInput | null;
}

export interface UserCreateOrConnectWithoutCollaboratorCreatedByUserInput {
  where: UserWhereUniqueInput;
  create: UserCreateWithoutCollaboratorCreatedByUserInput;
}

export interface UserCreateOrConnectWithoutCollaboratorUserInput {
  where: UserWhereUniqueInput;
  create: UserCreateWithoutCollaboratorUserInput;
}

export interface UserCreateOrConnectWithoutFeeEarnerInput {
  where: UserWhereUniqueInput;
  create: UserCreateWithoutFeeEarnerInput;
}

export interface UserCreateOrConnectWithoutNotificationsInput {
  where: UserWhereUniqueInput;
  create: UserCreateWithoutNotificationsInput;
}

export interface UserCreateOrConnectWithoutNotifyRulesInput {
  where: UserWhereUniqueInput;
  create: UserCreateWithoutNotifyRulesInput;
}

export interface UserCreateOrConnectWithoutTriggeredRulesInput {
  where: UserWhereUniqueInput;
  create: UserCreateWithoutTriggeredRulesInput;
}

export interface UserCreateWithoutCollaboratorCreatedByUserInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  userName: string;
  displayName: string;
  mattersId?: number | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutUsersInput | null;
  matters?: MatterCreateNestedManyWithoutCreatedByInput | null;
  parentMatters?: ParentMatterCreateNestedManyWithoutCreatedByInput | null;
  notifications?: NotificationCreateNestedManyWithoutUserInput | null;
  userSettings?: UserSettingsCreateNestedOneWithoutUserInput | null;
  triggeredRules?: NotificationRuleUserTriggerCreateNestedManyWithoutUserInput | null;
  notifyRules?: NotificationRuleUserNotifyCreateNestedManyWithoutUserInput | null;
  collaboratorUser?: CollaboratorCreateNestedManyWithoutUserInput | null;
}

export interface UserCreateWithoutCollaboratorUserInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  userName: string;
  displayName: string;
  mattersId?: number | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutUsersInput | null;
  matters?: MatterCreateNestedManyWithoutCreatedByInput | null;
  parentMatters?: ParentMatterCreateNestedManyWithoutCreatedByInput | null;
  notifications?: NotificationCreateNestedManyWithoutUserInput | null;
  userSettings?: UserSettingsCreateNestedOneWithoutUserInput | null;
  triggeredRules?: NotificationRuleUserTriggerCreateNestedManyWithoutUserInput | null;
  notifyRules?: NotificationRuleUserNotifyCreateNestedManyWithoutUserInput | null;
  collaboratorCreatedByUser?: CollaboratorCreateNestedManyWithoutCreatedByUserInput | null;
}

export interface UserCreateWithoutFeeEarnerInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  userName: string;
  displayName: string;
  mattersId?: number | null;
  matters?: MatterCreateNestedManyWithoutCreatedByInput | null;
  parentMatters?: ParentMatterCreateNestedManyWithoutCreatedByInput | null;
  notifications?: NotificationCreateNestedManyWithoutUserInput | null;
  userSettings?: UserSettingsCreateNestedOneWithoutUserInput | null;
  triggeredRules?: NotificationRuleUserTriggerCreateNestedManyWithoutUserInput | null;
  notifyRules?: NotificationRuleUserNotifyCreateNestedManyWithoutUserInput | null;
  collaboratorUser?: CollaboratorCreateNestedManyWithoutUserInput | null;
  collaboratorCreatedByUser?: CollaboratorCreateNestedManyWithoutCreatedByUserInput | null;
}

export interface UserCreateWithoutNotificationsInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  userName: string;
  displayName: string;
  mattersId?: number | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutUsersInput | null;
  matters?: MatterCreateNestedManyWithoutCreatedByInput | null;
  parentMatters?: ParentMatterCreateNestedManyWithoutCreatedByInput | null;
  userSettings?: UserSettingsCreateNestedOneWithoutUserInput | null;
  triggeredRules?: NotificationRuleUserTriggerCreateNestedManyWithoutUserInput | null;
  notifyRules?: NotificationRuleUserNotifyCreateNestedManyWithoutUserInput | null;
  collaboratorUser?: CollaboratorCreateNestedManyWithoutUserInput | null;
  collaboratorCreatedByUser?: CollaboratorCreateNestedManyWithoutCreatedByUserInput | null;
}

export interface UserCreateWithoutNotifyRulesInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  userName: string;
  displayName: string;
  mattersId?: number | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutUsersInput | null;
  matters?: MatterCreateNestedManyWithoutCreatedByInput | null;
  parentMatters?: ParentMatterCreateNestedManyWithoutCreatedByInput | null;
  notifications?: NotificationCreateNestedManyWithoutUserInput | null;
  userSettings?: UserSettingsCreateNestedOneWithoutUserInput | null;
  triggeredRules?: NotificationRuleUserTriggerCreateNestedManyWithoutUserInput | null;
  collaboratorUser?: CollaboratorCreateNestedManyWithoutUserInput | null;
  collaboratorCreatedByUser?: CollaboratorCreateNestedManyWithoutCreatedByUserInput | null;
}

export interface UserCreateWithoutTriggeredRulesInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  deletedAt?: any | null;
  externalId?: string | null;
  externalReference?: string | null;
  externalCreatedAt?: any | null;
  externalUpdatedAt?: any | null;
  externalDeletedAt?: any | null;
  userName: string;
  displayName: string;
  mattersId?: number | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutUsersInput | null;
  matters?: MatterCreateNestedManyWithoutCreatedByInput | null;
  parentMatters?: ParentMatterCreateNestedManyWithoutCreatedByInput | null;
  notifications?: NotificationCreateNestedManyWithoutUserInput | null;
  userSettings?: UserSettingsCreateNestedOneWithoutUserInput | null;
  notifyRules?: NotificationRuleUserNotifyCreateNestedManyWithoutUserInput | null;
  collaboratorUser?: CollaboratorCreateNestedManyWithoutUserInput | null;
  collaboratorCreatedByUser?: CollaboratorCreateNestedManyWithoutCreatedByUserInput | null;
}

export interface UserFilterInput {
  displayName?: string | null;
}

export interface UserRelationFilter {
  is?: UserWhereInput | null;
  isNot?: UserWhereInput | null;
}

export interface UserSettingsCreateNestedOneWithoutUserInput {
  create?: UserSettingsCreateWithoutUserInput | null;
  connectOrCreate?: UserSettingsCreateOrConnectWithoutUserInput | null;
  connect?: UserSettingsWhereUniqueInput | null;
}

export interface UserSettingsCreateOrConnectWithoutUserInput {
  where: UserSettingsWhereUniqueInput;
  create: UserSettingsCreateWithoutUserInput;
}

export interface UserSettingsCreateWithoutUserInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  darkTheme?: boolean | null;
  customPaletteHex?: string | null;
}

export interface UserSettingsRelationFilter {
  is?: UserSettingsWhereInput | null;
  isNot?: UserSettingsWhereInput | null;
}

export interface UserSettingsUpdateInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  darkTheme?: BoolFieldUpdateOperationsInput | null;
  customPaletteHex?: NullableStringFieldUpdateOperationsInput | null;
}

export interface UserSettingsUpdateOneWithoutUserNestedInput {
  create?: UserSettingsCreateWithoutUserInput | null;
  connectOrCreate?: UserSettingsCreateOrConnectWithoutUserInput | null;
  upsert?: UserSettingsUpsertWithoutUserInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: UserSettingsWhereUniqueInput | null;
  update?: UserSettingsUpdateWithoutUserInput | null;
}

export interface UserSettingsUpdateWithoutUserInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  darkTheme?: BoolFieldUpdateOperationsInput | null;
  customPaletteHex?: NullableStringFieldUpdateOperationsInput | null;
}

export interface UserSettingsUpsertWithoutUserInput {
  update: UserSettingsUpdateWithoutUserInput;
  create: UserSettingsCreateWithoutUserInput;
}

export interface UserSettingsWhereInput {
  AND?: UserSettingsWhereInput[] | null;
  OR?: UserSettingsWhereInput[] | null;
  NOT?: UserSettingsWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  darkTheme?: BoolFilter | null;
  customPaletteHex?: StringNullableFilter | null;
}

export interface UserSettingsWhereUniqueInput {
  id?: number | null;
}

export interface UserUpdateOneRequiredWithoutCollaboratorCreatedByUserNestedInput {
  create?: UserCreateWithoutCollaboratorCreatedByUserInput | null;
  connectOrCreate?: UserCreateOrConnectWithoutCollaboratorCreatedByUserInput | null;
  upsert?: UserUpsertWithoutCollaboratorCreatedByUserInput | null;
  connect?: UserWhereUniqueInput | null;
  update?: UserUpdateWithoutCollaboratorCreatedByUserInput | null;
}

export interface UserUpdateOneRequiredWithoutCollaboratorUserNestedInput {
  create?: UserCreateWithoutCollaboratorUserInput | null;
  connectOrCreate?: UserCreateOrConnectWithoutCollaboratorUserInput | null;
  upsert?: UserUpsertWithoutCollaboratorUserInput | null;
  connect?: UserWhereUniqueInput | null;
  update?: UserUpdateWithoutCollaboratorUserInput | null;
}

export interface UserUpdateOneRequiredWithoutNotificationsNestedInput {
  create?: UserCreateWithoutNotificationsInput | null;
  connectOrCreate?: UserCreateOrConnectWithoutNotificationsInput | null;
  upsert?: UserUpsertWithoutNotificationsInput | null;
  connect?: UserWhereUniqueInput | null;
  update?: UserUpdateWithoutNotificationsInput | null;
}

export interface UserUpdateOneRequiredWithoutNotifyRulesNestedInput {
  create?: UserCreateWithoutNotifyRulesInput | null;
  connectOrCreate?: UserCreateOrConnectWithoutNotifyRulesInput | null;
  upsert?: UserUpsertWithoutNotifyRulesInput | null;
  connect?: UserWhereUniqueInput | null;
  update?: UserUpdateWithoutNotifyRulesInput | null;
}

export interface UserUpdateOneRequiredWithoutTriggeredRulesNestedInput {
  create?: UserCreateWithoutTriggeredRulesInput | null;
  connectOrCreate?: UserCreateOrConnectWithoutTriggeredRulesInput | null;
  upsert?: UserUpsertWithoutTriggeredRulesInput | null;
  connect?: UserWhereUniqueInput | null;
  update?: UserUpdateWithoutTriggeredRulesInput | null;
}

export interface UserUpdateOneWithoutFeeEarnerNestedInput {
  create?: UserCreateWithoutFeeEarnerInput | null;
  connectOrCreate?: UserCreateOrConnectWithoutFeeEarnerInput | null;
  upsert?: UserUpsertWithoutFeeEarnerInput | null;
  disconnect?: boolean | null;
  delete?: boolean | null;
  connect?: UserWhereUniqueInput | null;
  update?: UserUpdateWithoutFeeEarnerInput | null;
}

export interface UserUpdateWithoutCollaboratorCreatedByUserInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  userName?: StringFieldUpdateOperationsInput | null;
  displayName?: StringFieldUpdateOperationsInput | null;
  mattersId?: NullableIntFieldUpdateOperationsInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutUsersNestedInput | null;
  matters?: MatterUpdateManyWithoutCreatedByNestedInput | null;
  parentMatters?: ParentMatterUpdateManyWithoutCreatedByNestedInput | null;
  notifications?: NotificationUpdateManyWithoutUserNestedInput | null;
  userSettings?: UserSettingsUpdateOneWithoutUserNestedInput | null;
  triggeredRules?: NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput | null;
  notifyRules?: NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput | null;
  collaboratorUser?: CollaboratorUpdateManyWithoutUserNestedInput | null;
}

export interface UserUpdateWithoutCollaboratorUserInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  userName?: StringFieldUpdateOperationsInput | null;
  displayName?: StringFieldUpdateOperationsInput | null;
  mattersId?: NullableIntFieldUpdateOperationsInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutUsersNestedInput | null;
  matters?: MatterUpdateManyWithoutCreatedByNestedInput | null;
  parentMatters?: ParentMatterUpdateManyWithoutCreatedByNestedInput | null;
  notifications?: NotificationUpdateManyWithoutUserNestedInput | null;
  userSettings?: UserSettingsUpdateOneWithoutUserNestedInput | null;
  triggeredRules?: NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput | null;
  notifyRules?: NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput | null;
  collaboratorCreatedByUser?: CollaboratorUpdateManyWithoutCreatedByUserNestedInput | null;
}

export interface UserUpdateWithoutFeeEarnerInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  userName?: StringFieldUpdateOperationsInput | null;
  displayName?: StringFieldUpdateOperationsInput | null;
  mattersId?: NullableIntFieldUpdateOperationsInput | null;
  matters?: MatterUpdateManyWithoutCreatedByNestedInput | null;
  parentMatters?: ParentMatterUpdateManyWithoutCreatedByNestedInput | null;
  notifications?: NotificationUpdateManyWithoutUserNestedInput | null;
  userSettings?: UserSettingsUpdateOneWithoutUserNestedInput | null;
  triggeredRules?: NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput | null;
  notifyRules?: NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput | null;
  collaboratorUser?: CollaboratorUpdateManyWithoutUserNestedInput | null;
  collaboratorCreatedByUser?: CollaboratorUpdateManyWithoutCreatedByUserNestedInput | null;
}

export interface UserUpdateWithoutNotificationsInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  userName?: StringFieldUpdateOperationsInput | null;
  displayName?: StringFieldUpdateOperationsInput | null;
  mattersId?: NullableIntFieldUpdateOperationsInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutUsersNestedInput | null;
  matters?: MatterUpdateManyWithoutCreatedByNestedInput | null;
  parentMatters?: ParentMatterUpdateManyWithoutCreatedByNestedInput | null;
  userSettings?: UserSettingsUpdateOneWithoutUserNestedInput | null;
  triggeredRules?: NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput | null;
  notifyRules?: NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput | null;
  collaboratorUser?: CollaboratorUpdateManyWithoutUserNestedInput | null;
  collaboratorCreatedByUser?: CollaboratorUpdateManyWithoutCreatedByUserNestedInput | null;
}

export interface UserUpdateWithoutNotifyRulesInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  userName?: StringFieldUpdateOperationsInput | null;
  displayName?: StringFieldUpdateOperationsInput | null;
  mattersId?: NullableIntFieldUpdateOperationsInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutUsersNestedInput | null;
  matters?: MatterUpdateManyWithoutCreatedByNestedInput | null;
  parentMatters?: ParentMatterUpdateManyWithoutCreatedByNestedInput | null;
  notifications?: NotificationUpdateManyWithoutUserNestedInput | null;
  userSettings?: UserSettingsUpdateOneWithoutUserNestedInput | null;
  triggeredRules?: NotificationRuleUserTriggerUpdateManyWithoutUserNestedInput | null;
  collaboratorUser?: CollaboratorUpdateManyWithoutUserNestedInput | null;
  collaboratorCreatedByUser?: CollaboratorUpdateManyWithoutCreatedByUserNestedInput | null;
}

export interface UserUpdateWithoutTriggeredRulesInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  deletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalId?: NullableStringFieldUpdateOperationsInput | null;
  externalReference?: NullableStringFieldUpdateOperationsInput | null;
  externalCreatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalUpdatedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  externalDeletedAt?: NullableDateTimeFieldUpdateOperationsInput | null;
  userName?: StringFieldUpdateOperationsInput | null;
  displayName?: StringFieldUpdateOperationsInput | null;
  mattersId?: NullableIntFieldUpdateOperationsInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutUsersNestedInput | null;
  matters?: MatterUpdateManyWithoutCreatedByNestedInput | null;
  parentMatters?: ParentMatterUpdateManyWithoutCreatedByNestedInput | null;
  notifications?: NotificationUpdateManyWithoutUserNestedInput | null;
  userSettings?: UserSettingsUpdateOneWithoutUserNestedInput | null;
  notifyRules?: NotificationRuleUserNotifyUpdateManyWithoutUserNestedInput | null;
  collaboratorUser?: CollaboratorUpdateManyWithoutUserNestedInput | null;
  collaboratorCreatedByUser?: CollaboratorUpdateManyWithoutCreatedByUserNestedInput | null;
}

export interface UserUpsertWithoutCollaboratorCreatedByUserInput {
  update: UserUpdateWithoutCollaboratorCreatedByUserInput;
  create: UserCreateWithoutCollaboratorCreatedByUserInput;
}

export interface UserUpsertWithoutCollaboratorUserInput {
  update: UserUpdateWithoutCollaboratorUserInput;
  create: UserCreateWithoutCollaboratorUserInput;
}

export interface UserUpsertWithoutFeeEarnerInput {
  update: UserUpdateWithoutFeeEarnerInput;
  create: UserCreateWithoutFeeEarnerInput;
}

export interface UserUpsertWithoutNotificationsInput {
  update: UserUpdateWithoutNotificationsInput;
  create: UserCreateWithoutNotificationsInput;
}

export interface UserUpsertWithoutNotifyRulesInput {
  update: UserUpdateWithoutNotifyRulesInput;
  create: UserCreateWithoutNotifyRulesInput;
}

export interface UserUpsertWithoutTriggeredRulesInput {
  update: UserUpdateWithoutTriggeredRulesInput;
  create: UserCreateWithoutTriggeredRulesInput;
}

export interface UserWhereInput {
  AND?: UserWhereInput[] | null;
  OR?: UserWhereInput[] | null;
  NOT?: UserWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  deletedAt?: DateTimeNullableFilter | null;
  externalId?: StringNullableFilter | null;
  externalReference?: StringNullableFilter | null;
  externalCreatedAt?: DateTimeNullableFilter | null;
  externalUpdatedAt?: DateTimeNullableFilter | null;
  externalDeletedAt?: DateTimeNullableFilter | null;
  userName?: StringFilter | null;
  displayName?: StringFilter | null;
  feeEarnerId?: IntNullableFilter | null;
  mattersId?: IntNullableFilter | null;
  feeEarner?: FeeEarnerRelationFilter | null;
  matters?: MatterListRelationFilter | null;
  parentMatters?: ParentMatterListRelationFilter | null;
  notifications?: NotificationListRelationFilter | null;
  userSettings?: UserSettingsRelationFilter | null;
  triggeredRules?: NotificationRuleUserTriggerListRelationFilter | null;
  notifyRules?: NotificationRuleUserNotifyListRelationFilter | null;
  collaboratorUser?: CollaboratorListRelationFilter | null;
  collaboratorCreatedByUser?: CollaboratorListRelationFilter | null;
}

export interface UserWhereUniqueInput {
  id?: number | null;
  externalId?: string | null;
  userName?: string | null;
  feeEarnerId?: number | null;
}

export interface UuidFilter {
  equals?: string | null;
  in?: string[] | null;
  notIn?: string[] | null;
  lt?: string | null;
  lte?: string | null;
  gt?: string | null;
  gte?: string | null;
  mode?: QueryMode | null;
  not?: NestedUuidFilter | null;
}

export interface WorkCreateInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  timeLower?: number | null;
  timeUpper?: number | null;
  timeSingle?: number | null;
  phase: PhaseCreateNestedOneWithoutWorkInput;
  selectedRate?: RateCreateNestedOneWithoutWorkInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutWorkInput | null;
  feeEarnerLevel?: FeeEarnerLevelCreateNestedOneWithoutWorkInput | null;
}

export interface WorkCreateManyFeeEarnerInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  phaseId: number;
  selectedRateId?: number | null;
  feeEarnerLevelId?: number | null;
  timeLower?: number | null;
  timeUpper?: number | null;
  timeSingle?: number | null;
}

export interface WorkCreateManyFeeEarnerInputEnvelope {
  data: WorkCreateManyFeeEarnerInput[];
  skipDuplicates?: boolean | null;
}

export interface WorkCreateManyFeeEarnerLevelInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  phaseId: number;
  feeEarnerId?: number | null;
  selectedRateId?: number | null;
  timeLower?: number | null;
  timeUpper?: number | null;
  timeSingle?: number | null;
}

export interface WorkCreateManyFeeEarnerLevelInputEnvelope {
  data: WorkCreateManyFeeEarnerLevelInput[];
  skipDuplicates?: boolean | null;
}

export interface WorkCreateManyPhaseInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  feeEarnerId?: number | null;
  selectedRateId?: number | null;
  feeEarnerLevelId?: number | null;
  timeLower?: number | null;
  timeUpper?: number | null;
  timeSingle?: number | null;
}

export interface WorkCreateManyPhaseInputEnvelope {
  data: WorkCreateManyPhaseInput[];
  skipDuplicates?: boolean | null;
}

export interface WorkCreateManySelectedRateInput {
  id?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  phaseId: number;
  feeEarnerId?: number | null;
  feeEarnerLevelId?: number | null;
  timeLower?: number | null;
  timeUpper?: number | null;
  timeSingle?: number | null;
}

export interface WorkCreateManySelectedRateInputEnvelope {
  data: WorkCreateManySelectedRateInput[];
  skipDuplicates?: boolean | null;
}

export interface WorkCreateNestedManyWithoutFeeEarnerInput {
  create?: WorkCreateWithoutFeeEarnerInput[] | null;
  connectOrCreate?: WorkCreateOrConnectWithoutFeeEarnerInput[] | null;
  createMany?: WorkCreateManyFeeEarnerInputEnvelope | null;
  connect?: WorkWhereUniqueInput[] | null;
}

export interface WorkCreateNestedManyWithoutFeeEarnerLevelInput {
  create?: WorkCreateWithoutFeeEarnerLevelInput[] | null;
  connectOrCreate?: WorkCreateOrConnectWithoutFeeEarnerLevelInput[] | null;
  createMany?: WorkCreateManyFeeEarnerLevelInputEnvelope | null;
  connect?: WorkWhereUniqueInput[] | null;
}

export interface WorkCreateNestedManyWithoutPhaseInput {
  create?: WorkCreateWithoutPhaseInput[] | null;
  connectOrCreate?: WorkCreateOrConnectWithoutPhaseInput[] | null;
  createMany?: WorkCreateManyPhaseInputEnvelope | null;
  connect?: WorkWhereUniqueInput[] | null;
}

export interface WorkCreateNestedManyWithoutSelectedRateInput {
  create?: WorkCreateWithoutSelectedRateInput[] | null;
  connectOrCreate?: WorkCreateOrConnectWithoutSelectedRateInput[] | null;
  createMany?: WorkCreateManySelectedRateInputEnvelope | null;
  connect?: WorkWhereUniqueInput[] | null;
}

export interface WorkCreateOrConnectWithoutFeeEarnerInput {
  where: WorkWhereUniqueInput;
  create: WorkCreateWithoutFeeEarnerInput;
}

export interface WorkCreateOrConnectWithoutFeeEarnerLevelInput {
  where: WorkWhereUniqueInput;
  create: WorkCreateWithoutFeeEarnerLevelInput;
}

export interface WorkCreateOrConnectWithoutPhaseInput {
  where: WorkWhereUniqueInput;
  create: WorkCreateWithoutPhaseInput;
}

export interface WorkCreateOrConnectWithoutSelectedRateInput {
  where: WorkWhereUniqueInput;
  create: WorkCreateWithoutSelectedRateInput;
}

export interface WorkCreateWithoutFeeEarnerInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  timeLower?: number | null;
  timeUpper?: number | null;
  timeSingle?: number | null;
  phase: PhaseCreateNestedOneWithoutWorkInput;
  selectedRate?: RateCreateNestedOneWithoutWorkInput | null;
  feeEarnerLevel?: FeeEarnerLevelCreateNestedOneWithoutWorkInput | null;
}

export interface WorkCreateWithoutFeeEarnerLevelInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  timeLower?: number | null;
  timeUpper?: number | null;
  timeSingle?: number | null;
  phase: PhaseCreateNestedOneWithoutWorkInput;
  selectedRate?: RateCreateNestedOneWithoutWorkInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutWorkInput | null;
}

export interface WorkCreateWithoutPhaseInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  timeLower?: number | null;
  timeUpper?: number | null;
  timeSingle?: number | null;
  selectedRate?: RateCreateNestedOneWithoutWorkInput | null;
  feeEarner?: FeeEarnerCreateNestedOneWithoutWorkInput | null;
  feeEarnerLevel?: FeeEarnerLevelCreateNestedOneWithoutWorkInput | null;
}

export interface WorkCreateWithoutSelectedRateInput {
  createdAt?: any | null;
  updatedAt?: any | null;
  timeLower?: number | null;
  timeUpper?: number | null;
  timeSingle?: number | null;
  phase: PhaseCreateNestedOneWithoutWorkInput;
  feeEarner?: FeeEarnerCreateNestedOneWithoutWorkInput | null;
  feeEarnerLevel?: FeeEarnerLevelCreateNestedOneWithoutWorkInput | null;
}

export interface WorkListRelationFilter {
  every?: WorkWhereInput | null;
  some?: WorkWhereInput | null;
  none?: WorkWhereInput | null;
}

export interface WorkScalarWhereInput {
  AND?: WorkScalarWhereInput[] | null;
  OR?: WorkScalarWhereInput[] | null;
  NOT?: WorkScalarWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  phaseId?: IntFilter | null;
  feeEarnerId?: IntNullableFilter | null;
  selectedRateId?: IntNullableFilter | null;
  feeEarnerLevelId?: IntNullableFilter | null;
  timeLower?: IntNullableFilter | null;
  timeUpper?: IntNullableFilter | null;
  timeSingle?: IntNullableFilter | null;
}

export interface WorkUpdateInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  timeLower?: NullableIntFieldUpdateOperationsInput | null;
  timeUpper?: NullableIntFieldUpdateOperationsInput | null;
  timeSingle?: NullableIntFieldUpdateOperationsInput | null;
  phase?: PhaseUpdateOneRequiredWithoutWorkNestedInput | null;
  selectedRate?: RateUpdateOneWithoutWorkNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutWorkNestedInput | null;
  feeEarnerLevel?: FeeEarnerLevelUpdateOneWithoutWorkNestedInput | null;
}

export interface WorkUpdateManyMutationInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  timeLower?: NullableIntFieldUpdateOperationsInput | null;
  timeUpper?: NullableIntFieldUpdateOperationsInput | null;
  timeSingle?: NullableIntFieldUpdateOperationsInput | null;
}

export interface WorkUpdateManyWithWhereWithoutFeeEarnerInput {
  where: WorkScalarWhereInput;
  data: WorkUpdateManyMutationInput;
}

export interface WorkUpdateManyWithWhereWithoutFeeEarnerLevelInput {
  where: WorkScalarWhereInput;
  data: WorkUpdateManyMutationInput;
}

export interface WorkUpdateManyWithWhereWithoutPhaseInput {
  where: WorkScalarWhereInput;
  data: WorkUpdateManyMutationInput;
}

export interface WorkUpdateManyWithWhereWithoutSelectedRateInput {
  where: WorkScalarWhereInput;
  data: WorkUpdateManyMutationInput;
}

export interface WorkUpdateManyWithoutFeeEarnerLevelNestedInput {
  create?: WorkCreateWithoutFeeEarnerLevelInput[] | null;
  connectOrCreate?: WorkCreateOrConnectWithoutFeeEarnerLevelInput[] | null;
  upsert?: WorkUpsertWithWhereUniqueWithoutFeeEarnerLevelInput[] | null;
  createMany?: WorkCreateManyFeeEarnerLevelInputEnvelope | null;
  set?: WorkWhereUniqueInput[] | null;
  disconnect?: WorkWhereUniqueInput[] | null;
  delete?: WorkWhereUniqueInput[] | null;
  connect?: WorkWhereUniqueInput[] | null;
  update?: WorkUpdateWithWhereUniqueWithoutFeeEarnerLevelInput[] | null;
  updateMany?: WorkUpdateManyWithWhereWithoutFeeEarnerLevelInput[] | null;
  deleteMany?: WorkScalarWhereInput[] | null;
}

export interface WorkUpdateManyWithoutFeeEarnerNestedInput {
  create?: WorkCreateWithoutFeeEarnerInput[] | null;
  connectOrCreate?: WorkCreateOrConnectWithoutFeeEarnerInput[] | null;
  upsert?: WorkUpsertWithWhereUniqueWithoutFeeEarnerInput[] | null;
  createMany?: WorkCreateManyFeeEarnerInputEnvelope | null;
  set?: WorkWhereUniqueInput[] | null;
  disconnect?: WorkWhereUniqueInput[] | null;
  delete?: WorkWhereUniqueInput[] | null;
  connect?: WorkWhereUniqueInput[] | null;
  update?: WorkUpdateWithWhereUniqueWithoutFeeEarnerInput[] | null;
  updateMany?: WorkUpdateManyWithWhereWithoutFeeEarnerInput[] | null;
  deleteMany?: WorkScalarWhereInput[] | null;
}

export interface WorkUpdateManyWithoutPhaseNestedInput {
  create?: WorkCreateWithoutPhaseInput[] | null;
  connectOrCreate?: WorkCreateOrConnectWithoutPhaseInput[] | null;
  upsert?: WorkUpsertWithWhereUniqueWithoutPhaseInput[] | null;
  createMany?: WorkCreateManyPhaseInputEnvelope | null;
  set?: WorkWhereUniqueInput[] | null;
  disconnect?: WorkWhereUniqueInput[] | null;
  delete?: WorkWhereUniqueInput[] | null;
  connect?: WorkWhereUniqueInput[] | null;
  update?: WorkUpdateWithWhereUniqueWithoutPhaseInput[] | null;
  updateMany?: WorkUpdateManyWithWhereWithoutPhaseInput[] | null;
  deleteMany?: WorkScalarWhereInput[] | null;
}

export interface WorkUpdateManyWithoutSelectedRateNestedInput {
  create?: WorkCreateWithoutSelectedRateInput[] | null;
  connectOrCreate?: WorkCreateOrConnectWithoutSelectedRateInput[] | null;
  upsert?: WorkUpsertWithWhereUniqueWithoutSelectedRateInput[] | null;
  createMany?: WorkCreateManySelectedRateInputEnvelope | null;
  set?: WorkWhereUniqueInput[] | null;
  disconnect?: WorkWhereUniqueInput[] | null;
  delete?: WorkWhereUniqueInput[] | null;
  connect?: WorkWhereUniqueInput[] | null;
  update?: WorkUpdateWithWhereUniqueWithoutSelectedRateInput[] | null;
  updateMany?: WorkUpdateManyWithWhereWithoutSelectedRateInput[] | null;
  deleteMany?: WorkScalarWhereInput[] | null;
}

export interface WorkUpdateWithWhereUniqueWithoutFeeEarnerInput {
  where: WorkWhereUniqueInput;
  data: WorkUpdateWithoutFeeEarnerInput;
}

export interface WorkUpdateWithWhereUniqueWithoutFeeEarnerLevelInput {
  where: WorkWhereUniqueInput;
  data: WorkUpdateWithoutFeeEarnerLevelInput;
}

export interface WorkUpdateWithWhereUniqueWithoutPhaseInput {
  where: WorkWhereUniqueInput;
  data: WorkUpdateWithoutPhaseInput;
}

export interface WorkUpdateWithWhereUniqueWithoutSelectedRateInput {
  where: WorkWhereUniqueInput;
  data: WorkUpdateWithoutSelectedRateInput;
}

export interface WorkUpdateWithoutFeeEarnerInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  timeLower?: NullableIntFieldUpdateOperationsInput | null;
  timeUpper?: NullableIntFieldUpdateOperationsInput | null;
  timeSingle?: NullableIntFieldUpdateOperationsInput | null;
  phase?: PhaseUpdateOneRequiredWithoutWorkNestedInput | null;
  selectedRate?: RateUpdateOneWithoutWorkNestedInput | null;
  feeEarnerLevel?: FeeEarnerLevelUpdateOneWithoutWorkNestedInput | null;
}

export interface WorkUpdateWithoutFeeEarnerLevelInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  timeLower?: NullableIntFieldUpdateOperationsInput | null;
  timeUpper?: NullableIntFieldUpdateOperationsInput | null;
  timeSingle?: NullableIntFieldUpdateOperationsInput | null;
  phase?: PhaseUpdateOneRequiredWithoutWorkNestedInput | null;
  selectedRate?: RateUpdateOneWithoutWorkNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutWorkNestedInput | null;
}

export interface WorkUpdateWithoutPhaseInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  timeLower?: NullableIntFieldUpdateOperationsInput | null;
  timeUpper?: NullableIntFieldUpdateOperationsInput | null;
  timeSingle?: NullableIntFieldUpdateOperationsInput | null;
  selectedRate?: RateUpdateOneWithoutWorkNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutWorkNestedInput | null;
  feeEarnerLevel?: FeeEarnerLevelUpdateOneWithoutWorkNestedInput | null;
}

export interface WorkUpdateWithoutSelectedRateInput {
  createdAt?: DateTimeFieldUpdateOperationsInput | null;
  updatedAt?: DateTimeFieldUpdateOperationsInput | null;
  timeLower?: NullableIntFieldUpdateOperationsInput | null;
  timeUpper?: NullableIntFieldUpdateOperationsInput | null;
  timeSingle?: NullableIntFieldUpdateOperationsInput | null;
  phase?: PhaseUpdateOneRequiredWithoutWorkNestedInput | null;
  feeEarner?: FeeEarnerUpdateOneWithoutWorkNestedInput | null;
  feeEarnerLevel?: FeeEarnerLevelUpdateOneWithoutWorkNestedInput | null;
}

export interface WorkUpsertWithWhereUniqueWithoutFeeEarnerInput {
  where: WorkWhereUniqueInput;
  update: WorkUpdateWithoutFeeEarnerInput;
  create: WorkCreateWithoutFeeEarnerInput;
}

export interface WorkUpsertWithWhereUniqueWithoutFeeEarnerLevelInput {
  where: WorkWhereUniqueInput;
  update: WorkUpdateWithoutFeeEarnerLevelInput;
  create: WorkCreateWithoutFeeEarnerLevelInput;
}

export interface WorkUpsertWithWhereUniqueWithoutPhaseInput {
  where: WorkWhereUniqueInput;
  update: WorkUpdateWithoutPhaseInput;
  create: WorkCreateWithoutPhaseInput;
}

export interface WorkUpsertWithWhereUniqueWithoutSelectedRateInput {
  where: WorkWhereUniqueInput;
  update: WorkUpdateWithoutSelectedRateInput;
  create: WorkCreateWithoutSelectedRateInput;
}

export interface WorkWhereInput {
  AND?: WorkWhereInput[] | null;
  OR?: WorkWhereInput[] | null;
  NOT?: WorkWhereInput[] | null;
  id?: IntFilter | null;
  createdAt?: DateTimeFilter | null;
  updatedAt?: DateTimeFilter | null;
  phaseId?: IntFilter | null;
  feeEarnerId?: IntNullableFilter | null;
  selectedRateId?: IntNullableFilter | null;
  feeEarnerLevelId?: IntNullableFilter | null;
  timeLower?: IntNullableFilter | null;
  timeUpper?: IntNullableFilter | null;
  timeSingle?: IntNullableFilter | null;
  phase?: PhaseRelationFilter | null;
  selectedRate?: RateRelationFilter | null;
  feeEarner?: FeeEarnerRelationFilter | null;
  feeEarnerLevel?: FeeEarnerLevelRelationFilter | null;
}

export interface WorkWhereUniqueInput {
  id?: number | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
